// AUTO-GENERATED FILE. DON'T CHANGE THIS FILE MANUALLY
/* eslint-disable */
// @ts-nocheck
import {
  GraphQLResolveInfo,
  GraphQLScalarType,
  GraphQLScalarTypeConfig,
} from 'graphql';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type RequireFields<T, K extends keyof T> = Omit<T, K> & {
  [P in K]-?: NonNullable<T[P]>;
};
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DataPointValue: any;
  Date: any;
  Float32: any;
  Float64: any;
  Int32: number;
  Int64: any;
  JSONObject: any;
  Timestamp: string;
  _SequenceRowValues: any;
  _UnknownType: any;
};

/** #Access */
export type Access = {
  __typename?: 'Access';
  _type?: Maybe<_InstanceType>;
  externalId: Scalars['ID'];
  /** #role */
  role: Scalars['String'];
  space: Scalars['String'];
  /** #tenant */
  tenant: Scalars['String'];
  /** #userId */
  userId: Scalars['String'];
};

/** #ConsistencyCollection */
export type ConsistencyCollection = {
  __typename?: 'ConsistencyCollection';
  _type?: Maybe<_InstanceType>;
  /** #createdAt */
  createdAt?: Maybe<Scalars['Timestamp']>;
  /** #description */
  description?: Maybe<Scalars['String']>;
  externalId: Scalars['ID'];
  /** #labels */
  labels?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** #name */
  name: Scalars['String'];
  /** #project */
  project?: Maybe<DigitalTwin>;
  /** #projectId */
  projectId: Scalars['String'];
  /** #reportTemplate */
  reportTemplate?: Maybe<Scalars['String']>;
  /** #rules */
  rules?: Maybe<_ConsistencyRuleConnection>;
  /** #schemaFilters */
  schemaFilters?: Maybe<_ConsistencySchemaFilterConnection>;
  space: Scalars['String'];
  /** #tenant */
  tenant: Scalars['String'];
};

/** #ConsistencyCollection */
export type ConsistencyCollectionRulesArgs = {
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<_ListConsistencyRuleFilter>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<_ConsistencyRuleSort>>;
};

/** #ConsistencyCollection */
export type ConsistencyCollectionSchemaFiltersArgs = {
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<_ListConsistencySchemaFilterFilter>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<_ConsistencySchemaFilterSort>>;
};

/** #ConsistencyConditionCheck */
export type ConsistencyConditionCheck = {
  __typename?: 'ConsistencyConditionCheck';
  _type?: Maybe<_InstanceType>;
  externalId: Scalars['ID'];
  /** #isLiteralValue */
  isLiteralValue?: Maybe<Scalars['Boolean']>;
  /** #operator */
  operator: Scalars['String'];
  /** #rule */
  rule?: Maybe<ConsistencyRule>;
  /** #sourceAttribute */
  sourceAttribute: Scalars['String'];
  space: Scalars['String'];
  /** #targetAttribute */
  targetAttribute: Scalars['String'];
  /** #useTargetSchema */
  useTargetSchema?: Maybe<Scalars['Boolean']>;
};

/** #ConsistencyRule */
export type ConsistencyRule = {
  __typename?: 'ConsistencyRule';
  _type?: Maybe<_InstanceType>;
  /** #collection */
  collection?: Maybe<ConsistencyCollection>;
  /** #conditionChecks */
  conditionChecks?: Maybe<_ConsistencyConditionCheckConnection>;
  /** #conditionChecksOnly */
  conditionChecksOnly?: Maybe<Scalars['Boolean']>;
  /** #customerDefinedId */
  customerDefinedId?: Maybe<Scalars['String']>;
  /** #description */
  description?: Maybe<Scalars['String']>;
  /** #errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  externalId: Scalars['ID'];
  /** #name */
  name: Scalars['String'];
  /** #operator */
  operator: Scalars['String'];
  /** #projectId */
  projectId: Scalars['String'];
  /** #runStatuses */
  runStatuses?: Maybe<_ConsistencyRunStatusConnection>;
  /** #severity */
  severity?: Maybe<Scalars['String']>;
  /** #sourceAttribute */
  sourceAttribute: Scalars['String'];
  /** #sourceFilters */
  sourceFilters?: Maybe<Scalars['String']>;
  /** #sourceSchemaFilter */
  sourceSchemaFilter?: Maybe<ConsistencySchemaFilter>;
  space: Scalars['String'];
  /** #tags */
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** #targetAttribute */
  targetAttribute: Scalars['String'];
  /** #targetFilters */
  targetFilters?: Maybe<Scalars['String']>;
  /** #targetSchemaFilter */
  targetSchemaFilter?: Maybe<ConsistencySchemaFilter>;
};

/** #ConsistencyRule */
export type ConsistencyRuleConditionChecksArgs = {
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<_ListConsistencyConditionCheckFilter>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<_ConsistencyConditionCheckSort>>;
};

/** #ConsistencyRule */
export type ConsistencyRuleRunStatusesArgs = {
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<_ListConsistencyRunStatusFilter>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<_ConsistencyRunStatusSort>>;
};

/** #ConsistencyRunStatus */
export type ConsistencyRunStatus = {
  __typename?: 'ConsistencyRunStatus';
  _type?: Maybe<_InstanceType>;
  /** #attributes */
  attributes?: Maybe<Array<Maybe<Scalars['String']>>>;
  externalId: Scalars['ID'];
  /** #failedInstances */
  failedInstances?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** #message */
  message?: Maybe<Scalars['String']>;
  /** #reportId */
  reportId?: Maybe<Scalars['String']>;
  /** #rule */
  rule?: Maybe<ConsistencyRule>;
  /** #runAt */
  runAt?: Maybe<Scalars['Timestamp']>;
  space: Scalars['String'];
  /** #status */
  status: Scalars['String'];
  /** #totalFailed */
  totalFailed?: Maybe<Scalars['Int32']>;
  /** #totalValid */
  totalValid?: Maybe<Scalars['Int32']>;
};

/** #ConsistencySchemaFilter */
export type ConsistencySchemaFilter = {
  __typename?: 'ConsistencySchemaFilter';
  _type?: Maybe<_InstanceType>;
  /** #collection */
  collection?: Maybe<ConsistencyCollection>;
  /** #description */
  description?: Maybe<Scalars['String']>;
  externalId: Scalars['ID'];
  /** #filters */
  filters?: Maybe<Scalars['String']>;
  /** #labels */
  labels?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** #name */
  name: Scalars['String'];
  /** #projectId */
  projectId: Scalars['String'];
  /** #schemaCollectionId */
  schemaCollectionId: Scalars['String'];
  /** #schemaType */
  schemaType: Scalars['String'];
  /** #sourceForRules */
  sourceForRules?: Maybe<_ConsistencyRuleConnection>;
  space: Scalars['String'];
  /** #targetForRules */
  targetForRules?: Maybe<_ConsistencyRuleConnection>;
};

/** #ConsistencySchemaFilter */
export type ConsistencySchemaFilterSourceForRulesArgs = {
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<_ListConsistencyRuleFilter>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<_ConsistencyRuleSort>>;
};

/** #ConsistencySchemaFilter */
export type ConsistencySchemaFilterTargetForRulesArgs = {
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<_ListConsistencyRuleFilter>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<_ConsistencyRuleSort>>;
};

export type DataPoint = {
  __typename?: 'DataPoint';
  average?: Maybe<Scalars['Float64']>;
  continuousVariance?: Maybe<Scalars['Float64']>;
  count?: Maybe<Scalars['Int32']>;
  discreteVariance?: Maybe<Scalars['Float64']>;
  interpolation?: Maybe<Scalars['Float64']>;
  max?: Maybe<Scalars['Float64']>;
  min?: Maybe<Scalars['Float64']>;
  stepInterpolation?: Maybe<Scalars['Float64']>;
  sum?: Maybe<Scalars['Float64']>;
  timestamp?: Maybe<Scalars['Timestamp']>;
  totalVariation?: Maybe<Scalars['Float64']>;
  value?: Maybe<Scalars['DataPointValue']>;
};

/** #DigitalTwin */
export type DigitalTwin = {
  __typename?: 'DigitalTwin';
  _type?: Maybe<_InstanceType>;
  /** #consistencyCollections */
  consistencyCollections?: Maybe<_ConsistencyCollectionConnection>;
  externalId: Scalars['ID'];
  /** #name */
  name: Scalars['String'];
  /** #schemaCollections */
  schemaCollections?: Maybe<_SchemaCollectionConnection>;
  space: Scalars['String'];
  /** #tenant */
  tenant: Scalars['String'];
};

/** #DigitalTwin */
export type DigitalTwinConsistencyCollectionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<_ListConsistencyCollectionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<_ConsistencyCollectionSort>>;
};

/** #DigitalTwin */
export type DigitalTwinSchemaCollectionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<_ListSchemaCollectionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<_SchemaCollectionSort>>;
};

export type Error = {
  __typename?: 'Error';
  hint?: Maybe<Scalars['String']>;
  kind: ErrorKind;
  location: SourceLocationRange;
  message: Scalars['String'];
};

export enum ErrorKind {
  CompileError = 'COMPILE_ERROR',
  DiffError = 'DIFF_ERROR',
}

export type File = {
  __typename?: 'File';
  assetIds?: Maybe<Array<Maybe<Scalars['Int64']>>>;
  dataSetId?: Maybe<Scalars['Int64']>;
  directory?: Maybe<Scalars['String']>;
  downloadLink?: Maybe<_DownloadLink>;
  externalId?: Maybe<Scalars['String']>;
  geoLocation?: Maybe<_GeoLocation>;
  id?: Maybe<Scalars['Int64']>;
  labels?: Maybe<Array<Maybe<Scalars['String']>>>;
  metadata?: Maybe<Scalars['JSONObject']>;
  mimeType?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  securityCategories?: Maybe<Array<Maybe<Scalars['Int64']>>>;
  source?: Maybe<Scalars['String']>;
  sourceCreatedTime?: Maybe<Scalars['Timestamp']>;
  sourceModifiedTime?: Maybe<Scalars['Timestamp']>;
  uploaded?: Maybe<Scalars['Boolean']>;
  uploadedTime?: Maybe<Scalars['Timestamp']>;
};

export type FileDownloadLinkArgs = {
  extendedExpiration?: InputMaybe<Scalars['Boolean']>;
};

export type GraphQlDmlVersion = {
  __typename?: 'GraphQlDmlVersion';
  createdTime: Scalars['Timestamp'];
  description?: Maybe<Scalars['String']>;
  externalId: Scalars['String'];
  graphQlDml?: Maybe<Scalars['String']>;
  lastUpdatedTime: Scalars['Timestamp'];
  name?: Maybe<Scalars['String']>;
  space: Scalars['String'];
  version: Scalars['String'];
  views: Array<ViewRef>;
};

export type GraphQlDmlVersionConnection = {
  __typename?: 'GraphQlDmlVersionConnection';
  edges: Array<Maybe<GraphQlDmlVersionEdge>>;
  items: Array<Maybe<GraphQlDmlVersion>>;
  pageInfo: PageInfo;
};

export type GraphQlDmlVersionEdge = {
  __typename?: 'GraphQlDmlVersionEdge';
  cursor: Scalars['String'];
  node: GraphQlDmlVersion;
};

export type GraphQlDmlVersionFilter = {
  externalId?: InputMaybe<StringFilter>;
  space?: InputMaybe<StringFilter>;
};

export type GraphQlDmlVersionSort = {
  createdTime?: InputMaybe<SortOrder>;
};

export type GraphQlDmlVersionUpsert = {
  description?: InputMaybe<Scalars['String']>;
  externalId: Scalars['String'];
  graphQlDml?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  /**  Whether or not to store the DML schema string in DMS */
  preserveDml?: InputMaybe<Scalars['Boolean']>;
  /** Set this to the previous version of the data model */
  previousVersion?: InputMaybe<Scalars['String']>;
  space: Scalars['String'];
  version: Scalars['String'];
};

export type InstanceRef = {
  externalId: Scalars['String'];
  space: Scalars['String'];
};

/** #Milestone */
export type Milestone = {
  __typename?: 'Milestone';
  _type?: Maybe<_InstanceType>;
  /** #description */
  description?: Maybe<Scalars['String']>;
  /** #endActiveTime */
  endActiveTime?: Maybe<Scalars['Timestamp']>;
  /** #endScheduleTime */
  endScheduleTime?: Maybe<Scalars['Timestamp']>;
  externalId: Scalars['ID'];
  /** #milestoneType */
  milestoneType?: Maybe<Scalars['String']>;
  /** #name */
  name: Scalars['String'];
  /** #orderIndex */
  orderIndex?: Maybe<Scalars['Int32']>;
  /** #projectId */
  projectId?: Maybe<Scalars['String']>;
  /** #reportTemplate */
  reportTemplate?: Maybe<Scalars['String']>;
  /** #rules */
  rules?: Maybe<_RuleConnection>;
  /** #rulesets */
  rulesets?: Maybe<_RulesetConnection>;
  /** #schedule */
  schedule?: Maybe<Scalars['String']>;
  /** #schemaCollection */
  schemaCollection?: Maybe<SchemaCollection>;
  space: Scalars['String'];
  /** #startActiveTime */
  startActiveTime?: Maybe<Scalars['Timestamp']>;
  /** #startScheduleTime */
  startScheduleTime?: Maybe<Scalars['Timestamp']>;
};

/** #Milestone */
export type MilestoneRulesArgs = {
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<_ListRuleFilter>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<_RuleSort>>;
};

/** #Milestone */
export type MilestoneRulesetsArgs = {
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<_ListRulesetFilter>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<_RulesetSort>>;
};

export enum MilestoneType {
  Default = 'DEFAULT',
  Static = 'STATIC',
}

export type Mutation = {
  __typename?: 'Mutation';
  AddSchemaCollectionProject?: Maybe<_TempReturn>;
  Add_ConsistencyCollection_rules?: Maybe<_TempReturn>;
  Add_ConsistencyCollection_schemaFilters?: Maybe<_TempReturn>;
  Add_ConsistencyRule_conditionChecks?: Maybe<_TempReturn>;
  Add_ConsistencyRule_runStatuses?: Maybe<_TempReturn>;
  Add_DigitalTwin_consistencyCollections?: Maybe<_TempReturn>;
  Add_DigitalTwin_schemaCollections?: Maybe<DigitalTwin>;
  Add_Milestone_rules?: Maybe<_TempReturn>;
  Add_Milestone_rulesets?: Maybe<_TempReturn>;
  Add_Rule_milestones?: Maybe<_TempReturn>;
  Add_Rule_ruleRunStatus?: Maybe<_TempReturn>;
  Add_Rule_rulesets?: Maybe<_TempReturn>;
  Add_Ruleset_milestones?: Maybe<_TempReturn>;
  Add_Ruleset_rules?: Maybe<_TempReturn>;
  Add_SchemaCollection_milestones?: Maybe<_TempReturn>;
  Add_SchemaCollection_rules?: Maybe<_TempReturn>;
  Add_SchemaCollection_rulesets?: Maybe<_TempReturn>;
  Create_Access?: Maybe<Access>;
  Create_ConsistencyCollection?: Maybe<ConsistencyCollection>;
  Create_ConsistencyConditionCheck?: Maybe<ConsistencyConditionCheck>;
  Create_ConsistencyRule?: Maybe<ConsistencyRule>;
  Create_ConsistencyRunStatus?: Maybe<ConsistencyRunStatus>;
  Create_ConsistencySchemaFilter?: Maybe<ConsistencySchemaFilter>;
  Create_DigitalTwin?: Maybe<DigitalTwin>;
  Create_Milestone?: Maybe<Milestone>;
  Create_Rule?: Maybe<Rule>;
  Create_RuleRunStatus?: Maybe<RuleRunStatus>;
  Create_Ruleset?: Maybe<Ruleset>;
  Create_SchemaCollection?: Maybe<SchemaCollection>;
  Delete_Access?: Maybe<Access>;
  Delete_ConsistencyCollection?: Maybe<ConsistencyCollection>;
  Delete_ConsistencyConditionCheck?: Maybe<ConsistencyConditionCheck>;
  Delete_ConsistencyRule?: Maybe<ConsistencyRule>;
  Delete_ConsistencyRunStatus?: Maybe<ConsistencyRunStatus>;
  Delete_ConsistencySchemaFilter?: Maybe<ConsistencySchemaFilter>;
  Delete_DigitalTwin?: Maybe<DigitalTwin>;
  Delete_Milestone?: Maybe<Milestone>;
  Delete_Rule?: Maybe<Rule>;
  Delete_RuleRunStatus?: Maybe<RuleRunStatus>;
  Delete_Ruleset?: Maybe<Ruleset>;
  Delete_SchemaCollection?: Maybe<SchemaCollection>;
  RemoveSchemaCollectionProject?: Maybe<_TempReturn>;
  Remove_ConsistencyCollection_rules?: Maybe<_TempReturn>;
  Remove_ConsistencyCollection_schemaFilters?: Maybe<_TempReturn>;
  Remove_ConsistencyRule_conditionChecks?: Maybe<_TempReturn>;
  Remove_ConsistencyRule_runStatuses?: Maybe<_TempReturn>;
  Remove_DigitalTwin_consistencyCollections?: Maybe<_TempReturn>;
  Remove_DigitalTwin_schemaCollections?: Maybe<_TempReturn>;
  Remove_Milestone_rules?: Maybe<_TempReturn>;
  Remove_Milestone_rulesets?: Maybe<_TempReturn>;
  Remove_Rule_milestones?: Maybe<_TempReturn>;
  Remove_Rule_ruleRunStatus?: Maybe<_TempReturn>;
  Remove_Rule_rulesets?: Maybe<_TempReturn>;
  Remove_Ruleset_milestones?: Maybe<_TempReturn>;
  Remove_Ruleset_rules?: Maybe<_TempReturn>;
  Remove_SchemaCollection_milestones?: Maybe<_TempReturn>;
  Remove_SchemaCollection_rules?: Maybe<_TempReturn>;
  Remove_SchemaCollection_rulesets?: Maybe<_TempReturn>;
  Update_Access?: Maybe<Access>;
  Update_ConsistencyCollection?: Maybe<ConsistencyCollection>;
  Update_ConsistencyConditionCheck?: Maybe<ConsistencyConditionCheck>;
  Update_ConsistencyRule?: Maybe<ConsistencyRule>;
  Update_ConsistencyRunStatus?: Maybe<ConsistencyRunStatus>;
  Update_ConsistencySchemaFilter?: Maybe<ConsistencySchemaFilter>;
  Update_DigitalTwin?: Maybe<DigitalTwin>;
  Update_Milestone?: Maybe<Milestone>;
  Update_Rule?: Maybe<Rule>;
  Update_RuleRunStatus?: Maybe<RuleRunStatus>;
  Update_Ruleset?: Maybe<Ruleset>;
  Update_SchemaCollection?: Maybe<SchemaCollection>;
};

export type MutationAddSchemaCollectionProjectArgs = {
  endNode: Scalars['ID'];
  startNode: Scalars['ID'];
};

export type MutationAdd_ConsistencyCollection_RulesArgs = {
  endNode: Scalars['ID'];
  startNode: Scalars['ID'];
};

export type MutationAdd_ConsistencyCollection_SchemaFiltersArgs = {
  endNode: Scalars['ID'];
  startNode: Scalars['ID'];
};

export type MutationAdd_ConsistencyRule_ConditionChecksArgs = {
  endNode: Scalars['ID'];
  startNode: Scalars['ID'];
};

export type MutationAdd_ConsistencyRule_RunStatusesArgs = {
  endNode: Scalars['ID'];
  startNode: Scalars['ID'];
};

export type MutationAdd_DigitalTwin_ConsistencyCollectionsArgs = {
  endNode: Scalars['ID'];
  startNode: Scalars['ID'];
};

export type MutationAdd_DigitalTwin_SchemaCollectionsArgs = {
  endNode: Scalars['ID'];
  startNode: Scalars['ID'];
};

export type MutationAdd_Milestone_RulesArgs = {
  endNode: Scalars['ID'];
  startNode: Scalars['ID'];
};

export type MutationAdd_Milestone_RulesetsArgs = {
  endNode: Scalars['ID'];
  startNode: Scalars['ID'];
};

export type MutationAdd_Rule_MilestonesArgs = {
  endNode: Scalars['ID'];
  startNode: Scalars['ID'];
};

export type MutationAdd_Rule_RuleRunStatusArgs = {
  endNode: Scalars['ID'];
  startNode: Scalars['ID'];
};

export type MutationAdd_Rule_RulesetsArgs = {
  endNode: Scalars['ID'];
  startNode: Scalars['ID'];
};

export type MutationAdd_Ruleset_MilestonesArgs = {
  endNode: Scalars['ID'];
  startNode: Scalars['ID'];
};

export type MutationAdd_Ruleset_RulesArgs = {
  endNode: Scalars['ID'];
  startNode: Scalars['ID'];
};

export type MutationAdd_SchemaCollection_MilestonesArgs = {
  endNode: Scalars['ID'];
  startNode: Scalars['ID'];
};

export type MutationAdd_SchemaCollection_RulesArgs = {
  endNode: Scalars['ID'];
  startNode: Scalars['ID'];
};

export type MutationAdd_SchemaCollection_RulesetsArgs = {
  endNode: Scalars['ID'];
  startNode: Scalars['ID'];
};

export type MutationCreate_AccessArgs = {
  id?: InputMaybe<Scalars['ID']>;
  role: Scalars['String'];
  tenant: Scalars['String'];
  userId: Scalars['String'];
};

export type MutationCreate_ConsistencyCollectionArgs = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  labels?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name: Scalars['String'];
  project: _DirectRelationInput;
  projectId?: InputMaybe<Scalars['String']>;
  tenant: Scalars['String'];
};

export type MutationCreate_ConsistencyConditionCheckArgs = {
  id: Scalars['ID'];
  isLiteralValue?: InputMaybe<Scalars['Boolean']>;
  operator: Scalars['String'];
  rule: _DirectRelationInput;
  sourceAttribute: Scalars['String'];
  targetAttribute: Scalars['String'];
  useTargetSchema?: InputMaybe<Scalars['Boolean']>;
};

export type MutationCreate_ConsistencyRuleArgs = {
  collection: _DirectRelationInput;
  conditionChecksOnly?: InputMaybe<Scalars['Boolean']>;
  customerDefinedId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  operator: Scalars['String'];
  projectId?: InputMaybe<Scalars['String']>;
  severity?: InputMaybe<Scalars['String']>;
  sourceAttribute: Scalars['String'];
  sourceFilters?: InputMaybe<Scalars['String']>;
  sourceSchemaFilter: _DirectRelationInput;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  targetAttribute: Scalars['String'];
  targetFilters?: InputMaybe<Scalars['String']>;
  targetSchemaFilter: _DirectRelationInput;
};

export type MutationCreate_ConsistencyRunStatusArgs = {
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  failedInstances?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id: Scalars['ID'];
  message?: InputMaybe<Scalars['String']>;
  reportId?: InputMaybe<Scalars['String']>;
  rule: _DirectRelationInput;
  runAt?: InputMaybe<Scalars['Timestamp']>;
  status: Scalars['String'];
  totalFailed?: InputMaybe<Scalars['Int']>;
  totalValid?: InputMaybe<Scalars['Int']>;
};

export type MutationCreate_ConsistencySchemaFilterArgs = {
  collection: _DirectRelationInput;
  description?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  labels?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name: Scalars['String'];
  projectId?: InputMaybe<Scalars['String']>;
  schemaCollectionId: Scalars['String'];
  schemaType: Scalars['String'];
};

export type MutationCreate_DigitalTwinArgs = {
  id?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  tenant: Scalars['String'];
};

export type MutationCreate_MilestoneArgs = {
  description?: InputMaybe<Scalars['String']>;
  endActiveTime?: InputMaybe<Scalars['Timestamp']>;
  endScheduleTime?: InputMaybe<Scalars['Timestamp']>;
  id?: InputMaybe<Scalars['ID']>;
  milestoneType?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  orderIndex?: InputMaybe<Scalars['Int']>;
  projectId?: InputMaybe<Scalars['ID']>;
  schedule?: InputMaybe<Scalars['String']>;
  schemaCollection: _DirectRelationInput;
  startActiveTime?: InputMaybe<Scalars['Timestamp']>;
  startScheduleTime?: InputMaybe<Scalars['Timestamp']>;
};

export type MutationCreate_RuleArgs = {
  advanceRules?: InputMaybe<Scalars['String']>;
  customerDefinedId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  invertedRules?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  primaryKeyName?: InputMaybe<Scalars['String']>;
  projectId?: InputMaybe<Scalars['ID']>;
  rules?: InputMaybe<Scalars['String']>;
  schemaCollection: _DirectRelationInput;
  schemaType?: InputMaybe<Scalars['String']>;
  severity?: InputMaybe<Scalars['String']>;
  simpleInvertedRules?: InputMaybe<Scalars['String']>;
  simpleRules?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MutationCreate_RuleRunStatusArgs = {
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  failedInstances?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  filteredInstances?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['ID']>;
  isFilterResult?: InputMaybe<Scalars['Boolean']>;
  message?: InputMaybe<Scalars['String']>;
  reportId?: InputMaybe<Scalars['String']>;
  rule: _DirectRelationInput;
  runAt?: InputMaybe<Scalars['Timestamp']>;
  status: Scalars['String'];
  totalFailed?: InputMaybe<Scalars['Int']>;
  totalValid?: InputMaybe<Scalars['Int']>;
};

export type MutationCreate_RulesetArgs = {
  description?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  labels?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name: Scalars['String'];
  projectId: Scalars['ID'];
  schemaType?: InputMaybe<Scalars['String']>;
};

export type MutationCreate_SchemaCollectionArgs = {
  description?: InputMaybe<Scalars['String']>;
  graphQLSchemaString?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  project: _DirectRelationInput;
  refId?: InputMaybe<Scalars['ID']>;
  refVersion?: InputMaybe<Scalars['Int']>;
  tenant: Scalars['String'];
};

export type MutationDelete_AccessArgs = {
  id: Scalars['ID'];
};

export type MutationDelete_ConsistencyCollectionArgs = {
  id: Scalars['ID'];
};

export type MutationDelete_ConsistencyConditionCheckArgs = {
  id: Scalars['ID'];
};

export type MutationDelete_ConsistencyRuleArgs = {
  id: Scalars['ID'];
};

export type MutationDelete_ConsistencyRunStatusArgs = {
  id: Scalars['ID'];
};

export type MutationDelete_ConsistencySchemaFilterArgs = {
  id: Scalars['ID'];
};

export type MutationDelete_DigitalTwinArgs = {
  id: Scalars['ID'];
};

export type MutationDelete_MilestoneArgs = {
  id: Scalars['ID'];
};

export type MutationDelete_RuleArgs = {
  id: Scalars['ID'];
};

export type MutationDelete_RuleRunStatusArgs = {
  id: Scalars['ID'];
};

export type MutationDelete_RulesetArgs = {
  id: Scalars['ID'];
};

export type MutationDelete_SchemaCollectionArgs = {
  id: Scalars['ID'];
};

export type MutationRemoveSchemaCollectionProjectArgs = {
  endNode: Scalars['ID'];
  startNode: Scalars['ID'];
};

export type MutationRemove_ConsistencyCollection_RulesArgs = {
  endNode: Scalars['ID'];
  startNode: Scalars['ID'];
};

export type MutationRemove_ConsistencyCollection_SchemaFiltersArgs = {
  endNode: Scalars['ID'];
  startNode: Scalars['ID'];
};

export type MutationRemove_ConsistencyRule_ConditionChecksArgs = {
  endNode: Scalars['ID'];
  startNode: Scalars['ID'];
};

export type MutationRemove_ConsistencyRule_RunStatusesArgs = {
  endNode: Scalars['ID'];
  startNode: Scalars['ID'];
};

export type MutationRemove_DigitalTwin_ConsistencyCollectionsArgs = {
  endNode: Scalars['ID'];
  startNode: Scalars['ID'];
};

export type MutationRemove_DigitalTwin_SchemaCollectionsArgs = {
  endNode: Scalars['ID'];
  startNode: Scalars['ID'];
};

export type MutationRemove_Milestone_RulesArgs = {
  endNode: Scalars['ID'];
  startNode: Scalars['ID'];
};

export type MutationRemove_Milestone_RulesetsArgs = {
  endNode: Scalars['ID'];
  startNode: Scalars['ID'];
};

export type MutationRemove_Rule_MilestonesArgs = {
  endNode: Scalars['ID'];
  startNode: Scalars['ID'];
};

export type MutationRemove_Rule_RuleRunStatusArgs = {
  endNode: Scalars['ID'];
  startNode: Scalars['ID'];
};

export type MutationRemove_Rule_RulesetsArgs = {
  endNode: Scalars['ID'];
  startNode: Scalars['ID'];
};

export type MutationRemove_Ruleset_MilestonesArgs = {
  endNode: Scalars['ID'];
  startNode: Scalars['ID'];
};

export type MutationRemove_Ruleset_RulesArgs = {
  endNode: Scalars['ID'];
  startNode: Scalars['ID'];
};

export type MutationRemove_SchemaCollection_MilestonesArgs = {
  endNode: Scalars['ID'];
  startNode: Scalars['ID'];
};

export type MutationRemove_SchemaCollection_RulesArgs = {
  endNode: Scalars['ID'];
  startNode: Scalars['ID'];
};

export type MutationRemove_SchemaCollection_RulesetsArgs = {
  endNode: Scalars['ID'];
  startNode: Scalars['ID'];
};

export type MutationUpdate_AccessArgs = {
  id: Scalars['ID'];
  role?: InputMaybe<Scalars['String']>;
  tenant?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type MutationUpdate_ConsistencyCollectionArgs = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  labels?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  reportTemplate?: InputMaybe<Scalars['String']>;
};

export type MutationUpdate_ConsistencyConditionCheckArgs = {
  id: Scalars['ID'];
  isLiteralValue?: InputMaybe<Scalars['Boolean']>;
  operator?: InputMaybe<Scalars['String']>;
  sourceAttribute?: InputMaybe<Scalars['String']>;
  targetAttribute?: InputMaybe<Scalars['String']>;
  useTargetSchema?: InputMaybe<Scalars['Boolean']>;
};

export type MutationUpdate_ConsistencyRuleArgs = {
  conditionChecksOnly?: InputMaybe<Scalars['Boolean']>;
  customerDefinedId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  operator?: InputMaybe<Scalars['String']>;
  severity?: InputMaybe<Scalars['String']>;
  sourceAttribute?: InputMaybe<Scalars['String']>;
  sourceFilters?: InputMaybe<Scalars['String']>;
  sourceSchemaFilter?: InputMaybe<_DirectRelationInput>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  targetAttribute?: InputMaybe<Scalars['String']>;
  targetFilters?: InputMaybe<Scalars['String']>;
  targetSchemaFilter?: InputMaybe<_DirectRelationInput>;
};

export type MutationUpdate_ConsistencyRunStatusArgs = {
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  failedInstances?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id: Scalars['ID'];
  message?: InputMaybe<Scalars['String']>;
  reportId?: InputMaybe<Scalars['String']>;
  runAt?: InputMaybe<Scalars['Timestamp']>;
  status?: InputMaybe<Scalars['String']>;
  totalFailed?: InputMaybe<Scalars['Int']>;
  totalValid?: InputMaybe<Scalars['Int']>;
};

export type MutationUpdate_ConsistencySchemaFilterArgs = {
  description?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  labels?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  schemaCollectionId?: InputMaybe<Scalars['String']>;
  schemaType?: InputMaybe<Scalars['String']>;
};

export type MutationUpdate_DigitalTwinArgs = {
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  tenant?: InputMaybe<Scalars['String']>;
};

export type MutationUpdate_MilestoneArgs = {
  description?: InputMaybe<Scalars['String']>;
  endActiveTime?: InputMaybe<Scalars['Timestamp']>;
  endScheduleTime?: InputMaybe<Scalars['Timestamp']>;
  id: Scalars['ID'];
  milestoneType?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  orderIndex?: InputMaybe<Scalars['Int']>;
  projectId?: InputMaybe<Scalars['String']>;
  reportTemplate?: InputMaybe<Scalars['String']>;
  schedule?: InputMaybe<Scalars['String']>;
  startActiveTime?: InputMaybe<Scalars['Timestamp']>;
  startScheduleTime?: InputMaybe<Scalars['Timestamp']>;
};

export type MutationUpdate_RuleArgs = {
  advanceRules?: InputMaybe<Scalars['String']>;
  customerDefinedId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  invertedRules?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  primaryKeyName?: InputMaybe<Scalars['String']>;
  projectId?: InputMaybe<Scalars['String']>;
  rules?: InputMaybe<Scalars['String']>;
  schemaType?: InputMaybe<Scalars['String']>;
  severity?: InputMaybe<Scalars['String']>;
  simpleInvertedRules?: InputMaybe<Scalars['String']>;
  simpleRules?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MutationUpdate_RuleRunStatusArgs = {
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  failedInstances?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  filteredInstances?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id: Scalars['ID'];
  isFilterResult?: InputMaybe<Scalars['Boolean']>;
  message?: InputMaybe<Scalars['String']>;
  reportId?: InputMaybe<Scalars['String']>;
  runAt?: InputMaybe<Scalars['Timestamp']>;
  status?: InputMaybe<Scalars['String']>;
  totalFailed?: InputMaybe<Scalars['Int']>;
  totalValid?: InputMaybe<Scalars['Int']>;
};

export type MutationUpdate_RulesetArgs = {
  description?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  labels?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  projectId?: InputMaybe<Scalars['String']>;
  schemaType?: InputMaybe<Scalars['String']>;
};

export type MutationUpdate_SchemaCollectionArgs = {
  description?: InputMaybe<Scalars['String']>;
  graphQLSchemaString?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  refId?: InputMaybe<Scalars['String']>;
  tenant?: InputMaybe<Scalars['String']>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  /** This query can help find aggregation for ___Access___ type */
  aggregateAccess?: Maybe<_AccessAggregateConnection>;
  /** This query can help find aggregation for ___ConsistencyCollection___ type */
  aggregateConsistencyCollection?: Maybe<_ConsistencyCollectionAggregateConnection>;
  /** This query can help find aggregation for ___ConsistencyConditionCheck___ type */
  aggregateConsistencyConditionCheck?: Maybe<_ConsistencyConditionCheckAggregateConnection>;
  /** This query can help find aggregation for ___ConsistencyRule___ type */
  aggregateConsistencyRule?: Maybe<_ConsistencyRuleAggregateConnection>;
  /** This query can help find aggregation for ___ConsistencyRunStatus___ type */
  aggregateConsistencyRunStatus?: Maybe<_ConsistencyRunStatusAggregateConnection>;
  /** This query can help find aggregation for ___ConsistencySchemaFilter___ type */
  aggregateConsistencySchemaFilter?: Maybe<_ConsistencySchemaFilterAggregateConnection>;
  /** This query can help find aggregation for ___DigitalTwin___ type */
  aggregateDigitalTwin?: Maybe<_DigitalTwinAggregateConnection>;
  /** This query can help find aggregation for ___Milestone___ type */
  aggregateMilestone?: Maybe<_MilestoneAggregateConnection>;
  /** This query can help find aggregation for ___Rule___ type */
  aggregateRule?: Maybe<_RuleAggregateConnection>;
  /** This query can help find aggregation for ___RuleRunStatus___ type */
  aggregateRuleRunStatus?: Maybe<_RuleRunStatusAggregateConnection>;
  /** This query can help find aggregation for ___Ruleset___ type */
  aggregateRuleset?: Maybe<_RulesetAggregateConnection>;
  /** This query can help find aggregation for ___SchemaCollection___ type */
  aggregateSchemaCollection?: Maybe<_SchemaCollectionAggregateConnection>;
  getAccessById?: Maybe<_AccessConnection>;
  getConsistencyCollectionById?: Maybe<_ConsistencyCollectionConnection>;
  getConsistencyConditionCheckById?: Maybe<_ConsistencyConditionCheckConnection>;
  getConsistencyRuleById?: Maybe<_ConsistencyRuleConnection>;
  getConsistencyRunStatusById?: Maybe<_ConsistencyRunStatusConnection>;
  getConsistencySchemaFilterById?: Maybe<_ConsistencySchemaFilterConnection>;
  getDigitalTwinById?: Maybe<_DigitalTwinConnection>;
  getMilestoneById?: Maybe<_MilestoneConnection>;
  getRuleById?: Maybe<_RuleConnection>;
  getRuleRunStatusById?: Maybe<_RuleRunStatusConnection>;
  getRulesetById?: Maybe<_RulesetConnection>;
  getSchemaCollectionById?: Maybe<_SchemaCollectionConnection>;
  graphQlDmlVersionsById?: Maybe<GraphQlDmlVersionConnection>;
  listAccess?: Maybe<_AccessConnection>;
  listConsistencyCollection?: Maybe<_ConsistencyCollectionConnection>;
  listConsistencyConditionCheck?: Maybe<_ConsistencyConditionCheckConnection>;
  listConsistencyRule?: Maybe<_ConsistencyRuleConnection>;
  listConsistencyRunStatus?: Maybe<_ConsistencyRunStatusConnection>;
  listConsistencySchemaFilter?: Maybe<_ConsistencySchemaFilterConnection>;
  listDigitalTwin?: Maybe<_DigitalTwinConnection>;
  /** 'limit' and 'cursor' is deprecated and will be removed soon */
  listGraphQlDmlVersions?: Maybe<GraphQlDmlVersionConnection>;
  listMilestone?: Maybe<_MilestoneConnection>;
  listRule?: Maybe<_RuleConnection>;
  listRuleRunStatus?: Maybe<_RuleRunStatusConnection>;
  listRuleset?: Maybe<_RulesetConnection>;
  listSchemaCollection?: Maybe<_SchemaCollectionConnection>;
  searchAccess?: Maybe<_AccessConnection>;
  searchConsistencyCollection?: Maybe<_ConsistencyCollectionConnection>;
  searchConsistencyConditionCheck?: Maybe<_ConsistencyConditionCheckConnection>;
  searchConsistencyRule?: Maybe<_ConsistencyRuleConnection>;
  searchConsistencyRunStatus?: Maybe<_ConsistencyRunStatusConnection>;
  searchConsistencySchemaFilter?: Maybe<_ConsistencySchemaFilterConnection>;
  searchDigitalTwin?: Maybe<_DigitalTwinConnection>;
  searchMilestone?: Maybe<_MilestoneConnection>;
  searchRule?: Maybe<_RuleConnection>;
  searchRuleRunStatus?: Maybe<_RuleRunStatusConnection>;
  searchRuleset?: Maybe<_RulesetConnection>;
  searchSchemaCollection?: Maybe<_SchemaCollectionConnection>;
  unsafelyWipeAndRegenerateDmlBasedOnDataModel?: Maybe<GraphQlDmlVersionConnection>;
};

export type QueryAggregateAccessArgs = {
  after?: InputMaybe<Scalars['String']>;
  fields?: InputMaybe<Array<_SearchAccessFields>>;
  filter?: InputMaybe<_SearchAccessFilter>;
  groupBy?: InputMaybe<Array<_SearchAccessFields>>;
  operator?: InputMaybe<_SearchOperatorEnum>;
  query?: InputMaybe<Scalars['String']>;
};

export type QueryAggregateConsistencyCollectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  fields?: InputMaybe<Array<_SearchConsistencyCollectionFields>>;
  filter?: InputMaybe<_SearchConsistencyCollectionFilter>;
  groupBy?: InputMaybe<Array<_SearchConsistencyCollectionFields>>;
  operator?: InputMaybe<_SearchOperatorEnum>;
  query?: InputMaybe<Scalars['String']>;
};

export type QueryAggregateConsistencyConditionCheckArgs = {
  after?: InputMaybe<Scalars['String']>;
  fields?: InputMaybe<Array<_SearchConsistencyConditionCheckFields>>;
  filter?: InputMaybe<_SearchConsistencyConditionCheckFilter>;
  groupBy?: InputMaybe<Array<_SearchConsistencyConditionCheckFields>>;
  operator?: InputMaybe<_SearchOperatorEnum>;
  query?: InputMaybe<Scalars['String']>;
};

export type QueryAggregateConsistencyRuleArgs = {
  after?: InputMaybe<Scalars['String']>;
  fields?: InputMaybe<Array<_SearchConsistencyRuleFields>>;
  filter?: InputMaybe<_SearchConsistencyRuleFilter>;
  groupBy?: InputMaybe<Array<_SearchConsistencyRuleFields>>;
  operator?: InputMaybe<_SearchOperatorEnum>;
  query?: InputMaybe<Scalars['String']>;
};

export type QueryAggregateConsistencyRunStatusArgs = {
  after?: InputMaybe<Scalars['String']>;
  fields?: InputMaybe<Array<_SearchConsistencyRunStatusFields>>;
  filter?: InputMaybe<_SearchConsistencyRunStatusFilter>;
  groupBy?: InputMaybe<Array<_SearchConsistencyRunStatusFields>>;
  operator?: InputMaybe<_SearchOperatorEnum>;
  query?: InputMaybe<Scalars['String']>;
};

export type QueryAggregateConsistencySchemaFilterArgs = {
  after?: InputMaybe<Scalars['String']>;
  fields?: InputMaybe<Array<_SearchConsistencySchemaFilterFields>>;
  filter?: InputMaybe<_SearchConsistencySchemaFilterFilter>;
  groupBy?: InputMaybe<Array<_SearchConsistencySchemaFilterFields>>;
  operator?: InputMaybe<_SearchOperatorEnum>;
  query?: InputMaybe<Scalars['String']>;
};

export type QueryAggregateDigitalTwinArgs = {
  after?: InputMaybe<Scalars['String']>;
  fields?: InputMaybe<Array<_SearchDigitalTwinFields>>;
  filter?: InputMaybe<_SearchDigitalTwinFilter>;
  groupBy?: InputMaybe<Array<_SearchDigitalTwinFields>>;
  operator?: InputMaybe<_SearchOperatorEnum>;
  query?: InputMaybe<Scalars['String']>;
};

export type QueryAggregateMilestoneArgs = {
  after?: InputMaybe<Scalars['String']>;
  fields?: InputMaybe<Array<_SearchMilestoneFields>>;
  filter?: InputMaybe<_SearchMilestoneFilter>;
  groupBy?: InputMaybe<Array<_SearchMilestoneFields>>;
  operator?: InputMaybe<_SearchOperatorEnum>;
  query?: InputMaybe<Scalars['String']>;
};

export type QueryAggregateRuleArgs = {
  after?: InputMaybe<Scalars['String']>;
  fields?: InputMaybe<Array<_SearchRuleFields>>;
  filter?: InputMaybe<_SearchRuleFilter>;
  groupBy?: InputMaybe<Array<_SearchRuleFields>>;
  operator?: InputMaybe<_SearchOperatorEnum>;
  query?: InputMaybe<Scalars['String']>;
};

export type QueryAggregateRuleRunStatusArgs = {
  after?: InputMaybe<Scalars['String']>;
  fields?: InputMaybe<Array<_SearchRuleRunStatusFields>>;
  filter?: InputMaybe<_SearchRuleRunStatusFilter>;
  groupBy?: InputMaybe<Array<_SearchRuleRunStatusFields>>;
  operator?: InputMaybe<_SearchOperatorEnum>;
  query?: InputMaybe<Scalars['String']>;
};

export type QueryAggregateRulesetArgs = {
  after?: InputMaybe<Scalars['String']>;
  fields?: InputMaybe<Array<_SearchRulesetFields>>;
  filter?: InputMaybe<_SearchRulesetFilter>;
  groupBy?: InputMaybe<Array<_SearchRulesetFields>>;
  operator?: InputMaybe<_SearchOperatorEnum>;
  query?: InputMaybe<Scalars['String']>;
};

export type QueryAggregateSchemaCollectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  fields?: InputMaybe<Array<_SearchSchemaCollectionFields>>;
  filter?: InputMaybe<_SearchSchemaCollectionFilter>;
  groupBy?: InputMaybe<Array<_SearchSchemaCollectionFields>>;
  operator?: InputMaybe<_SearchOperatorEnum>;
  query?: InputMaybe<Scalars['String']>;
};

export type QueryGetAccessByIdArgs = {
  instance: InstanceRef;
};

export type QueryGetConsistencyCollectionByIdArgs = {
  instance: InstanceRef;
};

export type QueryGetConsistencyConditionCheckByIdArgs = {
  instance: InstanceRef;
};

export type QueryGetConsistencyRuleByIdArgs = {
  instance: InstanceRef;
};

export type QueryGetConsistencyRunStatusByIdArgs = {
  instance: InstanceRef;
};

export type QueryGetConsistencySchemaFilterByIdArgs = {
  instance: InstanceRef;
};

export type QueryGetDigitalTwinByIdArgs = {
  instance: InstanceRef;
};

export type QueryGetMilestoneByIdArgs = {
  instance: InstanceRef;
};

export type QueryGetRuleByIdArgs = {
  instance: InstanceRef;
};

export type QueryGetRuleRunStatusByIdArgs = {
  instance: InstanceRef;
};

export type QueryGetRulesetByIdArgs = {
  instance: InstanceRef;
};

export type QueryGetSchemaCollectionByIdArgs = {
  instance: InstanceRef;
};

export type QueryGraphQlDmlVersionsByIdArgs = {
  externalId: Scalars['String'];
  space: Scalars['String'];
};

export type QueryListAccessArgs = {
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<_ListAccessFilter>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<_AccessSort>>;
};

export type QueryListConsistencyCollectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<_ListConsistencyCollectionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<_ConsistencyCollectionSort>>;
};

export type QueryListConsistencyConditionCheckArgs = {
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<_ListConsistencyConditionCheckFilter>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<_ConsistencyConditionCheckSort>>;
};

export type QueryListConsistencyRuleArgs = {
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<_ListConsistencyRuleFilter>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<_ConsistencyRuleSort>>;
};

export type QueryListConsistencyRunStatusArgs = {
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<_ListConsistencyRunStatusFilter>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<_ConsistencyRunStatusSort>>;
};

export type QueryListConsistencySchemaFilterArgs = {
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<_ListConsistencySchemaFilterFilter>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<_ConsistencySchemaFilterSort>>;
};

export type QueryListDigitalTwinArgs = {
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<_ListDigitalTwinFilter>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<_DigitalTwinSort>>;
};

export type QueryListGraphQlDmlVersionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  cursor?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  includeGlobal?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  spaces?: InputMaybe<Array<Scalars['String']>>;
};

export type QueryListMilestoneArgs = {
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<_ListMilestoneFilter>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<_MilestoneSort>>;
};

export type QueryListRuleArgs = {
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<_ListRuleFilter>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<_RuleSort>>;
};

export type QueryListRuleRunStatusArgs = {
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<_ListRuleRunStatusFilter>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<_RuleRunStatusSort>>;
};

export type QueryListRulesetArgs = {
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<_ListRulesetFilter>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<_RulesetSort>>;
};

export type QueryListSchemaCollectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<_ListSchemaCollectionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<_SchemaCollectionSort>>;
};

export type QuerySearchAccessArgs = {
  fields?: InputMaybe<Array<_SearchAccessFields>>;
  filter?: InputMaybe<_SearchAccessFilter>;
  first?: InputMaybe<Scalars['Int']>;
  operator?: InputMaybe<_SearchOperatorEnum>;
  query: Scalars['String'];
  sort?: InputMaybe<Array<_AccessSort>>;
};

export type QuerySearchConsistencyCollectionArgs = {
  fields?: InputMaybe<Array<_SearchConsistencyCollectionFields>>;
  filter?: InputMaybe<_SearchConsistencyCollectionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  operator?: InputMaybe<_SearchOperatorEnum>;
  query: Scalars['String'];
  sort?: InputMaybe<Array<_ConsistencyCollectionSort>>;
};

export type QuerySearchConsistencyConditionCheckArgs = {
  fields?: InputMaybe<Array<_SearchConsistencyConditionCheckFields>>;
  filter?: InputMaybe<_SearchConsistencyConditionCheckFilter>;
  first?: InputMaybe<Scalars['Int']>;
  operator?: InputMaybe<_SearchOperatorEnum>;
  query: Scalars['String'];
  sort?: InputMaybe<Array<_ConsistencyConditionCheckSort>>;
};

export type QuerySearchConsistencyRuleArgs = {
  fields?: InputMaybe<Array<_SearchConsistencyRuleFields>>;
  filter?: InputMaybe<_SearchConsistencyRuleFilter>;
  first?: InputMaybe<Scalars['Int']>;
  operator?: InputMaybe<_SearchOperatorEnum>;
  query: Scalars['String'];
  sort?: InputMaybe<Array<_ConsistencyRuleSort>>;
};

export type QuerySearchConsistencyRunStatusArgs = {
  fields?: InputMaybe<Array<_SearchConsistencyRunStatusFields>>;
  filter?: InputMaybe<_SearchConsistencyRunStatusFilter>;
  first?: InputMaybe<Scalars['Int']>;
  operator?: InputMaybe<_SearchOperatorEnum>;
  query: Scalars['String'];
  sort?: InputMaybe<Array<_ConsistencyRunStatusSort>>;
};

export type QuerySearchConsistencySchemaFilterArgs = {
  fields?: InputMaybe<Array<_SearchConsistencySchemaFilterFields>>;
  filter?: InputMaybe<_SearchConsistencySchemaFilterFilter>;
  first?: InputMaybe<Scalars['Int']>;
  operator?: InputMaybe<_SearchOperatorEnum>;
  query: Scalars['String'];
  sort?: InputMaybe<Array<_ConsistencySchemaFilterSort>>;
};

export type QuerySearchDigitalTwinArgs = {
  fields?: InputMaybe<Array<_SearchDigitalTwinFields>>;
  filter?: InputMaybe<_SearchDigitalTwinFilter>;
  first?: InputMaybe<Scalars['Int']>;
  operator?: InputMaybe<_SearchOperatorEnum>;
  query: Scalars['String'];
  sort?: InputMaybe<Array<_DigitalTwinSort>>;
};

export type QuerySearchMilestoneArgs = {
  fields?: InputMaybe<Array<_SearchMilestoneFields>>;
  filter?: InputMaybe<_SearchMilestoneFilter>;
  first?: InputMaybe<Scalars['Int']>;
  operator?: InputMaybe<_SearchOperatorEnum>;
  query: Scalars['String'];
  sort?: InputMaybe<Array<_MilestoneSort>>;
};

export type QuerySearchRuleArgs = {
  fields?: InputMaybe<Array<_SearchRuleFields>>;
  filter?: InputMaybe<_SearchRuleFilter>;
  first?: InputMaybe<Scalars['Int']>;
  operator?: InputMaybe<_SearchOperatorEnum>;
  query: Scalars['String'];
  sort?: InputMaybe<Array<_RuleSort>>;
};

export type QuerySearchRuleRunStatusArgs = {
  fields?: InputMaybe<Array<_SearchRuleRunStatusFields>>;
  filter?: InputMaybe<_SearchRuleRunStatusFilter>;
  first?: InputMaybe<Scalars['Int']>;
  operator?: InputMaybe<_SearchOperatorEnum>;
  query: Scalars['String'];
  sort?: InputMaybe<Array<_RuleRunStatusSort>>;
};

export type QuerySearchRulesetArgs = {
  fields?: InputMaybe<Array<_SearchRulesetFields>>;
  filter?: InputMaybe<_SearchRulesetFilter>;
  first?: InputMaybe<Scalars['Int']>;
  operator?: InputMaybe<_SearchOperatorEnum>;
  query: Scalars['String'];
  sort?: InputMaybe<Array<_RulesetSort>>;
};

export type QuerySearchSchemaCollectionArgs = {
  fields?: InputMaybe<Array<_SearchSchemaCollectionFields>>;
  filter?: InputMaybe<_SearchSchemaCollectionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  operator?: InputMaybe<_SearchOperatorEnum>;
  query: Scalars['String'];
  sort?: InputMaybe<Array<_SchemaCollectionSort>>;
};

export type QueryUnsafelyWipeAndRegenerateDmlBasedOnDataModelArgs = {
  externalId: Scalars['String'];
  space: Scalars['String'];
  version: Scalars['String'];
};

export enum Role {
  Admin = 'Admin',
  Editor = 'Editor',
  Viewer = 'Viewer',
}

/** #Rule */
export type Rule = {
  __typename?: 'Rule';
  _type?: Maybe<_InstanceType>;
  /** #advanceRules */
  advanceRules?: Maybe<Scalars['String']>;
  /** #customerDefinedId */
  customerDefinedId?: Maybe<Scalars['String']>;
  /** #description */
  description?: Maybe<Scalars['String']>;
  /** #errorMessage */
  errorMessage?: Maybe<Scalars['String']>;
  externalId: Scalars['ID'];
  /** #filters */
  filters?: Maybe<Scalars['String']>;
  /** #invertedRules */
  invertedRules?: Maybe<Scalars['String']>;
  /** #milestones */
  milestones?: Maybe<_MilestoneConnection>;
  /** #name */
  name?: Maybe<Scalars['String']>;
  /** #primaryKeyName */
  primaryKeyName?: Maybe<Scalars['String']>;
  /** #projectId */
  projectId?: Maybe<Scalars['String']>;
  /** #ruleRunStatus */
  ruleRunStatus?: Maybe<_RuleRunStatusConnection>;
  /** #rules */
  rules?: Maybe<Scalars['String']>;
  /** #rulesets */
  rulesets?: Maybe<_RulesetConnection>;
  /** #schemaCollection */
  schemaCollection?: Maybe<SchemaCollection>;
  /** #schemaType */
  schemaType?: Maybe<Scalars['String']>;
  /** #severity */
  severity?: Maybe<Scalars['String']>;
  /** #simpleInvertedRules */
  simpleInvertedRules?: Maybe<Scalars['String']>;
  /** #simpleRules */
  simpleRules?: Maybe<Scalars['String']>;
  space: Scalars['String'];
  /** #tags */
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** #Rule */
export type RuleMilestonesArgs = {
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<_ListMilestoneFilter>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<_MilestoneSort>>;
};

/** #Rule */
export type RuleRuleRunStatusArgs = {
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<_ListRuleRunStatusFilter>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<_RuleRunStatusSort>>;
};

/** #Rule */
export type RuleRulesetsArgs = {
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<_ListRulesetFilter>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<_RulesetSort>>;
};

/** #RuleRunStatus */
export type RuleRunStatus = {
  __typename?: 'RuleRunStatus';
  _type?: Maybe<_InstanceType>;
  /** #attributes */
  attributes?: Maybe<Array<Maybe<Scalars['String']>>>;
  externalId: Scalars['ID'];
  /** #failedInstances */
  failedInstances?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** #filteredInstances */
  filteredInstances?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** #isFilterResult */
  isFilterResult?: Maybe<Scalars['Boolean']>;
  /** #message */
  message?: Maybe<Scalars['String']>;
  /** #reportId */
  reportId?: Maybe<Scalars['String']>;
  /** #rule */
  rule?: Maybe<Rule>;
  /** #runAt */
  runAt?: Maybe<Scalars['Timestamp']>;
  space: Scalars['String'];
  /** #status */
  status: Scalars['String'];
  /** #totalFailed */
  totalFailed?: Maybe<Scalars['Int32']>;
  /** #totalValid */
  totalValid?: Maybe<Scalars['Int32']>;
};

export enum RuleSeverity {
  Critical = 'CRITICAL',
  Minor = 'MINOR',
  None = 'NONE',
  Warning = 'WARNING',
}

export enum RuleType {
  Condition = 'CONDITION',
  Filter = 'FILTER',
}

/** #Ruleset */
export type Ruleset = {
  __typename?: 'Ruleset';
  _type?: Maybe<_InstanceType>;
  /** #description */
  description?: Maybe<Scalars['String']>;
  externalId: Scalars['ID'];
  /** #filters */
  filters?: Maybe<Scalars['String']>;
  /** #labels */
  labels?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** #milestones */
  milestones?: Maybe<_MilestoneConnection>;
  /** #name */
  name: Scalars['String'];
  /** #projectId */
  projectId?: Maybe<Scalars['String']>;
  /** #rules */
  rules?: Maybe<_RuleConnection>;
  /** #schemaType */
  schemaType?: Maybe<Scalars['String']>;
  space: Scalars['String'];
};

/** #Ruleset */
export type RulesetMilestonesArgs = {
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<_ListMilestoneFilter>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<_MilestoneSort>>;
};

/** #Ruleset */
export type RulesetRulesArgs = {
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<_ListRuleFilter>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<_RuleSort>>;
};

/** Data Validation */
export enum RunStatus {
  Error = 'ERROR',
  InProgress = 'IN_PROGRESS',
  Success = 'SUCCESS',
}

/** #SchemaCollection */
export type SchemaCollection = {
  __typename?: 'SchemaCollection';
  _type?: Maybe<_InstanceType>;
  /** #description */
  description?: Maybe<Scalars['String']>;
  externalId: Scalars['ID'];
  /** #graphQLSchemaString */
  graphQLSchemaString?: Maybe<Scalars['String']>;
  /** #milestones */
  milestones?: Maybe<_MilestoneConnection>;
  /** #name */
  name: Scalars['String'];
  /** #project */
  project?: Maybe<DigitalTwin>;
  /** #refId */
  refId?: Maybe<Scalars['String']>;
  /** #refVersion */
  refVersion?: Maybe<Scalars['Int32']>;
  /** #rules */
  rules?: Maybe<_RuleConnection>;
  /** #rulesets */
  rulesets?: Maybe<_RulesetConnection>;
  space: Scalars['String'];
  /** #tenant */
  tenant: Scalars['String'];
};

/** #SchemaCollection */
export type SchemaCollectionMilestonesArgs = {
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<_ListMilestoneFilter>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<_MilestoneSort>>;
};

/** #SchemaCollection */
export type SchemaCollectionRulesArgs = {
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<_ListRuleFilter>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<_RuleSort>>;
};

/** #SchemaCollection */
export type SchemaCollectionRulesetsArgs = {
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<_ListRulesetFilter>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<_RulesetSort>>;
};

export type Sequence = {
  __typename?: 'Sequence';
  assetId?: Maybe<Scalars['Int64']>;
  columns?: Maybe<Array<Maybe<_SequenceColumn>>>;
  data?: Maybe<_SequenceRow>;
  dataSetId?: Maybe<Scalars['Int64']>;
  description?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int64']>;
  latest?: Maybe<_SequenceRow>;
  metadata?: Maybe<Scalars['JSONObject']>;
  name?: Maybe<Scalars['String']>;
};

export type SequenceDataArgs = {
  columns?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  end?: InputMaybe<Scalars['Int64']>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['Int64']>;
};

export type SequenceLatestArgs = {
  before?: InputMaybe<Scalars['Int64']>;
  columns?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export enum SortDirection {
  Asc = 'ASC',
  AscNullsFirst = 'ASC_NULLS_FIRST',
  AscNullsLast = 'ASC_NULLS_LAST',
  Desc = 'DESC',
  DescNullsFirst = 'DESC_NULLS_FIRST',
  DescNullsLast = 'DESC_NULLS_LAST',
}

export enum SortOrder {
  Ascending = 'ASCENDING',
  Descending = 'DESCENDING',
}

export type SourceLocation = {
  __typename?: 'SourceLocation';
  /** 1 indexed */
  column: Scalars['Int'];
  /** 1 indexed */
  line: Scalars['Int'];
};

export type SourceLocationRange = {
  __typename?: 'SourceLocationRange';
  end?: Maybe<SourceLocation>;
  start: SourceLocation;
};

export type StringFilter = {
  eq?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
};

export type TimeSeries = {
  __typename?: 'TimeSeries';
  assetId?: Maybe<Scalars['Int64']>;
  /** @deprecated Use getDataPoints instead. */
  dataPoints?: Maybe<Array<Maybe<DataPoint>>>;
  datasetId?: Maybe<Scalars['Int64']>;
  description?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  getDataPoints?: Maybe<_DataPointConnection>;
  getLatestDataPoint?: Maybe<_DataPointConnection>;
  id?: Maybe<Scalars['Int64']>;
  isStep?: Maybe<Scalars['Boolean']>;
  isString?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use getLatestDataPoint instead. */
  latestDataPoint?: Maybe<DataPoint>;
  metadata?: Maybe<Scalars['JSONObject']>;
  name?: Maybe<Scalars['String']>;
  securityCategories?: Maybe<Array<Maybe<Scalars['Int64']>>>;
  unit?: Maybe<Scalars['String']>;
  unitExternalId?: Maybe<Scalars['ID']>;
};

export type TimeSeriesDataPointsArgs = {
  aggregates?: InputMaybe<Array<_AggregateKind>>;
  end?: InputMaybe<Scalars['Int64']>;
  granularity?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['Int64']>;
};

export type TimeSeriesGetDataPointsArgs = {
  after?: InputMaybe<Scalars['String']>;
  aggregates?: InputMaybe<Array<_AggregateKind>>;
  end?: InputMaybe<Scalars['Int64']>;
  first?: InputMaybe<Scalars['Int']>;
  granularity?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int64']>;
  targetUnit?: InputMaybe<Scalars['ID']>;
  targetUnitSystem?: InputMaybe<Scalars['ID']>;
};

export type TimeSeriesGetLatestDataPointArgs = {
  before?: InputMaybe<Scalars['String']>;
  targetUnit?: InputMaybe<Scalars['ID']>;
  targetUnitSystem?: InputMaybe<Scalars['ID']>;
};

export type TimeSeriesLatestDataPointArgs = {
  before?: InputMaybe<Scalars['String']>;
};

export type UnitInfo = {
  __typename?: 'UnitInfo';
  sourceUnit?: Maybe<Scalars['String']>;
  unitExternalId: Scalars['ID'];
};

export type UpsertGraphQlDmlVersionResult = {
  __typename?: 'UpsertGraphQlDmlVersionResult';
  errors?: Maybe<Array<Error>>;
  result?: Maybe<GraphQlDmlVersion>;
};

export type ViewRef = {
  __typename?: 'ViewRef';
  externalId: Scalars['ID'];
  space: Scalars['String'];
  version: Scalars['String'];
};

export type _AccessAggregateConnection = {
  __typename?: '_AccessAggregateConnection';
  edges: Array<Maybe<_AccessAggregateEdge>>;
  items: Array<Maybe<_AccessAggregateResult>>;
  pageInfo: PageInfo;
};

export type _AccessAggregateEdge = {
  __typename?: '_AccessAggregateEdge';
  _type?: Maybe<_InstanceType>;
  cursor?: Maybe<Scalars['String']>;
  externalId: Scalars['ID'];
  node: _AccessAggregateResult;
  space: Scalars['String'];
};

export type _AccessAggregateFieldCountResult = {
  __typename?: '_AccessAggregateFieldCountResult';
  externalId?: Maybe<Scalars['Int']>;
  role?: Maybe<Scalars['Int']>;
  tenant?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['Int']>;
};

export type _AccessAggregateFieldResult = {
  __typename?: '_AccessAggregateFieldResult';
  _empty: Scalars['Int'];
};

export type _AccessAggregateHistogramFieldResult = {
  __typename?: '_AccessAggregateHistogramFieldResult';
  _empty?: Maybe<Array<Maybe<_AggregateHistogramObjectType>>>;
};

/** This type contains Aggregation Results for the ___Access___ type */
export type _AccessAggregateResult = {
  __typename?: '_AccessAggregateResult';
  /** Average for selected nodes, can only be selected for _numeric_ fields, and always returns a `Float` response */
  avg?: Maybe<_AccessAvgAggregateFieldResult>;
  /** Count for selected fields, can use this to count the number of nodes */
  count?: Maybe<_AccessAggregateFieldCountResult>;
  /** Apply groupBy operations on the _fields_ argument passed */
  group?: Maybe<Scalars['JSONObject']>;
  /** Histogram  */
  histogram?: Maybe<_AccessAggregateHistogramFieldResult>;
  /** Maximum of any of the nodes, can only be selected for _numeric_ fields */
  max?: Maybe<_AccessAggregateFieldResult>;
  /** Minimum of any of the nodes, can only be selected for _numeric_ fields */
  min?: Maybe<_AccessAggregateFieldResult>;
  /** Sum for selected fields, can only be selected for _numeric_ fields */
  sum?: Maybe<_AccessAggregateFieldResult>;
};

/** This type contains Aggregation Results for the ___Access___ type */
export type _AccessAggregateResultHistogramArgs = {
  interval: Scalars['Int'];
};

export type _AccessAvgAggregateFieldResult = {
  __typename?: '_AccessAvgAggregateFieldResult';
  _empty: Scalars['Int'];
};

export type _AccessConnection = {
  __typename?: '_AccessConnection';
  edges: Array<Maybe<_AccessEdge>>;
  items: Array<Maybe<Access>>;
  pageInfo: PageInfo;
};

export type _AccessEdge = {
  __typename?: '_AccessEdge';
  _type?: Maybe<_InstanceType>;
  cursor?: Maybe<Scalars['String']>;
  externalId: Scalars['ID'];
  node: Access;
  space: Scalars['String'];
};

export type _AccessSort = {
  externalId?: InputMaybe<SortDirection>;
  role?: InputMaybe<SortDirection>;
  space?: InputMaybe<SortDirection>;
  tenant?: InputMaybe<SortDirection>;
  userId?: InputMaybe<SortDirection>;
};

export type _AggregateHistogramObjectType = {
  __typename?: '_AggregateHistogramObjectType';
  count?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
};

export enum _AggregateKind {
  Average = 'AVERAGE',
  ContinuousVariance = 'CONTINUOUS_VARIANCE',
  Count = 'COUNT',
  DiscreteVariance = 'DISCRETE_VARIANCE',
  Interpolation = 'INTERPOLATION',
  Max = 'MAX',
  Min = 'MIN',
  StepInterpolation = 'STEP_INTERPOLATION',
  Sum = 'SUM',
  TotalVariation = 'TOTAL_VARIATION',
}

export type _BooleanCondition = {
  eq?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<Scalars['Boolean']>>;
  isNull?: InputMaybe<Scalars['Boolean']>;
};

export type _ConsistencyCollectionAggregateConnection = {
  __typename?: '_ConsistencyCollectionAggregateConnection';
  edges: Array<Maybe<_ConsistencyCollectionAggregateEdge>>;
  items: Array<Maybe<_ConsistencyCollectionAggregateResult>>;
  pageInfo: PageInfo;
};

export type _ConsistencyCollectionAggregateEdge = {
  __typename?: '_ConsistencyCollectionAggregateEdge';
  _type?: Maybe<_InstanceType>;
  cursor?: Maybe<Scalars['String']>;
  externalId: Scalars['ID'];
  node: _ConsistencyCollectionAggregateResult;
  space: Scalars['String'];
};

export type _ConsistencyCollectionAggregateFieldCountResult = {
  __typename?: '_ConsistencyCollectionAggregateFieldCountResult';
  createdAt?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['Int']>;
  externalId?: Maybe<Scalars['Int']>;
  labels?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['Int']>;
  project?: Maybe<Scalars['Int']>;
  projectId?: Maybe<Scalars['Int']>;
  reportTemplate?: Maybe<Scalars['Int']>;
  tenant?: Maybe<Scalars['Int']>;
};

export type _ConsistencyCollectionAggregateFieldResult = {
  __typename?: '_ConsistencyCollectionAggregateFieldResult';
  _empty: Scalars['Int'];
};

export type _ConsistencyCollectionAggregateHistogramFieldResult = {
  __typename?: '_ConsistencyCollectionAggregateHistogramFieldResult';
  _empty?: Maybe<Array<Maybe<_AggregateHistogramObjectType>>>;
};

/** This type contains Aggregation Results for the ___ConsistencyCollection___ type */
export type _ConsistencyCollectionAggregateResult = {
  __typename?: '_ConsistencyCollectionAggregateResult';
  /** Average for selected nodes, can only be selected for _numeric_ fields, and always returns a `Float` response */
  avg?: Maybe<_ConsistencyCollectionAvgAggregateFieldResult>;
  /** Count for selected fields, can use this to count the number of nodes */
  count?: Maybe<_ConsistencyCollectionAggregateFieldCountResult>;
  /** Apply groupBy operations on the _fields_ argument passed */
  group?: Maybe<Scalars['JSONObject']>;
  /** Histogram  */
  histogram?: Maybe<_ConsistencyCollectionAggregateHistogramFieldResult>;
  /** Maximum of any of the nodes, can only be selected for _numeric_ fields */
  max?: Maybe<_ConsistencyCollectionAggregateFieldResult>;
  /** Minimum of any of the nodes, can only be selected for _numeric_ fields */
  min?: Maybe<_ConsistencyCollectionAggregateFieldResult>;
  /** Sum for selected fields, can only be selected for _numeric_ fields */
  sum?: Maybe<_ConsistencyCollectionAggregateFieldResult>;
};

/** This type contains Aggregation Results for the ___ConsistencyCollection___ type */
export type _ConsistencyCollectionAggregateResultHistogramArgs = {
  interval: Scalars['Int'];
};

export type _ConsistencyCollectionAvgAggregateFieldResult = {
  __typename?: '_ConsistencyCollectionAvgAggregateFieldResult';
  _empty: Scalars['Int'];
};

export type _ConsistencyCollectionConnection = {
  __typename?: '_ConsistencyCollectionConnection';
  edges: Array<Maybe<_ConsistencyCollectionEdge>>;
  items: Array<Maybe<ConsistencyCollection>>;
  pageInfo: PageInfo;
};

export type _ConsistencyCollectionEdge = {
  __typename?: '_ConsistencyCollectionEdge';
  _type?: Maybe<_InstanceType>;
  cursor?: Maybe<Scalars['String']>;
  externalId: Scalars['ID'];
  node: ConsistencyCollection;
  space: Scalars['String'];
};

export type _ConsistencyCollectionSort = {
  createdAt?: InputMaybe<SortDirection>;
  description?: InputMaybe<SortDirection>;
  externalId?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  project?: InputMaybe<SortDirection>;
  projectId?: InputMaybe<SortDirection>;
  reportTemplate?: InputMaybe<SortDirection>;
  space?: InputMaybe<SortDirection>;
  tenant?: InputMaybe<SortDirection>;
};

export type _ConsistencyConditionCheckAggregateConnection = {
  __typename?: '_ConsistencyConditionCheckAggregateConnection';
  edges: Array<Maybe<_ConsistencyConditionCheckAggregateEdge>>;
  items: Array<Maybe<_ConsistencyConditionCheckAggregateResult>>;
  pageInfo: PageInfo;
};

export type _ConsistencyConditionCheckAggregateEdge = {
  __typename?: '_ConsistencyConditionCheckAggregateEdge';
  _type?: Maybe<_InstanceType>;
  cursor?: Maybe<Scalars['String']>;
  externalId: Scalars['ID'];
  node: _ConsistencyConditionCheckAggregateResult;
  space: Scalars['String'];
};

export type _ConsistencyConditionCheckAggregateFieldCountResult = {
  __typename?: '_ConsistencyConditionCheckAggregateFieldCountResult';
  externalId?: Maybe<Scalars['Int']>;
  isLiteralValue?: Maybe<Scalars['Int']>;
  operator?: Maybe<Scalars['Int']>;
  rule?: Maybe<Scalars['Int']>;
  sourceAttribute?: Maybe<Scalars['Int']>;
  targetAttribute?: Maybe<Scalars['Int']>;
  useTargetSchema?: Maybe<Scalars['Int']>;
};

export type _ConsistencyConditionCheckAggregateFieldResult = {
  __typename?: '_ConsistencyConditionCheckAggregateFieldResult';
  _empty: Scalars['Int'];
};

export type _ConsistencyConditionCheckAggregateHistogramFieldResult = {
  __typename?: '_ConsistencyConditionCheckAggregateHistogramFieldResult';
  _empty?: Maybe<Array<Maybe<_AggregateHistogramObjectType>>>;
};

/** This type contains Aggregation Results for the ___ConsistencyConditionCheck___ type */
export type _ConsistencyConditionCheckAggregateResult = {
  __typename?: '_ConsistencyConditionCheckAggregateResult';
  /** Average for selected nodes, can only be selected for _numeric_ fields, and always returns a `Float` response */
  avg?: Maybe<_ConsistencyConditionCheckAvgAggregateFieldResult>;
  /** Count for selected fields, can use this to count the number of nodes */
  count?: Maybe<_ConsistencyConditionCheckAggregateFieldCountResult>;
  /** Apply groupBy operations on the _fields_ argument passed */
  group?: Maybe<Scalars['JSONObject']>;
  /** Histogram  */
  histogram?: Maybe<_ConsistencyConditionCheckAggregateHistogramFieldResult>;
  /** Maximum of any of the nodes, can only be selected for _numeric_ fields */
  max?: Maybe<_ConsistencyConditionCheckAggregateFieldResult>;
  /** Minimum of any of the nodes, can only be selected for _numeric_ fields */
  min?: Maybe<_ConsistencyConditionCheckAggregateFieldResult>;
  /** Sum for selected fields, can only be selected for _numeric_ fields */
  sum?: Maybe<_ConsistencyConditionCheckAggregateFieldResult>;
};

/** This type contains Aggregation Results for the ___ConsistencyConditionCheck___ type */
export type _ConsistencyConditionCheckAggregateResultHistogramArgs = {
  interval: Scalars['Int'];
};

export type _ConsistencyConditionCheckAvgAggregateFieldResult = {
  __typename?: '_ConsistencyConditionCheckAvgAggregateFieldResult';
  _empty: Scalars['Int'];
};

export type _ConsistencyConditionCheckConnection = {
  __typename?: '_ConsistencyConditionCheckConnection';
  edges: Array<Maybe<_ConsistencyConditionCheckEdge>>;
  items: Array<Maybe<ConsistencyConditionCheck>>;
  pageInfo: PageInfo;
};

export type _ConsistencyConditionCheckEdge = {
  __typename?: '_ConsistencyConditionCheckEdge';
  _type?: Maybe<_InstanceType>;
  cursor?: Maybe<Scalars['String']>;
  externalId: Scalars['ID'];
  node: ConsistencyConditionCheck;
  space: Scalars['String'];
};

export type _ConsistencyConditionCheckSort = {
  externalId?: InputMaybe<SortDirection>;
  isLiteralValue?: InputMaybe<SortDirection>;
  operator?: InputMaybe<SortDirection>;
  rule?: InputMaybe<SortDirection>;
  sourceAttribute?: InputMaybe<SortDirection>;
  space?: InputMaybe<SortDirection>;
  targetAttribute?: InputMaybe<SortDirection>;
  useTargetSchema?: InputMaybe<SortDirection>;
};

export type _ConsistencyRuleAggregateConnection = {
  __typename?: '_ConsistencyRuleAggregateConnection';
  edges: Array<Maybe<_ConsistencyRuleAggregateEdge>>;
  items: Array<Maybe<_ConsistencyRuleAggregateResult>>;
  pageInfo: PageInfo;
};

export type _ConsistencyRuleAggregateEdge = {
  __typename?: '_ConsistencyRuleAggregateEdge';
  _type?: Maybe<_InstanceType>;
  cursor?: Maybe<Scalars['String']>;
  externalId: Scalars['ID'];
  node: _ConsistencyRuleAggregateResult;
  space: Scalars['String'];
};

export type _ConsistencyRuleAggregateFieldCountResult = {
  __typename?: '_ConsistencyRuleAggregateFieldCountResult';
  collection?: Maybe<Scalars['Int']>;
  conditionChecksOnly?: Maybe<Scalars['Int']>;
  customerDefinedId?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['Int']>;
  errorMessage?: Maybe<Scalars['Int']>;
  externalId?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['Int']>;
  operator?: Maybe<Scalars['Int']>;
  projectId?: Maybe<Scalars['Int']>;
  severity?: Maybe<Scalars['Int']>;
  sourceAttribute?: Maybe<Scalars['Int']>;
  sourceFilters?: Maybe<Scalars['Int']>;
  sourceSchemaFilter?: Maybe<Scalars['Int']>;
  tags?: Maybe<Scalars['Int']>;
  targetAttribute?: Maybe<Scalars['Int']>;
  targetFilters?: Maybe<Scalars['Int']>;
  targetSchemaFilter?: Maybe<Scalars['Int']>;
};

export type _ConsistencyRuleAggregateFieldResult = {
  __typename?: '_ConsistencyRuleAggregateFieldResult';
  _empty: Scalars['Int'];
};

export type _ConsistencyRuleAggregateHistogramFieldResult = {
  __typename?: '_ConsistencyRuleAggregateHistogramFieldResult';
  _empty?: Maybe<Array<Maybe<_AggregateHistogramObjectType>>>;
};

/** This type contains Aggregation Results for the ___ConsistencyRule___ type */
export type _ConsistencyRuleAggregateResult = {
  __typename?: '_ConsistencyRuleAggregateResult';
  /** Average for selected nodes, can only be selected for _numeric_ fields, and always returns a `Float` response */
  avg?: Maybe<_ConsistencyRuleAvgAggregateFieldResult>;
  /** Count for selected fields, can use this to count the number of nodes */
  count?: Maybe<_ConsistencyRuleAggregateFieldCountResult>;
  /** Apply groupBy operations on the _fields_ argument passed */
  group?: Maybe<Scalars['JSONObject']>;
  /** Histogram  */
  histogram?: Maybe<_ConsistencyRuleAggregateHistogramFieldResult>;
  /** Maximum of any of the nodes, can only be selected for _numeric_ fields */
  max?: Maybe<_ConsistencyRuleAggregateFieldResult>;
  /** Minimum of any of the nodes, can only be selected for _numeric_ fields */
  min?: Maybe<_ConsistencyRuleAggregateFieldResult>;
  /** Sum for selected fields, can only be selected for _numeric_ fields */
  sum?: Maybe<_ConsistencyRuleAggregateFieldResult>;
};

/** This type contains Aggregation Results for the ___ConsistencyRule___ type */
export type _ConsistencyRuleAggregateResultHistogramArgs = {
  interval: Scalars['Int'];
};

export type _ConsistencyRuleAvgAggregateFieldResult = {
  __typename?: '_ConsistencyRuleAvgAggregateFieldResult';
  _empty: Scalars['Int'];
};

export type _ConsistencyRuleConnection = {
  __typename?: '_ConsistencyRuleConnection';
  edges: Array<Maybe<_ConsistencyRuleEdge>>;
  items: Array<Maybe<ConsistencyRule>>;
  pageInfo: PageInfo;
};

export type _ConsistencyRuleEdge = {
  __typename?: '_ConsistencyRuleEdge';
  _type?: Maybe<_InstanceType>;
  cursor?: Maybe<Scalars['String']>;
  externalId: Scalars['ID'];
  node: ConsistencyRule;
  space: Scalars['String'];
};

export type _ConsistencyRuleSort = {
  collection?: InputMaybe<SortDirection>;
  conditionChecksOnly?: InputMaybe<SortDirection>;
  customerDefinedId?: InputMaybe<SortDirection>;
  description?: InputMaybe<SortDirection>;
  errorMessage?: InputMaybe<SortDirection>;
  externalId?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  operator?: InputMaybe<SortDirection>;
  projectId?: InputMaybe<SortDirection>;
  severity?: InputMaybe<SortDirection>;
  sourceAttribute?: InputMaybe<SortDirection>;
  sourceFilters?: InputMaybe<SortDirection>;
  sourceSchemaFilter?: InputMaybe<SortDirection>;
  space?: InputMaybe<SortDirection>;
  targetAttribute?: InputMaybe<SortDirection>;
  targetFilters?: InputMaybe<SortDirection>;
  targetSchemaFilter?: InputMaybe<SortDirection>;
};

export type _ConsistencyRunStatusAggregateConnection = {
  __typename?: '_ConsistencyRunStatusAggregateConnection';
  edges: Array<Maybe<_ConsistencyRunStatusAggregateEdge>>;
  items: Array<Maybe<_ConsistencyRunStatusAggregateResult>>;
  pageInfo: PageInfo;
};

export type _ConsistencyRunStatusAggregateEdge = {
  __typename?: '_ConsistencyRunStatusAggregateEdge';
  _type?: Maybe<_InstanceType>;
  cursor?: Maybe<Scalars['String']>;
  externalId: Scalars['ID'];
  node: _ConsistencyRunStatusAggregateResult;
  space: Scalars['String'];
};

export type _ConsistencyRunStatusAggregateFieldCountResult = {
  __typename?: '_ConsistencyRunStatusAggregateFieldCountResult';
  attributes?: Maybe<Scalars['Int']>;
  externalId?: Maybe<Scalars['Int']>;
  failedInstances?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['Int']>;
  reportId?: Maybe<Scalars['Int']>;
  rule?: Maybe<Scalars['Int']>;
  runAt?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['Int']>;
  totalFailed?: Maybe<Scalars['Int']>;
  totalValid?: Maybe<Scalars['Int']>;
};

export type _ConsistencyRunStatusAggregateFieldResult = {
  __typename?: '_ConsistencyRunStatusAggregateFieldResult';
  totalFailed?: Maybe<Scalars['Int32']>;
  totalValid?: Maybe<Scalars['Int32']>;
};

export type _ConsistencyRunStatusAggregateHistogramFieldResult = {
  __typename?: '_ConsistencyRunStatusAggregateHistogramFieldResult';
  totalFailed?: Maybe<Array<Maybe<_AggregateHistogramObjectType>>>;
  totalValid?: Maybe<Array<Maybe<_AggregateHistogramObjectType>>>;
};

/** This type contains Aggregation Results for the ___ConsistencyRunStatus___ type */
export type _ConsistencyRunStatusAggregateResult = {
  __typename?: '_ConsistencyRunStatusAggregateResult';
  /** Average for selected nodes, can only be selected for _numeric_ fields, and always returns a `Float` response */
  avg?: Maybe<_ConsistencyRunStatusAvgAggregateFieldResult>;
  /** Count for selected fields, can use this to count the number of nodes */
  count?: Maybe<_ConsistencyRunStatusAggregateFieldCountResult>;
  /** Apply groupBy operations on the _fields_ argument passed */
  group?: Maybe<Scalars['JSONObject']>;
  /** Histogram  */
  histogram?: Maybe<_ConsistencyRunStatusAggregateHistogramFieldResult>;
  /** Maximum of any of the nodes, can only be selected for _numeric_ fields */
  max?: Maybe<_ConsistencyRunStatusAggregateFieldResult>;
  /** Minimum of any of the nodes, can only be selected for _numeric_ fields */
  min?: Maybe<_ConsistencyRunStatusAggregateFieldResult>;
  /** Sum for selected fields, can only be selected for _numeric_ fields */
  sum?: Maybe<_ConsistencyRunStatusAggregateFieldResult>;
};

/** This type contains Aggregation Results for the ___ConsistencyRunStatus___ type */
export type _ConsistencyRunStatusAggregateResultHistogramArgs = {
  interval: Scalars['Int'];
};

export type _ConsistencyRunStatusAvgAggregateFieldResult = {
  __typename?: '_ConsistencyRunStatusAvgAggregateFieldResult';
  totalFailed?: Maybe<Scalars['Float']>;
  totalValid?: Maybe<Scalars['Float']>;
};

export type _ConsistencyRunStatusConnection = {
  __typename?: '_ConsistencyRunStatusConnection';
  edges: Array<Maybe<_ConsistencyRunStatusEdge>>;
  items: Array<Maybe<ConsistencyRunStatus>>;
  pageInfo: PageInfo;
};

export type _ConsistencyRunStatusEdge = {
  __typename?: '_ConsistencyRunStatusEdge';
  _type?: Maybe<_InstanceType>;
  cursor?: Maybe<Scalars['String']>;
  externalId: Scalars['ID'];
  node: ConsistencyRunStatus;
  space: Scalars['String'];
};

export type _ConsistencyRunStatusSort = {
  externalId?: InputMaybe<SortDirection>;
  message?: InputMaybe<SortDirection>;
  reportId?: InputMaybe<SortDirection>;
  rule?: InputMaybe<SortDirection>;
  runAt?: InputMaybe<SortDirection>;
  space?: InputMaybe<SortDirection>;
  status?: InputMaybe<SortDirection>;
  totalFailed?: InputMaybe<SortDirection>;
  totalValid?: InputMaybe<SortDirection>;
};

export type _ConsistencySchemaFilterAggregateConnection = {
  __typename?: '_ConsistencySchemaFilterAggregateConnection';
  edges: Array<Maybe<_ConsistencySchemaFilterAggregateEdge>>;
  items: Array<Maybe<_ConsistencySchemaFilterAggregateResult>>;
  pageInfo: PageInfo;
};

export type _ConsistencySchemaFilterAggregateEdge = {
  __typename?: '_ConsistencySchemaFilterAggregateEdge';
  _type?: Maybe<_InstanceType>;
  cursor?: Maybe<Scalars['String']>;
  externalId: Scalars['ID'];
  node: _ConsistencySchemaFilterAggregateResult;
  space: Scalars['String'];
};

export type _ConsistencySchemaFilterAggregateFieldCountResult = {
  __typename?: '_ConsistencySchemaFilterAggregateFieldCountResult';
  collection?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['Int']>;
  externalId?: Maybe<Scalars['Int']>;
  filters?: Maybe<Scalars['Int']>;
  labels?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['Int']>;
  projectId?: Maybe<Scalars['Int']>;
  schemaCollectionId?: Maybe<Scalars['Int']>;
  schemaType?: Maybe<Scalars['Int']>;
};

export type _ConsistencySchemaFilterAggregateFieldResult = {
  __typename?: '_ConsistencySchemaFilterAggregateFieldResult';
  _empty: Scalars['Int'];
};

export type _ConsistencySchemaFilterAggregateHistogramFieldResult = {
  __typename?: '_ConsistencySchemaFilterAggregateHistogramFieldResult';
  _empty?: Maybe<Array<Maybe<_AggregateHistogramObjectType>>>;
};

/** This type contains Aggregation Results for the ___ConsistencySchemaFilter___ type */
export type _ConsistencySchemaFilterAggregateResult = {
  __typename?: '_ConsistencySchemaFilterAggregateResult';
  /** Average for selected nodes, can only be selected for _numeric_ fields, and always returns a `Float` response */
  avg?: Maybe<_ConsistencySchemaFilterAvgAggregateFieldResult>;
  /** Count for selected fields, can use this to count the number of nodes */
  count?: Maybe<_ConsistencySchemaFilterAggregateFieldCountResult>;
  /** Apply groupBy operations on the _fields_ argument passed */
  group?: Maybe<Scalars['JSONObject']>;
  /** Histogram  */
  histogram?: Maybe<_ConsistencySchemaFilterAggregateHistogramFieldResult>;
  /** Maximum of any of the nodes, can only be selected for _numeric_ fields */
  max?: Maybe<_ConsistencySchemaFilterAggregateFieldResult>;
  /** Minimum of any of the nodes, can only be selected for _numeric_ fields */
  min?: Maybe<_ConsistencySchemaFilterAggregateFieldResult>;
  /** Sum for selected fields, can only be selected for _numeric_ fields */
  sum?: Maybe<_ConsistencySchemaFilterAggregateFieldResult>;
};

/** This type contains Aggregation Results for the ___ConsistencySchemaFilter___ type */
export type _ConsistencySchemaFilterAggregateResultHistogramArgs = {
  interval: Scalars['Int'];
};

export type _ConsistencySchemaFilterAvgAggregateFieldResult = {
  __typename?: '_ConsistencySchemaFilterAvgAggregateFieldResult';
  _empty: Scalars['Int'];
};

export type _ConsistencySchemaFilterConnection = {
  __typename?: '_ConsistencySchemaFilterConnection';
  edges: Array<Maybe<_ConsistencySchemaFilterEdge>>;
  items: Array<Maybe<ConsistencySchemaFilter>>;
  pageInfo: PageInfo;
};

export type _ConsistencySchemaFilterEdge = {
  __typename?: '_ConsistencySchemaFilterEdge';
  _type?: Maybe<_InstanceType>;
  cursor?: Maybe<Scalars['String']>;
  externalId: Scalars['ID'];
  node: ConsistencySchemaFilter;
  space: Scalars['String'];
};

export type _ConsistencySchemaFilterSort = {
  collection?: InputMaybe<SortDirection>;
  description?: InputMaybe<SortDirection>;
  externalId?: InputMaybe<SortDirection>;
  filters?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  projectId?: InputMaybe<SortDirection>;
  schemaCollectionId?: InputMaybe<SortDirection>;
  schemaType?: InputMaybe<SortDirection>;
  space?: InputMaybe<SortDirection>;
};

export type _DataPointConnection = {
  __typename?: '_DataPointConnection';
  edges: Array<Maybe<_DataPointEdge>>;
  items: Array<Maybe<DataPoint>>;
  pageInfo: PageInfo;
  unitExternalId?: Maybe<Scalars['ID']>;
};

export type _DataPointEdge = {
  __typename?: '_DataPointEdge';
  _type?: Maybe<_InstanceType>;
  cursor?: Maybe<Scalars['String']>;
  externalId: Scalars['ID'];
  node: DataPoint;
  space: Scalars['String'];
};

export type _DateCondition = {
  eq?: InputMaybe<Scalars['Date']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<Scalars['Date']>>;
  isNull?: InputMaybe<Scalars['Boolean']>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
};

export type _DeleteResponse = {
  __typename?: '_DeleteResponse';
  externalId: Scalars['ID'];
  space: Scalars['String'];
};

export type _DigitalTwinAggregateConnection = {
  __typename?: '_DigitalTwinAggregateConnection';
  edges: Array<Maybe<_DigitalTwinAggregateEdge>>;
  items: Array<Maybe<_DigitalTwinAggregateResult>>;
  pageInfo: PageInfo;
};

export type _DigitalTwinAggregateEdge = {
  __typename?: '_DigitalTwinAggregateEdge';
  _type?: Maybe<_InstanceType>;
  cursor?: Maybe<Scalars['String']>;
  externalId: Scalars['ID'];
  node: _DigitalTwinAggregateResult;
  space: Scalars['String'];
};

export type _DigitalTwinAggregateFieldCountResult = {
  __typename?: '_DigitalTwinAggregateFieldCountResult';
  externalId?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['Int']>;
  tenant?: Maybe<Scalars['Int']>;
};

export type _DigitalTwinAggregateFieldResult = {
  __typename?: '_DigitalTwinAggregateFieldResult';
  _empty: Scalars['Int'];
};

export type _DigitalTwinAggregateHistogramFieldResult = {
  __typename?: '_DigitalTwinAggregateHistogramFieldResult';
  _empty?: Maybe<Array<Maybe<_AggregateHistogramObjectType>>>;
};

/** This type contains Aggregation Results for the ___DigitalTwin___ type */
export type _DigitalTwinAggregateResult = {
  __typename?: '_DigitalTwinAggregateResult';
  /** Average for selected nodes, can only be selected for _numeric_ fields, and always returns a `Float` response */
  avg?: Maybe<_DigitalTwinAvgAggregateFieldResult>;
  /** Count for selected fields, can use this to count the number of nodes */
  count?: Maybe<_DigitalTwinAggregateFieldCountResult>;
  /** Apply groupBy operations on the _fields_ argument passed */
  group?: Maybe<Scalars['JSONObject']>;
  /** Histogram  */
  histogram?: Maybe<_DigitalTwinAggregateHistogramFieldResult>;
  /** Maximum of any of the nodes, can only be selected for _numeric_ fields */
  max?: Maybe<_DigitalTwinAggregateFieldResult>;
  /** Minimum of any of the nodes, can only be selected for _numeric_ fields */
  min?: Maybe<_DigitalTwinAggregateFieldResult>;
  /** Sum for selected fields, can only be selected for _numeric_ fields */
  sum?: Maybe<_DigitalTwinAggregateFieldResult>;
};

/** This type contains Aggregation Results for the ___DigitalTwin___ type */
export type _DigitalTwinAggregateResultHistogramArgs = {
  interval: Scalars['Int'];
};

export type _DigitalTwinAvgAggregateFieldResult = {
  __typename?: '_DigitalTwinAvgAggregateFieldResult';
  _empty: Scalars['Int'];
};

export type _DigitalTwinConnection = {
  __typename?: '_DigitalTwinConnection';
  edges: Array<Maybe<_DigitalTwinEdge>>;
  items: Array<Maybe<DigitalTwin>>;
  pageInfo: PageInfo;
};

export type _DigitalTwinEdge = {
  __typename?: '_DigitalTwinEdge';
  _type?: Maybe<_InstanceType>;
  cursor?: Maybe<Scalars['String']>;
  externalId: Scalars['ID'];
  node: DigitalTwin;
  space: Scalars['String'];
};

export type _DigitalTwinSort = {
  externalId?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  space?: InputMaybe<SortDirection>;
  tenant?: InputMaybe<SortDirection>;
};

export type _DirectRelationInput = {
  _directRelation: Scalars['ID'];
};

export type _DownloadLink = {
  __typename?: '_DownloadLink';
  downloadUrl?: Maybe<Scalars['String']>;
};

export type _Float32Condition = {
  eq?: InputMaybe<Scalars['Float32']>;
  gt?: InputMaybe<Scalars['Float32']>;
  gte?: InputMaybe<Scalars['Float32']>;
  in?: InputMaybe<Array<Scalars['Float32']>>;
  isNull?: InputMaybe<Scalars['Boolean']>;
  lt?: InputMaybe<Scalars['Float32']>;
  lte?: InputMaybe<Scalars['Float32']>;
};

export type _Float64Condition = {
  eq?: InputMaybe<Scalars['Float64']>;
  gt?: InputMaybe<Scalars['Float64']>;
  gte?: InputMaybe<Scalars['Float64']>;
  in?: InputMaybe<Array<Scalars['Float64']>>;
  isNull?: InputMaybe<Scalars['Boolean']>;
  lt?: InputMaybe<Scalars['Float64']>;
  lte?: InputMaybe<Scalars['Float64']>;
};

export type _FloatCondition = {
  eq?: InputMaybe<Scalars['Float']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<Scalars['Float']>>;
  isNull?: InputMaybe<Scalars['Boolean']>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
};

export type _GeoLocation = {
  __typename?: '_GeoLocation';
  geometry?: Maybe<_GeoLocationGeometry>;
  properties?: Maybe<Scalars['JSONObject']>;
  type?: Maybe<Scalars['String']>;
};

export type _GeoLocationGeometry = {
  __typename?: '_GeoLocationGeometry';
  coordinates?: Maybe<Scalars['JSONObject']>;
  type?: Maybe<_GeoLocationType>;
};

export enum _GeoLocationType {
  LineString = 'LineString',
  MultiLineString = 'MultiLineString',
  MultiPoint = 'MultiPoint',
  MultiPolygon = 'MultiPolygon',
  Point = 'Point',
  Polygon = 'Polygon',
}

export type _GlobalIdInput = {
  id: Scalars['ID'];
};

export type _IdCondition = {
  eq?: InputMaybe<Scalars['ID']>;
  gt?: InputMaybe<Scalars['ID']>;
  gte?: InputMaybe<Scalars['ID']>;
  in?: InputMaybe<Array<Scalars['ID']>>;
  isNull?: InputMaybe<Scalars['Boolean']>;
  lt?: InputMaybe<Scalars['ID']>;
  lte?: InputMaybe<Scalars['ID']>;
  prefix?: InputMaybe<Scalars['ID']>;
};

export type _InstanceType = {
  __typename?: '_InstanceType';
  externalId: Scalars['String'];
  space: Scalars['String'];
};

export type _InstanceTypeCondition = {
  eq?: InputMaybe<InstanceRef>;
  in?: InputMaybe<Array<InstanceRef>>;
  isNull?: InputMaybe<Scalars['Boolean']>;
};

export type _Int32Condition = {
  eq?: InputMaybe<Scalars['Int32']>;
  gt?: InputMaybe<Scalars['Int32']>;
  gte?: InputMaybe<Scalars['Int32']>;
  in?: InputMaybe<Array<Scalars['Int32']>>;
  isNull?: InputMaybe<Scalars['Boolean']>;
  lt?: InputMaybe<Scalars['Int32']>;
  lte?: InputMaybe<Scalars['Int32']>;
};

export type _Int64Condition = {
  eq?: InputMaybe<Scalars['Int64']>;
  gt?: InputMaybe<Scalars['Int64']>;
  gte?: InputMaybe<Scalars['Int64']>;
  in?: InputMaybe<Array<Scalars['Int64']>>;
  isNull?: InputMaybe<Scalars['Boolean']>;
  lt?: InputMaybe<Scalars['Int64']>;
  lte?: InputMaybe<Scalars['Int64']>;
};

export type _IntCondition = {
  eq?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  isNull?: InputMaybe<Scalars['Boolean']>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
};

export type _ListAccessFilter = {
  _type?: InputMaybe<_InstanceTypeCondition>;
  and?: InputMaybe<Array<_ListAccessFilter>>;
  createdTime?: InputMaybe<_TimestampCondition>;
  externalId?: InputMaybe<_IdCondition>;
  lastUpdatedTime?: InputMaybe<_TimestampCondition>;
  not?: InputMaybe<_ListAccessFilter>;
  or?: InputMaybe<Array<_ListAccessFilter>>;
  role?: InputMaybe<_StringCondition>;
  space?: InputMaybe<_StringCondition>;
  tenant?: InputMaybe<_StringCondition>;
  userId?: InputMaybe<_StringCondition>;
};

export type _ListBooleanFilter = {
  containsAll?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  containsAny?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type _ListConsistencyCollectionFilter = {
  _type?: InputMaybe<_InstanceTypeCondition>;
  and?: InputMaybe<Array<_ListConsistencyCollectionFilter>>;
  createdAt?: InputMaybe<_TimestampCondition>;
  createdTime?: InputMaybe<_TimestampCondition>;
  description?: InputMaybe<_StringCondition>;
  externalId?: InputMaybe<_IdCondition>;
  labels?: InputMaybe<_ListStringFilter>;
  lastUpdatedTime?: InputMaybe<_TimestampCondition>;
  name?: InputMaybe<_StringCondition>;
  not?: InputMaybe<_ListConsistencyCollectionFilter>;
  or?: InputMaybe<Array<_ListConsistencyCollectionFilter>>;
  project?: InputMaybe<_ListDigitalTwinFilter>;
  projectId?: InputMaybe<_StringCondition>;
  reportTemplate?: InputMaybe<_StringCondition>;
  space?: InputMaybe<_StringCondition>;
  tenant?: InputMaybe<_StringCondition>;
};

export type _ListConsistencyConditionCheckFilter = {
  _type?: InputMaybe<_InstanceTypeCondition>;
  and?: InputMaybe<Array<_ListConsistencyConditionCheckFilter>>;
  createdTime?: InputMaybe<_TimestampCondition>;
  externalId?: InputMaybe<_IdCondition>;
  isLiteralValue?: InputMaybe<_BooleanCondition>;
  lastUpdatedTime?: InputMaybe<_TimestampCondition>;
  not?: InputMaybe<_ListConsistencyConditionCheckFilter>;
  operator?: InputMaybe<_StringCondition>;
  or?: InputMaybe<Array<_ListConsistencyConditionCheckFilter>>;
  rule?: InputMaybe<_ListConsistencyRuleFilter>;
  sourceAttribute?: InputMaybe<_StringCondition>;
  space?: InputMaybe<_StringCondition>;
  targetAttribute?: InputMaybe<_StringCondition>;
  useTargetSchema?: InputMaybe<_BooleanCondition>;
};

export type _ListConsistencyRuleFilter = {
  _type?: InputMaybe<_InstanceTypeCondition>;
  and?: InputMaybe<Array<_ListConsistencyRuleFilter>>;
  collection?: InputMaybe<_ListConsistencyCollectionFilter>;
  conditionChecksOnly?: InputMaybe<_BooleanCondition>;
  createdTime?: InputMaybe<_TimestampCondition>;
  customerDefinedId?: InputMaybe<_StringCondition>;
  description?: InputMaybe<_StringCondition>;
  errorMessage?: InputMaybe<_StringCondition>;
  externalId?: InputMaybe<_IdCondition>;
  lastUpdatedTime?: InputMaybe<_TimestampCondition>;
  name?: InputMaybe<_StringCondition>;
  not?: InputMaybe<_ListConsistencyRuleFilter>;
  operator?: InputMaybe<_StringCondition>;
  or?: InputMaybe<Array<_ListConsistencyRuleFilter>>;
  projectId?: InputMaybe<_StringCondition>;
  severity?: InputMaybe<_StringCondition>;
  sourceAttribute?: InputMaybe<_StringCondition>;
  sourceFilters?: InputMaybe<_StringCondition>;
  sourceSchemaFilter?: InputMaybe<_ListConsistencySchemaFilterFilter>;
  space?: InputMaybe<_StringCondition>;
  tags?: InputMaybe<_ListStringFilter>;
  targetAttribute?: InputMaybe<_StringCondition>;
  targetFilters?: InputMaybe<_StringCondition>;
  targetSchemaFilter?: InputMaybe<_ListConsistencySchemaFilterFilter>;
};

export type _ListConsistencyRunStatusFilter = {
  _type?: InputMaybe<_InstanceTypeCondition>;
  and?: InputMaybe<Array<_ListConsistencyRunStatusFilter>>;
  attributes?: InputMaybe<_ListStringFilter>;
  createdTime?: InputMaybe<_TimestampCondition>;
  externalId?: InputMaybe<_IdCondition>;
  failedInstances?: InputMaybe<_ListStringFilter>;
  lastUpdatedTime?: InputMaybe<_TimestampCondition>;
  message?: InputMaybe<_StringCondition>;
  not?: InputMaybe<_ListConsistencyRunStatusFilter>;
  or?: InputMaybe<Array<_ListConsistencyRunStatusFilter>>;
  reportId?: InputMaybe<_StringCondition>;
  rule?: InputMaybe<_ListConsistencyRuleFilter>;
  runAt?: InputMaybe<_TimestampCondition>;
  space?: InputMaybe<_StringCondition>;
  status?: InputMaybe<_StringCondition>;
  totalFailed?: InputMaybe<_Int32Condition>;
  totalValid?: InputMaybe<_Int32Condition>;
};

export type _ListConsistencySchemaFilterFilter = {
  _type?: InputMaybe<_InstanceTypeCondition>;
  and?: InputMaybe<Array<_ListConsistencySchemaFilterFilter>>;
  collection?: InputMaybe<_ListConsistencyCollectionFilter>;
  createdTime?: InputMaybe<_TimestampCondition>;
  description?: InputMaybe<_StringCondition>;
  externalId?: InputMaybe<_IdCondition>;
  filters?: InputMaybe<_StringCondition>;
  labels?: InputMaybe<_ListStringFilter>;
  lastUpdatedTime?: InputMaybe<_TimestampCondition>;
  name?: InputMaybe<_StringCondition>;
  not?: InputMaybe<_ListConsistencySchemaFilterFilter>;
  or?: InputMaybe<Array<_ListConsistencySchemaFilterFilter>>;
  projectId?: InputMaybe<_StringCondition>;
  schemaCollectionId?: InputMaybe<_StringCondition>;
  schemaType?: InputMaybe<_StringCondition>;
  space?: InputMaybe<_StringCondition>;
};

export type _ListDateFilter = {
  containsAll?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  containsAny?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type _ListDigitalTwinFilter = {
  _type?: InputMaybe<_InstanceTypeCondition>;
  and?: InputMaybe<Array<_ListDigitalTwinFilter>>;
  createdTime?: InputMaybe<_TimestampCondition>;
  externalId?: InputMaybe<_IdCondition>;
  lastUpdatedTime?: InputMaybe<_TimestampCondition>;
  name?: InputMaybe<_StringCondition>;
  not?: InputMaybe<_ListDigitalTwinFilter>;
  or?: InputMaybe<Array<_ListDigitalTwinFilter>>;
  space?: InputMaybe<_StringCondition>;
  tenant?: InputMaybe<_StringCondition>;
};

export type _ListDirectRelationFilter = {
  containsAll?: InputMaybe<Array<InputMaybe<InstanceRef>>>;
  containsAny?: InputMaybe<Array<InputMaybe<InstanceRef>>>;
  prefix?: InputMaybe<Array<InputMaybe<InstanceRef>>>;
};

export type _ListFloat32Filter = {
  containsAll?: InputMaybe<Array<InputMaybe<Scalars['Float32']>>>;
  containsAny?: InputMaybe<Array<InputMaybe<Scalars['Float32']>>>;
};

export type _ListFloat64Filter = {
  containsAll?: InputMaybe<Array<InputMaybe<Scalars['Float64']>>>;
  containsAny?: InputMaybe<Array<InputMaybe<Scalars['Float64']>>>;
};

export type _ListFloatFilter = {
  containsAll?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  containsAny?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type _ListIdFilter = {
  containsAll?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  containsAny?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type _ListInt32Filter = {
  containsAll?: InputMaybe<Array<InputMaybe<Scalars['Int32']>>>;
  containsAny?: InputMaybe<Array<InputMaybe<Scalars['Int32']>>>;
};

export type _ListInt64Filter = {
  containsAll?: InputMaybe<Array<InputMaybe<Scalars['Int64']>>>;
  containsAny?: InputMaybe<Array<InputMaybe<Scalars['Int64']>>>;
};

export type _ListIntFilter = {
  containsAll?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  containsAny?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type _ListMilestoneFilter = {
  _type?: InputMaybe<_InstanceTypeCondition>;
  and?: InputMaybe<Array<_ListMilestoneFilter>>;
  createdTime?: InputMaybe<_TimestampCondition>;
  description?: InputMaybe<_StringCondition>;
  endActiveTime?: InputMaybe<_TimestampCondition>;
  endScheduleTime?: InputMaybe<_TimestampCondition>;
  externalId?: InputMaybe<_IdCondition>;
  lastUpdatedTime?: InputMaybe<_TimestampCondition>;
  milestoneType?: InputMaybe<_StringCondition>;
  name?: InputMaybe<_StringCondition>;
  not?: InputMaybe<_ListMilestoneFilter>;
  or?: InputMaybe<Array<_ListMilestoneFilter>>;
  orderIndex?: InputMaybe<_Int32Condition>;
  projectId?: InputMaybe<_StringCondition>;
  reportTemplate?: InputMaybe<_StringCondition>;
  schedule?: InputMaybe<_StringCondition>;
  schemaCollection?: InputMaybe<_ListSchemaCollectionFilter>;
  space?: InputMaybe<_StringCondition>;
  startActiveTime?: InputMaybe<_TimestampCondition>;
  startScheduleTime?: InputMaybe<_TimestampCondition>;
};

export type _ListRuleFilter = {
  _type?: InputMaybe<_InstanceTypeCondition>;
  advanceRules?: InputMaybe<_StringCondition>;
  and?: InputMaybe<Array<_ListRuleFilter>>;
  createdTime?: InputMaybe<_TimestampCondition>;
  customerDefinedId?: InputMaybe<_StringCondition>;
  description?: InputMaybe<_StringCondition>;
  errorMessage?: InputMaybe<_StringCondition>;
  externalId?: InputMaybe<_IdCondition>;
  filters?: InputMaybe<_StringCondition>;
  invertedRules?: InputMaybe<_StringCondition>;
  lastUpdatedTime?: InputMaybe<_TimestampCondition>;
  name?: InputMaybe<_StringCondition>;
  not?: InputMaybe<_ListRuleFilter>;
  or?: InputMaybe<Array<_ListRuleFilter>>;
  primaryKeyName?: InputMaybe<_StringCondition>;
  projectId?: InputMaybe<_StringCondition>;
  rules?: InputMaybe<_StringCondition>;
  schemaCollection?: InputMaybe<_ListSchemaCollectionFilter>;
  schemaType?: InputMaybe<_StringCondition>;
  severity?: InputMaybe<_StringCondition>;
  simpleInvertedRules?: InputMaybe<_StringCondition>;
  simpleRules?: InputMaybe<_StringCondition>;
  space?: InputMaybe<_StringCondition>;
  tags?: InputMaybe<_ListStringFilter>;
};

export type _ListRuleRunStatusFilter = {
  _type?: InputMaybe<_InstanceTypeCondition>;
  and?: InputMaybe<Array<_ListRuleRunStatusFilter>>;
  attributes?: InputMaybe<_ListStringFilter>;
  createdTime?: InputMaybe<_TimestampCondition>;
  externalId?: InputMaybe<_IdCondition>;
  failedInstances?: InputMaybe<_ListStringFilter>;
  filteredInstances?: InputMaybe<_ListStringFilter>;
  isFilterResult?: InputMaybe<_BooleanCondition>;
  lastUpdatedTime?: InputMaybe<_TimestampCondition>;
  message?: InputMaybe<_StringCondition>;
  not?: InputMaybe<_ListRuleRunStatusFilter>;
  or?: InputMaybe<Array<_ListRuleRunStatusFilter>>;
  reportId?: InputMaybe<_StringCondition>;
  rule?: InputMaybe<_ListRuleFilter>;
  runAt?: InputMaybe<_TimestampCondition>;
  space?: InputMaybe<_StringCondition>;
  status?: InputMaybe<_StringCondition>;
  totalFailed?: InputMaybe<_Int32Condition>;
  totalValid?: InputMaybe<_Int32Condition>;
};

export type _ListRulesetFilter = {
  _type?: InputMaybe<_InstanceTypeCondition>;
  and?: InputMaybe<Array<_ListRulesetFilter>>;
  createdTime?: InputMaybe<_TimestampCondition>;
  description?: InputMaybe<_StringCondition>;
  externalId?: InputMaybe<_IdCondition>;
  filters?: InputMaybe<_StringCondition>;
  labels?: InputMaybe<_ListStringFilter>;
  lastUpdatedTime?: InputMaybe<_TimestampCondition>;
  name?: InputMaybe<_StringCondition>;
  not?: InputMaybe<_ListRulesetFilter>;
  or?: InputMaybe<Array<_ListRulesetFilter>>;
  projectId?: InputMaybe<_StringCondition>;
  schemaType?: InputMaybe<_StringCondition>;
  space?: InputMaybe<_StringCondition>;
};

export type _ListSchemaCollectionFilter = {
  _type?: InputMaybe<_InstanceTypeCondition>;
  and?: InputMaybe<Array<_ListSchemaCollectionFilter>>;
  createdTime?: InputMaybe<_TimestampCondition>;
  description?: InputMaybe<_StringCondition>;
  externalId?: InputMaybe<_IdCondition>;
  graphQLSchemaString?: InputMaybe<_StringCondition>;
  lastUpdatedTime?: InputMaybe<_TimestampCondition>;
  name?: InputMaybe<_StringCondition>;
  not?: InputMaybe<_ListSchemaCollectionFilter>;
  or?: InputMaybe<Array<_ListSchemaCollectionFilter>>;
  project?: InputMaybe<_ListDigitalTwinFilter>;
  refId?: InputMaybe<_StringCondition>;
  refVersion?: InputMaybe<_Int32Condition>;
  space?: InputMaybe<_StringCondition>;
  tenant?: InputMaybe<_StringCondition>;
};

export type _ListStringFilter = {
  containsAll?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  containsAny?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type _ListTimestampFilter = {
  containsAll?: InputMaybe<Array<InputMaybe<Scalars['Timestamp']>>>;
  containsAny?: InputMaybe<Array<InputMaybe<Scalars['Timestamp']>>>;
};

export type _MilestoneAggregateConnection = {
  __typename?: '_MilestoneAggregateConnection';
  edges: Array<Maybe<_MilestoneAggregateEdge>>;
  items: Array<Maybe<_MilestoneAggregateResult>>;
  pageInfo: PageInfo;
};

export type _MilestoneAggregateEdge = {
  __typename?: '_MilestoneAggregateEdge';
  _type?: Maybe<_InstanceType>;
  cursor?: Maybe<Scalars['String']>;
  externalId: Scalars['ID'];
  node: _MilestoneAggregateResult;
  space: Scalars['String'];
};

export type _MilestoneAggregateFieldCountResult = {
  __typename?: '_MilestoneAggregateFieldCountResult';
  description?: Maybe<Scalars['Int']>;
  endActiveTime?: Maybe<Scalars['Int']>;
  endScheduleTime?: Maybe<Scalars['Int']>;
  externalId?: Maybe<Scalars['Int']>;
  milestoneType?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['Int']>;
  orderIndex?: Maybe<Scalars['Int']>;
  projectId?: Maybe<Scalars['Int']>;
  reportTemplate?: Maybe<Scalars['Int']>;
  schedule?: Maybe<Scalars['Int']>;
  schemaCollection?: Maybe<Scalars['Int']>;
  startActiveTime?: Maybe<Scalars['Int']>;
  startScheduleTime?: Maybe<Scalars['Int']>;
};

export type _MilestoneAggregateFieldResult = {
  __typename?: '_MilestoneAggregateFieldResult';
  orderIndex?: Maybe<Scalars['Int32']>;
};

export type _MilestoneAggregateHistogramFieldResult = {
  __typename?: '_MilestoneAggregateHistogramFieldResult';
  orderIndex?: Maybe<Array<Maybe<_AggregateHistogramObjectType>>>;
};

/** This type contains Aggregation Results for the ___Milestone___ type */
export type _MilestoneAggregateResult = {
  __typename?: '_MilestoneAggregateResult';
  /** Average for selected nodes, can only be selected for _numeric_ fields, and always returns a `Float` response */
  avg?: Maybe<_MilestoneAvgAggregateFieldResult>;
  /** Count for selected fields, can use this to count the number of nodes */
  count?: Maybe<_MilestoneAggregateFieldCountResult>;
  /** Apply groupBy operations on the _fields_ argument passed */
  group?: Maybe<Scalars['JSONObject']>;
  /** Histogram  */
  histogram?: Maybe<_MilestoneAggregateHistogramFieldResult>;
  /** Maximum of any of the nodes, can only be selected for _numeric_ fields */
  max?: Maybe<_MilestoneAggregateFieldResult>;
  /** Minimum of any of the nodes, can only be selected for _numeric_ fields */
  min?: Maybe<_MilestoneAggregateFieldResult>;
  /** Sum for selected fields, can only be selected for _numeric_ fields */
  sum?: Maybe<_MilestoneAggregateFieldResult>;
};

/** This type contains Aggregation Results for the ___Milestone___ type */
export type _MilestoneAggregateResultHistogramArgs = {
  interval: Scalars['Int'];
};

export type _MilestoneAvgAggregateFieldResult = {
  __typename?: '_MilestoneAvgAggregateFieldResult';
  orderIndex?: Maybe<Scalars['Float']>;
};

export type _MilestoneConnection = {
  __typename?: '_MilestoneConnection';
  edges: Array<Maybe<_MilestoneEdge>>;
  items: Array<Maybe<Milestone>>;
  pageInfo: PageInfo;
};

export type _MilestoneEdge = {
  __typename?: '_MilestoneEdge';
  _type?: Maybe<_InstanceType>;
  cursor?: Maybe<Scalars['String']>;
  externalId: Scalars['ID'];
  node: Milestone;
  space: Scalars['String'];
};

export type _MilestoneSort = {
  description?: InputMaybe<SortDirection>;
  endActiveTime?: InputMaybe<SortDirection>;
  endScheduleTime?: InputMaybe<SortDirection>;
  externalId?: InputMaybe<SortDirection>;
  milestoneType?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  orderIndex?: InputMaybe<SortDirection>;
  projectId?: InputMaybe<SortDirection>;
  reportTemplate?: InputMaybe<SortDirection>;
  schedule?: InputMaybe<SortDirection>;
  schemaCollection?: InputMaybe<SortDirection>;
  space?: InputMaybe<SortDirection>;
  startActiveTime?: InputMaybe<SortDirection>;
  startScheduleTime?: InputMaybe<SortDirection>;
};

export type _RuleAggregateConnection = {
  __typename?: '_RuleAggregateConnection';
  edges: Array<Maybe<_RuleAggregateEdge>>;
  items: Array<Maybe<_RuleAggregateResult>>;
  pageInfo: PageInfo;
};

export type _RuleAggregateEdge = {
  __typename?: '_RuleAggregateEdge';
  _type?: Maybe<_InstanceType>;
  cursor?: Maybe<Scalars['String']>;
  externalId: Scalars['ID'];
  node: _RuleAggregateResult;
  space: Scalars['String'];
};

export type _RuleAggregateFieldCountResult = {
  __typename?: '_RuleAggregateFieldCountResult';
  advanceRules?: Maybe<Scalars['Int']>;
  customerDefinedId?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['Int']>;
  errorMessage?: Maybe<Scalars['Int']>;
  externalId?: Maybe<Scalars['Int']>;
  filters?: Maybe<Scalars['Int']>;
  invertedRules?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['Int']>;
  primaryKeyName?: Maybe<Scalars['Int']>;
  projectId?: Maybe<Scalars['Int']>;
  rules?: Maybe<Scalars['Int']>;
  schemaCollection?: Maybe<Scalars['Int']>;
  schemaType?: Maybe<Scalars['Int']>;
  severity?: Maybe<Scalars['Int']>;
  simpleInvertedRules?: Maybe<Scalars['Int']>;
  simpleRules?: Maybe<Scalars['Int']>;
  tags?: Maybe<Scalars['Int']>;
};

export type _RuleAggregateFieldResult = {
  __typename?: '_RuleAggregateFieldResult';
  _empty: Scalars['Int'];
};

export type _RuleAggregateHistogramFieldResult = {
  __typename?: '_RuleAggregateHistogramFieldResult';
  _empty?: Maybe<Array<Maybe<_AggregateHistogramObjectType>>>;
};

/** This type contains Aggregation Results for the ___Rule___ type */
export type _RuleAggregateResult = {
  __typename?: '_RuleAggregateResult';
  /** Average for selected nodes, can only be selected for _numeric_ fields, and always returns a `Float` response */
  avg?: Maybe<_RuleAvgAggregateFieldResult>;
  /** Count for selected fields, can use this to count the number of nodes */
  count?: Maybe<_RuleAggregateFieldCountResult>;
  /** Apply groupBy operations on the _fields_ argument passed */
  group?: Maybe<Scalars['JSONObject']>;
  /** Histogram  */
  histogram?: Maybe<_RuleAggregateHistogramFieldResult>;
  /** Maximum of any of the nodes, can only be selected for _numeric_ fields */
  max?: Maybe<_RuleAggregateFieldResult>;
  /** Minimum of any of the nodes, can only be selected for _numeric_ fields */
  min?: Maybe<_RuleAggregateFieldResult>;
  /** Sum for selected fields, can only be selected for _numeric_ fields */
  sum?: Maybe<_RuleAggregateFieldResult>;
};

/** This type contains Aggregation Results for the ___Rule___ type */
export type _RuleAggregateResultHistogramArgs = {
  interval: Scalars['Int'];
};

export type _RuleAvgAggregateFieldResult = {
  __typename?: '_RuleAvgAggregateFieldResult';
  _empty: Scalars['Int'];
};

export type _RuleConnection = {
  __typename?: '_RuleConnection';
  edges: Array<Maybe<_RuleEdge>>;
  items: Array<Maybe<Rule>>;
  pageInfo: PageInfo;
};

export type _RuleEdge = {
  __typename?: '_RuleEdge';
  _type?: Maybe<_InstanceType>;
  cursor?: Maybe<Scalars['String']>;
  externalId: Scalars['ID'];
  node: Rule;
  space: Scalars['String'];
};

export type _RuleRunStatusAggregateConnection = {
  __typename?: '_RuleRunStatusAggregateConnection';
  edges: Array<Maybe<_RuleRunStatusAggregateEdge>>;
  items: Array<Maybe<_RuleRunStatusAggregateResult>>;
  pageInfo: PageInfo;
};

export type _RuleRunStatusAggregateEdge = {
  __typename?: '_RuleRunStatusAggregateEdge';
  _type?: Maybe<_InstanceType>;
  cursor?: Maybe<Scalars['String']>;
  externalId: Scalars['ID'];
  node: _RuleRunStatusAggregateResult;
  space: Scalars['String'];
};

export type _RuleRunStatusAggregateFieldCountResult = {
  __typename?: '_RuleRunStatusAggregateFieldCountResult';
  attributes?: Maybe<Scalars['Int']>;
  externalId?: Maybe<Scalars['Int']>;
  failedInstances?: Maybe<Scalars['Int']>;
  filteredInstances?: Maybe<Scalars['Int']>;
  isFilterResult?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['Int']>;
  reportId?: Maybe<Scalars['Int']>;
  rule?: Maybe<Scalars['Int']>;
  runAt?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['Int']>;
  totalFailed?: Maybe<Scalars['Int']>;
  totalValid?: Maybe<Scalars['Int']>;
};

export type _RuleRunStatusAggregateFieldResult = {
  __typename?: '_RuleRunStatusAggregateFieldResult';
  totalFailed?: Maybe<Scalars['Int32']>;
  totalValid?: Maybe<Scalars['Int32']>;
};

export type _RuleRunStatusAggregateHistogramFieldResult = {
  __typename?: '_RuleRunStatusAggregateHistogramFieldResult';
  totalFailed?: Maybe<Array<Maybe<_AggregateHistogramObjectType>>>;
  totalValid?: Maybe<Array<Maybe<_AggregateHistogramObjectType>>>;
};

/** This type contains Aggregation Results for the ___RuleRunStatus___ type */
export type _RuleRunStatusAggregateResult = {
  __typename?: '_RuleRunStatusAggregateResult';
  /** Average for selected nodes, can only be selected for _numeric_ fields, and always returns a `Float` response */
  avg?: Maybe<_RuleRunStatusAvgAggregateFieldResult>;
  /** Count for selected fields, can use this to count the number of nodes */
  count?: Maybe<_RuleRunStatusAggregateFieldCountResult>;
  /** Apply groupBy operations on the _fields_ argument passed */
  group?: Maybe<Scalars['JSONObject']>;
  /** Histogram  */
  histogram?: Maybe<_RuleRunStatusAggregateHistogramFieldResult>;
  /** Maximum of any of the nodes, can only be selected for _numeric_ fields */
  max?: Maybe<_RuleRunStatusAggregateFieldResult>;
  /** Minimum of any of the nodes, can only be selected for _numeric_ fields */
  min?: Maybe<_RuleRunStatusAggregateFieldResult>;
  /** Sum for selected fields, can only be selected for _numeric_ fields */
  sum?: Maybe<_RuleRunStatusAggregateFieldResult>;
};

/** This type contains Aggregation Results for the ___RuleRunStatus___ type */
export type _RuleRunStatusAggregateResultHistogramArgs = {
  interval: Scalars['Int'];
};

export type _RuleRunStatusAvgAggregateFieldResult = {
  __typename?: '_RuleRunStatusAvgAggregateFieldResult';
  totalFailed?: Maybe<Scalars['Float']>;
  totalValid?: Maybe<Scalars['Float']>;
};

export type _RuleRunStatusConnection = {
  __typename?: '_RuleRunStatusConnection';
  edges: Array<Maybe<_RuleRunStatusEdge>>;
  items: Array<Maybe<RuleRunStatus>>;
  pageInfo: PageInfo;
};

export type _RuleRunStatusEdge = {
  __typename?: '_RuleRunStatusEdge';
  _type?: Maybe<_InstanceType>;
  cursor?: Maybe<Scalars['String']>;
  externalId: Scalars['ID'];
  node: RuleRunStatus;
  space: Scalars['String'];
};

export type _RuleRunStatusSort = {
  externalId?: InputMaybe<SortDirection>;
  isFilterResult?: InputMaybe<SortDirection>;
  message?: InputMaybe<SortDirection>;
  reportId?: InputMaybe<SortDirection>;
  rule?: InputMaybe<SortDirection>;
  runAt?: InputMaybe<SortDirection>;
  space?: InputMaybe<SortDirection>;
  status?: InputMaybe<SortDirection>;
  totalFailed?: InputMaybe<SortDirection>;
  totalValid?: InputMaybe<SortDirection>;
};

export type _RuleSort = {
  advanceRules?: InputMaybe<SortDirection>;
  customerDefinedId?: InputMaybe<SortDirection>;
  description?: InputMaybe<SortDirection>;
  errorMessage?: InputMaybe<SortDirection>;
  externalId?: InputMaybe<SortDirection>;
  filters?: InputMaybe<SortDirection>;
  invertedRules?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  primaryKeyName?: InputMaybe<SortDirection>;
  projectId?: InputMaybe<SortDirection>;
  rules?: InputMaybe<SortDirection>;
  schemaCollection?: InputMaybe<SortDirection>;
  schemaType?: InputMaybe<SortDirection>;
  severity?: InputMaybe<SortDirection>;
  simpleInvertedRules?: InputMaybe<SortDirection>;
  simpleRules?: InputMaybe<SortDirection>;
  space?: InputMaybe<SortDirection>;
};

export type _RulesetAggregateConnection = {
  __typename?: '_RulesetAggregateConnection';
  edges: Array<Maybe<_RulesetAggregateEdge>>;
  items: Array<Maybe<_RulesetAggregateResult>>;
  pageInfo: PageInfo;
};

export type _RulesetAggregateEdge = {
  __typename?: '_RulesetAggregateEdge';
  _type?: Maybe<_InstanceType>;
  cursor?: Maybe<Scalars['String']>;
  externalId: Scalars['ID'];
  node: _RulesetAggregateResult;
  space: Scalars['String'];
};

export type _RulesetAggregateFieldCountResult = {
  __typename?: '_RulesetAggregateFieldCountResult';
  description?: Maybe<Scalars['Int']>;
  externalId?: Maybe<Scalars['Int']>;
  filters?: Maybe<Scalars['Int']>;
  labels?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['Int']>;
  projectId?: Maybe<Scalars['Int']>;
  schemaType?: Maybe<Scalars['Int']>;
};

export type _RulesetAggregateFieldResult = {
  __typename?: '_RulesetAggregateFieldResult';
  _empty: Scalars['Int'];
};

export type _RulesetAggregateHistogramFieldResult = {
  __typename?: '_RulesetAggregateHistogramFieldResult';
  _empty?: Maybe<Array<Maybe<_AggregateHistogramObjectType>>>;
};

/** This type contains Aggregation Results for the ___Ruleset___ type */
export type _RulesetAggregateResult = {
  __typename?: '_RulesetAggregateResult';
  /** Average for selected nodes, can only be selected for _numeric_ fields, and always returns a `Float` response */
  avg?: Maybe<_RulesetAvgAggregateFieldResult>;
  /** Count for selected fields, can use this to count the number of nodes */
  count?: Maybe<_RulesetAggregateFieldCountResult>;
  /** Apply groupBy operations on the _fields_ argument passed */
  group?: Maybe<Scalars['JSONObject']>;
  /** Histogram  */
  histogram?: Maybe<_RulesetAggregateHistogramFieldResult>;
  /** Maximum of any of the nodes, can only be selected for _numeric_ fields */
  max?: Maybe<_RulesetAggregateFieldResult>;
  /** Minimum of any of the nodes, can only be selected for _numeric_ fields */
  min?: Maybe<_RulesetAggregateFieldResult>;
  /** Sum for selected fields, can only be selected for _numeric_ fields */
  sum?: Maybe<_RulesetAggregateFieldResult>;
};

/** This type contains Aggregation Results for the ___Ruleset___ type */
export type _RulesetAggregateResultHistogramArgs = {
  interval: Scalars['Int'];
};

export type _RulesetAvgAggregateFieldResult = {
  __typename?: '_RulesetAvgAggregateFieldResult';
  _empty: Scalars['Int'];
};

export type _RulesetConnection = {
  __typename?: '_RulesetConnection';
  edges: Array<Maybe<_RulesetEdge>>;
  items: Array<Maybe<Ruleset>>;
  pageInfo: PageInfo;
};

export type _RulesetEdge = {
  __typename?: '_RulesetEdge';
  _type?: Maybe<_InstanceType>;
  cursor?: Maybe<Scalars['String']>;
  externalId: Scalars['ID'];
  node: Ruleset;
  space: Scalars['String'];
};

export type _RulesetSort = {
  description?: InputMaybe<SortDirection>;
  externalId?: InputMaybe<SortDirection>;
  filters?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  projectId?: InputMaybe<SortDirection>;
  schemaType?: InputMaybe<SortDirection>;
  space?: InputMaybe<SortDirection>;
};

export type _SchemaCollectionAggregateConnection = {
  __typename?: '_SchemaCollectionAggregateConnection';
  edges: Array<Maybe<_SchemaCollectionAggregateEdge>>;
  items: Array<Maybe<_SchemaCollectionAggregateResult>>;
  pageInfo: PageInfo;
};

export type _SchemaCollectionAggregateEdge = {
  __typename?: '_SchemaCollectionAggregateEdge';
  _type?: Maybe<_InstanceType>;
  cursor?: Maybe<Scalars['String']>;
  externalId: Scalars['ID'];
  node: _SchemaCollectionAggregateResult;
  space: Scalars['String'];
};

export type _SchemaCollectionAggregateFieldCountResult = {
  __typename?: '_SchemaCollectionAggregateFieldCountResult';
  description?: Maybe<Scalars['Int']>;
  externalId?: Maybe<Scalars['Int']>;
  graphQLSchemaString?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['Int']>;
  project?: Maybe<Scalars['Int']>;
  refId?: Maybe<Scalars['Int']>;
  refVersion?: Maybe<Scalars['Int']>;
  tenant?: Maybe<Scalars['Int']>;
};

export type _SchemaCollectionAggregateFieldResult = {
  __typename?: '_SchemaCollectionAggregateFieldResult';
  refVersion?: Maybe<Scalars['Int32']>;
};

export type _SchemaCollectionAggregateHistogramFieldResult = {
  __typename?: '_SchemaCollectionAggregateHistogramFieldResult';
  refVersion?: Maybe<Array<Maybe<_AggregateHistogramObjectType>>>;
};

/** This type contains Aggregation Results for the ___SchemaCollection___ type */
export type _SchemaCollectionAggregateResult = {
  __typename?: '_SchemaCollectionAggregateResult';
  /** Average for selected nodes, can only be selected for _numeric_ fields, and always returns a `Float` response */
  avg?: Maybe<_SchemaCollectionAvgAggregateFieldResult>;
  /** Count for selected fields, can use this to count the number of nodes */
  count?: Maybe<_SchemaCollectionAggregateFieldCountResult>;
  /** Apply groupBy operations on the _fields_ argument passed */
  group?: Maybe<Scalars['JSONObject']>;
  /** Histogram  */
  histogram?: Maybe<_SchemaCollectionAggregateHistogramFieldResult>;
  /** Maximum of any of the nodes, can only be selected for _numeric_ fields */
  max?: Maybe<_SchemaCollectionAggregateFieldResult>;
  /** Minimum of any of the nodes, can only be selected for _numeric_ fields */
  min?: Maybe<_SchemaCollectionAggregateFieldResult>;
  /** Sum for selected fields, can only be selected for _numeric_ fields */
  sum?: Maybe<_SchemaCollectionAggregateFieldResult>;
};

/** This type contains Aggregation Results for the ___SchemaCollection___ type */
export type _SchemaCollectionAggregateResultHistogramArgs = {
  interval: Scalars['Int'];
};

export type _SchemaCollectionAvgAggregateFieldResult = {
  __typename?: '_SchemaCollectionAvgAggregateFieldResult';
  refVersion?: Maybe<Scalars['Float']>;
};

export type _SchemaCollectionConnection = {
  __typename?: '_SchemaCollectionConnection';
  edges: Array<Maybe<_SchemaCollectionEdge>>;
  items: Array<Maybe<SchemaCollection>>;
  pageInfo: PageInfo;
};

export type _SchemaCollectionEdge = {
  __typename?: '_SchemaCollectionEdge';
  _type?: Maybe<_InstanceType>;
  cursor?: Maybe<Scalars['String']>;
  externalId: Scalars['ID'];
  node: SchemaCollection;
  space: Scalars['String'];
};

export type _SchemaCollectionSort = {
  description?: InputMaybe<SortDirection>;
  externalId?: InputMaybe<SortDirection>;
  graphQLSchemaString?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  project?: InputMaybe<SortDirection>;
  refId?: InputMaybe<SortDirection>;
  refVersion?: InputMaybe<SortDirection>;
  space?: InputMaybe<SortDirection>;
  tenant?: InputMaybe<SortDirection>;
};

export enum _SearchAccessFields {
  ExternalId = 'externalId',
  Role = 'role',
  Space = 'space',
  Tenant = 'tenant',
  UserId = 'userId',
}

export type _SearchAccessFilter = {
  _type?: InputMaybe<_InstanceTypeCondition>;
  and?: InputMaybe<Array<_SearchAccessFilter>>;
  createdTime?: InputMaybe<_TimestampCondition>;
  externalId?: InputMaybe<_IdCondition>;
  lastUpdatedTime?: InputMaybe<_TimestampCondition>;
  not?: InputMaybe<_SearchAccessFilter>;
  or?: InputMaybe<Array<_SearchAccessFilter>>;
  role?: InputMaybe<_StringCondition>;
  space?: InputMaybe<_StringCondition>;
  tenant?: InputMaybe<_StringCondition>;
  userId?: InputMaybe<_StringCondition>;
};

export enum _SearchConsistencyCollectionFields {
  CreatedAt = 'createdAt',
  Description = 'description',
  ExternalId = 'externalId',
  Labels = 'labels',
  Name = 'name',
  Project = 'project',
  ProjectId = 'projectId',
  ReportTemplate = 'reportTemplate',
  Space = 'space',
  Tenant = 'tenant',
}

export type _SearchConsistencyCollectionFilter = {
  _type?: InputMaybe<_InstanceTypeCondition>;
  and?: InputMaybe<Array<_SearchConsistencyCollectionFilter>>;
  createdAt?: InputMaybe<_TimestampCondition>;
  createdTime?: InputMaybe<_TimestampCondition>;
  description?: InputMaybe<_StringCondition>;
  externalId?: InputMaybe<_IdCondition>;
  labels?: InputMaybe<_ListStringFilter>;
  lastUpdatedTime?: InputMaybe<_TimestampCondition>;
  name?: InputMaybe<_StringCondition>;
  not?: InputMaybe<_SearchConsistencyCollectionFilter>;
  or?: InputMaybe<Array<_SearchConsistencyCollectionFilter>>;
  projectId?: InputMaybe<_StringCondition>;
  reportTemplate?: InputMaybe<_StringCondition>;
  space?: InputMaybe<_StringCondition>;
  tenant?: InputMaybe<_StringCondition>;
};

export enum _SearchConsistencyConditionCheckFields {
  ExternalId = 'externalId',
  IsLiteralValue = 'isLiteralValue',
  Operator = 'operator',
  Rule = 'rule',
  SourceAttribute = 'sourceAttribute',
  Space = 'space',
  TargetAttribute = 'targetAttribute',
  UseTargetSchema = 'useTargetSchema',
}

export type _SearchConsistencyConditionCheckFilter = {
  _type?: InputMaybe<_InstanceTypeCondition>;
  and?: InputMaybe<Array<_SearchConsistencyConditionCheckFilter>>;
  createdTime?: InputMaybe<_TimestampCondition>;
  externalId?: InputMaybe<_IdCondition>;
  isLiteralValue?: InputMaybe<_BooleanCondition>;
  lastUpdatedTime?: InputMaybe<_TimestampCondition>;
  not?: InputMaybe<_SearchConsistencyConditionCheckFilter>;
  operator?: InputMaybe<_StringCondition>;
  or?: InputMaybe<Array<_SearchConsistencyConditionCheckFilter>>;
  sourceAttribute?: InputMaybe<_StringCondition>;
  space?: InputMaybe<_StringCondition>;
  targetAttribute?: InputMaybe<_StringCondition>;
  useTargetSchema?: InputMaybe<_BooleanCondition>;
};

export enum _SearchConsistencyRuleFields {
  Collection = 'collection',
  ConditionChecksOnly = 'conditionChecksOnly',
  CustomerDefinedId = 'customerDefinedId',
  Description = 'description',
  ErrorMessage = 'errorMessage',
  ExternalId = 'externalId',
  Name = 'name',
  Operator = 'operator',
  ProjectId = 'projectId',
  Severity = 'severity',
  SourceAttribute = 'sourceAttribute',
  SourceFilters = 'sourceFilters',
  SourceSchemaFilter = 'sourceSchemaFilter',
  Space = 'space',
  Tags = 'tags',
  TargetAttribute = 'targetAttribute',
  TargetFilters = 'targetFilters',
  TargetSchemaFilter = 'targetSchemaFilter',
}

export type _SearchConsistencyRuleFilter = {
  _type?: InputMaybe<_InstanceTypeCondition>;
  and?: InputMaybe<Array<_SearchConsistencyRuleFilter>>;
  conditionChecksOnly?: InputMaybe<_BooleanCondition>;
  createdTime?: InputMaybe<_TimestampCondition>;
  customerDefinedId?: InputMaybe<_StringCondition>;
  description?: InputMaybe<_StringCondition>;
  errorMessage?: InputMaybe<_StringCondition>;
  externalId?: InputMaybe<_IdCondition>;
  lastUpdatedTime?: InputMaybe<_TimestampCondition>;
  name?: InputMaybe<_StringCondition>;
  not?: InputMaybe<_SearchConsistencyRuleFilter>;
  operator?: InputMaybe<_StringCondition>;
  or?: InputMaybe<Array<_SearchConsistencyRuleFilter>>;
  projectId?: InputMaybe<_StringCondition>;
  severity?: InputMaybe<_StringCondition>;
  sourceAttribute?: InputMaybe<_StringCondition>;
  sourceFilters?: InputMaybe<_StringCondition>;
  space?: InputMaybe<_StringCondition>;
  tags?: InputMaybe<_ListStringFilter>;
  targetAttribute?: InputMaybe<_StringCondition>;
  targetFilters?: InputMaybe<_StringCondition>;
};

export enum _SearchConsistencyRunStatusFields {
  Attributes = 'attributes',
  ExternalId = 'externalId',
  FailedInstances = 'failedInstances',
  Message = 'message',
  ReportId = 'reportId',
  Rule = 'rule',
  RunAt = 'runAt',
  Space = 'space',
  Status = 'status',
  TotalFailed = 'totalFailed',
  TotalValid = 'totalValid',
}

export type _SearchConsistencyRunStatusFilter = {
  _type?: InputMaybe<_InstanceTypeCondition>;
  and?: InputMaybe<Array<_SearchConsistencyRunStatusFilter>>;
  attributes?: InputMaybe<_ListStringFilter>;
  createdTime?: InputMaybe<_TimestampCondition>;
  externalId?: InputMaybe<_IdCondition>;
  failedInstances?: InputMaybe<_ListStringFilter>;
  lastUpdatedTime?: InputMaybe<_TimestampCondition>;
  message?: InputMaybe<_StringCondition>;
  not?: InputMaybe<_SearchConsistencyRunStatusFilter>;
  or?: InputMaybe<Array<_SearchConsistencyRunStatusFilter>>;
  reportId?: InputMaybe<_StringCondition>;
  runAt?: InputMaybe<_TimestampCondition>;
  space?: InputMaybe<_StringCondition>;
  status?: InputMaybe<_StringCondition>;
  totalFailed?: InputMaybe<_Int32Condition>;
  totalValid?: InputMaybe<_Int32Condition>;
};

export enum _SearchConsistencySchemaFilterFields {
  Collection = 'collection',
  Description = 'description',
  ExternalId = 'externalId',
  Filters = 'filters',
  Labels = 'labels',
  Name = 'name',
  ProjectId = 'projectId',
  SchemaCollectionId = 'schemaCollectionId',
  SchemaType = 'schemaType',
  Space = 'space',
}

export type _SearchConsistencySchemaFilterFilter = {
  _type?: InputMaybe<_InstanceTypeCondition>;
  and?: InputMaybe<Array<_SearchConsistencySchemaFilterFilter>>;
  createdTime?: InputMaybe<_TimestampCondition>;
  description?: InputMaybe<_StringCondition>;
  externalId?: InputMaybe<_IdCondition>;
  filters?: InputMaybe<_StringCondition>;
  labels?: InputMaybe<_ListStringFilter>;
  lastUpdatedTime?: InputMaybe<_TimestampCondition>;
  name?: InputMaybe<_StringCondition>;
  not?: InputMaybe<_SearchConsistencySchemaFilterFilter>;
  or?: InputMaybe<Array<_SearchConsistencySchemaFilterFilter>>;
  projectId?: InputMaybe<_StringCondition>;
  schemaCollectionId?: InputMaybe<_StringCondition>;
  schemaType?: InputMaybe<_StringCondition>;
  space?: InputMaybe<_StringCondition>;
};

export enum _SearchDigitalTwinFields {
  ExternalId = 'externalId',
  Name = 'name',
  Space = 'space',
  Tenant = 'tenant',
}

export type _SearchDigitalTwinFilter = {
  _type?: InputMaybe<_InstanceTypeCondition>;
  and?: InputMaybe<Array<_SearchDigitalTwinFilter>>;
  createdTime?: InputMaybe<_TimestampCondition>;
  externalId?: InputMaybe<_IdCondition>;
  lastUpdatedTime?: InputMaybe<_TimestampCondition>;
  name?: InputMaybe<_StringCondition>;
  not?: InputMaybe<_SearchDigitalTwinFilter>;
  or?: InputMaybe<Array<_SearchDigitalTwinFilter>>;
  space?: InputMaybe<_StringCondition>;
  tenant?: InputMaybe<_StringCondition>;
};

export enum _SearchMilestoneFields {
  Description = 'description',
  EndActiveTime = 'endActiveTime',
  EndScheduleTime = 'endScheduleTime',
  ExternalId = 'externalId',
  MilestoneType = 'milestoneType',
  Name = 'name',
  OrderIndex = 'orderIndex',
  ProjectId = 'projectId',
  ReportTemplate = 'reportTemplate',
  Schedule = 'schedule',
  SchemaCollection = 'schemaCollection',
  Space = 'space',
  StartActiveTime = 'startActiveTime',
  StartScheduleTime = 'startScheduleTime',
}

export type _SearchMilestoneFilter = {
  _type?: InputMaybe<_InstanceTypeCondition>;
  and?: InputMaybe<Array<_SearchMilestoneFilter>>;
  createdTime?: InputMaybe<_TimestampCondition>;
  description?: InputMaybe<_StringCondition>;
  endActiveTime?: InputMaybe<_TimestampCondition>;
  endScheduleTime?: InputMaybe<_TimestampCondition>;
  externalId?: InputMaybe<_IdCondition>;
  lastUpdatedTime?: InputMaybe<_TimestampCondition>;
  milestoneType?: InputMaybe<_StringCondition>;
  name?: InputMaybe<_StringCondition>;
  not?: InputMaybe<_SearchMilestoneFilter>;
  or?: InputMaybe<Array<_SearchMilestoneFilter>>;
  orderIndex?: InputMaybe<_Int32Condition>;
  projectId?: InputMaybe<_StringCondition>;
  reportTemplate?: InputMaybe<_StringCondition>;
  schedule?: InputMaybe<_StringCondition>;
  space?: InputMaybe<_StringCondition>;
  startActiveTime?: InputMaybe<_TimestampCondition>;
  startScheduleTime?: InputMaybe<_TimestampCondition>;
};

export enum _SearchRuleFields {
  AdvanceRules = 'advanceRules',
  CustomerDefinedId = 'customerDefinedId',
  Description = 'description',
  ErrorMessage = 'errorMessage',
  ExternalId = 'externalId',
  Filters = 'filters',
  InvertedRules = 'invertedRules',
  Name = 'name',
  PrimaryKeyName = 'primaryKeyName',
  ProjectId = 'projectId',
  Rules = 'rules',
  SchemaCollection = 'schemaCollection',
  SchemaType = 'schemaType',
  Severity = 'severity',
  SimpleInvertedRules = 'simpleInvertedRules',
  SimpleRules = 'simpleRules',
  Space = 'space',
  Tags = 'tags',
}

export type _SearchRuleFilter = {
  _type?: InputMaybe<_InstanceTypeCondition>;
  advanceRules?: InputMaybe<_StringCondition>;
  and?: InputMaybe<Array<_SearchRuleFilter>>;
  createdTime?: InputMaybe<_TimestampCondition>;
  customerDefinedId?: InputMaybe<_StringCondition>;
  description?: InputMaybe<_StringCondition>;
  errorMessage?: InputMaybe<_StringCondition>;
  externalId?: InputMaybe<_IdCondition>;
  filters?: InputMaybe<_StringCondition>;
  invertedRules?: InputMaybe<_StringCondition>;
  lastUpdatedTime?: InputMaybe<_TimestampCondition>;
  name?: InputMaybe<_StringCondition>;
  not?: InputMaybe<_SearchRuleFilter>;
  or?: InputMaybe<Array<_SearchRuleFilter>>;
  primaryKeyName?: InputMaybe<_StringCondition>;
  projectId?: InputMaybe<_StringCondition>;
  rules?: InputMaybe<_StringCondition>;
  schemaType?: InputMaybe<_StringCondition>;
  severity?: InputMaybe<_StringCondition>;
  simpleInvertedRules?: InputMaybe<_StringCondition>;
  simpleRules?: InputMaybe<_StringCondition>;
  space?: InputMaybe<_StringCondition>;
  tags?: InputMaybe<_ListStringFilter>;
};

export enum _SearchRuleRunStatusFields {
  Attributes = 'attributes',
  ExternalId = 'externalId',
  FailedInstances = 'failedInstances',
  FilteredInstances = 'filteredInstances',
  IsFilterResult = 'isFilterResult',
  Message = 'message',
  ReportId = 'reportId',
  Rule = 'rule',
  RunAt = 'runAt',
  Space = 'space',
  Status = 'status',
  TotalFailed = 'totalFailed',
  TotalValid = 'totalValid',
}

export type _SearchRuleRunStatusFilter = {
  _type?: InputMaybe<_InstanceTypeCondition>;
  and?: InputMaybe<Array<_SearchRuleRunStatusFilter>>;
  attributes?: InputMaybe<_ListStringFilter>;
  createdTime?: InputMaybe<_TimestampCondition>;
  externalId?: InputMaybe<_IdCondition>;
  failedInstances?: InputMaybe<_ListStringFilter>;
  filteredInstances?: InputMaybe<_ListStringFilter>;
  isFilterResult?: InputMaybe<_BooleanCondition>;
  lastUpdatedTime?: InputMaybe<_TimestampCondition>;
  message?: InputMaybe<_StringCondition>;
  not?: InputMaybe<_SearchRuleRunStatusFilter>;
  or?: InputMaybe<Array<_SearchRuleRunStatusFilter>>;
  reportId?: InputMaybe<_StringCondition>;
  runAt?: InputMaybe<_TimestampCondition>;
  space?: InputMaybe<_StringCondition>;
  status?: InputMaybe<_StringCondition>;
  totalFailed?: InputMaybe<_Int32Condition>;
  totalValid?: InputMaybe<_Int32Condition>;
};

export enum _SearchRulesetFields {
  Description = 'description',
  ExternalId = 'externalId',
  Filters = 'filters',
  Labels = 'labels',
  Name = 'name',
  ProjectId = 'projectId',
  SchemaType = 'schemaType',
  Space = 'space',
}

export type _SearchRulesetFilter = {
  _type?: InputMaybe<_InstanceTypeCondition>;
  and?: InputMaybe<Array<_SearchRulesetFilter>>;
  createdTime?: InputMaybe<_TimestampCondition>;
  description?: InputMaybe<_StringCondition>;
  externalId?: InputMaybe<_IdCondition>;
  filters?: InputMaybe<_StringCondition>;
  labels?: InputMaybe<_ListStringFilter>;
  lastUpdatedTime?: InputMaybe<_TimestampCondition>;
  name?: InputMaybe<_StringCondition>;
  not?: InputMaybe<_SearchRulesetFilter>;
  or?: InputMaybe<Array<_SearchRulesetFilter>>;
  projectId?: InputMaybe<_StringCondition>;
  schemaType?: InputMaybe<_StringCondition>;
  space?: InputMaybe<_StringCondition>;
};

export enum _SearchSchemaCollectionFields {
  Description = 'description',
  ExternalId = 'externalId',
  GraphQlSchemaString = 'graphQLSchemaString',
  Name = 'name',
  Project = 'project',
  RefId = 'refId',
  RefVersion = 'refVersion',
  Space = 'space',
  Tenant = 'tenant',
}

export type _SearchSchemaCollectionFilter = {
  _type?: InputMaybe<_InstanceTypeCondition>;
  and?: InputMaybe<Array<_SearchSchemaCollectionFilter>>;
  createdTime?: InputMaybe<_TimestampCondition>;
  description?: InputMaybe<_StringCondition>;
  externalId?: InputMaybe<_IdCondition>;
  graphQLSchemaString?: InputMaybe<_StringCondition>;
  lastUpdatedTime?: InputMaybe<_TimestampCondition>;
  name?: InputMaybe<_StringCondition>;
  not?: InputMaybe<_SearchSchemaCollectionFilter>;
  or?: InputMaybe<Array<_SearchSchemaCollectionFilter>>;
  refId?: InputMaybe<_StringCondition>;
  refVersion?: InputMaybe<_Int32Condition>;
  space?: InputMaybe<_StringCondition>;
  tenant?: InputMaybe<_StringCondition>;
};

export type _SequenceColumn = {
  __typename?: '_SequenceColumn';
  description?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['JSONObject']>;
  name?: Maybe<Scalars['String']>;
  valueType?: Maybe<_SequenceColumnValueType>;
};

export type _SequenceColumnInfo = {
  __typename?: '_SequenceColumnInfo';
  externalId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  valueType?: Maybe<_SequenceColumnValueType>;
};

export enum _SequenceColumnValueType {
  Double = 'DOUBLE',
  Long = 'LONG',
  String = 'STRING',
}

export type _SequenceRow = {
  __typename?: '_SequenceRow';
  columns?: Maybe<Array<Maybe<_SequenceColumnInfo>>>;
  externalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int64']>;
  rows?: Maybe<Array<Maybe<_SequenceRowsData>>>;
};

export type _SequenceRowsData = {
  __typename?: '_SequenceRowsData';
  rowNumber?: Maybe<Scalars['Int64']>;
  values?: Maybe<Scalars['_SequenceRowValues']>;
};

export type _StringCondition = {
  eq?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  isNull?: InputMaybe<Scalars['Boolean']>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  prefix?: InputMaybe<Scalars['String']>;
};

export type _TempReturn = {
  __typename?: '_TempReturn';
  /** Dont check the response */
  endNode?: Maybe<Scalars['ID']>;
  /** Dont check the response */
  startNode?: Maybe<Scalars['ID']>;
};

export type _TimestampCondition = {
  eq?: InputMaybe<Scalars['Timestamp']>;
  gt?: InputMaybe<Scalars['Timestamp']>;
  gte?: InputMaybe<Scalars['Timestamp']>;
  in?: InputMaybe<Array<Scalars['Timestamp']>>;
  isNull?: InputMaybe<Scalars['Boolean']>;
  lt?: InputMaybe<Scalars['Timestamp']>;
  lte?: InputMaybe<Scalars['Timestamp']>;
};

export type _UpsertAccess = {
  externalId: Scalars['ID'];
  role?: InputMaybe<Scalars['String']>;
  space: Scalars['String'];
  tenant?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type _UpsertConsistencyCollection = {
  createdAt?: InputMaybe<Scalars['Timestamp']>;
  description?: InputMaybe<Scalars['String']>;
  externalId: Scalars['ID'];
  labels?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  project?: InputMaybe<_UpsertConsistencyCollectionProjectFieldInput>;
  projectId?: InputMaybe<Scalars['String']>;
  reportTemplate?: InputMaybe<Scalars['String']>;
  rules?: InputMaybe<Array<_UpsertConsistencyCollectionRulesFieldInput>>;
  schemaFilters?: InputMaybe<
    Array<_UpsertConsistencyCollectionSchemaFiltersFieldInput>
  >;
  space: Scalars['String'];
  tenant?: InputMaybe<Scalars['String']>;
};

export type _UpsertConsistencyCollectionProjectFieldInput = {
  node: _UpsertDigitalTwin;
};

export type _UpsertConsistencyCollectionRulesFieldInput = {
  edge: InstanceRef;
  node: _UpsertConsistencyRule;
};

export type _UpsertConsistencyCollectionSchemaFiltersFieldInput = {
  edge: InstanceRef;
  node: _UpsertConsistencySchemaFilter;
};

export type _UpsertConsistencyConditionCheck = {
  externalId: Scalars['ID'];
  isLiteralValue?: InputMaybe<Scalars['Boolean']>;
  operator?: InputMaybe<Scalars['String']>;
  rule?: InputMaybe<_UpsertConsistencyConditionCheckRuleFieldInput>;
  sourceAttribute?: InputMaybe<Scalars['String']>;
  space: Scalars['String'];
  targetAttribute?: InputMaybe<Scalars['String']>;
  useTargetSchema?: InputMaybe<Scalars['Boolean']>;
};

export type _UpsertConsistencyConditionCheckRuleFieldInput = {
  node: _UpsertConsistencyRule;
};

export type _UpsertConsistencyRule = {
  collection?: InputMaybe<_UpsertConsistencyRuleCollectionFieldInput>;
  conditionChecks?: InputMaybe<
    Array<_UpsertConsistencyRuleConditionChecksFieldInput>
  >;
  conditionChecksOnly?: InputMaybe<Scalars['Boolean']>;
  customerDefinedId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  externalId: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  operator?: InputMaybe<Scalars['String']>;
  projectId?: InputMaybe<Scalars['String']>;
  runStatuses?: InputMaybe<Array<_UpsertConsistencyRuleRunStatusesFieldInput>>;
  severity?: InputMaybe<Scalars['String']>;
  sourceAttribute?: InputMaybe<Scalars['String']>;
  sourceFilters?: InputMaybe<Scalars['String']>;
  sourceSchemaFilter?: InputMaybe<_UpsertConsistencyRuleSourceSchemaFilterFieldInput>;
  space: Scalars['String'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  targetAttribute?: InputMaybe<Scalars['String']>;
  targetFilters?: InputMaybe<Scalars['String']>;
  targetSchemaFilter?: InputMaybe<_UpsertConsistencyRuleTargetSchemaFilterFieldInput>;
};

export type _UpsertConsistencyRuleCollectionFieldInput = {
  node: _UpsertConsistencyCollection;
};

export type _UpsertConsistencyRuleConditionChecksFieldInput = {
  edge: InstanceRef;
  node: _UpsertConsistencyConditionCheck;
};

export type _UpsertConsistencyRuleRunStatusesFieldInput = {
  edge: InstanceRef;
  node: _UpsertConsistencyRunStatus;
};

export type _UpsertConsistencyRuleSourceSchemaFilterFieldInput = {
  node: _UpsertConsistencySchemaFilter;
};

export type _UpsertConsistencyRuleTargetSchemaFilterFieldInput = {
  node: _UpsertConsistencySchemaFilter;
};

export type _UpsertConsistencyRunStatus = {
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalId: Scalars['ID'];
  failedInstances?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  message?: InputMaybe<Scalars['String']>;
  reportId?: InputMaybe<Scalars['String']>;
  rule?: InputMaybe<_UpsertConsistencyRunStatusRuleFieldInput>;
  runAt?: InputMaybe<Scalars['Timestamp']>;
  space: Scalars['String'];
  status?: InputMaybe<Scalars['String']>;
  totalFailed?: InputMaybe<Scalars['Int32']>;
  totalValid?: InputMaybe<Scalars['Int32']>;
};

export type _UpsertConsistencyRunStatusRuleFieldInput = {
  node: _UpsertConsistencyRule;
};

export type _UpsertConsistencySchemaFilter = {
  collection?: InputMaybe<_UpsertConsistencySchemaFilterCollectionFieldInput>;
  description?: InputMaybe<Scalars['String']>;
  externalId: Scalars['ID'];
  filters?: InputMaybe<Scalars['String']>;
  labels?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  projectId?: InputMaybe<Scalars['String']>;
  schemaCollectionId?: InputMaybe<Scalars['String']>;
  schemaType?: InputMaybe<Scalars['String']>;
  sourceForRules?: InputMaybe<
    Array<_UpsertConsistencySchemaFilterSourceForRulesFieldInput>
  >;
  space: Scalars['String'];
  targetForRules?: InputMaybe<
    Array<_UpsertConsistencySchemaFilterTargetForRulesFieldInput>
  >;
};

export type _UpsertConsistencySchemaFilterCollectionFieldInput = {
  node: _UpsertConsistencyCollection;
};

export type _UpsertConsistencySchemaFilterSourceForRulesFieldInput = {
  edge: InstanceRef;
  node: _UpsertConsistencyRule;
};

export type _UpsertConsistencySchemaFilterTargetForRulesFieldInput = {
  edge: InstanceRef;
  node: _UpsertConsistencyRule;
};

export type _UpsertDigitalTwin = {
  consistencyCollections?: InputMaybe<
    Array<_UpsertDigitalTwinConsistencyCollectionsFieldInput>
  >;
  externalId: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  schemaCollections?: InputMaybe<
    Array<_UpsertDigitalTwinSchemaCollectionsFieldInput>
  >;
  space: Scalars['String'];
  tenant?: InputMaybe<Scalars['String']>;
};

export type _UpsertDigitalTwinConsistencyCollectionsFieldInput = {
  edge: InstanceRef;
  node: _UpsertConsistencyCollection;
};

export type _UpsertDigitalTwinSchemaCollectionsFieldInput = {
  edge: InstanceRef;
  node: _UpsertSchemaCollection;
};

export type _UpsertMilestone = {
  description?: InputMaybe<Scalars['String']>;
  endActiveTime?: InputMaybe<Scalars['Timestamp']>;
  endScheduleTime?: InputMaybe<Scalars['Timestamp']>;
  externalId: Scalars['ID'];
  milestoneType?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  orderIndex?: InputMaybe<Scalars['Int32']>;
  projectId?: InputMaybe<Scalars['String']>;
  reportTemplate?: InputMaybe<Scalars['String']>;
  rules?: InputMaybe<Array<_UpsertMilestoneRulesFieldInput>>;
  rulesets?: InputMaybe<Array<_UpsertMilestoneRulesetsFieldInput>>;
  schedule?: InputMaybe<Scalars['String']>;
  schemaCollection?: InputMaybe<_UpsertMilestoneSchemaCollectionFieldInput>;
  space: Scalars['String'];
  startActiveTime?: InputMaybe<Scalars['Timestamp']>;
  startScheduleTime?: InputMaybe<Scalars['Timestamp']>;
};

export type _UpsertMilestoneRulesFieldInput = {
  edge: InstanceRef;
  node: _UpsertRule;
};

export type _UpsertMilestoneRulesetsFieldInput = {
  edge: InstanceRef;
  node: _UpsertRuleset;
};

export type _UpsertMilestoneSchemaCollectionFieldInput = {
  node: _UpsertSchemaCollection;
};

export type _UpsertResponse = {
  __typename?: '_UpsertResponse';
  externalId: Scalars['ID'];
  instanceType: Scalars['String'];
  space: Scalars['String'];
  version: Scalars['Int'];
  wasModified: Scalars['Boolean'];
};

export type _UpsertRule = {
  advanceRules?: InputMaybe<Scalars['String']>;
  customerDefinedId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  externalId: Scalars['ID'];
  filters?: InputMaybe<Scalars['String']>;
  invertedRules?: InputMaybe<Scalars['String']>;
  milestones?: InputMaybe<Array<_UpsertRuleMilestonesFieldInput>>;
  name?: InputMaybe<Scalars['String']>;
  primaryKeyName?: InputMaybe<Scalars['String']>;
  projectId?: InputMaybe<Scalars['String']>;
  ruleRunStatus?: InputMaybe<Array<_UpsertRuleRuleRunStatusFieldInput>>;
  rules?: InputMaybe<Scalars['String']>;
  rulesets?: InputMaybe<Array<_UpsertRuleRulesetsFieldInput>>;
  schemaCollection?: InputMaybe<_UpsertRuleSchemaCollectionFieldInput>;
  schemaType?: InputMaybe<Scalars['String']>;
  severity?: InputMaybe<Scalars['String']>;
  simpleInvertedRules?: InputMaybe<Scalars['String']>;
  simpleRules?: InputMaybe<Scalars['String']>;
  space: Scalars['String'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type _UpsertRuleMilestonesFieldInput = {
  edge: InstanceRef;
  node: _UpsertMilestone;
};

export type _UpsertRuleRuleRunStatusFieldInput = {
  edge: InstanceRef;
  node: _UpsertRuleRunStatus;
};

export type _UpsertRuleRulesetsFieldInput = {
  edge: InstanceRef;
  node: _UpsertRuleset;
};

export type _UpsertRuleRunStatus = {
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalId: Scalars['ID'];
  failedInstances?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  filteredInstances?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isFilterResult?: InputMaybe<Scalars['Boolean']>;
  message?: InputMaybe<Scalars['String']>;
  reportId?: InputMaybe<Scalars['String']>;
  rule?: InputMaybe<_UpsertRuleRunStatusRuleFieldInput>;
  runAt?: InputMaybe<Scalars['Timestamp']>;
  space: Scalars['String'];
  status?: InputMaybe<Scalars['String']>;
  totalFailed?: InputMaybe<Scalars['Int32']>;
  totalValid?: InputMaybe<Scalars['Int32']>;
};

export type _UpsertRuleRunStatusRuleFieldInput = {
  node: _UpsertRule;
};

export type _UpsertRuleSchemaCollectionFieldInput = {
  node: _UpsertSchemaCollection;
};

export type _UpsertRuleset = {
  description?: InputMaybe<Scalars['String']>;
  externalId: Scalars['ID'];
  filters?: InputMaybe<Scalars['String']>;
  labels?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  milestones?: InputMaybe<Array<_UpsertRulesetMilestonesFieldInput>>;
  name?: InputMaybe<Scalars['String']>;
  projectId?: InputMaybe<Scalars['String']>;
  rules?: InputMaybe<Array<_UpsertRulesetRulesFieldInput>>;
  schemaType?: InputMaybe<Scalars['String']>;
  space: Scalars['String'];
};

export type _UpsertRulesetMilestonesFieldInput = {
  edge: InstanceRef;
  node: _UpsertMilestone;
};

export type _UpsertRulesetRulesFieldInput = {
  edge: InstanceRef;
  node: _UpsertRule;
};

export type _UpsertSchemaCollection = {
  description?: InputMaybe<Scalars['String']>;
  externalId: Scalars['ID'];
  graphQLSchemaString?: InputMaybe<Scalars['String']>;
  milestones?: InputMaybe<Array<_UpsertSchemaCollectionMilestonesFieldInput>>;
  name?: InputMaybe<Scalars['String']>;
  project?: InputMaybe<_UpsertSchemaCollectionProjectFieldInput>;
  refId?: InputMaybe<Scalars['String']>;
  refVersion?: InputMaybe<Scalars['Int32']>;
  rules?: InputMaybe<Array<_UpsertSchemaCollectionRulesFieldInput>>;
  rulesets?: InputMaybe<Array<_UpsertSchemaCollectionRulesetsFieldInput>>;
  space: Scalars['String'];
  tenant?: InputMaybe<Scalars['String']>;
};

export type _UpsertSchemaCollectionMilestonesFieldInput = {
  edge: InstanceRef;
  node: _UpsertMilestone;
};

export type _UpsertSchemaCollectionProjectFieldInput = {
  node: _UpsertDigitalTwin;
};

export type _UpsertSchemaCollectionRulesFieldInput = {
  edge: InstanceRef;
  node: _UpsertRule;
};

export type _UpsertSchemaCollectionRulesetsFieldInput = {
  edge: InstanceRef;
  node: _UpsertRuleset;
};

export enum _SearchOperatorEnum {
  And = 'AND',
  Or = 'OR',
}

export type GetDigitalTwinsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  cursor?: InputMaybe<Scalars['String']>;
}>;

export type GetDigitalTwinsQuery = {
  __typename?: 'Query';
  listDigitalTwin?: {
    __typename?: '_DigitalTwinConnection';
    items: Array<{
      __typename?: 'DigitalTwin';
      externalId: string;
      name: string;
      tenant: string;
      schemaCollections?: {
        __typename?: '_SchemaCollectionConnection';
        items: Array<{
          __typename?: 'SchemaCollection';
          milestones?: {
            __typename?: '_MilestoneConnection';
            items: Array<{
              __typename?: 'Milestone';
              name: string;
              externalId: string;
              milestoneType?: string | null;
              orderIndex?: number | null;
              startActiveTime?: string | null;
              endActiveTime?: string | null;
            } | null>;
          } | null;
        } | null>;
      } | null;
    } | null>;
    pageInfo: {
      __typename?: 'PageInfo';
      startCursor?: string | null;
      endCursor?: string | null;
    };
  } | null;
};

export type CountDigitalTwinsQueryVariables = Exact<{ [key: string]: never }>;

export type CountDigitalTwinsQuery = {
  __typename?: 'Query';
  aggregateDigitalTwin?: {
    __typename?: '_DigitalTwinAggregateConnection';
    items: Array<{
      __typename?: '_DigitalTwinAggregateResult';
      count?: {
        __typename?: '_DigitalTwinAggregateFieldCountResult';
        externalId?: number | null;
      } | null;
    } | null>;
  } | null;
};

export type GetDigitalTwinQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type GetDigitalTwinQuery = {
  __typename?: 'Query';
  listDigitalTwin?: {
    __typename?: '_DigitalTwinConnection';
    items: Array<{
      __typename?: 'DigitalTwin';
      externalId: string;
      name: string;
      tenant: string;
      schemaCollections?: {
        __typename?: '_SchemaCollectionConnection';
        items: Array<{
          __typename?: 'SchemaCollection';
          externalId: string;
          refId?: string | null;
          name: string;
          tenant: string;
        } | null>;
      } | null;
    } | null>;
  } | null;
};

export type GetDigitalTwinNameQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type GetDigitalTwinNameQuery = {
  __typename?: 'Query';
  listDigitalTwin?: {
    __typename?: '_DigitalTwinConnection';
    items: Array<{
      __typename?: 'DigitalTwin';
      externalId: string;
      name: string;
      tenant: string;
    } | null>;
  } | null;
};

export type CreateDigitalTwinMutationVariables = Exact<{
  id: Scalars['ID'];
  name: Scalars['String'];
  tenant: Scalars['String'];
}>;

export type CreateDigitalTwinMutation = {
  __typename?: 'Mutation';
  Create_DigitalTwin?: {
    __typename?: 'DigitalTwin';
    externalId: string;
  } | null;
};

export type UpdateDigitalTwinMutationVariables = Exact<{
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  tenant: Scalars['String'];
}>;

export type UpdateDigitalTwinMutation = {
  __typename?: 'Mutation';
  Update_DigitalTwin?: {
    __typename?: 'DigitalTwin';
    externalId: string;
  } | null;
};

export type DeleteDigitalTwinMutationVariables = Exact<{
  id: Scalars['ID'];
}>;

export type DeleteDigitalTwinMutation = {
  __typename?: 'Mutation';
  Delete_DigitalTwin?: {
    __typename?: 'DigitalTwin';
    externalId: string;
  } | null;
};

export type GetSchemaCollectionQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  tenant?: InputMaybe<Scalars['String']>;
}>;

export type GetSchemaCollectionQuery = {
  __typename?: 'Query';
  listSchemaCollection?: {
    __typename?: '_SchemaCollectionConnection';
    items: Array<{
      __typename?: 'SchemaCollection';
      externalId: string;
      refId?: string | null;
      tenant: string;
      name: string;
    } | null>;
  } | null;
};

export type DeleteSchemaMutationVariables = Exact<{
  id: Scalars['ID'];
}>;

export type DeleteSchemaMutation = {
  __typename?: 'Mutation';
  Delete_SchemaCollection?: {
    __typename?: 'SchemaCollection';
    externalId: string;
  } | null;
};

export type GetRulesQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;

export type GetRulesQuery = {
  __typename?: 'Query';
  listRule?: {
    __typename?: '_RuleConnection';
    items: Array<{
      __typename?: 'Rule';
      externalId: string;
      name?: string | null;
      description?: string | null;
      customerDefinedId?: string | null;
      severity?: string | null;
      errorMessage?: string | null;
      tags?: Array<string | null> | null;
      schemaType?: string | null;
      primaryKeyName?: string | null;
      projectId?: string | null;
      rules?: string | null;
      invertedRules?: string | null;
      filters?: string | null;
      rulesets?: {
        __typename?: '_RulesetConnection';
        items: Array<{
          __typename?: 'Ruleset';
          externalId: string;
          name: string;
          description?: string | null;
          schemaType?: string | null;
          labels?: Array<string | null> | null;
          filters?: string | null;
        } | null>;
      } | null;
      milestones?: {
        __typename?: '_MilestoneConnection';
        items: Array<{
          __typename?: 'Milestone';
          externalId: string;
          name: string;
        } | null>;
      } | null;
    } | null>;
  } | null;
};

export type GetRuleRunStatusQueryVariables = Exact<{
  schemaId: Scalars['ID'];
}>;

export type GetRuleRunStatusQuery = {
  __typename?: 'Query';
  listRuleRunStatus?: {
    __typename?: '_RuleRunStatusConnection';
    items: Array<{
      __typename?: 'RuleRunStatus';
      externalId: string;
      message?: string | null;
      status: string;
      totalFailed?: number | null;
      totalValid?: number | null;
      filteredInstances?: Array<string | null> | null;
      failedInstances?: Array<string | null> | null;
      reportId?: string | null;
      runAt?: string | null;
      rule?: {
        __typename?: 'Rule';
        externalId: string;
        name?: string | null;
        customerDefinedId?: string | null;
        description?: string | null;
        severity?: string | null;
        errorMessage?: string | null;
        projectId?: string | null;
        schemaType?: string | null;
        primaryKeyName?: string | null;
        tags?: Array<string | null> | null;
        rules?: string | null;
        invertedRules?: string | null;
        filters?: string | null;
      } | null;
    } | null>;
  } | null;
};

export type GetRuleRunStatusByRuleIdQueryVariables = Exact<{
  ruleId: Scalars['ID'];
  first: Scalars['Int'];
}>;

export type GetRuleRunStatusByRuleIdQuery = {
  __typename?: 'Query';
  listRule?: {
    __typename?: '_RuleConnection';
    items: Array<{
      __typename?: 'Rule';
      externalId: string;
      ruleRunStatus?: {
        __typename?: '_RuleRunStatusConnection';
        items: Array<{
          __typename?: 'RuleRunStatus';
          externalId: string;
          message?: string | null;
          status: string;
          totalFailed?: number | null;
          totalValid?: number | null;
          filteredInstances?: Array<string | null> | null;
          failedInstances?: Array<string | null> | null;
          reportId?: string | null;
          runAt?: string | null;
          rule?: {
            __typename?: 'Rule';
            externalId: string;
            name?: string | null;
            customerDefinedId?: string | null;
            description?: string | null;
            severity?: string | null;
            errorMessage?: string | null;
            projectId?: string | null;
            schemaType?: string | null;
            primaryKeyName?: string | null;
            tags?: Array<string | null> | null;
            rules?: string | null;
            invertedRules?: string | null;
            filters?: string | null;
            rulesets?: {
              __typename?: '_RulesetConnection';
              items: Array<{
                __typename?: 'Ruleset';
                schemaType?: string | null;
                filters?: string | null;
                name: string;
              } | null>;
            } | null;
            milestones?: {
              __typename?: '_MilestoneConnection';
              items: Array<{
                __typename?: 'Milestone';
                schedule?: string | null;
                endActiveTime?: string | null;
                endScheduleTime?: string | null;
                startActiveTime?: string | null;
                startScheduleTime?: string | null;
              } | null>;
            } | null;
          } | null;
        } | null>;
      } | null;
    } | null>;
  } | null;
};

export type CreateRuleMutationVariables = Exact<{
  id: Scalars['ID'];
  description?: InputMaybe<Scalars['String']>;
  severity?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  customerDefinedId?: InputMaybe<Scalars['String']>;
  projectId: Scalars['ID'];
  errorMessage?: InputMaybe<Scalars['String']>;
  schemaType?: InputMaybe<Scalars['String']>;
  primaryKeyName?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<
    Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>
  >;
  rules?: InputMaybe<Scalars['String']>;
  invertedRules?: InputMaybe<Scalars['String']>;
  simpleRules?: InputMaybe<Scalars['String']>;
  simpleInvertedRules?: InputMaybe<Scalars['String']>;
  advanceRules?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Scalars['String']>;
}>;

export type CreateRuleMutation = {
  __typename?: 'Mutation';
  Create_Rule?: { __typename?: 'Rule'; externalId: string } | null;
  Add_SchemaCollection_rules?: {
    __typename?: '_TempReturn';
    endNode?: string | null;
    startNode?: string | null;
  } | null;
};

export type DeleteRuleMutationVariables = Exact<{
  id: Scalars['ID'];
}>;

export type DeleteRuleMutation = {
  __typename?: 'Mutation';
  Delete_Rule?: { __typename?: 'Rule'; externalId: string } | null;
};

export type UpdateRuleMutationVariables = Exact<{
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  customerDefinedId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  severity?: InputMaybe<Scalars['String']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  schemaType?: InputMaybe<Scalars['String']>;
  primaryKeyName?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<
    Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>
  >;
}>;

export type UpdateRuleMutation = {
  __typename?: 'Mutation';
  Update_Rule?: { __typename?: 'Rule'; externalId: string } | null;
};

export type GetMilestonesQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;

export type GetMilestonesQuery = {
  __typename?: 'Query';
  listMilestone?: {
    __typename?: '_MilestoneConnection';
    items: Array<{
      __typename?: 'Milestone';
      externalId: string;
      description?: string | null;
      endActiveTime?: string | null;
      endScheduleTime?: string | null;
      milestoneType?: string | null;
      name: string;
      orderIndex?: number | null;
      reportTemplate?: string | null;
      schedule?: string | null;
      startActiveTime?: string | null;
      startScheduleTime?: string | null;
      rules?: {
        __typename?: '_RuleConnection';
        items: Array<{
          __typename?: 'Rule';
          externalId: string;
          customerDefinedId?: string | null;
          description?: string | null;
          errorMessage?: string | null;
          filters?: string | null;
          invertedRules?: string | null;
          name?: string | null;
          primaryKeyName?: string | null;
          projectId?: string | null;
          rules?: string | null;
          schemaType?: string | null;
          severity?: string | null;
          tags?: Array<string | null> | null;
          rulesets?: {
            __typename?: '_RulesetConnection';
            items: Array<{
              __typename?: 'Ruleset';
              externalId: string;
              schemaType?: string | null;
            } | null>;
          } | null;
        } | null>;
      } | null;
      rulesets?: {
        __typename?: '_RulesetConnection';
        items: Array<{
          __typename?: 'Ruleset';
          externalId: string;
          description?: string | null;
          filters?: string | null;
          labels?: Array<string | null> | null;
          name: string;
          projectId?: string | null;
          schemaType?: string | null;
        } | null>;
      } | null;
    } | null>;
  } | null;
};

export type CreateMilestoneMutationVariables = Exact<{
  id: Scalars['ID'];
  name: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  orderIndex?: InputMaybe<Scalars['Int']>;
  milestoneType?: InputMaybe<Scalars['String']>;
  startActiveTime?: InputMaybe<Scalars['Timestamp']>;
  endActiveTime?: InputMaybe<Scalars['Timestamp']>;
  schedule?: InputMaybe<Scalars['String']>;
  startScheduleTime?: InputMaybe<Scalars['Timestamp']>;
  endScheduleTime?: InputMaybe<Scalars['Timestamp']>;
  projectId: Scalars['ID'];
}>;

export type CreateMilestoneMutation = {
  __typename?: 'Mutation';
  Create_Milestone?: { __typename?: 'Milestone'; externalId: string } | null;
  Add_SchemaCollection_milestones?: {
    __typename?: '_TempReturn';
    endNode?: string | null;
    startNode?: string | null;
  } | null;
};

export type AddSchemaCollectionToDigitalTwinMutationVariables = Exact<{
  digitalTwinId: Scalars['ID'];
  schemaCollectionId: Scalars['ID'];
  name: Scalars['String'];
  refId: Scalars['ID'];
  tenant: Scalars['String'];
}>;

export type AddSchemaCollectionToDigitalTwinMutation = {
  __typename?: 'Mutation';
  Create_SchemaCollection?: {
    __typename?: 'SchemaCollection';
    externalId: string;
  } | null;
  Add_DigitalTwin_schemaCollections?: {
    __typename?: 'DigitalTwin';
    externalId: string;
  } | null;
};

export type UpdateSchemaCollectionRefIdMutationVariables = Exact<{
  schemaCollectionId: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  refId: Scalars['String'];
  tenant: Scalars['String'];
}>;

export type UpdateSchemaCollectionRefIdMutation = {
  __typename?: 'Mutation';
  Update_SchemaCollection?: {
    __typename?: 'SchemaCollection';
    refId?: string | null;
  } | null;
};

export type DeleteMilestoneMutationVariables = Exact<{
  id: Scalars['ID'];
}>;

export type DeleteMilestoneMutation = {
  __typename?: 'Mutation';
  Delete_Milestone?: { __typename?: 'Milestone'; externalId: string } | null;
};

export type UpdateMilestoneMutationVariables = Exact<{
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  orderIndex?: InputMaybe<Scalars['Int']>;
  milestoneType?: InputMaybe<Scalars['String']>;
  startActiveTime?: InputMaybe<Scalars['Timestamp']>;
  endActiveTime?: InputMaybe<Scalars['Timestamp']>;
  schedule?: InputMaybe<Scalars['String']>;
  startScheduleTime?: InputMaybe<Scalars['Timestamp']>;
  endScheduleTime?: InputMaybe<Scalars['Timestamp']>;
}>;

export type UpdateMilestoneMutation = {
  __typename?: 'Mutation';
  Update_Milestone?: { __typename?: 'Milestone'; externalId: string } | null;
};

export type AddSchemaCollectionMilestonesMutationVariables = Exact<{
  endNode: Scalars['ID'];
  startNode: Scalars['ID'];
}>;

export type AddSchemaCollectionMilestonesMutation = {
  __typename?: 'Mutation';
  Add_SchemaCollection_milestones?: {
    __typename?: '_TempReturn';
    endNode?: string | null;
    startNode?: string | null;
  } | null;
};

export type AddMilestoneRulesetsMutationVariables = Exact<{
  endNode: Scalars['ID'];
  startNode: Scalars['ID'];
}>;

export type AddMilestoneRulesetsMutation = {
  __typename?: 'Mutation';
  Add_Milestone_rulesets?: {
    __typename?: '_TempReturn';
    endNode?: string | null;
    startNode?: string | null;
  } | null;
};

export type AddRulesetMilestonesMutationVariables = Exact<{
  endNode: Scalars['ID'];
  startNode: Scalars['ID'];
}>;

export type AddRulesetMilestonesMutation = {
  __typename?: 'Mutation';
  Add_Ruleset_milestones?: {
    __typename?: '_TempReturn';
    endNode?: string | null;
    startNode?: string | null;
  } | null;
};

export type AddMilestoneRulesMutationVariables = Exact<{
  endNode: Scalars['ID'];
  startNode: Scalars['ID'];
}>;

export type AddMilestoneRulesMutation = {
  __typename?: 'Mutation';
  Add_Milestone_rules?: {
    __typename?: '_TempReturn';
    endNode?: string | null;
    startNode?: string | null;
  } | null;
};

export type UpdateMilestoneReportTemplateMutationVariables = Exact<{
  id: Scalars['ID'];
  name: Scalars['String'];
  reportTemplate: Scalars['String'];
}>;

export type UpdateMilestoneReportTemplateMutation = {
  __typename?: 'Mutation';
  Update_Milestone?: { __typename?: 'Milestone'; externalId: string } | null;
};

export type AddRuleMilestonesMutationVariables = Exact<{
  endNode: Scalars['ID'];
  startNode: Scalars['ID'];
}>;

export type AddRuleMilestonesMutation = {
  __typename?: 'Mutation';
  Add_Rule_milestones?: {
    __typename?: '_TempReturn';
    endNode?: string | null;
    startNode?: string | null;
  } | null;
};

export type GetCollectionReportsQueryVariables = Exact<{
  projectId: Scalars['ID'];
}>;

export type GetCollectionReportsQuery = {
  __typename?: 'Query';
  listMilestone?: {
    __typename?: '_MilestoneConnection';
    items: Array<{
      __typename?: 'Milestone';
      externalId: string;
      name: string;
      milestoneType?: string | null;
      startActiveTime?: string | null;
      endActiveTime?: string | null;
      orderIndex?: number | null;
      schemaCollection?: {
        __typename?: 'SchemaCollection';
        name: string;
        refId?: string | null;
        externalId: string;
      } | null;
      rules?: {
        __typename?: '_RuleConnection';
        items: Array<{
          __typename?: 'Rule';
          ruleRunStatus?: {
            __typename?: '_RuleRunStatusConnection';
            items: Array<{
              __typename?: 'RuleRunStatus';
              runAt?: string | null;
              totalValid?: number | null;
              totalFailed?: number | null;
              reportId?: string | null;
            } | null>;
          } | null;
        } | null>;
      } | null;
    } | null>;
  } | null;
};

export type GetCollectionRunReportQueryVariables = Exact<{
  collectionReportId?: InputMaybe<Scalars['String']>;
}>;

export type GetCollectionRunReportQuery = {
  __typename?: 'Query';
  listRuleRunStatus?: {
    __typename?: '_RuleRunStatusConnection';
    items: Array<{
      __typename?: 'RuleRunStatus';
      externalId: string;
      totalFailed?: number | null;
      totalValid?: number | null;
      status: string;
      message?: string | null;
      runAt?: string | null;
      rule?: {
        __typename?: 'Rule';
        externalId: string;
        name?: string | null;
        customerDefinedId?: string | null;
        errorMessage?: string | null;
        tags?: Array<string | null> | null;
        severity?: string | null;
        schemaType?: string | null;
        rulesets?: {
          __typename?: '_RulesetConnection';
          items: Array<{
            __typename?: 'Ruleset';
            schemaType?: string | null;
          } | null>;
        } | null;
        milestones?: {
          __typename?: '_MilestoneConnection';
          items: Array<{ __typename?: 'Milestone'; externalId: string } | null>;
        } | null;
      } | null;
    } | null>;
  } | null;
};

export type GetCollectionDetailsReportQueryVariables = Exact<{
  collectionId: Scalars['ID'];
}>;

export type GetCollectionDetailsReportQuery = {
  __typename?: 'Query';
  listMilestone?: {
    __typename?: '_MilestoneConnection';
    items: Array<{
      __typename?: 'Milestone';
      name: string;
      schemaCollection?: {
        __typename?: 'SchemaCollection';
        name: string;
        externalId: string;
        refId?: string | null;
      } | null;
      rules?: {
        __typename?: '_RuleConnection';
        items: Array<{
          __typename?: 'Rule';
          ruleRunStatus?: {
            __typename?: '_RuleRunStatusConnection';
            items: Array<{
              __typename?: 'RuleRunStatus';
              runAt?: string | null;
              totalValid?: number | null;
              totalFailed?: number | null;
              reportId?: string | null;
            } | null>;
          } | null;
        } | null>;
      } | null;
    } | null>;
  } | null;
};

export type GetRuleDetailsAndHistoryQueryVariables = Exact<{
  ruleId?: InputMaybe<Scalars['ID']>;
}>;

export type GetRuleDetailsAndHistoryQuery = {
  __typename?: 'Query';
  listRule?: {
    __typename?: '_RuleConnection';
    items: Array<{
      __typename?: 'Rule';
      externalId: string;
      name?: string | null;
      primaryKeyName?: string | null;
      projectId?: string | null;
      tags?: Array<string | null> | null;
      space: string;
      severity?: string | null;
      schemaType?: string | null;
      filters?: string | null;
      rules?: string | null;
      errorMessage?: string | null;
      description?: string | null;
      customerDefinedId?: string | null;
      milestones?: {
        __typename?: '_MilestoneConnection';
        items: Array<{
          __typename?: 'Milestone';
          schedule?: string | null;
          startActiveTime?: string | null;
          startScheduleTime?: string | null;
          endActiveTime?: string | null;
          endScheduleTime?: string | null;
        } | null>;
      } | null;
      rulesets?: {
        __typename?: '_RulesetConnection';
        items: Array<{
          __typename?: 'Ruleset';
          name: string;
          schemaType?: string | null;
          filters?: string | null;
        } | null>;
      } | null;
      ruleRunStatus?: {
        __typename?: '_RuleRunStatusConnection';
        items: Array<{
          __typename?: 'RuleRunStatus';
          externalId: string;
          runAt?: string | null;
          totalFailed?: number | null;
          totalValid?: number | null;
          message?: string | null;
          status: string;
        } | null>;
      } | null;
    } | null>;
  } | null;
};

export type GetRulesetsQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;

export type GetRulesetsQuery = {
  __typename?: 'Query';
  listRuleset?: {
    __typename?: '_RulesetConnection';
    items: Array<{
      __typename?: 'Ruleset';
      externalId: string;
      name: string;
      description?: string | null;
      labels?: Array<string | null> | null;
      projectId?: string | null;
      schemaType?: string | null;
      filters?: string | null;
      rules?: {
        __typename?: '_RuleConnection';
        items: Array<{
          __typename?: 'Rule';
          description?: string | null;
          severity?: string | null;
          errorMessage?: string | null;
          externalId: string;
          name?: string | null;
          projectId?: string | null;
          customerDefinedId?: string | null;
          primaryKeyName?: string | null;
          rules?: string | null;
          invertedRules?: string | null;
          filters?: string | null;
          schemaType?: string | null;
          tags?: Array<string | null> | null;
          rulesets?: {
            __typename?: '_RulesetConnection';
            items: Array<{
              __typename?: 'Ruleset';
              externalId: string;
              name: string;
              schemaType?: string | null;
            } | null>;
          } | null;
          milestones?: {
            __typename?: '_MilestoneConnection';
            items: Array<{
              __typename?: 'Milestone';
              externalId: string;
              name: string;
            } | null>;
          } | null;
        } | null>;
      } | null;
      milestones?: {
        __typename?: '_MilestoneConnection';
        items: Array<{
          __typename?: 'Milestone';
          externalId: string;
          name: string;
        } | null>;
      } | null;
    } | null>;
  } | null;
};

export type GetRulesetQueryVariables = Exact<{
  id: Scalars['ID'];
  projectId: Scalars['String'];
}>;

export type GetRulesetQuery = {
  __typename?: 'Query';
  listRuleset?: {
    __typename?: '_RulesetConnection';
    items: Array<{
      __typename?: 'Ruleset';
      externalId: string;
      name: string;
      description?: string | null;
      labels?: Array<string | null> | null;
      schemaType?: string | null;
      filters?: string | null;
      rules?: {
        __typename?: '_RuleConnection';
        items: Array<{
          __typename?: 'Rule';
          description?: string | null;
          errorMessage?: string | null;
          externalId: string;
          name?: string | null;
          projectId?: string | null;
          customerDefinedId?: string | null;
          severity?: string | null;
          primaryKeyName?: string | null;
          rules?: string | null;
          invertedRules?: string | null;
          filters?: string | null;
          schemaType?: string | null;
          tags?: Array<string | null> | null;
          rulesets?: {
            __typename?: '_RulesetConnection';
            items: Array<{
              __typename?: 'Ruleset';
              externalId: string;
              name: string;
              schemaType?: string | null;
            } | null>;
          } | null;
          milestones?: {
            __typename?: '_MilestoneConnection';
            items: Array<{
              __typename?: 'Milestone';
              externalId: string;
              name: string;
            } | null>;
          } | null;
        } | null>;
      } | null;
      milestones?: {
        __typename?: '_MilestoneConnection';
        items: Array<{
          __typename?: 'Milestone';
          externalId: string;
          name: string;
        } | null>;
      } | null;
    } | null>;
  } | null;
};

export type CreateRulesetMutationVariables = Exact<{
  id: Scalars['ID'];
  name: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  labels?: InputMaybe<
    Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>
  >;
  schemaType?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Scalars['String']>;
  projectId: Scalars['ID'];
}>;

export type CreateRulesetMutation = {
  __typename?: 'Mutation';
  Create_Ruleset?: { __typename?: 'Ruleset'; externalId: string } | null;
  Add_SchemaCollection_rulesets?: {
    __typename?: '_TempReturn';
    endNode?: string | null;
    startNode?: string | null;
  } | null;
};

export type DeleteRulesetMutationVariables = Exact<{
  id: Scalars['ID'];
}>;

export type DeleteRulesetMutation = {
  __typename?: 'Mutation';
  Delete_Ruleset?: { __typename?: 'Ruleset'; externalId: string } | null;
};

export type UpdateRulesetMutationVariables = Exact<{
  id: Scalars['ID'];
  name: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  labels?: InputMaybe<
    Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>
  >;
  schemaType?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Scalars['String']>;
}>;

export type UpdateRulesetMutation = {
  __typename?: 'Mutation';
  Update_Ruleset?: { __typename?: 'Ruleset'; externalId: string } | null;
};

export type AddSchemaCollectionRulesetsMutationVariables = Exact<{
  endNode: Scalars['ID'];
  startNode: Scalars['ID'];
}>;

export type AddSchemaCollectionRulesetsMutation = {
  __typename?: 'Mutation';
  Add_SchemaCollection_rulesets?: {
    __typename?: '_TempReturn';
    endNode?: string | null;
    startNode?: string | null;
  } | null;
};

export type AddSchemaCollectionRulesMutationVariables = Exact<{
  endNode: Scalars['ID'];
  startNode: Scalars['ID'];
}>;

export type AddSchemaCollectionRulesMutation = {
  __typename?: 'Mutation';
  Add_SchemaCollection_rules?: {
    __typename?: '_TempReturn';
    endNode?: string | null;
    startNode?: string | null;
  } | null;
};

export type AddRulesetRulesMutationVariables = Exact<{
  endNode: Scalars['ID'];
  startNode: Scalars['ID'];
}>;

export type AddRulesetRulesMutation = {
  __typename?: 'Mutation';
  Add_Ruleset_rules?: {
    __typename?: '_TempReturn';
    endNode?: string | null;
    startNode?: string | null;
  } | null;
};

export type AddRuleRulesetsMutationVariables = Exact<{
  endNode: Scalars['ID'];
  startNode: Scalars['ID'];
}>;

export type AddRuleRulesetsMutation = {
  __typename?: 'Mutation';
  Add_Rule_rulesets?: {
    __typename?: '_TempReturn';
    endNode?: string | null;
    startNode?: string | null;
  } | null;
};

export type RemoveMilestoneRulesetsMutationVariables = Exact<{
  endNode: Scalars['ID'];
  startNode: Scalars['ID'];
}>;

export type RemoveMilestoneRulesetsMutation = {
  __typename?: 'Mutation';
  Remove_Milestone_rulesets?: {
    __typename?: '_TempReturn';
    endNode?: string | null;
    startNode?: string | null;
  } | null;
};

export type RemoveRulesetMilestonesMutationVariables = Exact<{
  endNode: Scalars['ID'];
  startNode: Scalars['ID'];
}>;

export type RemoveRulesetMilestonesMutation = {
  __typename?: 'Mutation';
  Remove_Ruleset_milestones?: {
    __typename?: '_TempReturn';
    endNode?: string | null;
    startNode?: string | null;
  } | null;
};

export type RemoveMilestoneRulesMutationVariables = Exact<{
  endNode: Scalars['ID'];
  startNode: Scalars['ID'];
}>;

export type RemoveMilestoneRulesMutation = {
  __typename?: 'Mutation';
  Remove_Milestone_rules?: {
    __typename?: '_TempReturn';
    endNode?: string | null;
    startNode?: string | null;
  } | null;
};

export type RemoveRuleMilestonesMutationVariables = Exact<{
  endNode: Scalars['ID'];
  startNode: Scalars['ID'];
}>;

export type RemoveRuleMilestonesMutation = {
  __typename?: 'Mutation';
  Remove_Rule_milestones?: {
    __typename?: '_TempReturn';
    endNode?: string | null;
    startNode?: string | null;
  } | null;
};

export type RemoveEdgeRuleMilestoneMutationVariables = Exact<{
  endNode: Scalars['ID'];
  startNode: Scalars['ID'];
}>;

export type RemoveEdgeRuleMilestoneMutation = {
  __typename?: 'Mutation';
  Remove_Milestone_rules?: {
    __typename?: '_TempReturn';
    endNode?: string | null;
    startNode?: string | null;
  } | null;
  Remove_Rule_milestones?: {
    __typename?: '_TempReturn';
    endNode?: string | null;
    startNode?: string | null;
  } | null;
};

export type GetAccessQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  cursor?: InputMaybe<Scalars['String']>;
}>;

export type GetAccessQuery = {
  __typename?: 'Query';
  listAccess?: {
    __typename?: '_AccessConnection';
    items: Array<{
      __typename?: 'Access';
      externalId: string;
      userId: string;
      role: string;
      tenant: string;
    } | null>;
    pageInfo: {
      __typename?: 'PageInfo';
      startCursor?: string | null;
      endCursor?: string | null;
    };
  } | null;
};

export type CountAccessQueryVariables = Exact<{ [key: string]: never }>;

export type CountAccessQuery = {
  __typename?: 'Query';
  aggregateAccess?: {
    __typename?: '_AccessAggregateConnection';
    items: Array<{
      __typename?: '_AccessAggregateResult';
      count?: {
        __typename?: '_AccessAggregateFieldCountResult';
        externalId?: number | null;
      } | null;
    } | null>;
  } | null;
};

export type CreateAccessMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  userId: Scalars['String'];
  role: Scalars['String'];
  tenant: Scalars['String'];
}>;

export type CreateAccessMutation = {
  __typename?: 'Mutation';
  Create_Access?: { __typename?: 'Access'; externalId: string } | null;
};

export type DeleteAccessMutationVariables = Exact<{
  id: Scalars['ID'];
}>;

export type DeleteAccessMutation = {
  __typename?: 'Mutation';
  Delete_Access?: { __typename?: 'Access'; externalId: string } | null;
};

export type UpdateAccessMutationVariables = Exact<{
  id: Scalars['ID'];
  userId: Scalars['String'];
  role: Scalars['String'];
}>;

export type UpdateAccessMutation = {
  __typename?: 'Mutation';
  Update_Access?: { __typename?: 'Access'; externalId: string } | null;
};

export type ToggleDisableRuleMutationVariables = Exact<{
  id: Scalars['ID'];
  tags?: InputMaybe<
    Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>
  >;
}>;

export type ToggleDisableRuleMutation = {
  __typename?: 'Mutation';
  Update_Rule?: { __typename?: 'Rule'; externalId: string } | null;
};

export type GetAllRuleRunStatusQueryVariables = Exact<{
  schemaIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  cursor?: InputMaybe<Scalars['String']>;
}>;

export type GetAllRuleRunStatusQuery = {
  __typename?: 'Query';
  listRuleRunStatus?: {
    __typename?: '_RuleRunStatusConnection';
    items: Array<{ __typename?: 'RuleRunStatus'; externalId: string } | null>;
    pageInfo: {
      __typename?: 'PageInfo';
      hasNextPage: boolean;
      startCursor?: string | null;
      endCursor?: string | null;
    };
  } | null;
};

export type GetConsistencyCollectionsQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;

export type GetConsistencyCollectionsQuery = {
  __typename?: 'Query';
  listConsistencyCollection?: {
    __typename?: '_ConsistencyCollectionConnection';
    items: Array<{
      __typename?: 'ConsistencyCollection';
      externalId: string;
      name: string;
      description?: string | null;
      tenant: string;
      projectId: string;
      createdAt?: string | null;
      labels?: Array<string | null> | null;
      reportTemplate?: string | null;
      schemaFilters?: {
        __typename?: '_ConsistencySchemaFilterConnection';
        items: Array<{
          __typename?: 'ConsistencySchemaFilter';
          externalId: string;
          name: string;
          description?: string | null;
          labels?: Array<string | null> | null;
          schemaType: string;
          schemaCollectionId: string;
          filters?: string | null;
          projectId: string;
        } | null>;
      } | null;
      rules?: {
        __typename?: '_ConsistencyRuleConnection';
        items: Array<{
          __typename?: 'ConsistencyRule';
          externalId: string;
          name: string;
          customerDefinedId?: string | null;
          description?: string | null;
          sourceAttribute: string;
          sourceFilters?: string | null;
          operator: string;
          targetAttribute: string;
          targetFilters?: string | null;
          severity?: string | null;
          errorMessage?: string | null;
          tags?: Array<string | null> | null;
          conditionChecksOnly?: boolean | null;
          projectId: string;
          sourceSchemaFilter?: {
            __typename?: 'ConsistencySchemaFilter';
            externalId: string;
            name: string;
          } | null;
          targetSchemaFilter?: {
            __typename?: 'ConsistencySchemaFilter';
            externalId: string;
            name: string;
          } | null;
          conditionChecks?: {
            __typename?: '_ConsistencyConditionCheckConnection';
            items: Array<{
              __typename?: 'ConsistencyConditionCheck';
              externalId: string;
              sourceAttribute: string;
              operator: string;
              targetAttribute: string;
              isLiteralValue?: boolean | null;
              useTargetSchema?: boolean | null;
            } | null>;
          } | null;
          runStatuses?: {
            __typename?: '_ConsistencyRunStatusConnection';
            items: Array<{
              __typename?: 'ConsistencyRunStatus';
              externalId: string;
              totalValid?: number | null;
              totalFailed?: number | null;
              status: string;
              runAt?: string | null;
              reportId?: string | null;
              message?: string | null;
            } | null>;
          } | null;
        } | null>;
      } | null;
    } | null>;
  } | null;
};

export type GetConsistencyReportQueryVariables = Exact<{
  reportId: Scalars['String'];
}>;

export type GetConsistencyReportQuery = {
  __typename?: 'Query';
  listConsistencyRunStatus?: {
    __typename?: '_ConsistencyRunStatusConnection';
    items: Array<{
      __typename?: 'ConsistencyRunStatus';
      externalId: string;
      totalValid?: number | null;
      totalFailed?: number | null;
      status: string;
      runAt?: string | null;
      reportId?: string | null;
      message?: string | null;
      rule?: {
        __typename?: 'ConsistencyRule';
        externalId: string;
        name: string;
        operator: string;
        sourceAttribute: string;
        targetAttribute: string;
        severity?: string | null;
        errorMessage?: string | null;
        sourceSchemaFilter?: {
          __typename?: 'ConsistencySchemaFilter';
          externalId: string;
          name: string;
        } | null;
        targetSchemaFilter?: {
          __typename?: 'ConsistencySchemaFilter';
          externalId: string;
          name: string;
        } | null;
        collection?: {
          __typename?: 'ConsistencyCollection';
          externalId: string;
          name: string;
          schemaFilters?: {
            __typename?: '_ConsistencySchemaFilterConnection';
            items: Array<{
              __typename?: 'ConsistencySchemaFilter';
              schemaType: string;
            } | null>;
          } | null;
        } | null;
      } | null;
    } | null>;
  } | null;
};

export type CreateConsistencyCollectionMutationVariables = Exact<{
  id: Scalars['ID'];
  name: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  tenant: Scalars['String'];
  labels?: InputMaybe<
    Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>
  >;
  projectId: Scalars['String'];
  digitalTwinId: Scalars['ID'];
}>;

export type CreateConsistencyCollectionMutation = {
  __typename?: 'Mutation';
  Create_ConsistencyCollection?: {
    __typename?: 'ConsistencyCollection';
    externalId: string;
  } | null;
  Add_DigitalTwin_consistencyCollections?: {
    __typename?: '_TempReturn';
    endNode?: string | null;
    startNode?: string | null;
  } | null;
};

export type UpdateConsistencyCollectionMutationVariables = Exact<{
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  labels?: InputMaybe<
    Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>
  >;
  reportTemplate?: InputMaybe<Scalars['String']>;
}>;

export type UpdateConsistencyCollectionMutation = {
  __typename?: 'Mutation';
  Update_ConsistencyCollection?: {
    __typename?: 'ConsistencyCollection';
    externalId: string;
  } | null;
};

export type DeleteConsistencyCollectionMutationVariables = Exact<{
  id: Scalars['ID'];
}>;

export type DeleteConsistencyCollectionMutation = {
  __typename?: 'Mutation';
  Delete_ConsistencyCollection?: {
    __typename?: 'ConsistencyCollection';
    externalId: string;
  } | null;
};

export type CreateConsistencySchemaFilterMutationVariables = Exact<{
  id: Scalars['ID'];
  name: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  labels?: InputMaybe<
    Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>
  >;
  schemaType: Scalars['String'];
  schemaCollectionId: Scalars['String'];
  filters?: InputMaybe<Scalars['String']>;
  projectId: Scalars['String'];
  collectionId: Scalars['ID'];
}>;

export type CreateConsistencySchemaFilterMutation = {
  __typename?: 'Mutation';
  Create_ConsistencySchemaFilter?: {
    __typename?: 'ConsistencySchemaFilter';
    externalId: string;
  } | null;
  Add_ConsistencyCollection_schemaFilters?: {
    __typename?: '_TempReturn';
    endNode?: string | null;
    startNode?: string | null;
  } | null;
};

export type UpdateConsistencySchemaFilterMutationVariables = Exact<{
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  labels?: InputMaybe<
    Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>
  >;
  schemaType?: InputMaybe<Scalars['String']>;
  schemaCollectionId?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Scalars['String']>;
}>;

export type UpdateConsistencySchemaFilterMutation = {
  __typename?: 'Mutation';
  Update_ConsistencySchemaFilter?: {
    __typename?: 'ConsistencySchemaFilter';
    externalId: string;
  } | null;
};

export type DeleteConsistencySchemaFilterMutationVariables = Exact<{
  id: Scalars['ID'];
}>;

export type DeleteConsistencySchemaFilterMutation = {
  __typename?: 'Mutation';
  Delete_ConsistencySchemaFilter?: {
    __typename?: 'ConsistencySchemaFilter';
    externalId: string;
  } | null;
};

export type CreateConsistencyRuleMutationVariables = Exact<{
  id: Scalars['ID'];
  name: Scalars['String'];
  customerDefinedId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  sourceAttribute: Scalars['String'];
  sourceFilters?: InputMaybe<Scalars['String']>;
  operator: Scalars['String'];
  targetAttribute: Scalars['String'];
  targetFilters?: InputMaybe<Scalars['String']>;
  severity?: InputMaybe<Scalars['String']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<
    Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>
  >;
  conditionChecksOnly?: InputMaybe<Scalars['Boolean']>;
  projectId: Scalars['String'];
  collectionId: Scalars['ID'];
  sourceSchemaFilterId: Scalars['ID'];
  targetSchemaFilterId: Scalars['ID'];
}>;

export type CreateConsistencyRuleMutation = {
  __typename?: 'Mutation';
  Create_ConsistencyRule?: {
    __typename?: 'ConsistencyRule';
    externalId: string;
  } | null;
  Add_ConsistencyCollection_rules?: {
    __typename?: '_TempReturn';
    endNode?: string | null;
    startNode?: string | null;
  } | null;
};

export type UpdateConsistencyRuleMutationVariables = Exact<{
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  customerDefinedId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  sourceAttribute?: InputMaybe<Scalars['String']>;
  sourceFilters?: InputMaybe<Scalars['String']>;
  operator?: InputMaybe<Scalars['String']>;
  targetAttribute?: InputMaybe<Scalars['String']>;
  targetFilters?: InputMaybe<Scalars['String']>;
  severity?: InputMaybe<Scalars['String']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<
    Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>
  >;
  conditionChecksOnly?: InputMaybe<Scalars['Boolean']>;
  sourceSchemaFilter?: InputMaybe<_DirectRelationInput>;
  targetSchemaFilter?: InputMaybe<_DirectRelationInput>;
}>;

export type UpdateConsistencyRuleMutation = {
  __typename?: 'Mutation';
  Update_ConsistencyRule?: {
    __typename?: 'ConsistencyRule';
    externalId: string;
  } | null;
};

export type DeleteConsistencyRuleMutationVariables = Exact<{
  id: Scalars['ID'];
}>;

export type DeleteConsistencyRuleMutation = {
  __typename?: 'Mutation';
  Delete_ConsistencyRule?: {
    __typename?: 'ConsistencyRule';
    externalId: string;
  } | null;
};

export type CreateConsistencyConditionCheckMutationVariables = Exact<{
  id: Scalars['ID'];
  sourceAttribute: Scalars['String'];
  operator: Scalars['String'];
  targetAttribute: Scalars['String'];
  isLiteralValue?: InputMaybe<Scalars['Boolean']>;
  useTargetSchema?: InputMaybe<Scalars['Boolean']>;
  ruleId: Scalars['ID'];
}>;

export type CreateConsistencyConditionCheckMutation = {
  __typename?: 'Mutation';
  Create_ConsistencyConditionCheck?: {
    __typename?: 'ConsistencyConditionCheck';
    externalId: string;
  } | null;
  Add_ConsistencyRule_conditionChecks?: {
    __typename?: '_TempReturn';
    endNode?: string | null;
    startNode?: string | null;
  } | null;
};

export type UpdateConsistencyConditionCheckMutationVariables = Exact<{
  id: Scalars['ID'];
  sourceAttribute?: InputMaybe<Scalars['String']>;
  operator?: InputMaybe<Scalars['String']>;
  targetAttribute?: InputMaybe<Scalars['String']>;
  isLiteralValue?: InputMaybe<Scalars['Boolean']>;
  useTargetSchema?: InputMaybe<Scalars['Boolean']>;
}>;

export type UpdateConsistencyConditionCheckMutation = {
  __typename?: 'Mutation';
  Update_ConsistencyConditionCheck?: {
    __typename?: 'ConsistencyConditionCheck';
    externalId: string;
  } | null;
};

export type DeleteConsistencyConditionCheckMutationVariables = Exact<{
  id: Scalars['ID'];
}>;

export type DeleteConsistencyConditionCheckMutation = {
  __typename?: 'Mutation';
  Delete_ConsistencyConditionCheck?: {
    __typename?: 'ConsistencyConditionCheck';
    externalId: string;
  } | null;
};

export type ResolverTypeWrapper<T> = Promise<T> | T;

export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> =
  | ResolverFn<TResult, TParent, TContext, TArgs>
  | ResolverWithResolve<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<
  TResult,
  TKey extends string,
  TParent,
  TContext,
  TArgs,
> {
  subscribe: SubscriptionSubscribeFn<
    { [key in TKey]: TResult },
    TParent,
    TContext,
    TArgs
  >;
  resolve?: SubscriptionResolveFn<
    TResult,
    { [key in TKey]: TResult },
    TContext,
    TArgs
  >;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<
  TResult,
  TKey extends string,
  TParent,
  TContext,
  TArgs,
> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<
  TResult,
  TKey extends string,
  TParent = {},
  TContext = {},
  TArgs = {},
> =
  | ((
      ...args: any[]
    ) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (
  obj: T,
  context: TContext,
  info: GraphQLResolveInfo
) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<
  TResult = {},
  TParent = {},
  TContext = {},
  TArgs = {},
> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = {
  Access: ResolverTypeWrapper<Access>;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']>;
  ConsistencyCollection: ResolverTypeWrapper<ConsistencyCollection>;
  ConsistencyConditionCheck: ResolverTypeWrapper<ConsistencyConditionCheck>;
  ConsistencyRule: ResolverTypeWrapper<ConsistencyRule>;
  ConsistencyRunStatus: ResolverTypeWrapper<ConsistencyRunStatus>;
  ConsistencySchemaFilter: ResolverTypeWrapper<ConsistencySchemaFilter>;
  DataPoint: ResolverTypeWrapper<DataPoint>;
  DataPointValue: ResolverTypeWrapper<Scalars['DataPointValue']>;
  Date: ResolverTypeWrapper<Scalars['Date']>;
  DigitalTwin: ResolverTypeWrapper<DigitalTwin>;
  Error: ResolverTypeWrapper<Error>;
  ErrorKind: ErrorKind;
  File: ResolverTypeWrapper<File>;
  Float: ResolverTypeWrapper<Scalars['Float']>;
  Float32: ResolverTypeWrapper<Scalars['Float32']>;
  Float64: ResolverTypeWrapper<Scalars['Float64']>;
  GraphQlDmlVersion: ResolverTypeWrapper<GraphQlDmlVersion>;
  GraphQlDmlVersionConnection: ResolverTypeWrapper<GraphQlDmlVersionConnection>;
  GraphQlDmlVersionEdge: ResolverTypeWrapper<GraphQlDmlVersionEdge>;
  GraphQlDmlVersionFilter: GraphQlDmlVersionFilter;
  GraphQlDmlVersionSort: GraphQlDmlVersionSort;
  GraphQlDmlVersionUpsert: GraphQlDmlVersionUpsert;
  ID: ResolverTypeWrapper<Scalars['ID']>;
  InstanceRef: InstanceRef;
  Int: ResolverTypeWrapper<Scalars['Int']>;
  Int32: ResolverTypeWrapper<Scalars['Int32']>;
  Int64: ResolverTypeWrapper<Scalars['Int64']>;
  JSONObject: ResolverTypeWrapper<Scalars['JSONObject']>;
  Milestone: ResolverTypeWrapper<Milestone>;
  MilestoneType: MilestoneType;
  Mutation: ResolverTypeWrapper<{}>;
  PageInfo: ResolverTypeWrapper<PageInfo>;
  Query: ResolverTypeWrapper<{}>;
  Role: Role;
  Rule: ResolverTypeWrapper<Rule>;
  RuleRunStatus: ResolverTypeWrapper<RuleRunStatus>;
  RuleSeverity: RuleSeverity;
  RuleType: RuleType;
  Ruleset: ResolverTypeWrapper<Ruleset>;
  RunStatus: RunStatus;
  SchemaCollection: ResolverTypeWrapper<SchemaCollection>;
  Sequence: ResolverTypeWrapper<Sequence>;
  SortDirection: SortDirection;
  SortOrder: SortOrder;
  SourceLocation: ResolverTypeWrapper<SourceLocation>;
  SourceLocationRange: ResolverTypeWrapper<SourceLocationRange>;
  String: ResolverTypeWrapper<Scalars['String']>;
  StringFilter: StringFilter;
  TimeSeries: ResolverTypeWrapper<TimeSeries>;
  Timestamp: ResolverTypeWrapper<Scalars['Timestamp']>;
  UnitInfo: ResolverTypeWrapper<UnitInfo>;
  UpsertGraphQlDmlVersionResult: ResolverTypeWrapper<UpsertGraphQlDmlVersionResult>;
  ViewRef: ResolverTypeWrapper<ViewRef>;
  _AccessAggregateConnection: ResolverTypeWrapper<_AccessAggregateConnection>;
  _AccessAggregateEdge: ResolverTypeWrapper<_AccessAggregateEdge>;
  _AccessAggregateFieldCountResult: ResolverTypeWrapper<_AccessAggregateFieldCountResult>;
  _AccessAggregateFieldResult: ResolverTypeWrapper<_AccessAggregateFieldResult>;
  _AccessAggregateHistogramFieldResult: ResolverTypeWrapper<_AccessAggregateHistogramFieldResult>;
  _AccessAggregateResult: ResolverTypeWrapper<_AccessAggregateResult>;
  _AccessAvgAggregateFieldResult: ResolverTypeWrapper<_AccessAvgAggregateFieldResult>;
  _AccessConnection: ResolverTypeWrapper<_AccessConnection>;
  _AccessEdge: ResolverTypeWrapper<_AccessEdge>;
  _AccessSort: _AccessSort;
  _AggregateHistogramObjectType: ResolverTypeWrapper<_AggregateHistogramObjectType>;
  _AggregateKind: _AggregateKind;
  _BooleanCondition: _BooleanCondition;
  _ConsistencyCollectionAggregateConnection: ResolverTypeWrapper<_ConsistencyCollectionAggregateConnection>;
  _ConsistencyCollectionAggregateEdge: ResolverTypeWrapper<_ConsistencyCollectionAggregateEdge>;
  _ConsistencyCollectionAggregateFieldCountResult: ResolverTypeWrapper<_ConsistencyCollectionAggregateFieldCountResult>;
  _ConsistencyCollectionAggregateFieldResult: ResolverTypeWrapper<_ConsistencyCollectionAggregateFieldResult>;
  _ConsistencyCollectionAggregateHistogramFieldResult: ResolverTypeWrapper<_ConsistencyCollectionAggregateHistogramFieldResult>;
  _ConsistencyCollectionAggregateResult: ResolverTypeWrapper<_ConsistencyCollectionAggregateResult>;
  _ConsistencyCollectionAvgAggregateFieldResult: ResolverTypeWrapper<_ConsistencyCollectionAvgAggregateFieldResult>;
  _ConsistencyCollectionConnection: ResolverTypeWrapper<_ConsistencyCollectionConnection>;
  _ConsistencyCollectionEdge: ResolverTypeWrapper<_ConsistencyCollectionEdge>;
  _ConsistencyCollectionSort: _ConsistencyCollectionSort;
  _ConsistencyConditionCheckAggregateConnection: ResolverTypeWrapper<_ConsistencyConditionCheckAggregateConnection>;
  _ConsistencyConditionCheckAggregateEdge: ResolverTypeWrapper<_ConsistencyConditionCheckAggregateEdge>;
  _ConsistencyConditionCheckAggregateFieldCountResult: ResolverTypeWrapper<_ConsistencyConditionCheckAggregateFieldCountResult>;
  _ConsistencyConditionCheckAggregateFieldResult: ResolverTypeWrapper<_ConsistencyConditionCheckAggregateFieldResult>;
  _ConsistencyConditionCheckAggregateHistogramFieldResult: ResolverTypeWrapper<_ConsistencyConditionCheckAggregateHistogramFieldResult>;
  _ConsistencyConditionCheckAggregateResult: ResolverTypeWrapper<_ConsistencyConditionCheckAggregateResult>;
  _ConsistencyConditionCheckAvgAggregateFieldResult: ResolverTypeWrapper<_ConsistencyConditionCheckAvgAggregateFieldResult>;
  _ConsistencyConditionCheckConnection: ResolverTypeWrapper<_ConsistencyConditionCheckConnection>;
  _ConsistencyConditionCheckEdge: ResolverTypeWrapper<_ConsistencyConditionCheckEdge>;
  _ConsistencyConditionCheckSort: _ConsistencyConditionCheckSort;
  _ConsistencyRuleAggregateConnection: ResolverTypeWrapper<_ConsistencyRuleAggregateConnection>;
  _ConsistencyRuleAggregateEdge: ResolverTypeWrapper<_ConsistencyRuleAggregateEdge>;
  _ConsistencyRuleAggregateFieldCountResult: ResolverTypeWrapper<_ConsistencyRuleAggregateFieldCountResult>;
  _ConsistencyRuleAggregateFieldResult: ResolverTypeWrapper<_ConsistencyRuleAggregateFieldResult>;
  _ConsistencyRuleAggregateHistogramFieldResult: ResolverTypeWrapper<_ConsistencyRuleAggregateHistogramFieldResult>;
  _ConsistencyRuleAggregateResult: ResolverTypeWrapper<_ConsistencyRuleAggregateResult>;
  _ConsistencyRuleAvgAggregateFieldResult: ResolverTypeWrapper<_ConsistencyRuleAvgAggregateFieldResult>;
  _ConsistencyRuleConnection: ResolverTypeWrapper<_ConsistencyRuleConnection>;
  _ConsistencyRuleEdge: ResolverTypeWrapper<_ConsistencyRuleEdge>;
  _ConsistencyRuleSort: _ConsistencyRuleSort;
  _ConsistencyRunStatusAggregateConnection: ResolverTypeWrapper<_ConsistencyRunStatusAggregateConnection>;
  _ConsistencyRunStatusAggregateEdge: ResolverTypeWrapper<_ConsistencyRunStatusAggregateEdge>;
  _ConsistencyRunStatusAggregateFieldCountResult: ResolverTypeWrapper<_ConsistencyRunStatusAggregateFieldCountResult>;
  _ConsistencyRunStatusAggregateFieldResult: ResolverTypeWrapper<_ConsistencyRunStatusAggregateFieldResult>;
  _ConsistencyRunStatusAggregateHistogramFieldResult: ResolverTypeWrapper<_ConsistencyRunStatusAggregateHistogramFieldResult>;
  _ConsistencyRunStatusAggregateResult: ResolverTypeWrapper<_ConsistencyRunStatusAggregateResult>;
  _ConsistencyRunStatusAvgAggregateFieldResult: ResolverTypeWrapper<_ConsistencyRunStatusAvgAggregateFieldResult>;
  _ConsistencyRunStatusConnection: ResolverTypeWrapper<_ConsistencyRunStatusConnection>;
  _ConsistencyRunStatusEdge: ResolverTypeWrapper<_ConsistencyRunStatusEdge>;
  _ConsistencyRunStatusSort: _ConsistencyRunStatusSort;
  _ConsistencySchemaFilterAggregateConnection: ResolverTypeWrapper<_ConsistencySchemaFilterAggregateConnection>;
  _ConsistencySchemaFilterAggregateEdge: ResolverTypeWrapper<_ConsistencySchemaFilterAggregateEdge>;
  _ConsistencySchemaFilterAggregateFieldCountResult: ResolverTypeWrapper<_ConsistencySchemaFilterAggregateFieldCountResult>;
  _ConsistencySchemaFilterAggregateFieldResult: ResolverTypeWrapper<_ConsistencySchemaFilterAggregateFieldResult>;
  _ConsistencySchemaFilterAggregateHistogramFieldResult: ResolverTypeWrapper<_ConsistencySchemaFilterAggregateHistogramFieldResult>;
  _ConsistencySchemaFilterAggregateResult: ResolverTypeWrapper<_ConsistencySchemaFilterAggregateResult>;
  _ConsistencySchemaFilterAvgAggregateFieldResult: ResolverTypeWrapper<_ConsistencySchemaFilterAvgAggregateFieldResult>;
  _ConsistencySchemaFilterConnection: ResolverTypeWrapper<_ConsistencySchemaFilterConnection>;
  _ConsistencySchemaFilterEdge: ResolverTypeWrapper<_ConsistencySchemaFilterEdge>;
  _ConsistencySchemaFilterSort: _ConsistencySchemaFilterSort;
  _DataPointConnection: ResolverTypeWrapper<_DataPointConnection>;
  _DataPointEdge: ResolverTypeWrapper<_DataPointEdge>;
  _DateCondition: _DateCondition;
  _DeleteResponse: ResolverTypeWrapper<_DeleteResponse>;
  _DigitalTwinAggregateConnection: ResolverTypeWrapper<_DigitalTwinAggregateConnection>;
  _DigitalTwinAggregateEdge: ResolverTypeWrapper<_DigitalTwinAggregateEdge>;
  _DigitalTwinAggregateFieldCountResult: ResolverTypeWrapper<_DigitalTwinAggregateFieldCountResult>;
  _DigitalTwinAggregateFieldResult: ResolverTypeWrapper<_DigitalTwinAggregateFieldResult>;
  _DigitalTwinAggregateHistogramFieldResult: ResolverTypeWrapper<_DigitalTwinAggregateHistogramFieldResult>;
  _DigitalTwinAggregateResult: ResolverTypeWrapper<_DigitalTwinAggregateResult>;
  _DigitalTwinAvgAggregateFieldResult: ResolverTypeWrapper<_DigitalTwinAvgAggregateFieldResult>;
  _DigitalTwinConnection: ResolverTypeWrapper<_DigitalTwinConnection>;
  _DigitalTwinEdge: ResolverTypeWrapper<_DigitalTwinEdge>;
  _DigitalTwinSort: _DigitalTwinSort;
  _DirectRelationInput: _DirectRelationInput;
  _DownloadLink: ResolverTypeWrapper<_DownloadLink>;
  _Float32Condition: _Float32Condition;
  _Float64Condition: _Float64Condition;
  _FloatCondition: _FloatCondition;
  _GeoLocation: ResolverTypeWrapper<_GeoLocation>;
  _GeoLocationGeometry: ResolverTypeWrapper<_GeoLocationGeometry>;
  _GeoLocationType: _GeoLocationType;
  _GlobalIdInput: _GlobalIdInput;
  _IDCondition: _IdCondition;
  _InstanceType: ResolverTypeWrapper<_InstanceType>;
  _InstanceTypeCondition: _InstanceTypeCondition;
  _Int32Condition: _Int32Condition;
  _Int64Condition: _Int64Condition;
  _IntCondition: _IntCondition;
  _ListAccessFilter: _ListAccessFilter;
  _ListBooleanFilter: _ListBooleanFilter;
  _ListConsistencyCollectionFilter: _ListConsistencyCollectionFilter;
  _ListConsistencyConditionCheckFilter: _ListConsistencyConditionCheckFilter;
  _ListConsistencyRuleFilter: _ListConsistencyRuleFilter;
  _ListConsistencyRunStatusFilter: _ListConsistencyRunStatusFilter;
  _ListConsistencySchemaFilterFilter: _ListConsistencySchemaFilterFilter;
  _ListDateFilter: _ListDateFilter;
  _ListDigitalTwinFilter: _ListDigitalTwinFilter;
  _ListDirectRelationFilter: _ListDirectRelationFilter;
  _ListFloat32Filter: _ListFloat32Filter;
  _ListFloat64Filter: _ListFloat64Filter;
  _ListFloatFilter: _ListFloatFilter;
  _ListIDFilter: _ListIdFilter;
  _ListInt32Filter: _ListInt32Filter;
  _ListInt64Filter: _ListInt64Filter;
  _ListIntFilter: _ListIntFilter;
  _ListMilestoneFilter: _ListMilestoneFilter;
  _ListRuleFilter: _ListRuleFilter;
  _ListRuleRunStatusFilter: _ListRuleRunStatusFilter;
  _ListRulesetFilter: _ListRulesetFilter;
  _ListSchemaCollectionFilter: _ListSchemaCollectionFilter;
  _ListStringFilter: _ListStringFilter;
  _ListTimestampFilter: _ListTimestampFilter;
  _MilestoneAggregateConnection: ResolverTypeWrapper<_MilestoneAggregateConnection>;
  _MilestoneAggregateEdge: ResolverTypeWrapper<_MilestoneAggregateEdge>;
  _MilestoneAggregateFieldCountResult: ResolverTypeWrapper<_MilestoneAggregateFieldCountResult>;
  _MilestoneAggregateFieldResult: ResolverTypeWrapper<_MilestoneAggregateFieldResult>;
  _MilestoneAggregateHistogramFieldResult: ResolverTypeWrapper<_MilestoneAggregateHistogramFieldResult>;
  _MilestoneAggregateResult: ResolverTypeWrapper<_MilestoneAggregateResult>;
  _MilestoneAvgAggregateFieldResult: ResolverTypeWrapper<_MilestoneAvgAggregateFieldResult>;
  _MilestoneConnection: ResolverTypeWrapper<_MilestoneConnection>;
  _MilestoneEdge: ResolverTypeWrapper<_MilestoneEdge>;
  _MilestoneSort: _MilestoneSort;
  _RuleAggregateConnection: ResolverTypeWrapper<_RuleAggregateConnection>;
  _RuleAggregateEdge: ResolverTypeWrapper<_RuleAggregateEdge>;
  _RuleAggregateFieldCountResult: ResolverTypeWrapper<_RuleAggregateFieldCountResult>;
  _RuleAggregateFieldResult: ResolverTypeWrapper<_RuleAggregateFieldResult>;
  _RuleAggregateHistogramFieldResult: ResolverTypeWrapper<_RuleAggregateHistogramFieldResult>;
  _RuleAggregateResult: ResolverTypeWrapper<_RuleAggregateResult>;
  _RuleAvgAggregateFieldResult: ResolverTypeWrapper<_RuleAvgAggregateFieldResult>;
  _RuleConnection: ResolverTypeWrapper<_RuleConnection>;
  _RuleEdge: ResolverTypeWrapper<_RuleEdge>;
  _RuleRunStatusAggregateConnection: ResolverTypeWrapper<_RuleRunStatusAggregateConnection>;
  _RuleRunStatusAggregateEdge: ResolverTypeWrapper<_RuleRunStatusAggregateEdge>;
  _RuleRunStatusAggregateFieldCountResult: ResolverTypeWrapper<_RuleRunStatusAggregateFieldCountResult>;
  _RuleRunStatusAggregateFieldResult: ResolverTypeWrapper<_RuleRunStatusAggregateFieldResult>;
  _RuleRunStatusAggregateHistogramFieldResult: ResolverTypeWrapper<_RuleRunStatusAggregateHistogramFieldResult>;
  _RuleRunStatusAggregateResult: ResolverTypeWrapper<_RuleRunStatusAggregateResult>;
  _RuleRunStatusAvgAggregateFieldResult: ResolverTypeWrapper<_RuleRunStatusAvgAggregateFieldResult>;
  _RuleRunStatusConnection: ResolverTypeWrapper<_RuleRunStatusConnection>;
  _RuleRunStatusEdge: ResolverTypeWrapper<_RuleRunStatusEdge>;
  _RuleRunStatusSort: _RuleRunStatusSort;
  _RuleSort: _RuleSort;
  _RulesetAggregateConnection: ResolverTypeWrapper<_RulesetAggregateConnection>;
  _RulesetAggregateEdge: ResolverTypeWrapper<_RulesetAggregateEdge>;
  _RulesetAggregateFieldCountResult: ResolverTypeWrapper<_RulesetAggregateFieldCountResult>;
  _RulesetAggregateFieldResult: ResolverTypeWrapper<_RulesetAggregateFieldResult>;
  _RulesetAggregateHistogramFieldResult: ResolverTypeWrapper<_RulesetAggregateHistogramFieldResult>;
  _RulesetAggregateResult: ResolverTypeWrapper<_RulesetAggregateResult>;
  _RulesetAvgAggregateFieldResult: ResolverTypeWrapper<_RulesetAvgAggregateFieldResult>;
  _RulesetConnection: ResolverTypeWrapper<_RulesetConnection>;
  _RulesetEdge: ResolverTypeWrapper<_RulesetEdge>;
  _RulesetSort: _RulesetSort;
  _SchemaCollectionAggregateConnection: ResolverTypeWrapper<_SchemaCollectionAggregateConnection>;
  _SchemaCollectionAggregateEdge: ResolverTypeWrapper<_SchemaCollectionAggregateEdge>;
  _SchemaCollectionAggregateFieldCountResult: ResolverTypeWrapper<_SchemaCollectionAggregateFieldCountResult>;
  _SchemaCollectionAggregateFieldResult: ResolverTypeWrapper<_SchemaCollectionAggregateFieldResult>;
  _SchemaCollectionAggregateHistogramFieldResult: ResolverTypeWrapper<_SchemaCollectionAggregateHistogramFieldResult>;
  _SchemaCollectionAggregateResult: ResolverTypeWrapper<_SchemaCollectionAggregateResult>;
  _SchemaCollectionAvgAggregateFieldResult: ResolverTypeWrapper<_SchemaCollectionAvgAggregateFieldResult>;
  _SchemaCollectionConnection: ResolverTypeWrapper<_SchemaCollectionConnection>;
  _SchemaCollectionEdge: ResolverTypeWrapper<_SchemaCollectionEdge>;
  _SchemaCollectionSort: _SchemaCollectionSort;
  _SearchAccessFields: _SearchAccessFields;
  _SearchAccessFilter: _SearchAccessFilter;
  _SearchConsistencyCollectionFields: _SearchConsistencyCollectionFields;
  _SearchConsistencyCollectionFilter: _SearchConsistencyCollectionFilter;
  _SearchConsistencyConditionCheckFields: _SearchConsistencyConditionCheckFields;
  _SearchConsistencyConditionCheckFilter: _SearchConsistencyConditionCheckFilter;
  _SearchConsistencyRuleFields: _SearchConsistencyRuleFields;
  _SearchConsistencyRuleFilter: _SearchConsistencyRuleFilter;
  _SearchConsistencyRunStatusFields: _SearchConsistencyRunStatusFields;
  _SearchConsistencyRunStatusFilter: _SearchConsistencyRunStatusFilter;
  _SearchConsistencySchemaFilterFields: _SearchConsistencySchemaFilterFields;
  _SearchConsistencySchemaFilterFilter: _SearchConsistencySchemaFilterFilter;
  _SearchDigitalTwinFields: _SearchDigitalTwinFields;
  _SearchDigitalTwinFilter: _SearchDigitalTwinFilter;
  _SearchMilestoneFields: _SearchMilestoneFields;
  _SearchMilestoneFilter: _SearchMilestoneFilter;
  _SearchRuleFields: _SearchRuleFields;
  _SearchRuleFilter: _SearchRuleFilter;
  _SearchRuleRunStatusFields: _SearchRuleRunStatusFields;
  _SearchRuleRunStatusFilter: _SearchRuleRunStatusFilter;
  _SearchRulesetFields: _SearchRulesetFields;
  _SearchRulesetFilter: _SearchRulesetFilter;
  _SearchSchemaCollectionFields: _SearchSchemaCollectionFields;
  _SearchSchemaCollectionFilter: _SearchSchemaCollectionFilter;
  _SequenceColumn: ResolverTypeWrapper<_SequenceColumn>;
  _SequenceColumnInfo: ResolverTypeWrapper<_SequenceColumnInfo>;
  _SequenceColumnValueType: _SequenceColumnValueType;
  _SequenceRow: ResolverTypeWrapper<_SequenceRow>;
  _SequenceRowValues: ResolverTypeWrapper<Scalars['_SequenceRowValues']>;
  _SequenceRowsData: ResolverTypeWrapper<_SequenceRowsData>;
  _StringCondition: _StringCondition;
  _TempReturn: ResolverTypeWrapper<_TempReturn>;
  _TimestampCondition: _TimestampCondition;
  _UnknownType: ResolverTypeWrapper<Scalars['_UnknownType']>;
  _UpsertAccess: _UpsertAccess;
  _UpsertConsistencyCollection: _UpsertConsistencyCollection;
  _UpsertConsistencyCollectionProjectFieldInput: _UpsertConsistencyCollectionProjectFieldInput;
  _UpsertConsistencyCollectionRulesFieldInput: _UpsertConsistencyCollectionRulesFieldInput;
  _UpsertConsistencyCollectionSchemaFiltersFieldInput: _UpsertConsistencyCollectionSchemaFiltersFieldInput;
  _UpsertConsistencyConditionCheck: _UpsertConsistencyConditionCheck;
  _UpsertConsistencyConditionCheckRuleFieldInput: _UpsertConsistencyConditionCheckRuleFieldInput;
  _UpsertConsistencyRule: _UpsertConsistencyRule;
  _UpsertConsistencyRuleCollectionFieldInput: _UpsertConsistencyRuleCollectionFieldInput;
  _UpsertConsistencyRuleConditionChecksFieldInput: _UpsertConsistencyRuleConditionChecksFieldInput;
  _UpsertConsistencyRuleRunStatusesFieldInput: _UpsertConsistencyRuleRunStatusesFieldInput;
  _UpsertConsistencyRuleSourceSchemaFilterFieldInput: _UpsertConsistencyRuleSourceSchemaFilterFieldInput;
  _UpsertConsistencyRuleTargetSchemaFilterFieldInput: _UpsertConsistencyRuleTargetSchemaFilterFieldInput;
  _UpsertConsistencyRunStatus: _UpsertConsistencyRunStatus;
  _UpsertConsistencyRunStatusRuleFieldInput: _UpsertConsistencyRunStatusRuleFieldInput;
  _UpsertConsistencySchemaFilter: _UpsertConsistencySchemaFilter;
  _UpsertConsistencySchemaFilterCollectionFieldInput: _UpsertConsistencySchemaFilterCollectionFieldInput;
  _UpsertConsistencySchemaFilterSourceForRulesFieldInput: _UpsertConsistencySchemaFilterSourceForRulesFieldInput;
  _UpsertConsistencySchemaFilterTargetForRulesFieldInput: _UpsertConsistencySchemaFilterTargetForRulesFieldInput;
  _UpsertDigitalTwin: _UpsertDigitalTwin;
  _UpsertDigitalTwinConsistencyCollectionsFieldInput: _UpsertDigitalTwinConsistencyCollectionsFieldInput;
  _UpsertDigitalTwinSchemaCollectionsFieldInput: _UpsertDigitalTwinSchemaCollectionsFieldInput;
  _UpsertMilestone: _UpsertMilestone;
  _UpsertMilestoneRulesFieldInput: _UpsertMilestoneRulesFieldInput;
  _UpsertMilestoneRulesetsFieldInput: _UpsertMilestoneRulesetsFieldInput;
  _UpsertMilestoneSchemaCollectionFieldInput: _UpsertMilestoneSchemaCollectionFieldInput;
  _UpsertResponse: ResolverTypeWrapper<_UpsertResponse>;
  _UpsertRule: _UpsertRule;
  _UpsertRuleMilestonesFieldInput: _UpsertRuleMilestonesFieldInput;
  _UpsertRuleRuleRunStatusFieldInput: _UpsertRuleRuleRunStatusFieldInput;
  _UpsertRuleRulesetsFieldInput: _UpsertRuleRulesetsFieldInput;
  _UpsertRuleRunStatus: _UpsertRuleRunStatus;
  _UpsertRuleRunStatusRuleFieldInput: _UpsertRuleRunStatusRuleFieldInput;
  _UpsertRuleSchemaCollectionFieldInput: _UpsertRuleSchemaCollectionFieldInput;
  _UpsertRuleset: _UpsertRuleset;
  _UpsertRulesetMilestonesFieldInput: _UpsertRulesetMilestonesFieldInput;
  _UpsertRulesetRulesFieldInput: _UpsertRulesetRulesFieldInput;
  _UpsertSchemaCollection: _UpsertSchemaCollection;
  _UpsertSchemaCollectionMilestonesFieldInput: _UpsertSchemaCollectionMilestonesFieldInput;
  _UpsertSchemaCollectionProjectFieldInput: _UpsertSchemaCollectionProjectFieldInput;
  _UpsertSchemaCollectionRulesFieldInput: _UpsertSchemaCollectionRulesFieldInput;
  _UpsertSchemaCollectionRulesetsFieldInput: _UpsertSchemaCollectionRulesetsFieldInput;
  _searchOperatorEnum: _SearchOperatorEnum;
};

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = {
  Access: Access;
  Boolean: Scalars['Boolean'];
  ConsistencyCollection: ConsistencyCollection;
  ConsistencyConditionCheck: ConsistencyConditionCheck;
  ConsistencyRule: ConsistencyRule;
  ConsistencyRunStatus: ConsistencyRunStatus;
  ConsistencySchemaFilter: ConsistencySchemaFilter;
  DataPoint: DataPoint;
  DataPointValue: Scalars['DataPointValue'];
  Date: Scalars['Date'];
  DigitalTwin: DigitalTwin;
  Error: Error;
  File: File;
  Float: Scalars['Float'];
  Float32: Scalars['Float32'];
  Float64: Scalars['Float64'];
  GraphQlDmlVersion: GraphQlDmlVersion;
  GraphQlDmlVersionConnection: GraphQlDmlVersionConnection;
  GraphQlDmlVersionEdge: GraphQlDmlVersionEdge;
  GraphQlDmlVersionFilter: GraphQlDmlVersionFilter;
  GraphQlDmlVersionSort: GraphQlDmlVersionSort;
  GraphQlDmlVersionUpsert: GraphQlDmlVersionUpsert;
  ID: Scalars['ID'];
  InstanceRef: InstanceRef;
  Int: Scalars['Int'];
  Int32: Scalars['Int32'];
  Int64: Scalars['Int64'];
  JSONObject: Scalars['JSONObject'];
  Milestone: Milestone;
  Mutation: {};
  PageInfo: PageInfo;
  Query: {};
  Rule: Rule;
  RuleRunStatus: RuleRunStatus;
  Ruleset: Ruleset;
  SchemaCollection: SchemaCollection;
  Sequence: Sequence;
  SourceLocation: SourceLocation;
  SourceLocationRange: SourceLocationRange;
  String: Scalars['String'];
  StringFilter: StringFilter;
  TimeSeries: TimeSeries;
  Timestamp: Scalars['Timestamp'];
  UnitInfo: UnitInfo;
  UpsertGraphQlDmlVersionResult: UpsertGraphQlDmlVersionResult;
  ViewRef: ViewRef;
  _AccessAggregateConnection: _AccessAggregateConnection;
  _AccessAggregateEdge: _AccessAggregateEdge;
  _AccessAggregateFieldCountResult: _AccessAggregateFieldCountResult;
  _AccessAggregateFieldResult: _AccessAggregateFieldResult;
  _AccessAggregateHistogramFieldResult: _AccessAggregateHistogramFieldResult;
  _AccessAggregateResult: _AccessAggregateResult;
  _AccessAvgAggregateFieldResult: _AccessAvgAggregateFieldResult;
  _AccessConnection: _AccessConnection;
  _AccessEdge: _AccessEdge;
  _AccessSort: _AccessSort;
  _AggregateHistogramObjectType: _AggregateHistogramObjectType;
  _BooleanCondition: _BooleanCondition;
  _ConsistencyCollectionAggregateConnection: _ConsistencyCollectionAggregateConnection;
  _ConsistencyCollectionAggregateEdge: _ConsistencyCollectionAggregateEdge;
  _ConsistencyCollectionAggregateFieldCountResult: _ConsistencyCollectionAggregateFieldCountResult;
  _ConsistencyCollectionAggregateFieldResult: _ConsistencyCollectionAggregateFieldResult;
  _ConsistencyCollectionAggregateHistogramFieldResult: _ConsistencyCollectionAggregateHistogramFieldResult;
  _ConsistencyCollectionAggregateResult: _ConsistencyCollectionAggregateResult;
  _ConsistencyCollectionAvgAggregateFieldResult: _ConsistencyCollectionAvgAggregateFieldResult;
  _ConsistencyCollectionConnection: _ConsistencyCollectionConnection;
  _ConsistencyCollectionEdge: _ConsistencyCollectionEdge;
  _ConsistencyCollectionSort: _ConsistencyCollectionSort;
  _ConsistencyConditionCheckAggregateConnection: _ConsistencyConditionCheckAggregateConnection;
  _ConsistencyConditionCheckAggregateEdge: _ConsistencyConditionCheckAggregateEdge;
  _ConsistencyConditionCheckAggregateFieldCountResult: _ConsistencyConditionCheckAggregateFieldCountResult;
  _ConsistencyConditionCheckAggregateFieldResult: _ConsistencyConditionCheckAggregateFieldResult;
  _ConsistencyConditionCheckAggregateHistogramFieldResult: _ConsistencyConditionCheckAggregateHistogramFieldResult;
  _ConsistencyConditionCheckAggregateResult: _ConsistencyConditionCheckAggregateResult;
  _ConsistencyConditionCheckAvgAggregateFieldResult: _ConsistencyConditionCheckAvgAggregateFieldResult;
  _ConsistencyConditionCheckConnection: _ConsistencyConditionCheckConnection;
  _ConsistencyConditionCheckEdge: _ConsistencyConditionCheckEdge;
  _ConsistencyConditionCheckSort: _ConsistencyConditionCheckSort;
  _ConsistencyRuleAggregateConnection: _ConsistencyRuleAggregateConnection;
  _ConsistencyRuleAggregateEdge: _ConsistencyRuleAggregateEdge;
  _ConsistencyRuleAggregateFieldCountResult: _ConsistencyRuleAggregateFieldCountResult;
  _ConsistencyRuleAggregateFieldResult: _ConsistencyRuleAggregateFieldResult;
  _ConsistencyRuleAggregateHistogramFieldResult: _ConsistencyRuleAggregateHistogramFieldResult;
  _ConsistencyRuleAggregateResult: _ConsistencyRuleAggregateResult;
  _ConsistencyRuleAvgAggregateFieldResult: _ConsistencyRuleAvgAggregateFieldResult;
  _ConsistencyRuleConnection: _ConsistencyRuleConnection;
  _ConsistencyRuleEdge: _ConsistencyRuleEdge;
  _ConsistencyRuleSort: _ConsistencyRuleSort;
  _ConsistencyRunStatusAggregateConnection: _ConsistencyRunStatusAggregateConnection;
  _ConsistencyRunStatusAggregateEdge: _ConsistencyRunStatusAggregateEdge;
  _ConsistencyRunStatusAggregateFieldCountResult: _ConsistencyRunStatusAggregateFieldCountResult;
  _ConsistencyRunStatusAggregateFieldResult: _ConsistencyRunStatusAggregateFieldResult;
  _ConsistencyRunStatusAggregateHistogramFieldResult: _ConsistencyRunStatusAggregateHistogramFieldResult;
  _ConsistencyRunStatusAggregateResult: _ConsistencyRunStatusAggregateResult;
  _ConsistencyRunStatusAvgAggregateFieldResult: _ConsistencyRunStatusAvgAggregateFieldResult;
  _ConsistencyRunStatusConnection: _ConsistencyRunStatusConnection;
  _ConsistencyRunStatusEdge: _ConsistencyRunStatusEdge;
  _ConsistencyRunStatusSort: _ConsistencyRunStatusSort;
  _ConsistencySchemaFilterAggregateConnection: _ConsistencySchemaFilterAggregateConnection;
  _ConsistencySchemaFilterAggregateEdge: _ConsistencySchemaFilterAggregateEdge;
  _ConsistencySchemaFilterAggregateFieldCountResult: _ConsistencySchemaFilterAggregateFieldCountResult;
  _ConsistencySchemaFilterAggregateFieldResult: _ConsistencySchemaFilterAggregateFieldResult;
  _ConsistencySchemaFilterAggregateHistogramFieldResult: _ConsistencySchemaFilterAggregateHistogramFieldResult;
  _ConsistencySchemaFilterAggregateResult: _ConsistencySchemaFilterAggregateResult;
  _ConsistencySchemaFilterAvgAggregateFieldResult: _ConsistencySchemaFilterAvgAggregateFieldResult;
  _ConsistencySchemaFilterConnection: _ConsistencySchemaFilterConnection;
  _ConsistencySchemaFilterEdge: _ConsistencySchemaFilterEdge;
  _ConsistencySchemaFilterSort: _ConsistencySchemaFilterSort;
  _DataPointConnection: _DataPointConnection;
  _DataPointEdge: _DataPointEdge;
  _DateCondition: _DateCondition;
  _DeleteResponse: _DeleteResponse;
  _DigitalTwinAggregateConnection: _DigitalTwinAggregateConnection;
  _DigitalTwinAggregateEdge: _DigitalTwinAggregateEdge;
  _DigitalTwinAggregateFieldCountResult: _DigitalTwinAggregateFieldCountResult;
  _DigitalTwinAggregateFieldResult: _DigitalTwinAggregateFieldResult;
  _DigitalTwinAggregateHistogramFieldResult: _DigitalTwinAggregateHistogramFieldResult;
  _DigitalTwinAggregateResult: _DigitalTwinAggregateResult;
  _DigitalTwinAvgAggregateFieldResult: _DigitalTwinAvgAggregateFieldResult;
  _DigitalTwinConnection: _DigitalTwinConnection;
  _DigitalTwinEdge: _DigitalTwinEdge;
  _DigitalTwinSort: _DigitalTwinSort;
  _DirectRelationInput: _DirectRelationInput;
  _DownloadLink: _DownloadLink;
  _Float32Condition: _Float32Condition;
  _Float64Condition: _Float64Condition;
  _FloatCondition: _FloatCondition;
  _GeoLocation: _GeoLocation;
  _GeoLocationGeometry: _GeoLocationGeometry;
  _GlobalIdInput: _GlobalIdInput;
  _IDCondition: _IdCondition;
  _InstanceType: _InstanceType;
  _InstanceTypeCondition: _InstanceTypeCondition;
  _Int32Condition: _Int32Condition;
  _Int64Condition: _Int64Condition;
  _IntCondition: _IntCondition;
  _ListAccessFilter: _ListAccessFilter;
  _ListBooleanFilter: _ListBooleanFilter;
  _ListConsistencyCollectionFilter: _ListConsistencyCollectionFilter;
  _ListConsistencyConditionCheckFilter: _ListConsistencyConditionCheckFilter;
  _ListConsistencyRuleFilter: _ListConsistencyRuleFilter;
  _ListConsistencyRunStatusFilter: _ListConsistencyRunStatusFilter;
  _ListConsistencySchemaFilterFilter: _ListConsistencySchemaFilterFilter;
  _ListDateFilter: _ListDateFilter;
  _ListDigitalTwinFilter: _ListDigitalTwinFilter;
  _ListDirectRelationFilter: _ListDirectRelationFilter;
  _ListFloat32Filter: _ListFloat32Filter;
  _ListFloat64Filter: _ListFloat64Filter;
  _ListFloatFilter: _ListFloatFilter;
  _ListIDFilter: _ListIdFilter;
  _ListInt32Filter: _ListInt32Filter;
  _ListInt64Filter: _ListInt64Filter;
  _ListIntFilter: _ListIntFilter;
  _ListMilestoneFilter: _ListMilestoneFilter;
  _ListRuleFilter: _ListRuleFilter;
  _ListRuleRunStatusFilter: _ListRuleRunStatusFilter;
  _ListRulesetFilter: _ListRulesetFilter;
  _ListSchemaCollectionFilter: _ListSchemaCollectionFilter;
  _ListStringFilter: _ListStringFilter;
  _ListTimestampFilter: _ListTimestampFilter;
  _MilestoneAggregateConnection: _MilestoneAggregateConnection;
  _MilestoneAggregateEdge: _MilestoneAggregateEdge;
  _MilestoneAggregateFieldCountResult: _MilestoneAggregateFieldCountResult;
  _MilestoneAggregateFieldResult: _MilestoneAggregateFieldResult;
  _MilestoneAggregateHistogramFieldResult: _MilestoneAggregateHistogramFieldResult;
  _MilestoneAggregateResult: _MilestoneAggregateResult;
  _MilestoneAvgAggregateFieldResult: _MilestoneAvgAggregateFieldResult;
  _MilestoneConnection: _MilestoneConnection;
  _MilestoneEdge: _MilestoneEdge;
  _MilestoneSort: _MilestoneSort;
  _RuleAggregateConnection: _RuleAggregateConnection;
  _RuleAggregateEdge: _RuleAggregateEdge;
  _RuleAggregateFieldCountResult: _RuleAggregateFieldCountResult;
  _RuleAggregateFieldResult: _RuleAggregateFieldResult;
  _RuleAggregateHistogramFieldResult: _RuleAggregateHistogramFieldResult;
  _RuleAggregateResult: _RuleAggregateResult;
  _RuleAvgAggregateFieldResult: _RuleAvgAggregateFieldResult;
  _RuleConnection: _RuleConnection;
  _RuleEdge: _RuleEdge;
  _RuleRunStatusAggregateConnection: _RuleRunStatusAggregateConnection;
  _RuleRunStatusAggregateEdge: _RuleRunStatusAggregateEdge;
  _RuleRunStatusAggregateFieldCountResult: _RuleRunStatusAggregateFieldCountResult;
  _RuleRunStatusAggregateFieldResult: _RuleRunStatusAggregateFieldResult;
  _RuleRunStatusAggregateHistogramFieldResult: _RuleRunStatusAggregateHistogramFieldResult;
  _RuleRunStatusAggregateResult: _RuleRunStatusAggregateResult;
  _RuleRunStatusAvgAggregateFieldResult: _RuleRunStatusAvgAggregateFieldResult;
  _RuleRunStatusConnection: _RuleRunStatusConnection;
  _RuleRunStatusEdge: _RuleRunStatusEdge;
  _RuleRunStatusSort: _RuleRunStatusSort;
  _RuleSort: _RuleSort;
  _RulesetAggregateConnection: _RulesetAggregateConnection;
  _RulesetAggregateEdge: _RulesetAggregateEdge;
  _RulesetAggregateFieldCountResult: _RulesetAggregateFieldCountResult;
  _RulesetAggregateFieldResult: _RulesetAggregateFieldResult;
  _RulesetAggregateHistogramFieldResult: _RulesetAggregateHistogramFieldResult;
  _RulesetAggregateResult: _RulesetAggregateResult;
  _RulesetAvgAggregateFieldResult: _RulesetAvgAggregateFieldResult;
  _RulesetConnection: _RulesetConnection;
  _RulesetEdge: _RulesetEdge;
  _RulesetSort: _RulesetSort;
  _SchemaCollectionAggregateConnection: _SchemaCollectionAggregateConnection;
  _SchemaCollectionAggregateEdge: _SchemaCollectionAggregateEdge;
  _SchemaCollectionAggregateFieldCountResult: _SchemaCollectionAggregateFieldCountResult;
  _SchemaCollectionAggregateFieldResult: _SchemaCollectionAggregateFieldResult;
  _SchemaCollectionAggregateHistogramFieldResult: _SchemaCollectionAggregateHistogramFieldResult;
  _SchemaCollectionAggregateResult: _SchemaCollectionAggregateResult;
  _SchemaCollectionAvgAggregateFieldResult: _SchemaCollectionAvgAggregateFieldResult;
  _SchemaCollectionConnection: _SchemaCollectionConnection;
  _SchemaCollectionEdge: _SchemaCollectionEdge;
  _SchemaCollectionSort: _SchemaCollectionSort;
  _SearchAccessFilter: _SearchAccessFilter;
  _SearchConsistencyCollectionFilter: _SearchConsistencyCollectionFilter;
  _SearchConsistencyConditionCheckFilter: _SearchConsistencyConditionCheckFilter;
  _SearchConsistencyRuleFilter: _SearchConsistencyRuleFilter;
  _SearchConsistencyRunStatusFilter: _SearchConsistencyRunStatusFilter;
  _SearchConsistencySchemaFilterFilter: _SearchConsistencySchemaFilterFilter;
  _SearchDigitalTwinFilter: _SearchDigitalTwinFilter;
  _SearchMilestoneFilter: _SearchMilestoneFilter;
  _SearchRuleFilter: _SearchRuleFilter;
  _SearchRuleRunStatusFilter: _SearchRuleRunStatusFilter;
  _SearchRulesetFilter: _SearchRulesetFilter;
  _SearchSchemaCollectionFilter: _SearchSchemaCollectionFilter;
  _SequenceColumn: _SequenceColumn;
  _SequenceColumnInfo: _SequenceColumnInfo;
  _SequenceRow: _SequenceRow;
  _SequenceRowValues: Scalars['_SequenceRowValues'];
  _SequenceRowsData: _SequenceRowsData;
  _StringCondition: _StringCondition;
  _TempReturn: _TempReturn;
  _TimestampCondition: _TimestampCondition;
  _UnknownType: Scalars['_UnknownType'];
  _UpsertAccess: _UpsertAccess;
  _UpsertConsistencyCollection: _UpsertConsistencyCollection;
  _UpsertConsistencyCollectionProjectFieldInput: _UpsertConsistencyCollectionProjectFieldInput;
  _UpsertConsistencyCollectionRulesFieldInput: _UpsertConsistencyCollectionRulesFieldInput;
  _UpsertConsistencyCollectionSchemaFiltersFieldInput: _UpsertConsistencyCollectionSchemaFiltersFieldInput;
  _UpsertConsistencyConditionCheck: _UpsertConsistencyConditionCheck;
  _UpsertConsistencyConditionCheckRuleFieldInput: _UpsertConsistencyConditionCheckRuleFieldInput;
  _UpsertConsistencyRule: _UpsertConsistencyRule;
  _UpsertConsistencyRuleCollectionFieldInput: _UpsertConsistencyRuleCollectionFieldInput;
  _UpsertConsistencyRuleConditionChecksFieldInput: _UpsertConsistencyRuleConditionChecksFieldInput;
  _UpsertConsistencyRuleRunStatusesFieldInput: _UpsertConsistencyRuleRunStatusesFieldInput;
  _UpsertConsistencyRuleSourceSchemaFilterFieldInput: _UpsertConsistencyRuleSourceSchemaFilterFieldInput;
  _UpsertConsistencyRuleTargetSchemaFilterFieldInput: _UpsertConsistencyRuleTargetSchemaFilterFieldInput;
  _UpsertConsistencyRunStatus: _UpsertConsistencyRunStatus;
  _UpsertConsistencyRunStatusRuleFieldInput: _UpsertConsistencyRunStatusRuleFieldInput;
  _UpsertConsistencySchemaFilter: _UpsertConsistencySchemaFilter;
  _UpsertConsistencySchemaFilterCollectionFieldInput: _UpsertConsistencySchemaFilterCollectionFieldInput;
  _UpsertConsistencySchemaFilterSourceForRulesFieldInput: _UpsertConsistencySchemaFilterSourceForRulesFieldInput;
  _UpsertConsistencySchemaFilterTargetForRulesFieldInput: _UpsertConsistencySchemaFilterTargetForRulesFieldInput;
  _UpsertDigitalTwin: _UpsertDigitalTwin;
  _UpsertDigitalTwinConsistencyCollectionsFieldInput: _UpsertDigitalTwinConsistencyCollectionsFieldInput;
  _UpsertDigitalTwinSchemaCollectionsFieldInput: _UpsertDigitalTwinSchemaCollectionsFieldInput;
  _UpsertMilestone: _UpsertMilestone;
  _UpsertMilestoneRulesFieldInput: _UpsertMilestoneRulesFieldInput;
  _UpsertMilestoneRulesetsFieldInput: _UpsertMilestoneRulesetsFieldInput;
  _UpsertMilestoneSchemaCollectionFieldInput: _UpsertMilestoneSchemaCollectionFieldInput;
  _UpsertResponse: _UpsertResponse;
  _UpsertRule: _UpsertRule;
  _UpsertRuleMilestonesFieldInput: _UpsertRuleMilestonesFieldInput;
  _UpsertRuleRuleRunStatusFieldInput: _UpsertRuleRuleRunStatusFieldInput;
  _UpsertRuleRulesetsFieldInput: _UpsertRuleRulesetsFieldInput;
  _UpsertRuleRunStatus: _UpsertRuleRunStatus;
  _UpsertRuleRunStatusRuleFieldInput: _UpsertRuleRunStatusRuleFieldInput;
  _UpsertRuleSchemaCollectionFieldInput: _UpsertRuleSchemaCollectionFieldInput;
  _UpsertRuleset: _UpsertRuleset;
  _UpsertRulesetMilestonesFieldInput: _UpsertRulesetMilestonesFieldInput;
  _UpsertRulesetRulesFieldInput: _UpsertRulesetRulesFieldInput;
  _UpsertSchemaCollection: _UpsertSchemaCollection;
  _UpsertSchemaCollectionMilestonesFieldInput: _UpsertSchemaCollectionMilestonesFieldInput;
  _UpsertSchemaCollectionProjectFieldInput: _UpsertSchemaCollectionProjectFieldInput;
  _UpsertSchemaCollectionRulesFieldInput: _UpsertSchemaCollectionRulesFieldInput;
  _UpsertSchemaCollectionRulesetsFieldInput: _UpsertSchemaCollectionRulesetsFieldInput;
};

export type OneOfDirectiveArgs = {};

export type OneOfDirectiveResolver<
  Result,
  Parent,
  ContextType = any,
  Args = OneOfDirectiveArgs,
> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type AccessResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Access'] =
    ResolversParentTypes['Access'],
> = {
  _type?: Resolver<
    Maybe<ResolversTypes['_InstanceType']>,
    ParentType,
    ContextType
  >;
  externalId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  role?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  space?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tenant?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ConsistencyCollectionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ConsistencyCollection'] =
    ResolversParentTypes['ConsistencyCollection'],
> = {
  _type?: Resolver<
    Maybe<ResolversTypes['_InstanceType']>,
    ParentType,
    ContextType
  >;
  createdAt?: Resolver<
    Maybe<ResolversTypes['Timestamp']>,
    ParentType,
    ContextType
  >;
  description?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  externalId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  labels?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['String']>>>,
    ParentType,
    ContextType
  >;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  project?: Resolver<
    Maybe<ResolversTypes['DigitalTwin']>,
    ParentType,
    ContextType
  >;
  projectId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reportTemplate?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  rules?: Resolver<
    Maybe<ResolversTypes['_ConsistencyRuleConnection']>,
    ParentType,
    ContextType,
    Partial<ConsistencyCollectionRulesArgs>
  >;
  schemaFilters?: Resolver<
    Maybe<ResolversTypes['_ConsistencySchemaFilterConnection']>,
    ParentType,
    ContextType,
    Partial<ConsistencyCollectionSchemaFiltersArgs>
  >;
  space?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tenant?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ConsistencyConditionCheckResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ConsistencyConditionCheck'] =
    ResolversParentTypes['ConsistencyConditionCheck'],
> = {
  _type?: Resolver<
    Maybe<ResolversTypes['_InstanceType']>,
    ParentType,
    ContextType
  >;
  externalId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isLiteralValue?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
  operator?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  rule?: Resolver<
    Maybe<ResolversTypes['ConsistencyRule']>,
    ParentType,
    ContextType
  >;
  sourceAttribute?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  space?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  targetAttribute?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  useTargetSchema?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ConsistencyRuleResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ConsistencyRule'] =
    ResolversParentTypes['ConsistencyRule'],
> = {
  _type?: Resolver<
    Maybe<ResolversTypes['_InstanceType']>,
    ParentType,
    ContextType
  >;
  collection?: Resolver<
    Maybe<ResolversTypes['ConsistencyCollection']>,
    ParentType,
    ContextType
  >;
  conditionChecks?: Resolver<
    Maybe<ResolversTypes['_ConsistencyConditionCheckConnection']>,
    ParentType,
    ContextType,
    Partial<ConsistencyRuleConditionChecksArgs>
  >;
  conditionChecksOnly?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
  customerDefinedId?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  description?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  errorMessage?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  externalId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  operator?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  projectId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  runStatuses?: Resolver<
    Maybe<ResolversTypes['_ConsistencyRunStatusConnection']>,
    ParentType,
    ContextType,
    Partial<ConsistencyRuleRunStatusesArgs>
  >;
  severity?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sourceAttribute?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sourceFilters?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  sourceSchemaFilter?: Resolver<
    Maybe<ResolversTypes['ConsistencySchemaFilter']>,
    ParentType,
    ContextType
  >;
  space?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tags?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['String']>>>,
    ParentType,
    ContextType
  >;
  targetAttribute?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  targetFilters?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  targetSchemaFilter?: Resolver<
    Maybe<ResolversTypes['ConsistencySchemaFilter']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ConsistencyRunStatusResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ConsistencyRunStatus'] =
    ResolversParentTypes['ConsistencyRunStatus'],
> = {
  _type?: Resolver<
    Maybe<ResolversTypes['_InstanceType']>,
    ParentType,
    ContextType
  >;
  attributes?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['String']>>>,
    ParentType,
    ContextType
  >;
  externalId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  failedInstances?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['String']>>>,
    ParentType,
    ContextType
  >;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reportId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rule?: Resolver<
    Maybe<ResolversTypes['ConsistencyRule']>,
    ParentType,
    ContextType
  >;
  runAt?: Resolver<Maybe<ResolversTypes['Timestamp']>, ParentType, ContextType>;
  space?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  totalFailed?: Resolver<
    Maybe<ResolversTypes['Int32']>,
    ParentType,
    ContextType
  >;
  totalValid?: Resolver<
    Maybe<ResolversTypes['Int32']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ConsistencySchemaFilterResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ConsistencySchemaFilter'] =
    ResolversParentTypes['ConsistencySchemaFilter'],
> = {
  _type?: Resolver<
    Maybe<ResolversTypes['_InstanceType']>,
    ParentType,
    ContextType
  >;
  collection?: Resolver<
    Maybe<ResolversTypes['ConsistencyCollection']>,
    ParentType,
    ContextType
  >;
  description?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  externalId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  filters?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  labels?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['String']>>>,
    ParentType,
    ContextType
  >;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  projectId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  schemaCollectionId?: Resolver<
    ResolversTypes['String'],
    ParentType,
    ContextType
  >;
  schemaType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sourceForRules?: Resolver<
    Maybe<ResolversTypes['_ConsistencyRuleConnection']>,
    ParentType,
    ContextType,
    Partial<ConsistencySchemaFilterSourceForRulesArgs>
  >;
  space?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  targetForRules?: Resolver<
    Maybe<ResolversTypes['_ConsistencyRuleConnection']>,
    ParentType,
    ContextType,
    Partial<ConsistencySchemaFilterTargetForRulesArgs>
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataPointResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DataPoint'] =
    ResolversParentTypes['DataPoint'],
> = {
  average?: Resolver<Maybe<ResolversTypes['Float64']>, ParentType, ContextType>;
  continuousVariance?: Resolver<
    Maybe<ResolversTypes['Float64']>,
    ParentType,
    ContextType
  >;
  count?: Resolver<Maybe<ResolversTypes['Int32']>, ParentType, ContextType>;
  discreteVariance?: Resolver<
    Maybe<ResolversTypes['Float64']>,
    ParentType,
    ContextType
  >;
  interpolation?: Resolver<
    Maybe<ResolversTypes['Float64']>,
    ParentType,
    ContextType
  >;
  max?: Resolver<Maybe<ResolversTypes['Float64']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['Float64']>, ParentType, ContextType>;
  stepInterpolation?: Resolver<
    Maybe<ResolversTypes['Float64']>,
    ParentType,
    ContextType
  >;
  sum?: Resolver<Maybe<ResolversTypes['Float64']>, ParentType, ContextType>;
  timestamp?: Resolver<
    Maybe<ResolversTypes['Timestamp']>,
    ParentType,
    ContextType
  >;
  totalVariation?: Resolver<
    Maybe<ResolversTypes['Float64']>,
    ParentType,
    ContextType
  >;
  value?: Resolver<
    Maybe<ResolversTypes['DataPointValue']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface DataPointValueScalarConfig extends GraphQLScalarTypeConfig<
  ResolversTypes['DataPointValue'],
  any
> {
  name: 'DataPointValue';
}

export interface DateScalarConfig extends GraphQLScalarTypeConfig<
  ResolversTypes['Date'],
  any
> {
  name: 'Date';
}

export type DigitalTwinResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DigitalTwin'] =
    ResolversParentTypes['DigitalTwin'],
> = {
  _type?: Resolver<
    Maybe<ResolversTypes['_InstanceType']>,
    ParentType,
    ContextType
  >;
  consistencyCollections?: Resolver<
    Maybe<ResolversTypes['_ConsistencyCollectionConnection']>,
    ParentType,
    ContextType,
    Partial<DigitalTwinConsistencyCollectionsArgs>
  >;
  externalId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  schemaCollections?: Resolver<
    Maybe<ResolversTypes['_SchemaCollectionConnection']>,
    ParentType,
    ContextType,
    Partial<DigitalTwinSchemaCollectionsArgs>
  >;
  space?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tenant?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ErrorResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Error'] =
    ResolversParentTypes['Error'],
> = {
  hint?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  kind?: Resolver<ResolversTypes['ErrorKind'], ParentType, ContextType>;
  location?: Resolver<
    ResolversTypes['SourceLocationRange'],
    ParentType,
    ContextType
  >;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FileResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['File'] =
    ResolversParentTypes['File'],
> = {
  assetIds?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['Int64']>>>,
    ParentType,
    ContextType
  >;
  dataSetId?: Resolver<Maybe<ResolversTypes['Int64']>, ParentType, ContextType>;
  directory?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  downloadLink?: Resolver<
    Maybe<ResolversTypes['_DownloadLink']>,
    ParentType,
    ContextType,
    Partial<FileDownloadLinkArgs>
  >;
  externalId?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  geoLocation?: Resolver<
    Maybe<ResolversTypes['_GeoLocation']>,
    ParentType,
    ContextType
  >;
  id?: Resolver<Maybe<ResolversTypes['Int64']>, ParentType, ContextType>;
  labels?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['String']>>>,
    ParentType,
    ContextType
  >;
  metadata?: Resolver<
    Maybe<ResolversTypes['JSONObject']>,
    ParentType,
    ContextType
  >;
  mimeType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  securityCategories?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['Int64']>>>,
    ParentType,
    ContextType
  >;
  source?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sourceCreatedTime?: Resolver<
    Maybe<ResolversTypes['Timestamp']>,
    ParentType,
    ContextType
  >;
  sourceModifiedTime?: Resolver<
    Maybe<ResolversTypes['Timestamp']>,
    ParentType,
    ContextType
  >;
  uploaded?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
  uploadedTime?: Resolver<
    Maybe<ResolversTypes['Timestamp']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface Float32ScalarConfig extends GraphQLScalarTypeConfig<
  ResolversTypes['Float32'],
  any
> {
  name: 'Float32';
}

export interface Float64ScalarConfig extends GraphQLScalarTypeConfig<
  ResolversTypes['Float64'],
  any
> {
  name: 'Float64';
}

export type GraphQlDmlVersionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['GraphQlDmlVersion'] =
    ResolversParentTypes['GraphQlDmlVersion'],
> = {
  createdTime?: Resolver<ResolversTypes['Timestamp'], ParentType, ContextType>;
  description?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  externalId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  graphQlDml?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  lastUpdatedTime?: Resolver<
    ResolversTypes['Timestamp'],
    ParentType,
    ContextType
  >;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  space?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  version?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  views?: Resolver<Array<ResolversTypes['ViewRef']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GraphQlDmlVersionConnectionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['GraphQlDmlVersionConnection'] =
    ResolversParentTypes['GraphQlDmlVersionConnection'],
> = {
  edges?: Resolver<
    Array<Maybe<ResolversTypes['GraphQlDmlVersionEdge']>>,
    ParentType,
    ContextType
  >;
  items?: Resolver<
    Array<Maybe<ResolversTypes['GraphQlDmlVersion']>>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GraphQlDmlVersionEdgeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['GraphQlDmlVersionEdge'] =
    ResolversParentTypes['GraphQlDmlVersionEdge'],
> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['GraphQlDmlVersion'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface Int32ScalarConfig extends GraphQLScalarTypeConfig<
  ResolversTypes['Int32'],
  any
> {
  name: 'Int32';
}

export interface Int64ScalarConfig extends GraphQLScalarTypeConfig<
  ResolversTypes['Int64'],
  any
> {
  name: 'Int64';
}

export interface JsonObjectScalarConfig extends GraphQLScalarTypeConfig<
  ResolversTypes['JSONObject'],
  any
> {
  name: 'JSONObject';
}

export type MilestoneResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Milestone'] =
    ResolversParentTypes['Milestone'],
> = {
  _type?: Resolver<
    Maybe<ResolversTypes['_InstanceType']>,
    ParentType,
    ContextType
  >;
  description?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  endActiveTime?: Resolver<
    Maybe<ResolversTypes['Timestamp']>,
    ParentType,
    ContextType
  >;
  endScheduleTime?: Resolver<
    Maybe<ResolversTypes['Timestamp']>,
    ParentType,
    ContextType
  >;
  externalId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  milestoneType?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  orderIndex?: Resolver<
    Maybe<ResolversTypes['Int32']>,
    ParentType,
    ContextType
  >;
  projectId?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  reportTemplate?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  rules?: Resolver<
    Maybe<ResolversTypes['_RuleConnection']>,
    ParentType,
    ContextType,
    Partial<MilestoneRulesArgs>
  >;
  rulesets?: Resolver<
    Maybe<ResolversTypes['_RulesetConnection']>,
    ParentType,
    ContextType,
    Partial<MilestoneRulesetsArgs>
  >;
  schedule?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  schemaCollection?: Resolver<
    Maybe<ResolversTypes['SchemaCollection']>,
    ParentType,
    ContextType
  >;
  space?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  startActiveTime?: Resolver<
    Maybe<ResolversTypes['Timestamp']>,
    ParentType,
    ContextType
  >;
  startScheduleTime?: Resolver<
    Maybe<ResolversTypes['Timestamp']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MutationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Mutation'] =
    ResolversParentTypes['Mutation'],
> = {
  AddSchemaCollectionProject?: Resolver<
    Maybe<ResolversTypes['_TempReturn']>,
    ParentType,
    ContextType,
    RequireFields<
      MutationAddSchemaCollectionProjectArgs,
      'endNode' | 'startNode'
    >
  >;
  Add_ConsistencyCollection_rules?: Resolver<
    Maybe<ResolversTypes['_TempReturn']>,
    ParentType,
    ContextType,
    RequireFields<
      MutationAdd_ConsistencyCollection_RulesArgs,
      'endNode' | 'startNode'
    >
  >;
  Add_ConsistencyCollection_schemaFilters?: Resolver<
    Maybe<ResolversTypes['_TempReturn']>,
    ParentType,
    ContextType,
    RequireFields<
      MutationAdd_ConsistencyCollection_SchemaFiltersArgs,
      'endNode' | 'startNode'
    >
  >;
  Add_ConsistencyRule_conditionChecks?: Resolver<
    Maybe<ResolversTypes['_TempReturn']>,
    ParentType,
    ContextType,
    RequireFields<
      MutationAdd_ConsistencyRule_ConditionChecksArgs,
      'endNode' | 'startNode'
    >
  >;
  Add_ConsistencyRule_runStatuses?: Resolver<
    Maybe<ResolversTypes['_TempReturn']>,
    ParentType,
    ContextType,
    RequireFields<
      MutationAdd_ConsistencyRule_RunStatusesArgs,
      'endNode' | 'startNode'
    >
  >;
  Add_DigitalTwin_consistencyCollections?: Resolver<
    Maybe<ResolversTypes['_TempReturn']>,
    ParentType,
    ContextType,
    RequireFields<
      MutationAdd_DigitalTwin_ConsistencyCollectionsArgs,
      'endNode' | 'startNode'
    >
  >;
  Add_DigitalTwin_schemaCollections?: Resolver<
    Maybe<ResolversTypes['DigitalTwin']>,
    ParentType,
    ContextType,
    RequireFields<
      MutationAdd_DigitalTwin_SchemaCollectionsArgs,
      'endNode' | 'startNode'
    >
  >;
  Add_Milestone_rules?: Resolver<
    Maybe<ResolversTypes['_TempReturn']>,
    ParentType,
    ContextType,
    RequireFields<MutationAdd_Milestone_RulesArgs, 'endNode' | 'startNode'>
  >;
  Add_Milestone_rulesets?: Resolver<
    Maybe<ResolversTypes['_TempReturn']>,
    ParentType,
    ContextType,
    RequireFields<MutationAdd_Milestone_RulesetsArgs, 'endNode' | 'startNode'>
  >;
  Add_Rule_milestones?: Resolver<
    Maybe<ResolversTypes['_TempReturn']>,
    ParentType,
    ContextType,
    RequireFields<MutationAdd_Rule_MilestonesArgs, 'endNode' | 'startNode'>
  >;
  Add_Rule_ruleRunStatus?: Resolver<
    Maybe<ResolversTypes['_TempReturn']>,
    ParentType,
    ContextType,
    RequireFields<MutationAdd_Rule_RuleRunStatusArgs, 'endNode' | 'startNode'>
  >;
  Add_Rule_rulesets?: Resolver<
    Maybe<ResolversTypes['_TempReturn']>,
    ParentType,
    ContextType,
    RequireFields<MutationAdd_Rule_RulesetsArgs, 'endNode' | 'startNode'>
  >;
  Add_Ruleset_milestones?: Resolver<
    Maybe<ResolversTypes['_TempReturn']>,
    ParentType,
    ContextType,
    RequireFields<MutationAdd_Ruleset_MilestonesArgs, 'endNode' | 'startNode'>
  >;
  Add_Ruleset_rules?: Resolver<
    Maybe<ResolversTypes['_TempReturn']>,
    ParentType,
    ContextType,
    RequireFields<MutationAdd_Ruleset_RulesArgs, 'endNode' | 'startNode'>
  >;
  Add_SchemaCollection_milestones?: Resolver<
    Maybe<ResolversTypes['_TempReturn']>,
    ParentType,
    ContextType,
    RequireFields<
      MutationAdd_SchemaCollection_MilestonesArgs,
      'endNode' | 'startNode'
    >
  >;
  Add_SchemaCollection_rules?: Resolver<
    Maybe<ResolversTypes['_TempReturn']>,
    ParentType,
    ContextType,
    RequireFields<
      MutationAdd_SchemaCollection_RulesArgs,
      'endNode' | 'startNode'
    >
  >;
  Add_SchemaCollection_rulesets?: Resolver<
    Maybe<ResolversTypes['_TempReturn']>,
    ParentType,
    ContextType,
    RequireFields<
      MutationAdd_SchemaCollection_RulesetsArgs,
      'endNode' | 'startNode'
    >
  >;
  Create_Access?: Resolver<
    Maybe<ResolversTypes['Access']>,
    ParentType,
    ContextType,
    RequireFields<MutationCreate_AccessArgs, 'role' | 'tenant' | 'userId'>
  >;
  Create_ConsistencyCollection?: Resolver<
    Maybe<ResolversTypes['ConsistencyCollection']>,
    ParentType,
    ContextType,
    RequireFields<
      MutationCreate_ConsistencyCollectionArgs,
      'id' | 'name' | 'project' | 'tenant'
    >
  >;
  Create_ConsistencyConditionCheck?: Resolver<
    Maybe<ResolversTypes['ConsistencyConditionCheck']>,
    ParentType,
    ContextType,
    RequireFields<
      MutationCreate_ConsistencyConditionCheckArgs,
      'id' | 'operator' | 'rule' | 'sourceAttribute' | 'targetAttribute'
    >
  >;
  Create_ConsistencyRule?: Resolver<
    Maybe<ResolversTypes['ConsistencyRule']>,
    ParentType,
    ContextType,
    RequireFields<
      MutationCreate_ConsistencyRuleArgs,
      | 'collection'
      | 'id'
      | 'name'
      | 'operator'
      | 'sourceAttribute'
      | 'sourceSchemaFilter'
      | 'targetAttribute'
      | 'targetSchemaFilter'
    >
  >;
  Create_ConsistencyRunStatus?: Resolver<
    Maybe<ResolversTypes['ConsistencyRunStatus']>,
    ParentType,
    ContextType,
    RequireFields<
      MutationCreate_ConsistencyRunStatusArgs,
      'id' | 'rule' | 'status'
    >
  >;
  Create_ConsistencySchemaFilter?: Resolver<
    Maybe<ResolversTypes['ConsistencySchemaFilter']>,
    ParentType,
    ContextType,
    RequireFields<
      MutationCreate_ConsistencySchemaFilterArgs,
      'collection' | 'id' | 'name' | 'schemaCollectionId' | 'schemaType'
    >
  >;
  Create_DigitalTwin?: Resolver<
    Maybe<ResolversTypes['DigitalTwin']>,
    ParentType,
    ContextType,
    RequireFields<MutationCreate_DigitalTwinArgs, 'name' | 'tenant'>
  >;
  Create_Milestone?: Resolver<
    Maybe<ResolversTypes['Milestone']>,
    ParentType,
    ContextType,
    RequireFields<MutationCreate_MilestoneArgs, 'name' | 'schemaCollection'>
  >;
  Create_Rule?: Resolver<
    Maybe<ResolversTypes['Rule']>,
    ParentType,
    ContextType,
    RequireFields<MutationCreate_RuleArgs, 'id' | 'schemaCollection'>
  >;
  Create_RuleRunStatus?: Resolver<
    Maybe<ResolversTypes['RuleRunStatus']>,
    ParentType,
    ContextType,
    RequireFields<MutationCreate_RuleRunStatusArgs, 'rule' | 'status'>
  >;
  Create_Ruleset?: Resolver<
    Maybe<ResolversTypes['Ruleset']>,
    ParentType,
    ContextType,
    RequireFields<MutationCreate_RulesetArgs, 'id' | 'name' | 'projectId'>
  >;
  Create_SchemaCollection?: Resolver<
    Maybe<ResolversTypes['SchemaCollection']>,
    ParentType,
    ContextType,
    RequireFields<
      MutationCreate_SchemaCollectionArgs,
      'name' | 'project' | 'tenant'
    >
  >;
  Delete_Access?: Resolver<
    Maybe<ResolversTypes['Access']>,
    ParentType,
    ContextType,
    RequireFields<MutationDelete_AccessArgs, 'id'>
  >;
  Delete_ConsistencyCollection?: Resolver<
    Maybe<ResolversTypes['ConsistencyCollection']>,
    ParentType,
    ContextType,
    RequireFields<MutationDelete_ConsistencyCollectionArgs, 'id'>
  >;
  Delete_ConsistencyConditionCheck?: Resolver<
    Maybe<ResolversTypes['ConsistencyConditionCheck']>,
    ParentType,
    ContextType,
    RequireFields<MutationDelete_ConsistencyConditionCheckArgs, 'id'>
  >;
  Delete_ConsistencyRule?: Resolver<
    Maybe<ResolversTypes['ConsistencyRule']>,
    ParentType,
    ContextType,
    RequireFields<MutationDelete_ConsistencyRuleArgs, 'id'>
  >;
  Delete_ConsistencyRunStatus?: Resolver<
    Maybe<ResolversTypes['ConsistencyRunStatus']>,
    ParentType,
    ContextType,
    RequireFields<MutationDelete_ConsistencyRunStatusArgs, 'id'>
  >;
  Delete_ConsistencySchemaFilter?: Resolver<
    Maybe<ResolversTypes['ConsistencySchemaFilter']>,
    ParentType,
    ContextType,
    RequireFields<MutationDelete_ConsistencySchemaFilterArgs, 'id'>
  >;
  Delete_DigitalTwin?: Resolver<
    Maybe<ResolversTypes['DigitalTwin']>,
    ParentType,
    ContextType,
    RequireFields<MutationDelete_DigitalTwinArgs, 'id'>
  >;
  Delete_Milestone?: Resolver<
    Maybe<ResolversTypes['Milestone']>,
    ParentType,
    ContextType,
    RequireFields<MutationDelete_MilestoneArgs, 'id'>
  >;
  Delete_Rule?: Resolver<
    Maybe<ResolversTypes['Rule']>,
    ParentType,
    ContextType,
    RequireFields<MutationDelete_RuleArgs, 'id'>
  >;
  Delete_RuleRunStatus?: Resolver<
    Maybe<ResolversTypes['RuleRunStatus']>,
    ParentType,
    ContextType,
    RequireFields<MutationDelete_RuleRunStatusArgs, 'id'>
  >;
  Delete_Ruleset?: Resolver<
    Maybe<ResolversTypes['Ruleset']>,
    ParentType,
    ContextType,
    RequireFields<MutationDelete_RulesetArgs, 'id'>
  >;
  Delete_SchemaCollection?: Resolver<
    Maybe<ResolversTypes['SchemaCollection']>,
    ParentType,
    ContextType,
    RequireFields<MutationDelete_SchemaCollectionArgs, 'id'>
  >;
  RemoveSchemaCollectionProject?: Resolver<
    Maybe<ResolversTypes['_TempReturn']>,
    ParentType,
    ContextType,
    RequireFields<
      MutationRemoveSchemaCollectionProjectArgs,
      'endNode' | 'startNode'
    >
  >;
  Remove_ConsistencyCollection_rules?: Resolver<
    Maybe<ResolversTypes['_TempReturn']>,
    ParentType,
    ContextType,
    RequireFields<
      MutationRemove_ConsistencyCollection_RulesArgs,
      'endNode' | 'startNode'
    >
  >;
  Remove_ConsistencyCollection_schemaFilters?: Resolver<
    Maybe<ResolversTypes['_TempReturn']>,
    ParentType,
    ContextType,
    RequireFields<
      MutationRemove_ConsistencyCollection_SchemaFiltersArgs,
      'endNode' | 'startNode'
    >
  >;
  Remove_ConsistencyRule_conditionChecks?: Resolver<
    Maybe<ResolversTypes['_TempReturn']>,
    ParentType,
    ContextType,
    RequireFields<
      MutationRemove_ConsistencyRule_ConditionChecksArgs,
      'endNode' | 'startNode'
    >
  >;
  Remove_ConsistencyRule_runStatuses?: Resolver<
    Maybe<ResolversTypes['_TempReturn']>,
    ParentType,
    ContextType,
    RequireFields<
      MutationRemove_ConsistencyRule_RunStatusesArgs,
      'endNode' | 'startNode'
    >
  >;
  Remove_DigitalTwin_consistencyCollections?: Resolver<
    Maybe<ResolversTypes['_TempReturn']>,
    ParentType,
    ContextType,
    RequireFields<
      MutationRemove_DigitalTwin_ConsistencyCollectionsArgs,
      'endNode' | 'startNode'
    >
  >;
  Remove_DigitalTwin_schemaCollections?: Resolver<
    Maybe<ResolversTypes['_TempReturn']>,
    ParentType,
    ContextType,
    RequireFields<
      MutationRemove_DigitalTwin_SchemaCollectionsArgs,
      'endNode' | 'startNode'
    >
  >;
  Remove_Milestone_rules?: Resolver<
    Maybe<ResolversTypes['_TempReturn']>,
    ParentType,
    ContextType,
    RequireFields<MutationRemove_Milestone_RulesArgs, 'endNode' | 'startNode'>
  >;
  Remove_Milestone_rulesets?: Resolver<
    Maybe<ResolversTypes['_TempReturn']>,
    ParentType,
    ContextType,
    RequireFields<
      MutationRemove_Milestone_RulesetsArgs,
      'endNode' | 'startNode'
    >
  >;
  Remove_Rule_milestones?: Resolver<
    Maybe<ResolversTypes['_TempReturn']>,
    ParentType,
    ContextType,
    RequireFields<MutationRemove_Rule_MilestonesArgs, 'endNode' | 'startNode'>
  >;
  Remove_Rule_ruleRunStatus?: Resolver<
    Maybe<ResolversTypes['_TempReturn']>,
    ParentType,
    ContextType,
    RequireFields<
      MutationRemove_Rule_RuleRunStatusArgs,
      'endNode' | 'startNode'
    >
  >;
  Remove_Rule_rulesets?: Resolver<
    Maybe<ResolversTypes['_TempReturn']>,
    ParentType,
    ContextType,
    RequireFields<MutationRemove_Rule_RulesetsArgs, 'endNode' | 'startNode'>
  >;
  Remove_Ruleset_milestones?: Resolver<
    Maybe<ResolversTypes['_TempReturn']>,
    ParentType,
    ContextType,
    RequireFields<
      MutationRemove_Ruleset_MilestonesArgs,
      'endNode' | 'startNode'
    >
  >;
  Remove_Ruleset_rules?: Resolver<
    Maybe<ResolversTypes['_TempReturn']>,
    ParentType,
    ContextType,
    RequireFields<MutationRemove_Ruleset_RulesArgs, 'endNode' | 'startNode'>
  >;
  Remove_SchemaCollection_milestones?: Resolver<
    Maybe<ResolversTypes['_TempReturn']>,
    ParentType,
    ContextType,
    RequireFields<
      MutationRemove_SchemaCollection_MilestonesArgs,
      'endNode' | 'startNode'
    >
  >;
  Remove_SchemaCollection_rules?: Resolver<
    Maybe<ResolversTypes['_TempReturn']>,
    ParentType,
    ContextType,
    RequireFields<
      MutationRemove_SchemaCollection_RulesArgs,
      'endNode' | 'startNode'
    >
  >;
  Remove_SchemaCollection_rulesets?: Resolver<
    Maybe<ResolversTypes['_TempReturn']>,
    ParentType,
    ContextType,
    RequireFields<
      MutationRemove_SchemaCollection_RulesetsArgs,
      'endNode' | 'startNode'
    >
  >;
  Update_Access?: Resolver<
    Maybe<ResolversTypes['Access']>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdate_AccessArgs, 'id'>
  >;
  Update_ConsistencyCollection?: Resolver<
    Maybe<ResolversTypes['ConsistencyCollection']>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdate_ConsistencyCollectionArgs, 'id'>
  >;
  Update_ConsistencyConditionCheck?: Resolver<
    Maybe<ResolversTypes['ConsistencyConditionCheck']>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdate_ConsistencyConditionCheckArgs, 'id'>
  >;
  Update_ConsistencyRule?: Resolver<
    Maybe<ResolversTypes['ConsistencyRule']>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdate_ConsistencyRuleArgs, 'id'>
  >;
  Update_ConsistencyRunStatus?: Resolver<
    Maybe<ResolversTypes['ConsistencyRunStatus']>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdate_ConsistencyRunStatusArgs, 'id'>
  >;
  Update_ConsistencySchemaFilter?: Resolver<
    Maybe<ResolversTypes['ConsistencySchemaFilter']>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdate_ConsistencySchemaFilterArgs, 'id'>
  >;
  Update_DigitalTwin?: Resolver<
    Maybe<ResolversTypes['DigitalTwin']>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdate_DigitalTwinArgs, 'id'>
  >;
  Update_Milestone?: Resolver<
    Maybe<ResolversTypes['Milestone']>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdate_MilestoneArgs, 'id'>
  >;
  Update_Rule?: Resolver<
    Maybe<ResolversTypes['Rule']>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdate_RuleArgs, 'id'>
  >;
  Update_RuleRunStatus?: Resolver<
    Maybe<ResolversTypes['RuleRunStatus']>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdate_RuleRunStatusArgs, 'id'>
  >;
  Update_Ruleset?: Resolver<
    Maybe<ResolversTypes['Ruleset']>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdate_RulesetArgs, 'id'>
  >;
  Update_SchemaCollection?: Resolver<
    Maybe<ResolversTypes['SchemaCollection']>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdate_SchemaCollectionArgs, 'id'>
  >;
};

export type PageInfoResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PageInfo'] =
    ResolversParentTypes['PageInfo'],
> = {
  endCursor?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<
    ResolversTypes['Boolean'],
    ParentType,
    ContextType
  >;
  startCursor?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QueryResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Query'] =
    ResolversParentTypes['Query'],
> = {
  aggregateAccess?: Resolver<
    Maybe<ResolversTypes['_AccessAggregateConnection']>,
    ParentType,
    ContextType,
    Partial<QueryAggregateAccessArgs>
  >;
  aggregateConsistencyCollection?: Resolver<
    Maybe<ResolversTypes['_ConsistencyCollectionAggregateConnection']>,
    ParentType,
    ContextType,
    Partial<QueryAggregateConsistencyCollectionArgs>
  >;
  aggregateConsistencyConditionCheck?: Resolver<
    Maybe<ResolversTypes['_ConsistencyConditionCheckAggregateConnection']>,
    ParentType,
    ContextType,
    Partial<QueryAggregateConsistencyConditionCheckArgs>
  >;
  aggregateConsistencyRule?: Resolver<
    Maybe<ResolversTypes['_ConsistencyRuleAggregateConnection']>,
    ParentType,
    ContextType,
    Partial<QueryAggregateConsistencyRuleArgs>
  >;
  aggregateConsistencyRunStatus?: Resolver<
    Maybe<ResolversTypes['_ConsistencyRunStatusAggregateConnection']>,
    ParentType,
    ContextType,
    Partial<QueryAggregateConsistencyRunStatusArgs>
  >;
  aggregateConsistencySchemaFilter?: Resolver<
    Maybe<ResolversTypes['_ConsistencySchemaFilterAggregateConnection']>,
    ParentType,
    ContextType,
    Partial<QueryAggregateConsistencySchemaFilterArgs>
  >;
  aggregateDigitalTwin?: Resolver<
    Maybe<ResolversTypes['_DigitalTwinAggregateConnection']>,
    ParentType,
    ContextType,
    Partial<QueryAggregateDigitalTwinArgs>
  >;
  aggregateMilestone?: Resolver<
    Maybe<ResolversTypes['_MilestoneAggregateConnection']>,
    ParentType,
    ContextType,
    Partial<QueryAggregateMilestoneArgs>
  >;
  aggregateRule?: Resolver<
    Maybe<ResolversTypes['_RuleAggregateConnection']>,
    ParentType,
    ContextType,
    Partial<QueryAggregateRuleArgs>
  >;
  aggregateRuleRunStatus?: Resolver<
    Maybe<ResolversTypes['_RuleRunStatusAggregateConnection']>,
    ParentType,
    ContextType,
    Partial<QueryAggregateRuleRunStatusArgs>
  >;
  aggregateRuleset?: Resolver<
    Maybe<ResolversTypes['_RulesetAggregateConnection']>,
    ParentType,
    ContextType,
    Partial<QueryAggregateRulesetArgs>
  >;
  aggregateSchemaCollection?: Resolver<
    Maybe<ResolversTypes['_SchemaCollectionAggregateConnection']>,
    ParentType,
    ContextType,
    Partial<QueryAggregateSchemaCollectionArgs>
  >;
  getAccessById?: Resolver<
    Maybe<ResolversTypes['_AccessConnection']>,
    ParentType,
    ContextType,
    RequireFields<QueryGetAccessByIdArgs, 'instance'>
  >;
  getConsistencyCollectionById?: Resolver<
    Maybe<ResolversTypes['_ConsistencyCollectionConnection']>,
    ParentType,
    ContextType,
    RequireFields<QueryGetConsistencyCollectionByIdArgs, 'instance'>
  >;
  getConsistencyConditionCheckById?: Resolver<
    Maybe<ResolversTypes['_ConsistencyConditionCheckConnection']>,
    ParentType,
    ContextType,
    RequireFields<QueryGetConsistencyConditionCheckByIdArgs, 'instance'>
  >;
  getConsistencyRuleById?: Resolver<
    Maybe<ResolversTypes['_ConsistencyRuleConnection']>,
    ParentType,
    ContextType,
    RequireFields<QueryGetConsistencyRuleByIdArgs, 'instance'>
  >;
  getConsistencyRunStatusById?: Resolver<
    Maybe<ResolversTypes['_ConsistencyRunStatusConnection']>,
    ParentType,
    ContextType,
    RequireFields<QueryGetConsistencyRunStatusByIdArgs, 'instance'>
  >;
  getConsistencySchemaFilterById?: Resolver<
    Maybe<ResolversTypes['_ConsistencySchemaFilterConnection']>,
    ParentType,
    ContextType,
    RequireFields<QueryGetConsistencySchemaFilterByIdArgs, 'instance'>
  >;
  getDigitalTwinById?: Resolver<
    Maybe<ResolversTypes['_DigitalTwinConnection']>,
    ParentType,
    ContextType,
    RequireFields<QueryGetDigitalTwinByIdArgs, 'instance'>
  >;
  getMilestoneById?: Resolver<
    Maybe<ResolversTypes['_MilestoneConnection']>,
    ParentType,
    ContextType,
    RequireFields<QueryGetMilestoneByIdArgs, 'instance'>
  >;
  getRuleById?: Resolver<
    Maybe<ResolversTypes['_RuleConnection']>,
    ParentType,
    ContextType,
    RequireFields<QueryGetRuleByIdArgs, 'instance'>
  >;
  getRuleRunStatusById?: Resolver<
    Maybe<ResolversTypes['_RuleRunStatusConnection']>,
    ParentType,
    ContextType,
    RequireFields<QueryGetRuleRunStatusByIdArgs, 'instance'>
  >;
  getRulesetById?: Resolver<
    Maybe<ResolversTypes['_RulesetConnection']>,
    ParentType,
    ContextType,
    RequireFields<QueryGetRulesetByIdArgs, 'instance'>
  >;
  getSchemaCollectionById?: Resolver<
    Maybe<ResolversTypes['_SchemaCollectionConnection']>,
    ParentType,
    ContextType,
    RequireFields<QueryGetSchemaCollectionByIdArgs, 'instance'>
  >;
  graphQlDmlVersionsById?: Resolver<
    Maybe<ResolversTypes['GraphQlDmlVersionConnection']>,
    ParentType,
    ContextType,
    RequireFields<QueryGraphQlDmlVersionsByIdArgs, 'externalId' | 'space'>
  >;
  listAccess?: Resolver<
    Maybe<ResolversTypes['_AccessConnection']>,
    ParentType,
    ContextType,
    Partial<QueryListAccessArgs>
  >;
  listConsistencyCollection?: Resolver<
    Maybe<ResolversTypes['_ConsistencyCollectionConnection']>,
    ParentType,
    ContextType,
    Partial<QueryListConsistencyCollectionArgs>
  >;
  listConsistencyConditionCheck?: Resolver<
    Maybe<ResolversTypes['_ConsistencyConditionCheckConnection']>,
    ParentType,
    ContextType,
    Partial<QueryListConsistencyConditionCheckArgs>
  >;
  listConsistencyRule?: Resolver<
    Maybe<ResolversTypes['_ConsistencyRuleConnection']>,
    ParentType,
    ContextType,
    Partial<QueryListConsistencyRuleArgs>
  >;
  listConsistencyRunStatus?: Resolver<
    Maybe<ResolversTypes['_ConsistencyRunStatusConnection']>,
    ParentType,
    ContextType,
    Partial<QueryListConsistencyRunStatusArgs>
  >;
  listConsistencySchemaFilter?: Resolver<
    Maybe<ResolversTypes['_ConsistencySchemaFilterConnection']>,
    ParentType,
    ContextType,
    Partial<QueryListConsistencySchemaFilterArgs>
  >;
  listDigitalTwin?: Resolver<
    Maybe<ResolversTypes['_DigitalTwinConnection']>,
    ParentType,
    ContextType,
    Partial<QueryListDigitalTwinArgs>
  >;
  listGraphQlDmlVersions?: Resolver<
    Maybe<ResolversTypes['GraphQlDmlVersionConnection']>,
    ParentType,
    ContextType,
    Partial<QueryListGraphQlDmlVersionsArgs>
  >;
  listMilestone?: Resolver<
    Maybe<ResolversTypes['_MilestoneConnection']>,
    ParentType,
    ContextType,
    Partial<QueryListMilestoneArgs>
  >;
  listRule?: Resolver<
    Maybe<ResolversTypes['_RuleConnection']>,
    ParentType,
    ContextType,
    Partial<QueryListRuleArgs>
  >;
  listRuleRunStatus?: Resolver<
    Maybe<ResolversTypes['_RuleRunStatusConnection']>,
    ParentType,
    ContextType,
    Partial<QueryListRuleRunStatusArgs>
  >;
  listRuleset?: Resolver<
    Maybe<ResolversTypes['_RulesetConnection']>,
    ParentType,
    ContextType,
    Partial<QueryListRulesetArgs>
  >;
  listSchemaCollection?: Resolver<
    Maybe<ResolversTypes['_SchemaCollectionConnection']>,
    ParentType,
    ContextType,
    Partial<QueryListSchemaCollectionArgs>
  >;
  searchAccess?: Resolver<
    Maybe<ResolversTypes['_AccessConnection']>,
    ParentType,
    ContextType,
    RequireFields<QuerySearchAccessArgs, 'query'>
  >;
  searchConsistencyCollection?: Resolver<
    Maybe<ResolversTypes['_ConsistencyCollectionConnection']>,
    ParentType,
    ContextType,
    RequireFields<QuerySearchConsistencyCollectionArgs, 'query'>
  >;
  searchConsistencyConditionCheck?: Resolver<
    Maybe<ResolversTypes['_ConsistencyConditionCheckConnection']>,
    ParentType,
    ContextType,
    RequireFields<QuerySearchConsistencyConditionCheckArgs, 'query'>
  >;
  searchConsistencyRule?: Resolver<
    Maybe<ResolversTypes['_ConsistencyRuleConnection']>,
    ParentType,
    ContextType,
    RequireFields<QuerySearchConsistencyRuleArgs, 'query'>
  >;
  searchConsistencyRunStatus?: Resolver<
    Maybe<ResolversTypes['_ConsistencyRunStatusConnection']>,
    ParentType,
    ContextType,
    RequireFields<QuerySearchConsistencyRunStatusArgs, 'query'>
  >;
  searchConsistencySchemaFilter?: Resolver<
    Maybe<ResolversTypes['_ConsistencySchemaFilterConnection']>,
    ParentType,
    ContextType,
    RequireFields<QuerySearchConsistencySchemaFilterArgs, 'query'>
  >;
  searchDigitalTwin?: Resolver<
    Maybe<ResolversTypes['_DigitalTwinConnection']>,
    ParentType,
    ContextType,
    RequireFields<QuerySearchDigitalTwinArgs, 'query'>
  >;
  searchMilestone?: Resolver<
    Maybe<ResolversTypes['_MilestoneConnection']>,
    ParentType,
    ContextType,
    RequireFields<QuerySearchMilestoneArgs, 'query'>
  >;
  searchRule?: Resolver<
    Maybe<ResolversTypes['_RuleConnection']>,
    ParentType,
    ContextType,
    RequireFields<QuerySearchRuleArgs, 'query'>
  >;
  searchRuleRunStatus?: Resolver<
    Maybe<ResolversTypes['_RuleRunStatusConnection']>,
    ParentType,
    ContextType,
    RequireFields<QuerySearchRuleRunStatusArgs, 'query'>
  >;
  searchRuleset?: Resolver<
    Maybe<ResolversTypes['_RulesetConnection']>,
    ParentType,
    ContextType,
    RequireFields<QuerySearchRulesetArgs, 'query'>
  >;
  searchSchemaCollection?: Resolver<
    Maybe<ResolversTypes['_SchemaCollectionConnection']>,
    ParentType,
    ContextType,
    RequireFields<QuerySearchSchemaCollectionArgs, 'query'>
  >;
  unsafelyWipeAndRegenerateDmlBasedOnDataModel?: Resolver<
    Maybe<ResolversTypes['GraphQlDmlVersionConnection']>,
    ParentType,
    ContextType,
    RequireFields<
      QueryUnsafelyWipeAndRegenerateDmlBasedOnDataModelArgs,
      'externalId' | 'space' | 'version'
    >
  >;
};

export type RuleResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Rule'] =
    ResolversParentTypes['Rule'],
> = {
  _type?: Resolver<
    Maybe<ResolversTypes['_InstanceType']>,
    ParentType,
    ContextType
  >;
  advanceRules?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  customerDefinedId?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  description?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  errorMessage?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  externalId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  filters?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  invertedRules?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  milestones?: Resolver<
    Maybe<ResolversTypes['_MilestoneConnection']>,
    ParentType,
    ContextType,
    Partial<RuleMilestonesArgs>
  >;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  primaryKeyName?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  projectId?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  ruleRunStatus?: Resolver<
    Maybe<ResolversTypes['_RuleRunStatusConnection']>,
    ParentType,
    ContextType,
    Partial<RuleRuleRunStatusArgs>
  >;
  rules?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rulesets?: Resolver<
    Maybe<ResolversTypes['_RulesetConnection']>,
    ParentType,
    ContextType,
    Partial<RuleRulesetsArgs>
  >;
  schemaCollection?: Resolver<
    Maybe<ResolversTypes['SchemaCollection']>,
    ParentType,
    ContextType
  >;
  schemaType?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  severity?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  simpleInvertedRules?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  simpleRules?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  space?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tags?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['String']>>>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RuleRunStatusResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['RuleRunStatus'] =
    ResolversParentTypes['RuleRunStatus'],
> = {
  _type?: Resolver<
    Maybe<ResolversTypes['_InstanceType']>,
    ParentType,
    ContextType
  >;
  attributes?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['String']>>>,
    ParentType,
    ContextType
  >;
  externalId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  failedInstances?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['String']>>>,
    ParentType,
    ContextType
  >;
  filteredInstances?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['String']>>>,
    ParentType,
    ContextType
  >;
  isFilterResult?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reportId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rule?: Resolver<Maybe<ResolversTypes['Rule']>, ParentType, ContextType>;
  runAt?: Resolver<Maybe<ResolversTypes['Timestamp']>, ParentType, ContextType>;
  space?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  totalFailed?: Resolver<
    Maybe<ResolversTypes['Int32']>,
    ParentType,
    ContextType
  >;
  totalValid?: Resolver<
    Maybe<ResolversTypes['Int32']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RulesetResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Ruleset'] =
    ResolversParentTypes['Ruleset'],
> = {
  _type?: Resolver<
    Maybe<ResolversTypes['_InstanceType']>,
    ParentType,
    ContextType
  >;
  description?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  externalId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  filters?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  labels?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['String']>>>,
    ParentType,
    ContextType
  >;
  milestones?: Resolver<
    Maybe<ResolversTypes['_MilestoneConnection']>,
    ParentType,
    ContextType,
    Partial<RulesetMilestonesArgs>
  >;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  projectId?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  rules?: Resolver<
    Maybe<ResolversTypes['_RuleConnection']>,
    ParentType,
    ContextType,
    Partial<RulesetRulesArgs>
  >;
  schemaType?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  space?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SchemaCollectionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SchemaCollection'] =
    ResolversParentTypes['SchemaCollection'],
> = {
  _type?: Resolver<
    Maybe<ResolversTypes['_InstanceType']>,
    ParentType,
    ContextType
  >;
  description?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  externalId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  graphQLSchemaString?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  milestones?: Resolver<
    Maybe<ResolversTypes['_MilestoneConnection']>,
    ParentType,
    ContextType,
    Partial<SchemaCollectionMilestonesArgs>
  >;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  project?: Resolver<
    Maybe<ResolversTypes['DigitalTwin']>,
    ParentType,
    ContextType
  >;
  refId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  refVersion?: Resolver<
    Maybe<ResolversTypes['Int32']>,
    ParentType,
    ContextType
  >;
  rules?: Resolver<
    Maybe<ResolversTypes['_RuleConnection']>,
    ParentType,
    ContextType,
    Partial<SchemaCollectionRulesArgs>
  >;
  rulesets?: Resolver<
    Maybe<ResolversTypes['_RulesetConnection']>,
    ParentType,
    ContextType,
    Partial<SchemaCollectionRulesetsArgs>
  >;
  space?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tenant?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SequenceResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Sequence'] =
    ResolversParentTypes['Sequence'],
> = {
  assetId?: Resolver<Maybe<ResolversTypes['Int64']>, ParentType, ContextType>;
  columns?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['_SequenceColumn']>>>,
    ParentType,
    ContextType
  >;
  data?: Resolver<
    Maybe<ResolversTypes['_SequenceRow']>,
    ParentType,
    ContextType,
    Partial<SequenceDataArgs>
  >;
  dataSetId?: Resolver<Maybe<ResolversTypes['Int64']>, ParentType, ContextType>;
  description?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  externalId?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  id?: Resolver<Maybe<ResolversTypes['Int64']>, ParentType, ContextType>;
  latest?: Resolver<
    Maybe<ResolversTypes['_SequenceRow']>,
    ParentType,
    ContextType,
    Partial<SequenceLatestArgs>
  >;
  metadata?: Resolver<
    Maybe<ResolversTypes['JSONObject']>,
    ParentType,
    ContextType
  >;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SourceLocationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SourceLocation'] =
    ResolversParentTypes['SourceLocation'],
> = {
  column?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  line?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SourceLocationRangeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SourceLocationRange'] =
    ResolversParentTypes['SourceLocationRange'],
> = {
  end?: Resolver<
    Maybe<ResolversTypes['SourceLocation']>,
    ParentType,
    ContextType
  >;
  start?: Resolver<ResolversTypes['SourceLocation'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TimeSeriesResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TimeSeries'] =
    ResolversParentTypes['TimeSeries'],
> = {
  assetId?: Resolver<Maybe<ResolversTypes['Int64']>, ParentType, ContextType>;
  dataPoints?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['DataPoint']>>>,
    ParentType,
    ContextType,
    Partial<TimeSeriesDataPointsArgs>
  >;
  datasetId?: Resolver<Maybe<ResolversTypes['Int64']>, ParentType, ContextType>;
  description?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  externalId?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  getDataPoints?: Resolver<
    Maybe<ResolversTypes['_DataPointConnection']>,
    ParentType,
    ContextType,
    Partial<TimeSeriesGetDataPointsArgs>
  >;
  getLatestDataPoint?: Resolver<
    Maybe<ResolversTypes['_DataPointConnection']>,
    ParentType,
    ContextType,
    Partial<TimeSeriesGetLatestDataPointArgs>
  >;
  id?: Resolver<Maybe<ResolversTypes['Int64']>, ParentType, ContextType>;
  isStep?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isString?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
  latestDataPoint?: Resolver<
    Maybe<ResolversTypes['DataPoint']>,
    ParentType,
    ContextType,
    Partial<TimeSeriesLatestDataPointArgs>
  >;
  metadata?: Resolver<
    Maybe<ResolversTypes['JSONObject']>,
    ParentType,
    ContextType
  >;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  securityCategories?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['Int64']>>>,
    ParentType,
    ContextType
  >;
  unit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  unitExternalId?: Resolver<
    Maybe<ResolversTypes['ID']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface TimestampScalarConfig extends GraphQLScalarTypeConfig<
  ResolversTypes['Timestamp'],
  any
> {
  name: 'Timestamp';
}

export type UnitInfoResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UnitInfo'] =
    ResolversParentTypes['UnitInfo'],
> = {
  sourceUnit?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  unitExternalId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpsertGraphQlDmlVersionResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UpsertGraphQlDmlVersionResult'] =
    ResolversParentTypes['UpsertGraphQlDmlVersionResult'],
> = {
  errors?: Resolver<
    Maybe<Array<ResolversTypes['Error']>>,
    ParentType,
    ContextType
  >;
  result?: Resolver<
    Maybe<ResolversTypes['GraphQlDmlVersion']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ViewRefResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ViewRef'] =
    ResolversParentTypes['ViewRef'],
> = {
  externalId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  space?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  version?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _AccessAggregateConnectionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['_AccessAggregateConnection'] =
    ResolversParentTypes['_AccessAggregateConnection'],
> = {
  edges?: Resolver<
    Array<Maybe<ResolversTypes['_AccessAggregateEdge']>>,
    ParentType,
    ContextType
  >;
  items?: Resolver<
    Array<Maybe<ResolversTypes['_AccessAggregateResult']>>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _AccessAggregateEdgeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['_AccessAggregateEdge'] =
    ResolversParentTypes['_AccessAggregateEdge'],
> = {
  _type?: Resolver<
    Maybe<ResolversTypes['_InstanceType']>,
    ParentType,
    ContextType
  >;
  cursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  externalId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  node?: Resolver<
    ResolversTypes['_AccessAggregateResult'],
    ParentType,
    ContextType
  >;
  space?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _AccessAggregateFieldCountResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['_AccessAggregateFieldCountResult'] =
    ResolversParentTypes['_AccessAggregateFieldCountResult'],
> = {
  externalId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  role?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  tenant?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _AccessAggregateFieldResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['_AccessAggregateFieldResult'] =
    ResolversParentTypes['_AccessAggregateFieldResult'],
> = {
  _empty?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _AccessAggregateHistogramFieldResultResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['_AccessAggregateHistogramFieldResult'] =
    ResolversParentTypes['_AccessAggregateHistogramFieldResult'],
> = {
  _empty?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['_AggregateHistogramObjectType']>>>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _AccessAggregateResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['_AccessAggregateResult'] =
    ResolversParentTypes['_AccessAggregateResult'],
> = {
  avg?: Resolver<
    Maybe<ResolversTypes['_AccessAvgAggregateFieldResult']>,
    ParentType,
    ContextType
  >;
  count?: Resolver<
    Maybe<ResolversTypes['_AccessAggregateFieldCountResult']>,
    ParentType,
    ContextType
  >;
  group?: Resolver<
    Maybe<ResolversTypes['JSONObject']>,
    ParentType,
    ContextType
  >;
  histogram?: Resolver<
    Maybe<ResolversTypes['_AccessAggregateHistogramFieldResult']>,
    ParentType,
    ContextType,
    RequireFields<_AccessAggregateResultHistogramArgs, 'interval'>
  >;
  max?: Resolver<
    Maybe<ResolversTypes['_AccessAggregateFieldResult']>,
    ParentType,
    ContextType
  >;
  min?: Resolver<
    Maybe<ResolversTypes['_AccessAggregateFieldResult']>,
    ParentType,
    ContextType
  >;
  sum?: Resolver<
    Maybe<ResolversTypes['_AccessAggregateFieldResult']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _AccessAvgAggregateFieldResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['_AccessAvgAggregateFieldResult'] =
    ResolversParentTypes['_AccessAvgAggregateFieldResult'],
> = {
  _empty?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _AccessConnectionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['_AccessConnection'] =
    ResolversParentTypes['_AccessConnection'],
> = {
  edges?: Resolver<
    Array<Maybe<ResolversTypes['_AccessEdge']>>,
    ParentType,
    ContextType
  >;
  items?: Resolver<
    Array<Maybe<ResolversTypes['Access']>>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _AccessEdgeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['_AccessEdge'] =
    ResolversParentTypes['_AccessEdge'],
> = {
  _type?: Resolver<
    Maybe<ResolversTypes['_InstanceType']>,
    ParentType,
    ContextType
  >;
  cursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  externalId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Access'], ParentType, ContextType>;
  space?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _AggregateHistogramObjectTypeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['_AggregateHistogramObjectType'] =
    ResolversParentTypes['_AggregateHistogramObjectType'],
> = {
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  start?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _ConsistencyCollectionAggregateConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['_ConsistencyCollectionAggregateConnection'] =
    ResolversParentTypes['_ConsistencyCollectionAggregateConnection'],
> = {
  edges?: Resolver<
    Array<Maybe<ResolversTypes['_ConsistencyCollectionAggregateEdge']>>,
    ParentType,
    ContextType
  >;
  items?: Resolver<
    Array<Maybe<ResolversTypes['_ConsistencyCollectionAggregateResult']>>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _ConsistencyCollectionAggregateEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['_ConsistencyCollectionAggregateEdge'] =
    ResolversParentTypes['_ConsistencyCollectionAggregateEdge'],
> = {
  _type?: Resolver<
    Maybe<ResolversTypes['_InstanceType']>,
    ParentType,
    ContextType
  >;
  cursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  externalId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  node?: Resolver<
    ResolversTypes['_ConsistencyCollectionAggregateResult'],
    ParentType,
    ContextType
  >;
  space?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _ConsistencyCollectionAggregateFieldCountResultResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['_ConsistencyCollectionAggregateFieldCountResult'] =
    ResolversParentTypes['_ConsistencyCollectionAggregateFieldCountResult'],
> = {
  createdAt?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  externalId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  labels?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  project?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  projectId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  reportTemplate?: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >;
  tenant?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _ConsistencyCollectionAggregateFieldResultResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['_ConsistencyCollectionAggregateFieldResult'] =
    ResolversParentTypes['_ConsistencyCollectionAggregateFieldResult'],
> = {
  _empty?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _ConsistencyCollectionAggregateHistogramFieldResultResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['_ConsistencyCollectionAggregateHistogramFieldResult'] =
    ResolversParentTypes['_ConsistencyCollectionAggregateHistogramFieldResult'],
> = {
  _empty?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['_AggregateHistogramObjectType']>>>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _ConsistencyCollectionAggregateResultResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['_ConsistencyCollectionAggregateResult'] =
    ResolversParentTypes['_ConsistencyCollectionAggregateResult'],
> = {
  avg?: Resolver<
    Maybe<ResolversTypes['_ConsistencyCollectionAvgAggregateFieldResult']>,
    ParentType,
    ContextType
  >;
  count?: Resolver<
    Maybe<ResolversTypes['_ConsistencyCollectionAggregateFieldCountResult']>,
    ParentType,
    ContextType
  >;
  group?: Resolver<
    Maybe<ResolversTypes['JSONObject']>,
    ParentType,
    ContextType
  >;
  histogram?: Resolver<
    Maybe<
      ResolversTypes['_ConsistencyCollectionAggregateHistogramFieldResult']
    >,
    ParentType,
    ContextType,
    RequireFields<
      _ConsistencyCollectionAggregateResultHistogramArgs,
      'interval'
    >
  >;
  max?: Resolver<
    Maybe<ResolversTypes['_ConsistencyCollectionAggregateFieldResult']>,
    ParentType,
    ContextType
  >;
  min?: Resolver<
    Maybe<ResolversTypes['_ConsistencyCollectionAggregateFieldResult']>,
    ParentType,
    ContextType
  >;
  sum?: Resolver<
    Maybe<ResolversTypes['_ConsistencyCollectionAggregateFieldResult']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _ConsistencyCollectionAvgAggregateFieldResultResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['_ConsistencyCollectionAvgAggregateFieldResult'] =
    ResolversParentTypes['_ConsistencyCollectionAvgAggregateFieldResult'],
> = {
  _empty?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _ConsistencyCollectionConnectionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['_ConsistencyCollectionConnection'] =
    ResolversParentTypes['_ConsistencyCollectionConnection'],
> = {
  edges?: Resolver<
    Array<Maybe<ResolversTypes['_ConsistencyCollectionEdge']>>,
    ParentType,
    ContextType
  >;
  items?: Resolver<
    Array<Maybe<ResolversTypes['ConsistencyCollection']>>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _ConsistencyCollectionEdgeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['_ConsistencyCollectionEdge'] =
    ResolversParentTypes['_ConsistencyCollectionEdge'],
> = {
  _type?: Resolver<
    Maybe<ResolversTypes['_InstanceType']>,
    ParentType,
    ContextType
  >;
  cursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  externalId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  node?: Resolver<
    ResolversTypes['ConsistencyCollection'],
    ParentType,
    ContextType
  >;
  space?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _ConsistencyConditionCheckAggregateConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['_ConsistencyConditionCheckAggregateConnection'] =
    ResolversParentTypes['_ConsistencyConditionCheckAggregateConnection'],
> = {
  edges?: Resolver<
    Array<Maybe<ResolversTypes['_ConsistencyConditionCheckAggregateEdge']>>,
    ParentType,
    ContextType
  >;
  items?: Resolver<
    Array<Maybe<ResolversTypes['_ConsistencyConditionCheckAggregateResult']>>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _ConsistencyConditionCheckAggregateEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['_ConsistencyConditionCheckAggregateEdge'] =
    ResolversParentTypes['_ConsistencyConditionCheckAggregateEdge'],
> = {
  _type?: Resolver<
    Maybe<ResolversTypes['_InstanceType']>,
    ParentType,
    ContextType
  >;
  cursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  externalId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  node?: Resolver<
    ResolversTypes['_ConsistencyConditionCheckAggregateResult'],
    ParentType,
    ContextType
  >;
  space?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _ConsistencyConditionCheckAggregateFieldCountResultResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['_ConsistencyConditionCheckAggregateFieldCountResult'] =
    ResolversParentTypes['_ConsistencyConditionCheckAggregateFieldCountResult'],
> = {
  externalId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  isLiteralValue?: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >;
  operator?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rule?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sourceAttribute?: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >;
  targetAttribute?: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >;
  useTargetSchema?: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _ConsistencyConditionCheckAggregateFieldResultResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['_ConsistencyConditionCheckAggregateFieldResult'] =
    ResolversParentTypes['_ConsistencyConditionCheckAggregateFieldResult'],
> = {
  _empty?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _ConsistencyConditionCheckAggregateHistogramFieldResultResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['_ConsistencyConditionCheckAggregateHistogramFieldResult'] =
    ResolversParentTypes['_ConsistencyConditionCheckAggregateHistogramFieldResult'],
> = {
  _empty?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['_AggregateHistogramObjectType']>>>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _ConsistencyConditionCheckAggregateResultResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['_ConsistencyConditionCheckAggregateResult'] =
    ResolversParentTypes['_ConsistencyConditionCheckAggregateResult'],
> = {
  avg?: Resolver<
    Maybe<ResolversTypes['_ConsistencyConditionCheckAvgAggregateFieldResult']>,
    ParentType,
    ContextType
  >;
  count?: Resolver<
    Maybe<
      ResolversTypes['_ConsistencyConditionCheckAggregateFieldCountResult']
    >,
    ParentType,
    ContextType
  >;
  group?: Resolver<
    Maybe<ResolversTypes['JSONObject']>,
    ParentType,
    ContextType
  >;
  histogram?: Resolver<
    Maybe<
      ResolversTypes['_ConsistencyConditionCheckAggregateHistogramFieldResult']
    >,
    ParentType,
    ContextType,
    RequireFields<
      _ConsistencyConditionCheckAggregateResultHistogramArgs,
      'interval'
    >
  >;
  max?: Resolver<
    Maybe<ResolversTypes['_ConsistencyConditionCheckAggregateFieldResult']>,
    ParentType,
    ContextType
  >;
  min?: Resolver<
    Maybe<ResolversTypes['_ConsistencyConditionCheckAggregateFieldResult']>,
    ParentType,
    ContextType
  >;
  sum?: Resolver<
    Maybe<ResolversTypes['_ConsistencyConditionCheckAggregateFieldResult']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _ConsistencyConditionCheckAvgAggregateFieldResultResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['_ConsistencyConditionCheckAvgAggregateFieldResult'] =
    ResolversParentTypes['_ConsistencyConditionCheckAvgAggregateFieldResult'],
> = {
  _empty?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _ConsistencyConditionCheckConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['_ConsistencyConditionCheckConnection'] =
    ResolversParentTypes['_ConsistencyConditionCheckConnection'],
> = {
  edges?: Resolver<
    Array<Maybe<ResolversTypes['_ConsistencyConditionCheckEdge']>>,
    ParentType,
    ContextType
  >;
  items?: Resolver<
    Array<Maybe<ResolversTypes['ConsistencyConditionCheck']>>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _ConsistencyConditionCheckEdgeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['_ConsistencyConditionCheckEdge'] =
    ResolversParentTypes['_ConsistencyConditionCheckEdge'],
> = {
  _type?: Resolver<
    Maybe<ResolversTypes['_InstanceType']>,
    ParentType,
    ContextType
  >;
  cursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  externalId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  node?: Resolver<
    ResolversTypes['ConsistencyConditionCheck'],
    ParentType,
    ContextType
  >;
  space?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _ConsistencyRuleAggregateConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['_ConsistencyRuleAggregateConnection'] =
    ResolversParentTypes['_ConsistencyRuleAggregateConnection'],
> = {
  edges?: Resolver<
    Array<Maybe<ResolversTypes['_ConsistencyRuleAggregateEdge']>>,
    ParentType,
    ContextType
  >;
  items?: Resolver<
    Array<Maybe<ResolversTypes['_ConsistencyRuleAggregateResult']>>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _ConsistencyRuleAggregateEdgeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['_ConsistencyRuleAggregateEdge'] =
    ResolversParentTypes['_ConsistencyRuleAggregateEdge'],
> = {
  _type?: Resolver<
    Maybe<ResolversTypes['_InstanceType']>,
    ParentType,
    ContextType
  >;
  cursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  externalId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  node?: Resolver<
    ResolversTypes['_ConsistencyRuleAggregateResult'],
    ParentType,
    ContextType
  >;
  space?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _ConsistencyRuleAggregateFieldCountResultResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['_ConsistencyRuleAggregateFieldCountResult'] =
    ResolversParentTypes['_ConsistencyRuleAggregateFieldCountResult'],
> = {
  collection?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  conditionChecksOnly?: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >;
  customerDefinedId?: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >;
  description?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  errorMessage?: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >;
  externalId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  operator?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  projectId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  severity?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sourceAttribute?: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >;
  sourceFilters?: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >;
  sourceSchemaFilter?: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >;
  tags?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  targetAttribute?: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >;
  targetFilters?: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >;
  targetSchemaFilter?: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _ConsistencyRuleAggregateFieldResultResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['_ConsistencyRuleAggregateFieldResult'] =
    ResolversParentTypes['_ConsistencyRuleAggregateFieldResult'],
> = {
  _empty?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _ConsistencyRuleAggregateHistogramFieldResultResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['_ConsistencyRuleAggregateHistogramFieldResult'] =
    ResolversParentTypes['_ConsistencyRuleAggregateHistogramFieldResult'],
> = {
  _empty?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['_AggregateHistogramObjectType']>>>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _ConsistencyRuleAggregateResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['_ConsistencyRuleAggregateResult'] =
    ResolversParentTypes['_ConsistencyRuleAggregateResult'],
> = {
  avg?: Resolver<
    Maybe<ResolversTypes['_ConsistencyRuleAvgAggregateFieldResult']>,
    ParentType,
    ContextType
  >;
  count?: Resolver<
    Maybe<ResolversTypes['_ConsistencyRuleAggregateFieldCountResult']>,
    ParentType,
    ContextType
  >;
  group?: Resolver<
    Maybe<ResolversTypes['JSONObject']>,
    ParentType,
    ContextType
  >;
  histogram?: Resolver<
    Maybe<ResolversTypes['_ConsistencyRuleAggregateHistogramFieldResult']>,
    ParentType,
    ContextType,
    RequireFields<_ConsistencyRuleAggregateResultHistogramArgs, 'interval'>
  >;
  max?: Resolver<
    Maybe<ResolversTypes['_ConsistencyRuleAggregateFieldResult']>,
    ParentType,
    ContextType
  >;
  min?: Resolver<
    Maybe<ResolversTypes['_ConsistencyRuleAggregateFieldResult']>,
    ParentType,
    ContextType
  >;
  sum?: Resolver<
    Maybe<ResolversTypes['_ConsistencyRuleAggregateFieldResult']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _ConsistencyRuleAvgAggregateFieldResultResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['_ConsistencyRuleAvgAggregateFieldResult'] =
    ResolversParentTypes['_ConsistencyRuleAvgAggregateFieldResult'],
> = {
  _empty?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _ConsistencyRuleConnectionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['_ConsistencyRuleConnection'] =
    ResolversParentTypes['_ConsistencyRuleConnection'],
> = {
  edges?: Resolver<
    Array<Maybe<ResolversTypes['_ConsistencyRuleEdge']>>,
    ParentType,
    ContextType
  >;
  items?: Resolver<
    Array<Maybe<ResolversTypes['ConsistencyRule']>>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _ConsistencyRuleEdgeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['_ConsistencyRuleEdge'] =
    ResolversParentTypes['_ConsistencyRuleEdge'],
> = {
  _type?: Resolver<
    Maybe<ResolversTypes['_InstanceType']>,
    ParentType,
    ContextType
  >;
  cursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  externalId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['ConsistencyRule'], ParentType, ContextType>;
  space?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _ConsistencyRunStatusAggregateConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['_ConsistencyRunStatusAggregateConnection'] =
    ResolversParentTypes['_ConsistencyRunStatusAggregateConnection'],
> = {
  edges?: Resolver<
    Array<Maybe<ResolversTypes['_ConsistencyRunStatusAggregateEdge']>>,
    ParentType,
    ContextType
  >;
  items?: Resolver<
    Array<Maybe<ResolversTypes['_ConsistencyRunStatusAggregateResult']>>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _ConsistencyRunStatusAggregateEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['_ConsistencyRunStatusAggregateEdge'] =
    ResolversParentTypes['_ConsistencyRunStatusAggregateEdge'],
> = {
  _type?: Resolver<
    Maybe<ResolversTypes['_InstanceType']>,
    ParentType,
    ContextType
  >;
  cursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  externalId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  node?: Resolver<
    ResolversTypes['_ConsistencyRunStatusAggregateResult'],
    ParentType,
    ContextType
  >;
  space?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _ConsistencyRunStatusAggregateFieldCountResultResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['_ConsistencyRunStatusAggregateFieldCountResult'] =
    ResolversParentTypes['_ConsistencyRunStatusAggregateFieldCountResult'],
> = {
  attributes?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  externalId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  failedInstances?: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >;
  message?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  reportId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rule?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  runAt?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalFailed?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalValid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _ConsistencyRunStatusAggregateFieldResultResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['_ConsistencyRunStatusAggregateFieldResult'] =
    ResolversParentTypes['_ConsistencyRunStatusAggregateFieldResult'],
> = {
  totalFailed?: Resolver<
    Maybe<ResolversTypes['Int32']>,
    ParentType,
    ContextType
  >;
  totalValid?: Resolver<
    Maybe<ResolversTypes['Int32']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _ConsistencyRunStatusAggregateHistogramFieldResultResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['_ConsistencyRunStatusAggregateHistogramFieldResult'] =
    ResolversParentTypes['_ConsistencyRunStatusAggregateHistogramFieldResult'],
> = {
  totalFailed?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['_AggregateHistogramObjectType']>>>,
    ParentType,
    ContextType
  >;
  totalValid?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['_AggregateHistogramObjectType']>>>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _ConsistencyRunStatusAggregateResultResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['_ConsistencyRunStatusAggregateResult'] =
    ResolversParentTypes['_ConsistencyRunStatusAggregateResult'],
> = {
  avg?: Resolver<
    Maybe<ResolversTypes['_ConsistencyRunStatusAvgAggregateFieldResult']>,
    ParentType,
    ContextType
  >;
  count?: Resolver<
    Maybe<ResolversTypes['_ConsistencyRunStatusAggregateFieldCountResult']>,
    ParentType,
    ContextType
  >;
  group?: Resolver<
    Maybe<ResolversTypes['JSONObject']>,
    ParentType,
    ContextType
  >;
  histogram?: Resolver<
    Maybe<ResolversTypes['_ConsistencyRunStatusAggregateHistogramFieldResult']>,
    ParentType,
    ContextType,
    RequireFields<_ConsistencyRunStatusAggregateResultHistogramArgs, 'interval'>
  >;
  max?: Resolver<
    Maybe<ResolversTypes['_ConsistencyRunStatusAggregateFieldResult']>,
    ParentType,
    ContextType
  >;
  min?: Resolver<
    Maybe<ResolversTypes['_ConsistencyRunStatusAggregateFieldResult']>,
    ParentType,
    ContextType
  >;
  sum?: Resolver<
    Maybe<ResolversTypes['_ConsistencyRunStatusAggregateFieldResult']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _ConsistencyRunStatusAvgAggregateFieldResultResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['_ConsistencyRunStatusAvgAggregateFieldResult'] =
    ResolversParentTypes['_ConsistencyRunStatusAvgAggregateFieldResult'],
> = {
  totalFailed?: Resolver<
    Maybe<ResolversTypes['Float']>,
    ParentType,
    ContextType
  >;
  totalValid?: Resolver<
    Maybe<ResolversTypes['Float']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _ConsistencyRunStatusConnectionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['_ConsistencyRunStatusConnection'] =
    ResolversParentTypes['_ConsistencyRunStatusConnection'],
> = {
  edges?: Resolver<
    Array<Maybe<ResolversTypes['_ConsistencyRunStatusEdge']>>,
    ParentType,
    ContextType
  >;
  items?: Resolver<
    Array<Maybe<ResolversTypes['ConsistencyRunStatus']>>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _ConsistencyRunStatusEdgeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['_ConsistencyRunStatusEdge'] =
    ResolversParentTypes['_ConsistencyRunStatusEdge'],
> = {
  _type?: Resolver<
    Maybe<ResolversTypes['_InstanceType']>,
    ParentType,
    ContextType
  >;
  cursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  externalId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  node?: Resolver<
    ResolversTypes['ConsistencyRunStatus'],
    ParentType,
    ContextType
  >;
  space?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _ConsistencySchemaFilterAggregateConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['_ConsistencySchemaFilterAggregateConnection'] =
    ResolversParentTypes['_ConsistencySchemaFilterAggregateConnection'],
> = {
  edges?: Resolver<
    Array<Maybe<ResolversTypes['_ConsistencySchemaFilterAggregateEdge']>>,
    ParentType,
    ContextType
  >;
  items?: Resolver<
    Array<Maybe<ResolversTypes['_ConsistencySchemaFilterAggregateResult']>>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _ConsistencySchemaFilterAggregateEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['_ConsistencySchemaFilterAggregateEdge'] =
    ResolversParentTypes['_ConsistencySchemaFilterAggregateEdge'],
> = {
  _type?: Resolver<
    Maybe<ResolversTypes['_InstanceType']>,
    ParentType,
    ContextType
  >;
  cursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  externalId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  node?: Resolver<
    ResolversTypes['_ConsistencySchemaFilterAggregateResult'],
    ParentType,
    ContextType
  >;
  space?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _ConsistencySchemaFilterAggregateFieldCountResultResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['_ConsistencySchemaFilterAggregateFieldCountResult'] =
    ResolversParentTypes['_ConsistencySchemaFilterAggregateFieldCountResult'],
> = {
  collection?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  externalId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  filters?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  labels?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  projectId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  schemaCollectionId?: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >;
  schemaType?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _ConsistencySchemaFilterAggregateFieldResultResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['_ConsistencySchemaFilterAggregateFieldResult'] =
    ResolversParentTypes['_ConsistencySchemaFilterAggregateFieldResult'],
> = {
  _empty?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _ConsistencySchemaFilterAggregateHistogramFieldResultResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['_ConsistencySchemaFilterAggregateHistogramFieldResult'] =
    ResolversParentTypes['_ConsistencySchemaFilterAggregateHistogramFieldResult'],
> = {
  _empty?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['_AggregateHistogramObjectType']>>>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _ConsistencySchemaFilterAggregateResultResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['_ConsistencySchemaFilterAggregateResult'] =
    ResolversParentTypes['_ConsistencySchemaFilterAggregateResult'],
> = {
  avg?: Resolver<
    Maybe<ResolversTypes['_ConsistencySchemaFilterAvgAggregateFieldResult']>,
    ParentType,
    ContextType
  >;
  count?: Resolver<
    Maybe<ResolversTypes['_ConsistencySchemaFilterAggregateFieldCountResult']>,
    ParentType,
    ContextType
  >;
  group?: Resolver<
    Maybe<ResolversTypes['JSONObject']>,
    ParentType,
    ContextType
  >;
  histogram?: Resolver<
    Maybe<
      ResolversTypes['_ConsistencySchemaFilterAggregateHistogramFieldResult']
    >,
    ParentType,
    ContextType,
    RequireFields<
      _ConsistencySchemaFilterAggregateResultHistogramArgs,
      'interval'
    >
  >;
  max?: Resolver<
    Maybe<ResolversTypes['_ConsistencySchemaFilterAggregateFieldResult']>,
    ParentType,
    ContextType
  >;
  min?: Resolver<
    Maybe<ResolversTypes['_ConsistencySchemaFilterAggregateFieldResult']>,
    ParentType,
    ContextType
  >;
  sum?: Resolver<
    Maybe<ResolversTypes['_ConsistencySchemaFilterAggregateFieldResult']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _ConsistencySchemaFilterAvgAggregateFieldResultResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['_ConsistencySchemaFilterAvgAggregateFieldResult'] =
    ResolversParentTypes['_ConsistencySchemaFilterAvgAggregateFieldResult'],
> = {
  _empty?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _ConsistencySchemaFilterConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['_ConsistencySchemaFilterConnection'] =
    ResolversParentTypes['_ConsistencySchemaFilterConnection'],
> = {
  edges?: Resolver<
    Array<Maybe<ResolversTypes['_ConsistencySchemaFilterEdge']>>,
    ParentType,
    ContextType
  >;
  items?: Resolver<
    Array<Maybe<ResolversTypes['ConsistencySchemaFilter']>>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _ConsistencySchemaFilterEdgeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['_ConsistencySchemaFilterEdge'] =
    ResolversParentTypes['_ConsistencySchemaFilterEdge'],
> = {
  _type?: Resolver<
    Maybe<ResolversTypes['_InstanceType']>,
    ParentType,
    ContextType
  >;
  cursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  externalId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  node?: Resolver<
    ResolversTypes['ConsistencySchemaFilter'],
    ParentType,
    ContextType
  >;
  space?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _DataPointConnectionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['_DataPointConnection'] =
    ResolversParentTypes['_DataPointConnection'],
> = {
  edges?: Resolver<
    Array<Maybe<ResolversTypes['_DataPointEdge']>>,
    ParentType,
    ContextType
  >;
  items?: Resolver<
    Array<Maybe<ResolversTypes['DataPoint']>>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  unitExternalId?: Resolver<
    Maybe<ResolversTypes['ID']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _DataPointEdgeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['_DataPointEdge'] =
    ResolversParentTypes['_DataPointEdge'],
> = {
  _type?: Resolver<
    Maybe<ResolversTypes['_InstanceType']>,
    ParentType,
    ContextType
  >;
  cursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  externalId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['DataPoint'], ParentType, ContextType>;
  space?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _DeleteResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['_DeleteResponse'] =
    ResolversParentTypes['_DeleteResponse'],
> = {
  externalId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  space?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _DigitalTwinAggregateConnectionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['_DigitalTwinAggregateConnection'] =
    ResolversParentTypes['_DigitalTwinAggregateConnection'],
> = {
  edges?: Resolver<
    Array<Maybe<ResolversTypes['_DigitalTwinAggregateEdge']>>,
    ParentType,
    ContextType
  >;
  items?: Resolver<
    Array<Maybe<ResolversTypes['_DigitalTwinAggregateResult']>>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _DigitalTwinAggregateEdgeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['_DigitalTwinAggregateEdge'] =
    ResolversParentTypes['_DigitalTwinAggregateEdge'],
> = {
  _type?: Resolver<
    Maybe<ResolversTypes['_InstanceType']>,
    ParentType,
    ContextType
  >;
  cursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  externalId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  node?: Resolver<
    ResolversTypes['_DigitalTwinAggregateResult'],
    ParentType,
    ContextType
  >;
  space?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _DigitalTwinAggregateFieldCountResultResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['_DigitalTwinAggregateFieldCountResult'] =
    ResolversParentTypes['_DigitalTwinAggregateFieldCountResult'],
> = {
  externalId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  tenant?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _DigitalTwinAggregateFieldResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['_DigitalTwinAggregateFieldResult'] =
    ResolversParentTypes['_DigitalTwinAggregateFieldResult'],
> = {
  _empty?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _DigitalTwinAggregateHistogramFieldResultResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['_DigitalTwinAggregateHistogramFieldResult'] =
    ResolversParentTypes['_DigitalTwinAggregateHistogramFieldResult'],
> = {
  _empty?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['_AggregateHistogramObjectType']>>>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _DigitalTwinAggregateResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['_DigitalTwinAggregateResult'] =
    ResolversParentTypes['_DigitalTwinAggregateResult'],
> = {
  avg?: Resolver<
    Maybe<ResolversTypes['_DigitalTwinAvgAggregateFieldResult']>,
    ParentType,
    ContextType
  >;
  count?: Resolver<
    Maybe<ResolversTypes['_DigitalTwinAggregateFieldCountResult']>,
    ParentType,
    ContextType
  >;
  group?: Resolver<
    Maybe<ResolversTypes['JSONObject']>,
    ParentType,
    ContextType
  >;
  histogram?: Resolver<
    Maybe<ResolversTypes['_DigitalTwinAggregateHistogramFieldResult']>,
    ParentType,
    ContextType,
    RequireFields<_DigitalTwinAggregateResultHistogramArgs, 'interval'>
  >;
  max?: Resolver<
    Maybe<ResolversTypes['_DigitalTwinAggregateFieldResult']>,
    ParentType,
    ContextType
  >;
  min?: Resolver<
    Maybe<ResolversTypes['_DigitalTwinAggregateFieldResult']>,
    ParentType,
    ContextType
  >;
  sum?: Resolver<
    Maybe<ResolversTypes['_DigitalTwinAggregateFieldResult']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _DigitalTwinAvgAggregateFieldResultResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['_DigitalTwinAvgAggregateFieldResult'] =
    ResolversParentTypes['_DigitalTwinAvgAggregateFieldResult'],
> = {
  _empty?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _DigitalTwinConnectionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['_DigitalTwinConnection'] =
    ResolversParentTypes['_DigitalTwinConnection'],
> = {
  edges?: Resolver<
    Array<Maybe<ResolversTypes['_DigitalTwinEdge']>>,
    ParentType,
    ContextType
  >;
  items?: Resolver<
    Array<Maybe<ResolversTypes['DigitalTwin']>>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _DigitalTwinEdgeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['_DigitalTwinEdge'] =
    ResolversParentTypes['_DigitalTwinEdge'],
> = {
  _type?: Resolver<
    Maybe<ResolversTypes['_InstanceType']>,
    ParentType,
    ContextType
  >;
  cursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  externalId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['DigitalTwin'], ParentType, ContextType>;
  space?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _DownloadLinkResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['_DownloadLink'] =
    ResolversParentTypes['_DownloadLink'],
> = {
  downloadUrl?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _GeoLocationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['_GeoLocation'] =
    ResolversParentTypes['_GeoLocation'],
> = {
  geometry?: Resolver<
    Maybe<ResolversTypes['_GeoLocationGeometry']>,
    ParentType,
    ContextType
  >;
  properties?: Resolver<
    Maybe<ResolversTypes['JSONObject']>,
    ParentType,
    ContextType
  >;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _GeoLocationGeometryResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['_GeoLocationGeometry'] =
    ResolversParentTypes['_GeoLocationGeometry'],
> = {
  coordinates?: Resolver<
    Maybe<ResolversTypes['JSONObject']>,
    ParentType,
    ContextType
  >;
  type?: Resolver<
    Maybe<ResolversTypes['_GeoLocationType']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _InstanceTypeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['_InstanceType'] =
    ResolversParentTypes['_InstanceType'],
> = {
  externalId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  space?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _MilestoneAggregateConnectionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['_MilestoneAggregateConnection'] =
    ResolversParentTypes['_MilestoneAggregateConnection'],
> = {
  edges?: Resolver<
    Array<Maybe<ResolversTypes['_MilestoneAggregateEdge']>>,
    ParentType,
    ContextType
  >;
  items?: Resolver<
    Array<Maybe<ResolversTypes['_MilestoneAggregateResult']>>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _MilestoneAggregateEdgeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['_MilestoneAggregateEdge'] =
    ResolversParentTypes['_MilestoneAggregateEdge'],
> = {
  _type?: Resolver<
    Maybe<ResolversTypes['_InstanceType']>,
    ParentType,
    ContextType
  >;
  cursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  externalId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  node?: Resolver<
    ResolversTypes['_MilestoneAggregateResult'],
    ParentType,
    ContextType
  >;
  space?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _MilestoneAggregateFieldCountResultResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['_MilestoneAggregateFieldCountResult'] =
    ResolversParentTypes['_MilestoneAggregateFieldCountResult'],
> = {
  description?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  endActiveTime?: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >;
  endScheduleTime?: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >;
  externalId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  milestoneType?: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >;
  name?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  orderIndex?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  projectId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  reportTemplate?: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >;
  schedule?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  schemaCollection?: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >;
  startActiveTime?: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >;
  startScheduleTime?: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _MilestoneAggregateFieldResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['_MilestoneAggregateFieldResult'] =
    ResolversParentTypes['_MilestoneAggregateFieldResult'],
> = {
  orderIndex?: Resolver<
    Maybe<ResolversTypes['Int32']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _MilestoneAggregateHistogramFieldResultResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['_MilestoneAggregateHistogramFieldResult'] =
    ResolversParentTypes['_MilestoneAggregateHistogramFieldResult'],
> = {
  orderIndex?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['_AggregateHistogramObjectType']>>>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _MilestoneAggregateResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['_MilestoneAggregateResult'] =
    ResolversParentTypes['_MilestoneAggregateResult'],
> = {
  avg?: Resolver<
    Maybe<ResolversTypes['_MilestoneAvgAggregateFieldResult']>,
    ParentType,
    ContextType
  >;
  count?: Resolver<
    Maybe<ResolversTypes['_MilestoneAggregateFieldCountResult']>,
    ParentType,
    ContextType
  >;
  group?: Resolver<
    Maybe<ResolversTypes['JSONObject']>,
    ParentType,
    ContextType
  >;
  histogram?: Resolver<
    Maybe<ResolversTypes['_MilestoneAggregateHistogramFieldResult']>,
    ParentType,
    ContextType,
    RequireFields<_MilestoneAggregateResultHistogramArgs, 'interval'>
  >;
  max?: Resolver<
    Maybe<ResolversTypes['_MilestoneAggregateFieldResult']>,
    ParentType,
    ContextType
  >;
  min?: Resolver<
    Maybe<ResolversTypes['_MilestoneAggregateFieldResult']>,
    ParentType,
    ContextType
  >;
  sum?: Resolver<
    Maybe<ResolversTypes['_MilestoneAggregateFieldResult']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _MilestoneAvgAggregateFieldResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['_MilestoneAvgAggregateFieldResult'] =
    ResolversParentTypes['_MilestoneAvgAggregateFieldResult'],
> = {
  orderIndex?: Resolver<
    Maybe<ResolversTypes['Float']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _MilestoneConnectionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['_MilestoneConnection'] =
    ResolversParentTypes['_MilestoneConnection'],
> = {
  edges?: Resolver<
    Array<Maybe<ResolversTypes['_MilestoneEdge']>>,
    ParentType,
    ContextType
  >;
  items?: Resolver<
    Array<Maybe<ResolversTypes['Milestone']>>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _MilestoneEdgeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['_MilestoneEdge'] =
    ResolversParentTypes['_MilestoneEdge'],
> = {
  _type?: Resolver<
    Maybe<ResolversTypes['_InstanceType']>,
    ParentType,
    ContextType
  >;
  cursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  externalId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Milestone'], ParentType, ContextType>;
  space?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _RuleAggregateConnectionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['_RuleAggregateConnection'] =
    ResolversParentTypes['_RuleAggregateConnection'],
> = {
  edges?: Resolver<
    Array<Maybe<ResolversTypes['_RuleAggregateEdge']>>,
    ParentType,
    ContextType
  >;
  items?: Resolver<
    Array<Maybe<ResolversTypes['_RuleAggregateResult']>>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _RuleAggregateEdgeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['_RuleAggregateEdge'] =
    ResolversParentTypes['_RuleAggregateEdge'],
> = {
  _type?: Resolver<
    Maybe<ResolversTypes['_InstanceType']>,
    ParentType,
    ContextType
  >;
  cursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  externalId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  node?: Resolver<
    ResolversTypes['_RuleAggregateResult'],
    ParentType,
    ContextType
  >;
  space?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _RuleAggregateFieldCountResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['_RuleAggregateFieldCountResult'] =
    ResolversParentTypes['_RuleAggregateFieldCountResult'],
> = {
  advanceRules?: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >;
  customerDefinedId?: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >;
  description?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  errorMessage?: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >;
  externalId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  filters?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  invertedRules?: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >;
  name?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  primaryKeyName?: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >;
  projectId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rules?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  schemaCollection?: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >;
  schemaType?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  severity?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  simpleInvertedRules?: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >;
  simpleRules?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  tags?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _RuleAggregateFieldResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['_RuleAggregateFieldResult'] =
    ResolversParentTypes['_RuleAggregateFieldResult'],
> = {
  _empty?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _RuleAggregateHistogramFieldResultResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['_RuleAggregateHistogramFieldResult'] =
    ResolversParentTypes['_RuleAggregateHistogramFieldResult'],
> = {
  _empty?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['_AggregateHistogramObjectType']>>>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _RuleAggregateResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['_RuleAggregateResult'] =
    ResolversParentTypes['_RuleAggregateResult'],
> = {
  avg?: Resolver<
    Maybe<ResolversTypes['_RuleAvgAggregateFieldResult']>,
    ParentType,
    ContextType
  >;
  count?: Resolver<
    Maybe<ResolversTypes['_RuleAggregateFieldCountResult']>,
    ParentType,
    ContextType
  >;
  group?: Resolver<
    Maybe<ResolversTypes['JSONObject']>,
    ParentType,
    ContextType
  >;
  histogram?: Resolver<
    Maybe<ResolversTypes['_RuleAggregateHistogramFieldResult']>,
    ParentType,
    ContextType,
    RequireFields<_RuleAggregateResultHistogramArgs, 'interval'>
  >;
  max?: Resolver<
    Maybe<ResolversTypes['_RuleAggregateFieldResult']>,
    ParentType,
    ContextType
  >;
  min?: Resolver<
    Maybe<ResolversTypes['_RuleAggregateFieldResult']>,
    ParentType,
    ContextType
  >;
  sum?: Resolver<
    Maybe<ResolversTypes['_RuleAggregateFieldResult']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _RuleAvgAggregateFieldResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['_RuleAvgAggregateFieldResult'] =
    ResolversParentTypes['_RuleAvgAggregateFieldResult'],
> = {
  _empty?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _RuleConnectionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['_RuleConnection'] =
    ResolversParentTypes['_RuleConnection'],
> = {
  edges?: Resolver<
    Array<Maybe<ResolversTypes['_RuleEdge']>>,
    ParentType,
    ContextType
  >;
  items?: Resolver<
    Array<Maybe<ResolversTypes['Rule']>>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _RuleEdgeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['_RuleEdge'] =
    ResolversParentTypes['_RuleEdge'],
> = {
  _type?: Resolver<
    Maybe<ResolversTypes['_InstanceType']>,
    ParentType,
    ContextType
  >;
  cursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  externalId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Rule'], ParentType, ContextType>;
  space?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _RuleRunStatusAggregateConnectionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['_RuleRunStatusAggregateConnection'] =
    ResolversParentTypes['_RuleRunStatusAggregateConnection'],
> = {
  edges?: Resolver<
    Array<Maybe<ResolversTypes['_RuleRunStatusAggregateEdge']>>,
    ParentType,
    ContextType
  >;
  items?: Resolver<
    Array<Maybe<ResolversTypes['_RuleRunStatusAggregateResult']>>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _RuleRunStatusAggregateEdgeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['_RuleRunStatusAggregateEdge'] =
    ResolversParentTypes['_RuleRunStatusAggregateEdge'],
> = {
  _type?: Resolver<
    Maybe<ResolversTypes['_InstanceType']>,
    ParentType,
    ContextType
  >;
  cursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  externalId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  node?: Resolver<
    ResolversTypes['_RuleRunStatusAggregateResult'],
    ParentType,
    ContextType
  >;
  space?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _RuleRunStatusAggregateFieldCountResultResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['_RuleRunStatusAggregateFieldCountResult'] =
    ResolversParentTypes['_RuleRunStatusAggregateFieldCountResult'],
> = {
  attributes?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  externalId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  failedInstances?: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >;
  filteredInstances?: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >;
  isFilterResult?: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >;
  message?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  reportId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rule?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  runAt?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalFailed?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalValid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _RuleRunStatusAggregateFieldResultResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['_RuleRunStatusAggregateFieldResult'] =
    ResolversParentTypes['_RuleRunStatusAggregateFieldResult'],
> = {
  totalFailed?: Resolver<
    Maybe<ResolversTypes['Int32']>,
    ParentType,
    ContextType
  >;
  totalValid?: Resolver<
    Maybe<ResolversTypes['Int32']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _RuleRunStatusAggregateHistogramFieldResultResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['_RuleRunStatusAggregateHistogramFieldResult'] =
    ResolversParentTypes['_RuleRunStatusAggregateHistogramFieldResult'],
> = {
  totalFailed?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['_AggregateHistogramObjectType']>>>,
    ParentType,
    ContextType
  >;
  totalValid?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['_AggregateHistogramObjectType']>>>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _RuleRunStatusAggregateResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['_RuleRunStatusAggregateResult'] =
    ResolversParentTypes['_RuleRunStatusAggregateResult'],
> = {
  avg?: Resolver<
    Maybe<ResolversTypes['_RuleRunStatusAvgAggregateFieldResult']>,
    ParentType,
    ContextType
  >;
  count?: Resolver<
    Maybe<ResolversTypes['_RuleRunStatusAggregateFieldCountResult']>,
    ParentType,
    ContextType
  >;
  group?: Resolver<
    Maybe<ResolversTypes['JSONObject']>,
    ParentType,
    ContextType
  >;
  histogram?: Resolver<
    Maybe<ResolversTypes['_RuleRunStatusAggregateHistogramFieldResult']>,
    ParentType,
    ContextType,
    RequireFields<_RuleRunStatusAggregateResultHistogramArgs, 'interval'>
  >;
  max?: Resolver<
    Maybe<ResolversTypes['_RuleRunStatusAggregateFieldResult']>,
    ParentType,
    ContextType
  >;
  min?: Resolver<
    Maybe<ResolversTypes['_RuleRunStatusAggregateFieldResult']>,
    ParentType,
    ContextType
  >;
  sum?: Resolver<
    Maybe<ResolversTypes['_RuleRunStatusAggregateFieldResult']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _RuleRunStatusAvgAggregateFieldResultResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['_RuleRunStatusAvgAggregateFieldResult'] =
    ResolversParentTypes['_RuleRunStatusAvgAggregateFieldResult'],
> = {
  totalFailed?: Resolver<
    Maybe<ResolversTypes['Float']>,
    ParentType,
    ContextType
  >;
  totalValid?: Resolver<
    Maybe<ResolversTypes['Float']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _RuleRunStatusConnectionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['_RuleRunStatusConnection'] =
    ResolversParentTypes['_RuleRunStatusConnection'],
> = {
  edges?: Resolver<
    Array<Maybe<ResolversTypes['_RuleRunStatusEdge']>>,
    ParentType,
    ContextType
  >;
  items?: Resolver<
    Array<Maybe<ResolversTypes['RuleRunStatus']>>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _RuleRunStatusEdgeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['_RuleRunStatusEdge'] =
    ResolversParentTypes['_RuleRunStatusEdge'],
> = {
  _type?: Resolver<
    Maybe<ResolversTypes['_InstanceType']>,
    ParentType,
    ContextType
  >;
  cursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  externalId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['RuleRunStatus'], ParentType, ContextType>;
  space?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _RulesetAggregateConnectionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['_RulesetAggregateConnection'] =
    ResolversParentTypes['_RulesetAggregateConnection'],
> = {
  edges?: Resolver<
    Array<Maybe<ResolversTypes['_RulesetAggregateEdge']>>,
    ParentType,
    ContextType
  >;
  items?: Resolver<
    Array<Maybe<ResolversTypes['_RulesetAggregateResult']>>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _RulesetAggregateEdgeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['_RulesetAggregateEdge'] =
    ResolversParentTypes['_RulesetAggregateEdge'],
> = {
  _type?: Resolver<
    Maybe<ResolversTypes['_InstanceType']>,
    ParentType,
    ContextType
  >;
  cursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  externalId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  node?: Resolver<
    ResolversTypes['_RulesetAggregateResult'],
    ParentType,
    ContextType
  >;
  space?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _RulesetAggregateFieldCountResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['_RulesetAggregateFieldCountResult'] =
    ResolversParentTypes['_RulesetAggregateFieldCountResult'],
> = {
  description?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  externalId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  filters?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  labels?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  projectId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  schemaType?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _RulesetAggregateFieldResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['_RulesetAggregateFieldResult'] =
    ResolversParentTypes['_RulesetAggregateFieldResult'],
> = {
  _empty?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _RulesetAggregateHistogramFieldResultResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['_RulesetAggregateHistogramFieldResult'] =
    ResolversParentTypes['_RulesetAggregateHistogramFieldResult'],
> = {
  _empty?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['_AggregateHistogramObjectType']>>>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _RulesetAggregateResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['_RulesetAggregateResult'] =
    ResolversParentTypes['_RulesetAggregateResult'],
> = {
  avg?: Resolver<
    Maybe<ResolversTypes['_RulesetAvgAggregateFieldResult']>,
    ParentType,
    ContextType
  >;
  count?: Resolver<
    Maybe<ResolversTypes['_RulesetAggregateFieldCountResult']>,
    ParentType,
    ContextType
  >;
  group?: Resolver<
    Maybe<ResolversTypes['JSONObject']>,
    ParentType,
    ContextType
  >;
  histogram?: Resolver<
    Maybe<ResolversTypes['_RulesetAggregateHistogramFieldResult']>,
    ParentType,
    ContextType,
    RequireFields<_RulesetAggregateResultHistogramArgs, 'interval'>
  >;
  max?: Resolver<
    Maybe<ResolversTypes['_RulesetAggregateFieldResult']>,
    ParentType,
    ContextType
  >;
  min?: Resolver<
    Maybe<ResolversTypes['_RulesetAggregateFieldResult']>,
    ParentType,
    ContextType
  >;
  sum?: Resolver<
    Maybe<ResolversTypes['_RulesetAggregateFieldResult']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _RulesetAvgAggregateFieldResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['_RulesetAvgAggregateFieldResult'] =
    ResolversParentTypes['_RulesetAvgAggregateFieldResult'],
> = {
  _empty?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _RulesetConnectionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['_RulesetConnection'] =
    ResolversParentTypes['_RulesetConnection'],
> = {
  edges?: Resolver<
    Array<Maybe<ResolversTypes['_RulesetEdge']>>,
    ParentType,
    ContextType
  >;
  items?: Resolver<
    Array<Maybe<ResolversTypes['Ruleset']>>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _RulesetEdgeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['_RulesetEdge'] =
    ResolversParentTypes['_RulesetEdge'],
> = {
  _type?: Resolver<
    Maybe<ResolversTypes['_InstanceType']>,
    ParentType,
    ContextType
  >;
  cursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  externalId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Ruleset'], ParentType, ContextType>;
  space?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _SchemaCollectionAggregateConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['_SchemaCollectionAggregateConnection'] =
    ResolversParentTypes['_SchemaCollectionAggregateConnection'],
> = {
  edges?: Resolver<
    Array<Maybe<ResolversTypes['_SchemaCollectionAggregateEdge']>>,
    ParentType,
    ContextType
  >;
  items?: Resolver<
    Array<Maybe<ResolversTypes['_SchemaCollectionAggregateResult']>>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _SchemaCollectionAggregateEdgeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['_SchemaCollectionAggregateEdge'] =
    ResolversParentTypes['_SchemaCollectionAggregateEdge'],
> = {
  _type?: Resolver<
    Maybe<ResolversTypes['_InstanceType']>,
    ParentType,
    ContextType
  >;
  cursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  externalId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  node?: Resolver<
    ResolversTypes['_SchemaCollectionAggregateResult'],
    ParentType,
    ContextType
  >;
  space?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _SchemaCollectionAggregateFieldCountResultResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['_SchemaCollectionAggregateFieldCountResult'] =
    ResolversParentTypes['_SchemaCollectionAggregateFieldCountResult'],
> = {
  description?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  externalId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  graphQLSchemaString?: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >;
  name?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  project?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  refId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  refVersion?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  tenant?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _SchemaCollectionAggregateFieldResultResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['_SchemaCollectionAggregateFieldResult'] =
    ResolversParentTypes['_SchemaCollectionAggregateFieldResult'],
> = {
  refVersion?: Resolver<
    Maybe<ResolversTypes['Int32']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _SchemaCollectionAggregateHistogramFieldResultResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['_SchemaCollectionAggregateHistogramFieldResult'] =
    ResolversParentTypes['_SchemaCollectionAggregateHistogramFieldResult'],
> = {
  refVersion?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['_AggregateHistogramObjectType']>>>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _SchemaCollectionAggregateResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['_SchemaCollectionAggregateResult'] =
    ResolversParentTypes['_SchemaCollectionAggregateResult'],
> = {
  avg?: Resolver<
    Maybe<ResolversTypes['_SchemaCollectionAvgAggregateFieldResult']>,
    ParentType,
    ContextType
  >;
  count?: Resolver<
    Maybe<ResolversTypes['_SchemaCollectionAggregateFieldCountResult']>,
    ParentType,
    ContextType
  >;
  group?: Resolver<
    Maybe<ResolversTypes['JSONObject']>,
    ParentType,
    ContextType
  >;
  histogram?: Resolver<
    Maybe<ResolversTypes['_SchemaCollectionAggregateHistogramFieldResult']>,
    ParentType,
    ContextType,
    RequireFields<_SchemaCollectionAggregateResultHistogramArgs, 'interval'>
  >;
  max?: Resolver<
    Maybe<ResolversTypes['_SchemaCollectionAggregateFieldResult']>,
    ParentType,
    ContextType
  >;
  min?: Resolver<
    Maybe<ResolversTypes['_SchemaCollectionAggregateFieldResult']>,
    ParentType,
    ContextType
  >;
  sum?: Resolver<
    Maybe<ResolversTypes['_SchemaCollectionAggregateFieldResult']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _SchemaCollectionAvgAggregateFieldResultResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['_SchemaCollectionAvgAggregateFieldResult'] =
    ResolversParentTypes['_SchemaCollectionAvgAggregateFieldResult'],
> = {
  refVersion?: Resolver<
    Maybe<ResolversTypes['Float']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _SchemaCollectionConnectionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['_SchemaCollectionConnection'] =
    ResolversParentTypes['_SchemaCollectionConnection'],
> = {
  edges?: Resolver<
    Array<Maybe<ResolversTypes['_SchemaCollectionEdge']>>,
    ParentType,
    ContextType
  >;
  items?: Resolver<
    Array<Maybe<ResolversTypes['SchemaCollection']>>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _SchemaCollectionEdgeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['_SchemaCollectionEdge'] =
    ResolversParentTypes['_SchemaCollectionEdge'],
> = {
  _type?: Resolver<
    Maybe<ResolversTypes['_InstanceType']>,
    ParentType,
    ContextType
  >;
  cursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  externalId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['SchemaCollection'], ParentType, ContextType>;
  space?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _SequenceColumnResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['_SequenceColumn'] =
    ResolversParentTypes['_SequenceColumn'],
> = {
  description?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  externalId?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  metadata?: Resolver<
    Maybe<ResolversTypes['JSONObject']>,
    ParentType,
    ContextType
  >;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  valueType?: Resolver<
    Maybe<ResolversTypes['_SequenceColumnValueType']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _SequenceColumnInfoResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['_SequenceColumnInfo'] =
    ResolversParentTypes['_SequenceColumnInfo'],
> = {
  externalId?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  valueType?: Resolver<
    Maybe<ResolversTypes['_SequenceColumnValueType']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _SequenceRowResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['_SequenceRow'] =
    ResolversParentTypes['_SequenceRow'],
> = {
  columns?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['_SequenceColumnInfo']>>>,
    ParentType,
    ContextType
  >;
  externalId?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  id?: Resolver<Maybe<ResolversTypes['Int64']>, ParentType, ContextType>;
  rows?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['_SequenceRowsData']>>>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface _SequenceRowValuesScalarConfig extends GraphQLScalarTypeConfig<
  ResolversTypes['_SequenceRowValues'],
  any
> {
  name: '_SequenceRowValues';
}

export type _SequenceRowsDataResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['_SequenceRowsData'] =
    ResolversParentTypes['_SequenceRowsData'],
> = {
  rowNumber?: Resolver<Maybe<ResolversTypes['Int64']>, ParentType, ContextType>;
  values?: Resolver<
    Maybe<ResolversTypes['_SequenceRowValues']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type _TempReturnResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['_TempReturn'] =
    ResolversParentTypes['_TempReturn'],
> = {
  endNode?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  startNode?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface _UnknownTypeScalarConfig extends GraphQLScalarTypeConfig<
  ResolversTypes['_UnknownType'],
  any
> {
  name: '_UnknownType';
}

export type _UpsertResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['_UpsertResponse'] =
    ResolversParentTypes['_UpsertResponse'],
> = {
  externalId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  instanceType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  space?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  version?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  wasModified?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Resolvers<ContextType = any> = {
  Access?: AccessResolvers<ContextType>;
  ConsistencyCollection?: ConsistencyCollectionResolvers<ContextType>;
  ConsistencyConditionCheck?: ConsistencyConditionCheckResolvers<ContextType>;
  ConsistencyRule?: ConsistencyRuleResolvers<ContextType>;
  ConsistencyRunStatus?: ConsistencyRunStatusResolvers<ContextType>;
  ConsistencySchemaFilter?: ConsistencySchemaFilterResolvers<ContextType>;
  DataPoint?: DataPointResolvers<ContextType>;
  DataPointValue?: GraphQLScalarType;
  Date?: GraphQLScalarType;
  DigitalTwin?: DigitalTwinResolvers<ContextType>;
  Error?: ErrorResolvers<ContextType>;
  File?: FileResolvers<ContextType>;
  Float32?: GraphQLScalarType;
  Float64?: GraphQLScalarType;
  GraphQlDmlVersion?: GraphQlDmlVersionResolvers<ContextType>;
  GraphQlDmlVersionConnection?: GraphQlDmlVersionConnectionResolvers<ContextType>;
  GraphQlDmlVersionEdge?: GraphQlDmlVersionEdgeResolvers<ContextType>;
  Int32?: GraphQLScalarType;
  Int64?: GraphQLScalarType;
  JSONObject?: GraphQLScalarType;
  Milestone?: MilestoneResolvers<ContextType>;
  Mutation?: MutationResolvers<ContextType>;
  PageInfo?: PageInfoResolvers<ContextType>;
  Query?: QueryResolvers<ContextType>;
  Rule?: RuleResolvers<ContextType>;
  RuleRunStatus?: RuleRunStatusResolvers<ContextType>;
  Ruleset?: RulesetResolvers<ContextType>;
  SchemaCollection?: SchemaCollectionResolvers<ContextType>;
  Sequence?: SequenceResolvers<ContextType>;
  SourceLocation?: SourceLocationResolvers<ContextType>;
  SourceLocationRange?: SourceLocationRangeResolvers<ContextType>;
  TimeSeries?: TimeSeriesResolvers<ContextType>;
  Timestamp?: GraphQLScalarType;
  UnitInfo?: UnitInfoResolvers<ContextType>;
  UpsertGraphQlDmlVersionResult?: UpsertGraphQlDmlVersionResultResolvers<ContextType>;
  ViewRef?: ViewRefResolvers<ContextType>;
  _AccessAggregateConnection?: _AccessAggregateConnectionResolvers<ContextType>;
  _AccessAggregateEdge?: _AccessAggregateEdgeResolvers<ContextType>;
  _AccessAggregateFieldCountResult?: _AccessAggregateFieldCountResultResolvers<ContextType>;
  _AccessAggregateFieldResult?: _AccessAggregateFieldResultResolvers<ContextType>;
  _AccessAggregateHistogramFieldResult?: _AccessAggregateHistogramFieldResultResolvers<ContextType>;
  _AccessAggregateResult?: _AccessAggregateResultResolvers<ContextType>;
  _AccessAvgAggregateFieldResult?: _AccessAvgAggregateFieldResultResolvers<ContextType>;
  _AccessConnection?: _AccessConnectionResolvers<ContextType>;
  _AccessEdge?: _AccessEdgeResolvers<ContextType>;
  _AggregateHistogramObjectType?: _AggregateHistogramObjectTypeResolvers<ContextType>;
  _ConsistencyCollectionAggregateConnection?: _ConsistencyCollectionAggregateConnectionResolvers<ContextType>;
  _ConsistencyCollectionAggregateEdge?: _ConsistencyCollectionAggregateEdgeResolvers<ContextType>;
  _ConsistencyCollectionAggregateFieldCountResult?: _ConsistencyCollectionAggregateFieldCountResultResolvers<ContextType>;
  _ConsistencyCollectionAggregateFieldResult?: _ConsistencyCollectionAggregateFieldResultResolvers<ContextType>;
  _ConsistencyCollectionAggregateHistogramFieldResult?: _ConsistencyCollectionAggregateHistogramFieldResultResolvers<ContextType>;
  _ConsistencyCollectionAggregateResult?: _ConsistencyCollectionAggregateResultResolvers<ContextType>;
  _ConsistencyCollectionAvgAggregateFieldResult?: _ConsistencyCollectionAvgAggregateFieldResultResolvers<ContextType>;
  _ConsistencyCollectionConnection?: _ConsistencyCollectionConnectionResolvers<ContextType>;
  _ConsistencyCollectionEdge?: _ConsistencyCollectionEdgeResolvers<ContextType>;
  _ConsistencyConditionCheckAggregateConnection?: _ConsistencyConditionCheckAggregateConnectionResolvers<ContextType>;
  _ConsistencyConditionCheckAggregateEdge?: _ConsistencyConditionCheckAggregateEdgeResolvers<ContextType>;
  _ConsistencyConditionCheckAggregateFieldCountResult?: _ConsistencyConditionCheckAggregateFieldCountResultResolvers<ContextType>;
  _ConsistencyConditionCheckAggregateFieldResult?: _ConsistencyConditionCheckAggregateFieldResultResolvers<ContextType>;
  _ConsistencyConditionCheckAggregateHistogramFieldResult?: _ConsistencyConditionCheckAggregateHistogramFieldResultResolvers<ContextType>;
  _ConsistencyConditionCheckAggregateResult?: _ConsistencyConditionCheckAggregateResultResolvers<ContextType>;
  _ConsistencyConditionCheckAvgAggregateFieldResult?: _ConsistencyConditionCheckAvgAggregateFieldResultResolvers<ContextType>;
  _ConsistencyConditionCheckConnection?: _ConsistencyConditionCheckConnectionResolvers<ContextType>;
  _ConsistencyConditionCheckEdge?: _ConsistencyConditionCheckEdgeResolvers<ContextType>;
  _ConsistencyRuleAggregateConnection?: _ConsistencyRuleAggregateConnectionResolvers<ContextType>;
  _ConsistencyRuleAggregateEdge?: _ConsistencyRuleAggregateEdgeResolvers<ContextType>;
  _ConsistencyRuleAggregateFieldCountResult?: _ConsistencyRuleAggregateFieldCountResultResolvers<ContextType>;
  _ConsistencyRuleAggregateFieldResult?: _ConsistencyRuleAggregateFieldResultResolvers<ContextType>;
  _ConsistencyRuleAggregateHistogramFieldResult?: _ConsistencyRuleAggregateHistogramFieldResultResolvers<ContextType>;
  _ConsistencyRuleAggregateResult?: _ConsistencyRuleAggregateResultResolvers<ContextType>;
  _ConsistencyRuleAvgAggregateFieldResult?: _ConsistencyRuleAvgAggregateFieldResultResolvers<ContextType>;
  _ConsistencyRuleConnection?: _ConsistencyRuleConnectionResolvers<ContextType>;
  _ConsistencyRuleEdge?: _ConsistencyRuleEdgeResolvers<ContextType>;
  _ConsistencyRunStatusAggregateConnection?: _ConsistencyRunStatusAggregateConnectionResolvers<ContextType>;
  _ConsistencyRunStatusAggregateEdge?: _ConsistencyRunStatusAggregateEdgeResolvers<ContextType>;
  _ConsistencyRunStatusAggregateFieldCountResult?: _ConsistencyRunStatusAggregateFieldCountResultResolvers<ContextType>;
  _ConsistencyRunStatusAggregateFieldResult?: _ConsistencyRunStatusAggregateFieldResultResolvers<ContextType>;
  _ConsistencyRunStatusAggregateHistogramFieldResult?: _ConsistencyRunStatusAggregateHistogramFieldResultResolvers<ContextType>;
  _ConsistencyRunStatusAggregateResult?: _ConsistencyRunStatusAggregateResultResolvers<ContextType>;
  _ConsistencyRunStatusAvgAggregateFieldResult?: _ConsistencyRunStatusAvgAggregateFieldResultResolvers<ContextType>;
  _ConsistencyRunStatusConnection?: _ConsistencyRunStatusConnectionResolvers<ContextType>;
  _ConsistencyRunStatusEdge?: _ConsistencyRunStatusEdgeResolvers<ContextType>;
  _ConsistencySchemaFilterAggregateConnection?: _ConsistencySchemaFilterAggregateConnectionResolvers<ContextType>;
  _ConsistencySchemaFilterAggregateEdge?: _ConsistencySchemaFilterAggregateEdgeResolvers<ContextType>;
  _ConsistencySchemaFilterAggregateFieldCountResult?: _ConsistencySchemaFilterAggregateFieldCountResultResolvers<ContextType>;
  _ConsistencySchemaFilterAggregateFieldResult?: _ConsistencySchemaFilterAggregateFieldResultResolvers<ContextType>;
  _ConsistencySchemaFilterAggregateHistogramFieldResult?: _ConsistencySchemaFilterAggregateHistogramFieldResultResolvers<ContextType>;
  _ConsistencySchemaFilterAggregateResult?: _ConsistencySchemaFilterAggregateResultResolvers<ContextType>;
  _ConsistencySchemaFilterAvgAggregateFieldResult?: _ConsistencySchemaFilterAvgAggregateFieldResultResolvers<ContextType>;
  _ConsistencySchemaFilterConnection?: _ConsistencySchemaFilterConnectionResolvers<ContextType>;
  _ConsistencySchemaFilterEdge?: _ConsistencySchemaFilterEdgeResolvers<ContextType>;
  _DataPointConnection?: _DataPointConnectionResolvers<ContextType>;
  _DataPointEdge?: _DataPointEdgeResolvers<ContextType>;
  _DeleteResponse?: _DeleteResponseResolvers<ContextType>;
  _DigitalTwinAggregateConnection?: _DigitalTwinAggregateConnectionResolvers<ContextType>;
  _DigitalTwinAggregateEdge?: _DigitalTwinAggregateEdgeResolvers<ContextType>;
  _DigitalTwinAggregateFieldCountResult?: _DigitalTwinAggregateFieldCountResultResolvers<ContextType>;
  _DigitalTwinAggregateFieldResult?: _DigitalTwinAggregateFieldResultResolvers<ContextType>;
  _DigitalTwinAggregateHistogramFieldResult?: _DigitalTwinAggregateHistogramFieldResultResolvers<ContextType>;
  _DigitalTwinAggregateResult?: _DigitalTwinAggregateResultResolvers<ContextType>;
  _DigitalTwinAvgAggregateFieldResult?: _DigitalTwinAvgAggregateFieldResultResolvers<ContextType>;
  _DigitalTwinConnection?: _DigitalTwinConnectionResolvers<ContextType>;
  _DigitalTwinEdge?: _DigitalTwinEdgeResolvers<ContextType>;
  _DownloadLink?: _DownloadLinkResolvers<ContextType>;
  _GeoLocation?: _GeoLocationResolvers<ContextType>;
  _GeoLocationGeometry?: _GeoLocationGeometryResolvers<ContextType>;
  _InstanceType?: _InstanceTypeResolvers<ContextType>;
  _MilestoneAggregateConnection?: _MilestoneAggregateConnectionResolvers<ContextType>;
  _MilestoneAggregateEdge?: _MilestoneAggregateEdgeResolvers<ContextType>;
  _MilestoneAggregateFieldCountResult?: _MilestoneAggregateFieldCountResultResolvers<ContextType>;
  _MilestoneAggregateFieldResult?: _MilestoneAggregateFieldResultResolvers<ContextType>;
  _MilestoneAggregateHistogramFieldResult?: _MilestoneAggregateHistogramFieldResultResolvers<ContextType>;
  _MilestoneAggregateResult?: _MilestoneAggregateResultResolvers<ContextType>;
  _MilestoneAvgAggregateFieldResult?: _MilestoneAvgAggregateFieldResultResolvers<ContextType>;
  _MilestoneConnection?: _MilestoneConnectionResolvers<ContextType>;
  _MilestoneEdge?: _MilestoneEdgeResolvers<ContextType>;
  _RuleAggregateConnection?: _RuleAggregateConnectionResolvers<ContextType>;
  _RuleAggregateEdge?: _RuleAggregateEdgeResolvers<ContextType>;
  _RuleAggregateFieldCountResult?: _RuleAggregateFieldCountResultResolvers<ContextType>;
  _RuleAggregateFieldResult?: _RuleAggregateFieldResultResolvers<ContextType>;
  _RuleAggregateHistogramFieldResult?: _RuleAggregateHistogramFieldResultResolvers<ContextType>;
  _RuleAggregateResult?: _RuleAggregateResultResolvers<ContextType>;
  _RuleAvgAggregateFieldResult?: _RuleAvgAggregateFieldResultResolvers<ContextType>;
  _RuleConnection?: _RuleConnectionResolvers<ContextType>;
  _RuleEdge?: _RuleEdgeResolvers<ContextType>;
  _RuleRunStatusAggregateConnection?: _RuleRunStatusAggregateConnectionResolvers<ContextType>;
  _RuleRunStatusAggregateEdge?: _RuleRunStatusAggregateEdgeResolvers<ContextType>;
  _RuleRunStatusAggregateFieldCountResult?: _RuleRunStatusAggregateFieldCountResultResolvers<ContextType>;
  _RuleRunStatusAggregateFieldResult?: _RuleRunStatusAggregateFieldResultResolvers<ContextType>;
  _RuleRunStatusAggregateHistogramFieldResult?: _RuleRunStatusAggregateHistogramFieldResultResolvers<ContextType>;
  _RuleRunStatusAggregateResult?: _RuleRunStatusAggregateResultResolvers<ContextType>;
  _RuleRunStatusAvgAggregateFieldResult?: _RuleRunStatusAvgAggregateFieldResultResolvers<ContextType>;
  _RuleRunStatusConnection?: _RuleRunStatusConnectionResolvers<ContextType>;
  _RuleRunStatusEdge?: _RuleRunStatusEdgeResolvers<ContextType>;
  _RulesetAggregateConnection?: _RulesetAggregateConnectionResolvers<ContextType>;
  _RulesetAggregateEdge?: _RulesetAggregateEdgeResolvers<ContextType>;
  _RulesetAggregateFieldCountResult?: _RulesetAggregateFieldCountResultResolvers<ContextType>;
  _RulesetAggregateFieldResult?: _RulesetAggregateFieldResultResolvers<ContextType>;
  _RulesetAggregateHistogramFieldResult?: _RulesetAggregateHistogramFieldResultResolvers<ContextType>;
  _RulesetAggregateResult?: _RulesetAggregateResultResolvers<ContextType>;
  _RulesetAvgAggregateFieldResult?: _RulesetAvgAggregateFieldResultResolvers<ContextType>;
  _RulesetConnection?: _RulesetConnectionResolvers<ContextType>;
  _RulesetEdge?: _RulesetEdgeResolvers<ContextType>;
  _SchemaCollectionAggregateConnection?: _SchemaCollectionAggregateConnectionResolvers<ContextType>;
  _SchemaCollectionAggregateEdge?: _SchemaCollectionAggregateEdgeResolvers<ContextType>;
  _SchemaCollectionAggregateFieldCountResult?: _SchemaCollectionAggregateFieldCountResultResolvers<ContextType>;
  _SchemaCollectionAggregateFieldResult?: _SchemaCollectionAggregateFieldResultResolvers<ContextType>;
  _SchemaCollectionAggregateHistogramFieldResult?: _SchemaCollectionAggregateHistogramFieldResultResolvers<ContextType>;
  _SchemaCollectionAggregateResult?: _SchemaCollectionAggregateResultResolvers<ContextType>;
  _SchemaCollectionAvgAggregateFieldResult?: _SchemaCollectionAvgAggregateFieldResultResolvers<ContextType>;
  _SchemaCollectionConnection?: _SchemaCollectionConnectionResolvers<ContextType>;
  _SchemaCollectionEdge?: _SchemaCollectionEdgeResolvers<ContextType>;
  _SequenceColumn?: _SequenceColumnResolvers<ContextType>;
  _SequenceColumnInfo?: _SequenceColumnInfoResolvers<ContextType>;
  _SequenceRow?: _SequenceRowResolvers<ContextType>;
  _SequenceRowValues?: GraphQLScalarType;
  _SequenceRowsData?: _SequenceRowsDataResolvers<ContextType>;
  _TempReturn?: _TempReturnResolvers<ContextType>;
  _UnknownType?: GraphQLScalarType;
  _UpsertResponse?: _UpsertResponseResolvers<ContextType>;
};

export type DirectiveResolvers<ContextType = any> = {
  oneOf?: OneOfDirectiveResolver<any, any, ContextType>;
};

export const GetDigitalTwinsDocument = gql`
  query GetDigitalTwins($first: Int = 50, $cursor: String = null) {
    listDigitalTwin(first: $first, after: $cursor) {
      items {
        externalId
        name
        tenant
        schemaCollections {
          items {
            milestones {
              items {
                name
                externalId
                milestoneType
                orderIndex
                startActiveTime
                endActiveTime
              }
            }
          }
        }
      }
      pageInfo {
        startCursor
        endCursor
      }
    }
  }
`;

/**
 * __useGetDigitalTwinsQuery__
 *
 * To run a query within a React component, call `useGetDigitalTwinsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDigitalTwinsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDigitalTwinsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useGetDigitalTwinsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetDigitalTwinsQuery,
    GetDigitalTwinsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetDigitalTwinsQuery, GetDigitalTwinsQueryVariables>(
    GetDigitalTwinsDocument,
    options
  );
}
export function useGetDigitalTwinsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDigitalTwinsQuery,
    GetDigitalTwinsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetDigitalTwinsQuery,
    GetDigitalTwinsQueryVariables
  >(GetDigitalTwinsDocument, options);
}
export type GetDigitalTwinsQueryHookResult = ReturnType<
  typeof useGetDigitalTwinsQuery
>;
export type GetDigitalTwinsLazyQueryHookResult = ReturnType<
  typeof useGetDigitalTwinsLazyQuery
>;
export type GetDigitalTwinsQueryResult = Apollo.QueryResult<
  GetDigitalTwinsQuery,
  GetDigitalTwinsQueryVariables
>;
export const CountDigitalTwinsDocument = gql`
  query CountDigitalTwins {
    aggregateDigitalTwin {
      items {
        count {
          externalId
        }
      }
    }
  }
`;

/**
 * __useCountDigitalTwinsQuery__
 *
 * To run a query within a React component, call `useCountDigitalTwinsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountDigitalTwinsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountDigitalTwinsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCountDigitalTwinsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CountDigitalTwinsQuery,
    CountDigitalTwinsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CountDigitalTwinsQuery,
    CountDigitalTwinsQueryVariables
  >(CountDigitalTwinsDocument, options);
}
export function useCountDigitalTwinsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CountDigitalTwinsQuery,
    CountDigitalTwinsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CountDigitalTwinsQuery,
    CountDigitalTwinsQueryVariables
  >(CountDigitalTwinsDocument, options);
}
export type CountDigitalTwinsQueryHookResult = ReturnType<
  typeof useCountDigitalTwinsQuery
>;
export type CountDigitalTwinsLazyQueryHookResult = ReturnType<
  typeof useCountDigitalTwinsLazyQuery
>;
export type CountDigitalTwinsQueryResult = Apollo.QueryResult<
  CountDigitalTwinsQuery,
  CountDigitalTwinsQueryVariables
>;
export const GetDigitalTwinDocument = gql`
  query GetDigitalTwin($id: ID!) {
    listDigitalTwin(filter: { externalId: { eq: $id } }) {
      items {
        externalId
        name
        tenant
        schemaCollections {
          items {
            externalId
            refId
            name
            tenant
          }
        }
      }
    }
  }
`;

/**
 * __useGetDigitalTwinQuery__
 *
 * To run a query within a React component, call `useGetDigitalTwinQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDigitalTwinQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDigitalTwinQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDigitalTwinQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetDigitalTwinQuery,
    GetDigitalTwinQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetDigitalTwinQuery, GetDigitalTwinQueryVariables>(
    GetDigitalTwinDocument,
    options
  );
}
export function useGetDigitalTwinLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDigitalTwinQuery,
    GetDigitalTwinQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetDigitalTwinQuery, GetDigitalTwinQueryVariables>(
    GetDigitalTwinDocument,
    options
  );
}
export type GetDigitalTwinQueryHookResult = ReturnType<
  typeof useGetDigitalTwinQuery
>;
export type GetDigitalTwinLazyQueryHookResult = ReturnType<
  typeof useGetDigitalTwinLazyQuery
>;
export type GetDigitalTwinQueryResult = Apollo.QueryResult<
  GetDigitalTwinQuery,
  GetDigitalTwinQueryVariables
>;
export const GetDigitalTwinNameDocument = gql`
  query GetDigitalTwinName($id: ID!) {
    listDigitalTwin(filter: { externalId: { eq: $id } }) {
      items {
        externalId
        name
        tenant
      }
    }
  }
`;

/**
 * __useGetDigitalTwinNameQuery__
 *
 * To run a query within a React component, call `useGetDigitalTwinNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDigitalTwinNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDigitalTwinNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDigitalTwinNameQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetDigitalTwinNameQuery,
    GetDigitalTwinNameQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetDigitalTwinNameQuery,
    GetDigitalTwinNameQueryVariables
  >(GetDigitalTwinNameDocument, options);
}
export function useGetDigitalTwinNameLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDigitalTwinNameQuery,
    GetDigitalTwinNameQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetDigitalTwinNameQuery,
    GetDigitalTwinNameQueryVariables
  >(GetDigitalTwinNameDocument, options);
}
export type GetDigitalTwinNameQueryHookResult = ReturnType<
  typeof useGetDigitalTwinNameQuery
>;
export type GetDigitalTwinNameLazyQueryHookResult = ReturnType<
  typeof useGetDigitalTwinNameLazyQuery
>;
export type GetDigitalTwinNameQueryResult = Apollo.QueryResult<
  GetDigitalTwinNameQuery,
  GetDigitalTwinNameQueryVariables
>;
export const CreateDigitalTwinDocument = gql`
  mutation CreateDigitalTwin($id: ID!, $name: String!, $tenant: String!) {
    Create_DigitalTwin(id: $id, name: $name, tenant: $tenant) {
      externalId
    }
  }
`;
export type CreateDigitalTwinMutationFn = Apollo.MutationFunction<
  CreateDigitalTwinMutation,
  CreateDigitalTwinMutationVariables
>;

/**
 * __useCreateDigitalTwinMutation__
 *
 * To run a mutation, you first call `useCreateDigitalTwinMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDigitalTwinMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDigitalTwinMutation, { data, loading, error }] = useCreateDigitalTwinMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      tenant: // value for 'tenant'
 *   },
 * });
 */
export function useCreateDigitalTwinMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateDigitalTwinMutation,
    CreateDigitalTwinMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateDigitalTwinMutation,
    CreateDigitalTwinMutationVariables
  >(CreateDigitalTwinDocument, options);
}
export type CreateDigitalTwinMutationHookResult = ReturnType<
  typeof useCreateDigitalTwinMutation
>;
export type CreateDigitalTwinMutationResult =
  Apollo.MutationResult<CreateDigitalTwinMutation>;
export type CreateDigitalTwinMutationOptions = Apollo.BaseMutationOptions<
  CreateDigitalTwinMutation,
  CreateDigitalTwinMutationVariables
>;
export const UpdateDigitalTwinDocument = gql`
  mutation UpdateDigitalTwin($id: ID!, $name: String, $tenant: String!) {
    Update_DigitalTwin(id: $id, name: $name, tenant: $tenant) {
      externalId
    }
  }
`;
export type UpdateDigitalTwinMutationFn = Apollo.MutationFunction<
  UpdateDigitalTwinMutation,
  UpdateDigitalTwinMutationVariables
>;

/**
 * __useUpdateDigitalTwinMutation__
 *
 * To run a mutation, you first call `useUpdateDigitalTwinMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDigitalTwinMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDigitalTwinMutation, { data, loading, error }] = useUpdateDigitalTwinMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      tenant: // value for 'tenant'
 *   },
 * });
 */
export function useUpdateDigitalTwinMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateDigitalTwinMutation,
    UpdateDigitalTwinMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateDigitalTwinMutation,
    UpdateDigitalTwinMutationVariables
  >(UpdateDigitalTwinDocument, options);
}
export type UpdateDigitalTwinMutationHookResult = ReturnType<
  typeof useUpdateDigitalTwinMutation
>;
export type UpdateDigitalTwinMutationResult =
  Apollo.MutationResult<UpdateDigitalTwinMutation>;
export type UpdateDigitalTwinMutationOptions = Apollo.BaseMutationOptions<
  UpdateDigitalTwinMutation,
  UpdateDigitalTwinMutationVariables
>;
export const DeleteDigitalTwinDocument = gql`
  mutation DeleteDigitalTwin($id: ID!) {
    Delete_DigitalTwin(id: $id) {
      externalId
    }
  }
`;
export type DeleteDigitalTwinMutationFn = Apollo.MutationFunction<
  DeleteDigitalTwinMutation,
  DeleteDigitalTwinMutationVariables
>;

/**
 * __useDeleteDigitalTwinMutation__
 *
 * To run a mutation, you first call `useDeleteDigitalTwinMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDigitalTwinMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDigitalTwinMutation, { data, loading, error }] = useDeleteDigitalTwinMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDigitalTwinMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteDigitalTwinMutation,
    DeleteDigitalTwinMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteDigitalTwinMutation,
    DeleteDigitalTwinMutationVariables
  >(DeleteDigitalTwinDocument, options);
}
export type DeleteDigitalTwinMutationHookResult = ReturnType<
  typeof useDeleteDigitalTwinMutation
>;
export type DeleteDigitalTwinMutationResult =
  Apollo.MutationResult<DeleteDigitalTwinMutation>;
export type DeleteDigitalTwinMutationOptions = Apollo.BaseMutationOptions<
  DeleteDigitalTwinMutation,
  DeleteDigitalTwinMutationVariables
>;
export const GetSchemaCollectionDocument = gql`
  query GetSchemaCollection($id: ID, $tenant: String) {
    listSchemaCollection(
      filter: {
        and: [{ externalId: { eq: $id } }, { tenant: { eq: $tenant } }]
      }
    ) {
      items {
        externalId
        refId
        tenant
        name
      }
    }
  }
`;

/**
 * __useGetSchemaCollectionQuery__
 *
 * To run a query within a React component, call `useGetSchemaCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSchemaCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSchemaCollectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *      tenant: // value for 'tenant'
 *   },
 * });
 */
export function useGetSchemaCollectionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetSchemaCollectionQuery,
    GetSchemaCollectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetSchemaCollectionQuery,
    GetSchemaCollectionQueryVariables
  >(GetSchemaCollectionDocument, options);
}
export function useGetSchemaCollectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSchemaCollectionQuery,
    GetSchemaCollectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetSchemaCollectionQuery,
    GetSchemaCollectionQueryVariables
  >(GetSchemaCollectionDocument, options);
}
export type GetSchemaCollectionQueryHookResult = ReturnType<
  typeof useGetSchemaCollectionQuery
>;
export type GetSchemaCollectionLazyQueryHookResult = ReturnType<
  typeof useGetSchemaCollectionLazyQuery
>;
export type GetSchemaCollectionQueryResult = Apollo.QueryResult<
  GetSchemaCollectionQuery,
  GetSchemaCollectionQueryVariables
>;
export const DeleteSchemaDocument = gql`
  mutation DeleteSchema($id: ID!) {
    Delete_SchemaCollection(id: $id) {
      externalId
    }
  }
`;
export type DeleteSchemaMutationFn = Apollo.MutationFunction<
  DeleteSchemaMutation,
  DeleteSchemaMutationVariables
>;

/**
 * __useDeleteSchemaMutation__
 *
 * To run a mutation, you first call `useDeleteSchemaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSchemaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSchemaMutation, { data, loading, error }] = useDeleteSchemaMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSchemaMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteSchemaMutation,
    DeleteSchemaMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteSchemaMutation,
    DeleteSchemaMutationVariables
  >(DeleteSchemaDocument, options);
}
export type DeleteSchemaMutationHookResult = ReturnType<
  typeof useDeleteSchemaMutation
>;
export type DeleteSchemaMutationResult =
  Apollo.MutationResult<DeleteSchemaMutation>;
export type DeleteSchemaMutationOptions = Apollo.BaseMutationOptions<
  DeleteSchemaMutation,
  DeleteSchemaMutationVariables
>;
export const GetRulesDocument = gql`
  query GetRules($projectId: String!) {
    listRule(filter: { projectId: { eq: $projectId } }, first: 1000) {
      items {
        externalId
        name
        description
        customerDefinedId
        severity
        errorMessage
        tags
        schemaType
        primaryKeyName
        projectId
        rulesets {
          items {
            externalId
            name
            description
            schemaType
            labels
            filters
          }
        }
        rules
        invertedRules
        filters
        milestones {
          items {
            externalId
            name
          }
        }
      }
    }
  }
`;

/**
 * __useGetRulesQuery__
 *
 * To run a query within a React component, call `useGetRulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRulesQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetRulesQuery(
  baseOptions: Apollo.QueryHookOptions<GetRulesQuery, GetRulesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetRulesQuery, GetRulesQueryVariables>(
    GetRulesDocument,
    options
  );
}
export function useGetRulesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetRulesQuery,
    GetRulesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetRulesQuery, GetRulesQueryVariables>(
    GetRulesDocument,
    options
  );
}
export type GetRulesQueryHookResult = ReturnType<typeof useGetRulesQuery>;
export type GetRulesLazyQueryHookResult = ReturnType<
  typeof useGetRulesLazyQuery
>;
export type GetRulesQueryResult = Apollo.QueryResult<
  GetRulesQuery,
  GetRulesQueryVariables
>;
export const GetRuleRunStatusDocument = gql`
  query GetRuleRunStatus($schemaId: ID!) {
    listRuleRunStatus(
      first: 1000
      sort: { runAt: DESC }
      filter: {
        and: [{ rule: { schemaCollection: { externalId: { eq: $schemaId } } } }]
      }
    ) {
      items {
        externalId
        message
        status
        totalFailed
        totalValid
        filteredInstances
        failedInstances
        reportId
        runAt
        rule {
          externalId
          name
          customerDefinedId
          description
          severity
          errorMessage
          projectId
          schemaType
          primaryKeyName
          tags
          rules
          invertedRules
          filters
        }
      }
    }
  }
`;

/**
 * __useGetRuleRunStatusQuery__
 *
 * To run a query within a React component, call `useGetRuleRunStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRuleRunStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRuleRunStatusQuery({
 *   variables: {
 *      schemaId: // value for 'schemaId'
 *   },
 * });
 */
export function useGetRuleRunStatusQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetRuleRunStatusQuery,
    GetRuleRunStatusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetRuleRunStatusQuery, GetRuleRunStatusQueryVariables>(
    GetRuleRunStatusDocument,
    options
  );
}
export function useGetRuleRunStatusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetRuleRunStatusQuery,
    GetRuleRunStatusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetRuleRunStatusQuery,
    GetRuleRunStatusQueryVariables
  >(GetRuleRunStatusDocument, options);
}
export type GetRuleRunStatusQueryHookResult = ReturnType<
  typeof useGetRuleRunStatusQuery
>;
export type GetRuleRunStatusLazyQueryHookResult = ReturnType<
  typeof useGetRuleRunStatusLazyQuery
>;
export type GetRuleRunStatusQueryResult = Apollo.QueryResult<
  GetRuleRunStatusQuery,
  GetRuleRunStatusQueryVariables
>;
export const GetRuleRunStatusByRuleIdDocument = gql`
  query GetRuleRunStatusByRuleId($ruleId: ID!, $first: Int!) {
    listRule(filter: { externalId: { eq: $ruleId } }) {
      items {
        externalId
        ruleRunStatus(first: $first) {
          items {
            externalId
            message
            status
            totalFailed
            totalValid
            filteredInstances
            failedInstances
            reportId
            runAt
            rule {
              externalId
              name
              customerDefinedId
              description
              severity
              errorMessage
              projectId
              schemaType
              primaryKeyName
              tags
              rules
              invertedRules
              filters
              rulesets {
                items {
                  schemaType
                  filters
                  name
                }
              }
              milestones {
                items {
                  schedule
                  endActiveTime
                  endScheduleTime
                  startActiveTime
                  startScheduleTime
                }
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetRuleRunStatusByRuleIdQuery__
 *
 * To run a query within a React component, call `useGetRuleRunStatusByRuleIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRuleRunStatusByRuleIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRuleRunStatusByRuleIdQuery({
 *   variables: {
 *      ruleId: // value for 'ruleId'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useGetRuleRunStatusByRuleIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetRuleRunStatusByRuleIdQuery,
    GetRuleRunStatusByRuleIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetRuleRunStatusByRuleIdQuery,
    GetRuleRunStatusByRuleIdQueryVariables
  >(GetRuleRunStatusByRuleIdDocument, options);
}
export function useGetRuleRunStatusByRuleIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetRuleRunStatusByRuleIdQuery,
    GetRuleRunStatusByRuleIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetRuleRunStatusByRuleIdQuery,
    GetRuleRunStatusByRuleIdQueryVariables
  >(GetRuleRunStatusByRuleIdDocument, options);
}
export type GetRuleRunStatusByRuleIdQueryHookResult = ReturnType<
  typeof useGetRuleRunStatusByRuleIdQuery
>;
export type GetRuleRunStatusByRuleIdLazyQueryHookResult = ReturnType<
  typeof useGetRuleRunStatusByRuleIdLazyQuery
>;
export type GetRuleRunStatusByRuleIdQueryResult = Apollo.QueryResult<
  GetRuleRunStatusByRuleIdQuery,
  GetRuleRunStatusByRuleIdQueryVariables
>;
export const CreateRuleDocument = gql`
  mutation CreateRule(
    $id: ID!
    $description: String
    $severity: String
    $name: String
    $customerDefinedId: String
    $projectId: ID!
    $errorMessage: String
    $schemaType: String
    $primaryKeyName: String
    $tags: [String]
    $rules: String
    $invertedRules: String
    $simpleRules: String
    $simpleInvertedRules: String
    $advanceRules: String
    $filters: String
  ) {
    Create_Rule(
      id: $id
      name: $name
      description: $description
      severity: $severity
      errorMessage: $errorMessage
      tags: $tags
      schemaType: $schemaType
      primaryKeyName: $primaryKeyName
      customerDefinedId: $customerDefinedId
      projectId: $projectId
      rules: $rules
      invertedRules: $invertedRules
      simpleRules: $simpleRules
      simpleInvertedRules: $simpleInvertedRules
      advanceRules: $advanceRules
      filters: $filters
      schemaCollection: { _directRelation: $projectId }
    ) {
      externalId
    }
    Add_SchemaCollection_rules(endNode: $id, startNode: $projectId) {
      endNode
      startNode
    }
  }
`;
export type CreateRuleMutationFn = Apollo.MutationFunction<
  CreateRuleMutation,
  CreateRuleMutationVariables
>;

/**
 * __useCreateRuleMutation__
 *
 * To run a mutation, you first call `useCreateRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRuleMutation, { data, loading, error }] = useCreateRuleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      description: // value for 'description'
 *      severity: // value for 'severity'
 *      name: // value for 'name'
 *      customerDefinedId: // value for 'customerDefinedId'
 *      projectId: // value for 'projectId'
 *      errorMessage: // value for 'errorMessage'
 *      schemaType: // value for 'schemaType'
 *      primaryKeyName: // value for 'primaryKeyName'
 *      tags: // value for 'tags'
 *      rules: // value for 'rules'
 *      invertedRules: // value for 'invertedRules'
 *      simpleRules: // value for 'simpleRules'
 *      simpleInvertedRules: // value for 'simpleInvertedRules'
 *      advanceRules: // value for 'advanceRules'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useCreateRuleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateRuleMutation,
    CreateRuleMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateRuleMutation, CreateRuleMutationVariables>(
    CreateRuleDocument,
    options
  );
}
export type CreateRuleMutationHookResult = ReturnType<
  typeof useCreateRuleMutation
>;
export type CreateRuleMutationResult =
  Apollo.MutationResult<CreateRuleMutation>;
export type CreateRuleMutationOptions = Apollo.BaseMutationOptions<
  CreateRuleMutation,
  CreateRuleMutationVariables
>;
export const DeleteRuleDocument = gql`
  mutation DeleteRule($id: ID!) {
    Delete_Rule(id: $id) {
      externalId
    }
  }
`;
export type DeleteRuleMutationFn = Apollo.MutationFunction<
  DeleteRuleMutation,
  DeleteRuleMutationVariables
>;

/**
 * __useDeleteRuleMutation__
 *
 * To run a mutation, you first call `useDeleteRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRuleMutation, { data, loading, error }] = useDeleteRuleMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteRuleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteRuleMutation,
    DeleteRuleMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteRuleMutation, DeleteRuleMutationVariables>(
    DeleteRuleDocument,
    options
  );
}
export type DeleteRuleMutationHookResult = ReturnType<
  typeof useDeleteRuleMutation
>;
export type DeleteRuleMutationResult =
  Apollo.MutationResult<DeleteRuleMutation>;
export type DeleteRuleMutationOptions = Apollo.BaseMutationOptions<
  DeleteRuleMutation,
  DeleteRuleMutationVariables
>;
export const UpdateRuleDocument = gql`
  mutation UpdateRule(
    $id: ID!
    $name: String
    $customerDefinedId: String
    $description: String
    $severity: String
    $errorMessage: String
    $schemaType: String
    $primaryKeyName: String
    $tags: [String]
  ) {
    Update_Rule(
      id: $id
      description: $description
      customerDefinedId: $customerDefinedId
      severity: $severity
      errorMessage: $errorMessage
      name: $name
      schemaType: $schemaType
      primaryKeyName: $primaryKeyName
      tags: $tags
    ) {
      externalId
    }
  }
`;
export type UpdateRuleMutationFn = Apollo.MutationFunction<
  UpdateRuleMutation,
  UpdateRuleMutationVariables
>;

/**
 * __useUpdateRuleMutation__
 *
 * To run a mutation, you first call `useUpdateRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRuleMutation, { data, loading, error }] = useUpdateRuleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      customerDefinedId: // value for 'customerDefinedId'
 *      description: // value for 'description'
 *      severity: // value for 'severity'
 *      errorMessage: // value for 'errorMessage'
 *      schemaType: // value for 'schemaType'
 *      primaryKeyName: // value for 'primaryKeyName'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useUpdateRuleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateRuleMutation,
    UpdateRuleMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateRuleMutation, UpdateRuleMutationVariables>(
    UpdateRuleDocument,
    options
  );
}
export type UpdateRuleMutationHookResult = ReturnType<
  typeof useUpdateRuleMutation
>;
export type UpdateRuleMutationResult =
  Apollo.MutationResult<UpdateRuleMutation>;
export type UpdateRuleMutationOptions = Apollo.BaseMutationOptions<
  UpdateRuleMutation,
  UpdateRuleMutationVariables
>;
export const GetMilestonesDocument = gql`
  query GetMilestones($projectId: String!) {
    listMilestone(
      filter: { projectId: { eq: $projectId } }
      sort: { orderIndex: ASC }
    ) {
      items {
        externalId
        description
        endActiveTime
        endScheduleTime
        milestoneType
        name
        orderIndex
        reportTemplate
        schedule
        startActiveTime
        startScheduleTime
        rules(first: 1000) {
          items {
            externalId
            customerDefinedId
            description
            errorMessage
            filters
            invertedRules
            name
            primaryKeyName
            projectId
            rules
            schemaType
            severity
            tags
            rulesets {
              items {
                externalId
                schemaType
              }
            }
          }
        }
        rulesets(first: 1000) {
          items {
            externalId
            description
            filters
            labels
            name
            projectId
            schemaType
          }
        }
      }
    }
  }
`;

/**
 * __useGetMilestonesQuery__
 *
 * To run a query within a React component, call `useGetMilestonesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMilestonesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMilestonesQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetMilestonesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetMilestonesQuery,
    GetMilestonesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetMilestonesQuery, GetMilestonesQueryVariables>(
    GetMilestonesDocument,
    options
  );
}
export function useGetMilestonesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetMilestonesQuery,
    GetMilestonesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetMilestonesQuery, GetMilestonesQueryVariables>(
    GetMilestonesDocument,
    options
  );
}
export type GetMilestonesQueryHookResult = ReturnType<
  typeof useGetMilestonesQuery
>;
export type GetMilestonesLazyQueryHookResult = ReturnType<
  typeof useGetMilestonesLazyQuery
>;
export type GetMilestonesQueryResult = Apollo.QueryResult<
  GetMilestonesQuery,
  GetMilestonesQueryVariables
>;
export const CreateMilestoneDocument = gql`
  mutation CreateMilestone(
    $id: ID!
    $name: String!
    $description: String
    $orderIndex: Int
    $milestoneType: String
    $startActiveTime: Timestamp
    $endActiveTime: Timestamp
    $schedule: String
    $startScheduleTime: Timestamp
    $endScheduleTime: Timestamp
    $projectId: ID!
  ) {
    Create_Milestone(
      id: $id
      name: $name
      description: $description
      projectId: $projectId
      orderIndex: $orderIndex
      milestoneType: $milestoneType
      startActiveTime: $startActiveTime
      endActiveTime: $endActiveTime
      schedule: $schedule
      startScheduleTime: $startScheduleTime
      endScheduleTime: $endScheduleTime
      schemaCollection: { _directRelation: $projectId }
    ) {
      externalId
    }
    Add_SchemaCollection_milestones(endNode: $id, startNode: $projectId) {
      endNode
      startNode
    }
  }
`;
export type CreateMilestoneMutationFn = Apollo.MutationFunction<
  CreateMilestoneMutation,
  CreateMilestoneMutationVariables
>;

/**
 * __useCreateMilestoneMutation__
 *
 * To run a mutation, you first call `useCreateMilestoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMilestoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMilestoneMutation, { data, loading, error }] = useCreateMilestoneMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      orderIndex: // value for 'orderIndex'
 *      milestoneType: // value for 'milestoneType'
 *      startActiveTime: // value for 'startActiveTime'
 *      endActiveTime: // value for 'endActiveTime'
 *      schedule: // value for 'schedule'
 *      startScheduleTime: // value for 'startScheduleTime'
 *      endScheduleTime: // value for 'endScheduleTime'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useCreateMilestoneMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateMilestoneMutation,
    CreateMilestoneMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateMilestoneMutation,
    CreateMilestoneMutationVariables
  >(CreateMilestoneDocument, options);
}
export type CreateMilestoneMutationHookResult = ReturnType<
  typeof useCreateMilestoneMutation
>;
export type CreateMilestoneMutationResult =
  Apollo.MutationResult<CreateMilestoneMutation>;
export type CreateMilestoneMutationOptions = Apollo.BaseMutationOptions<
  CreateMilestoneMutation,
  CreateMilestoneMutationVariables
>;
export const AddSchemaCollectionToDigitalTwinDocument = gql`
  mutation AddSchemaCollectionToDigitalTwin(
    $digitalTwinId: ID!
    $schemaCollectionId: ID!
    $name: String!
    $refId: ID!
    $tenant: String!
  ) {
    Create_SchemaCollection(
      name: $name
      refId: $refId
      tenant: $tenant
      id: $schemaCollectionId
      project: { _directRelation: $digitalTwinId }
    ) {
      externalId
    }
    Add_DigitalTwin_schemaCollections(
      endNode: $schemaCollectionId
      startNode: $digitalTwinId
    ) {
      externalId
    }
  }
`;
export type AddSchemaCollectionToDigitalTwinMutationFn =
  Apollo.MutationFunction<
    AddSchemaCollectionToDigitalTwinMutation,
    AddSchemaCollectionToDigitalTwinMutationVariables
  >;

/**
 * __useAddSchemaCollectionToDigitalTwinMutation__
 *
 * To run a mutation, you first call `useAddSchemaCollectionToDigitalTwinMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSchemaCollectionToDigitalTwinMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSchemaCollectionToDigitalTwinMutation, { data, loading, error }] = useAddSchemaCollectionToDigitalTwinMutation({
 *   variables: {
 *      digitalTwinId: // value for 'digitalTwinId'
 *      schemaCollectionId: // value for 'schemaCollectionId'
 *      name: // value for 'name'
 *      refId: // value for 'refId'
 *      tenant: // value for 'tenant'
 *   },
 * });
 */
export function useAddSchemaCollectionToDigitalTwinMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddSchemaCollectionToDigitalTwinMutation,
    AddSchemaCollectionToDigitalTwinMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AddSchemaCollectionToDigitalTwinMutation,
    AddSchemaCollectionToDigitalTwinMutationVariables
  >(AddSchemaCollectionToDigitalTwinDocument, options);
}
export type AddSchemaCollectionToDigitalTwinMutationHookResult = ReturnType<
  typeof useAddSchemaCollectionToDigitalTwinMutation
>;
export type AddSchemaCollectionToDigitalTwinMutationResult =
  Apollo.MutationResult<AddSchemaCollectionToDigitalTwinMutation>;
export type AddSchemaCollectionToDigitalTwinMutationOptions =
  Apollo.BaseMutationOptions<
    AddSchemaCollectionToDigitalTwinMutation,
    AddSchemaCollectionToDigitalTwinMutationVariables
  >;
export const UpdateSchemaCollectionRefIdDocument = gql`
  mutation UpdateSchemaCollectionRefId(
    $schemaCollectionId: ID!
    $name: String
    $refId: String!
    $tenant: String!
  ) {
    Update_SchemaCollection(
      id: $schemaCollectionId
      name: $name
      refId: $refId
      tenant: $tenant
    ) {
      refId
    }
  }
`;
export type UpdateSchemaCollectionRefIdMutationFn = Apollo.MutationFunction<
  UpdateSchemaCollectionRefIdMutation,
  UpdateSchemaCollectionRefIdMutationVariables
>;

/**
 * __useUpdateSchemaCollectionRefIdMutation__
 *
 * To run a mutation, you first call `useUpdateSchemaCollectionRefIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSchemaCollectionRefIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSchemaCollectionRefIdMutation, { data, loading, error }] = useUpdateSchemaCollectionRefIdMutation({
 *   variables: {
 *      schemaCollectionId: // value for 'schemaCollectionId'
 *      name: // value for 'name'
 *      refId: // value for 'refId'
 *      tenant: // value for 'tenant'
 *   },
 * });
 */
export function useUpdateSchemaCollectionRefIdMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateSchemaCollectionRefIdMutation,
    UpdateSchemaCollectionRefIdMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateSchemaCollectionRefIdMutation,
    UpdateSchemaCollectionRefIdMutationVariables
  >(UpdateSchemaCollectionRefIdDocument, options);
}
export type UpdateSchemaCollectionRefIdMutationHookResult = ReturnType<
  typeof useUpdateSchemaCollectionRefIdMutation
>;
export type UpdateSchemaCollectionRefIdMutationResult =
  Apollo.MutationResult<UpdateSchemaCollectionRefIdMutation>;
export type UpdateSchemaCollectionRefIdMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateSchemaCollectionRefIdMutation,
    UpdateSchemaCollectionRefIdMutationVariables
  >;
export const DeleteMilestoneDocument = gql`
  mutation DeleteMilestone($id: ID!) {
    Delete_Milestone(id: $id) {
      externalId
    }
  }
`;
export type DeleteMilestoneMutationFn = Apollo.MutationFunction<
  DeleteMilestoneMutation,
  DeleteMilestoneMutationVariables
>;

/**
 * __useDeleteMilestoneMutation__
 *
 * To run a mutation, you first call `useDeleteMilestoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMilestoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMilestoneMutation, { data, loading, error }] = useDeleteMilestoneMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMilestoneMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteMilestoneMutation,
    DeleteMilestoneMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteMilestoneMutation,
    DeleteMilestoneMutationVariables
  >(DeleteMilestoneDocument, options);
}
export type DeleteMilestoneMutationHookResult = ReturnType<
  typeof useDeleteMilestoneMutation
>;
export type DeleteMilestoneMutationResult =
  Apollo.MutationResult<DeleteMilestoneMutation>;
export type DeleteMilestoneMutationOptions = Apollo.BaseMutationOptions<
  DeleteMilestoneMutation,
  DeleteMilestoneMutationVariables
>;
export const UpdateMilestoneDocument = gql`
  mutation UpdateMilestone(
    $id: ID!
    $name: String
    $description: String
    $orderIndex: Int
    $milestoneType: String
    $startActiveTime: Timestamp
    $endActiveTime: Timestamp
    $schedule: String
    $startScheduleTime: Timestamp
    $endScheduleTime: Timestamp
  ) {
    Update_Milestone(
      id: $id
      name: $name
      description: $description
      orderIndex: $orderIndex
      milestoneType: $milestoneType
      startActiveTime: $startActiveTime
      endActiveTime: $endActiveTime
      schedule: $schedule
      startScheduleTime: $startScheduleTime
      endScheduleTime: $endScheduleTime
    ) {
      externalId
    }
  }
`;
export type UpdateMilestoneMutationFn = Apollo.MutationFunction<
  UpdateMilestoneMutation,
  UpdateMilestoneMutationVariables
>;

/**
 * __useUpdateMilestoneMutation__
 *
 * To run a mutation, you first call `useUpdateMilestoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMilestoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMilestoneMutation, { data, loading, error }] = useUpdateMilestoneMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      orderIndex: // value for 'orderIndex'
 *      milestoneType: // value for 'milestoneType'
 *      startActiveTime: // value for 'startActiveTime'
 *      endActiveTime: // value for 'endActiveTime'
 *      schedule: // value for 'schedule'
 *      startScheduleTime: // value for 'startScheduleTime'
 *      endScheduleTime: // value for 'endScheduleTime'
 *   },
 * });
 */
export function useUpdateMilestoneMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateMilestoneMutation,
    UpdateMilestoneMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateMilestoneMutation,
    UpdateMilestoneMutationVariables
  >(UpdateMilestoneDocument, options);
}
export type UpdateMilestoneMutationHookResult = ReturnType<
  typeof useUpdateMilestoneMutation
>;
export type UpdateMilestoneMutationResult =
  Apollo.MutationResult<UpdateMilestoneMutation>;
export type UpdateMilestoneMutationOptions = Apollo.BaseMutationOptions<
  UpdateMilestoneMutation,
  UpdateMilestoneMutationVariables
>;
export const AddSchemaCollectionMilestonesDocument = gql`
  mutation AddSchemaCollectionMilestones($endNode: ID!, $startNode: ID!) {
    Add_SchemaCollection_milestones(endNode: $endNode, startNode: $startNode) {
      endNode
      startNode
    }
  }
`;
export type AddSchemaCollectionMilestonesMutationFn = Apollo.MutationFunction<
  AddSchemaCollectionMilestonesMutation,
  AddSchemaCollectionMilestonesMutationVariables
>;

/**
 * __useAddSchemaCollectionMilestonesMutation__
 *
 * To run a mutation, you first call `useAddSchemaCollectionMilestonesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSchemaCollectionMilestonesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSchemaCollectionMilestonesMutation, { data, loading, error }] = useAddSchemaCollectionMilestonesMutation({
 *   variables: {
 *      endNode: // value for 'endNode'
 *      startNode: // value for 'startNode'
 *   },
 * });
 */
export function useAddSchemaCollectionMilestonesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddSchemaCollectionMilestonesMutation,
    AddSchemaCollectionMilestonesMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AddSchemaCollectionMilestonesMutation,
    AddSchemaCollectionMilestonesMutationVariables
  >(AddSchemaCollectionMilestonesDocument, options);
}
export type AddSchemaCollectionMilestonesMutationHookResult = ReturnType<
  typeof useAddSchemaCollectionMilestonesMutation
>;
export type AddSchemaCollectionMilestonesMutationResult =
  Apollo.MutationResult<AddSchemaCollectionMilestonesMutation>;
export type AddSchemaCollectionMilestonesMutationOptions =
  Apollo.BaseMutationOptions<
    AddSchemaCollectionMilestonesMutation,
    AddSchemaCollectionMilestonesMutationVariables
  >;
export const AddMilestoneRulesetsDocument = gql`
  mutation AddMilestoneRulesets($endNode: ID!, $startNode: ID!) {
    Add_Milestone_rulesets(endNode: $endNode, startNode: $startNode) {
      endNode
      startNode
    }
  }
`;
export type AddMilestoneRulesetsMutationFn = Apollo.MutationFunction<
  AddMilestoneRulesetsMutation,
  AddMilestoneRulesetsMutationVariables
>;

/**
 * __useAddMilestoneRulesetsMutation__
 *
 * To run a mutation, you first call `useAddMilestoneRulesetsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMilestoneRulesetsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMilestoneRulesetsMutation, { data, loading, error }] = useAddMilestoneRulesetsMutation({
 *   variables: {
 *      endNode: // value for 'endNode'
 *      startNode: // value for 'startNode'
 *   },
 * });
 */
export function useAddMilestoneRulesetsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddMilestoneRulesetsMutation,
    AddMilestoneRulesetsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AddMilestoneRulesetsMutation,
    AddMilestoneRulesetsMutationVariables
  >(AddMilestoneRulesetsDocument, options);
}
export type AddMilestoneRulesetsMutationHookResult = ReturnType<
  typeof useAddMilestoneRulesetsMutation
>;
export type AddMilestoneRulesetsMutationResult =
  Apollo.MutationResult<AddMilestoneRulesetsMutation>;
export type AddMilestoneRulesetsMutationOptions = Apollo.BaseMutationOptions<
  AddMilestoneRulesetsMutation,
  AddMilestoneRulesetsMutationVariables
>;
export const AddRulesetMilestonesDocument = gql`
  mutation AddRulesetMilestones($endNode: ID!, $startNode: ID!) {
    Add_Ruleset_milestones(endNode: $endNode, startNode: $startNode) {
      endNode
      startNode
    }
  }
`;
export type AddRulesetMilestonesMutationFn = Apollo.MutationFunction<
  AddRulesetMilestonesMutation,
  AddRulesetMilestonesMutationVariables
>;

/**
 * __useAddRulesetMilestonesMutation__
 *
 * To run a mutation, you first call `useAddRulesetMilestonesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddRulesetMilestonesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addRulesetMilestonesMutation, { data, loading, error }] = useAddRulesetMilestonesMutation({
 *   variables: {
 *      endNode: // value for 'endNode'
 *      startNode: // value for 'startNode'
 *   },
 * });
 */
export function useAddRulesetMilestonesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddRulesetMilestonesMutation,
    AddRulesetMilestonesMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AddRulesetMilestonesMutation,
    AddRulesetMilestonesMutationVariables
  >(AddRulesetMilestonesDocument, options);
}
export type AddRulesetMilestonesMutationHookResult = ReturnType<
  typeof useAddRulesetMilestonesMutation
>;
export type AddRulesetMilestonesMutationResult =
  Apollo.MutationResult<AddRulesetMilestonesMutation>;
export type AddRulesetMilestonesMutationOptions = Apollo.BaseMutationOptions<
  AddRulesetMilestonesMutation,
  AddRulesetMilestonesMutationVariables
>;
export const AddMilestoneRulesDocument = gql`
  mutation AddMilestoneRules($endNode: ID!, $startNode: ID!) {
    Add_Milestone_rules(endNode: $endNode, startNode: $startNode) {
      endNode
      startNode
    }
  }
`;
export type AddMilestoneRulesMutationFn = Apollo.MutationFunction<
  AddMilestoneRulesMutation,
  AddMilestoneRulesMutationVariables
>;

/**
 * __useAddMilestoneRulesMutation__
 *
 * To run a mutation, you first call `useAddMilestoneRulesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMilestoneRulesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMilestoneRulesMutation, { data, loading, error }] = useAddMilestoneRulesMutation({
 *   variables: {
 *      endNode: // value for 'endNode'
 *      startNode: // value for 'startNode'
 *   },
 * });
 */
export function useAddMilestoneRulesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddMilestoneRulesMutation,
    AddMilestoneRulesMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AddMilestoneRulesMutation,
    AddMilestoneRulesMutationVariables
  >(AddMilestoneRulesDocument, options);
}
export type AddMilestoneRulesMutationHookResult = ReturnType<
  typeof useAddMilestoneRulesMutation
>;
export type AddMilestoneRulesMutationResult =
  Apollo.MutationResult<AddMilestoneRulesMutation>;
export type AddMilestoneRulesMutationOptions = Apollo.BaseMutationOptions<
  AddMilestoneRulesMutation,
  AddMilestoneRulesMutationVariables
>;
export const UpdateMilestoneReportTemplateDocument = gql`
  mutation UpdateMilestoneReportTemplate(
    $id: ID!
    $name: String!
    $reportTemplate: String!
  ) {
    Update_Milestone(id: $id, name: $name, reportTemplate: $reportTemplate) {
      externalId
    }
  }
`;
export type UpdateMilestoneReportTemplateMutationFn = Apollo.MutationFunction<
  UpdateMilestoneReportTemplateMutation,
  UpdateMilestoneReportTemplateMutationVariables
>;

/**
 * __useUpdateMilestoneReportTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateMilestoneReportTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMilestoneReportTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMilestoneReportTemplateMutation, { data, loading, error }] = useUpdateMilestoneReportTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      reportTemplate: // value for 'reportTemplate'
 *   },
 * });
 */
export function useUpdateMilestoneReportTemplateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateMilestoneReportTemplateMutation,
    UpdateMilestoneReportTemplateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateMilestoneReportTemplateMutation,
    UpdateMilestoneReportTemplateMutationVariables
  >(UpdateMilestoneReportTemplateDocument, options);
}
export type UpdateMilestoneReportTemplateMutationHookResult = ReturnType<
  typeof useUpdateMilestoneReportTemplateMutation
>;
export type UpdateMilestoneReportTemplateMutationResult =
  Apollo.MutationResult<UpdateMilestoneReportTemplateMutation>;
export type UpdateMilestoneReportTemplateMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateMilestoneReportTemplateMutation,
    UpdateMilestoneReportTemplateMutationVariables
  >;
export const AddRuleMilestonesDocument = gql`
  mutation AddRuleMilestones($endNode: ID!, $startNode: ID!) {
    Add_Rule_milestones(endNode: $endNode, startNode: $startNode) {
      endNode
      startNode
    }
  }
`;
export type AddRuleMilestonesMutationFn = Apollo.MutationFunction<
  AddRuleMilestonesMutation,
  AddRuleMilestonesMutationVariables
>;

/**
 * __useAddRuleMilestonesMutation__
 *
 * To run a mutation, you first call `useAddRuleMilestonesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddRuleMilestonesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addRuleMilestonesMutation, { data, loading, error }] = useAddRuleMilestonesMutation({
 *   variables: {
 *      endNode: // value for 'endNode'
 *      startNode: // value for 'startNode'
 *   },
 * });
 */
export function useAddRuleMilestonesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddRuleMilestonesMutation,
    AddRuleMilestonesMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AddRuleMilestonesMutation,
    AddRuleMilestonesMutationVariables
  >(AddRuleMilestonesDocument, options);
}
export type AddRuleMilestonesMutationHookResult = ReturnType<
  typeof useAddRuleMilestonesMutation
>;
export type AddRuleMilestonesMutationResult =
  Apollo.MutationResult<AddRuleMilestonesMutation>;
export type AddRuleMilestonesMutationOptions = Apollo.BaseMutationOptions<
  AddRuleMilestonesMutation,
  AddRuleMilestonesMutationVariables
>;
export const GetCollectionReportsDocument = gql`
  query GetCollectionReports($projectId: ID!) {
    listMilestone(
      first: 1000
      filter: {
        schemaCollection: { project: { externalId: { eq: $projectId } } }
      }
    ) {
      items {
        externalId
        name
        milestoneType
        startActiveTime
        endActiveTime
        orderIndex
        schemaCollection {
          name
          refId
          externalId
        }
        rules(
          first: 1000
          filter: { not: { tags: { containsAny: "_disabled" } } }
        ) {
          items {
            ruleRunStatus(
              first: 1000
              filter: { and: [{ not: { reportId: { eq: "" } } }] }
            ) {
              items {
                runAt
                totalValid
                totalFailed
                reportId
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetCollectionReportsQuery__
 *
 * To run a query within a React component, call `useGetCollectionReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionReportsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetCollectionReportsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCollectionReportsQuery,
    GetCollectionReportsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCollectionReportsQuery,
    GetCollectionReportsQueryVariables
  >(GetCollectionReportsDocument, options);
}
export function useGetCollectionReportsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCollectionReportsQuery,
    GetCollectionReportsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCollectionReportsQuery,
    GetCollectionReportsQueryVariables
  >(GetCollectionReportsDocument, options);
}
export type GetCollectionReportsQueryHookResult = ReturnType<
  typeof useGetCollectionReportsQuery
>;
export type GetCollectionReportsLazyQueryHookResult = ReturnType<
  typeof useGetCollectionReportsLazyQuery
>;
export type GetCollectionReportsQueryResult = Apollo.QueryResult<
  GetCollectionReportsQuery,
  GetCollectionReportsQueryVariables
>;
export const GetCollectionRunReportDocument = gql`
  query GetCollectionRunReport($collectionReportId: String) {
    listRuleRunStatus(
      first: 1000
      filter: {
        and: [
          { reportId: { eq: $collectionReportId } }
          { rule: { not: { tags: { containsAny: "_disabled" } } } }
        ]
      }
    ) {
      items {
        externalId
        totalFailed
        totalValid
        status
        message
        runAt
        rule {
          externalId
          name
          customerDefinedId
          errorMessage
          tags
          severity
          schemaType
          rulesets {
            items {
              schemaType
            }
          }
          milestones {
            items {
              externalId
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetCollectionRunReportQuery__
 *
 * To run a query within a React component, call `useGetCollectionRunReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionRunReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionRunReportQuery({
 *   variables: {
 *      collectionReportId: // value for 'collectionReportId'
 *   },
 * });
 */
export function useGetCollectionRunReportQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetCollectionRunReportQuery,
    GetCollectionRunReportQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCollectionRunReportQuery,
    GetCollectionRunReportQueryVariables
  >(GetCollectionRunReportDocument, options);
}
export function useGetCollectionRunReportLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCollectionRunReportQuery,
    GetCollectionRunReportQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCollectionRunReportQuery,
    GetCollectionRunReportQueryVariables
  >(GetCollectionRunReportDocument, options);
}
export type GetCollectionRunReportQueryHookResult = ReturnType<
  typeof useGetCollectionRunReportQuery
>;
export type GetCollectionRunReportLazyQueryHookResult = ReturnType<
  typeof useGetCollectionRunReportLazyQuery
>;
export type GetCollectionRunReportQueryResult = Apollo.QueryResult<
  GetCollectionRunReportQuery,
  GetCollectionRunReportQueryVariables
>;
export const GetCollectionDetailsReportDocument = gql`
  query GetCollectionDetailsReport($collectionId: ID!) {
    listMilestone(filter: { externalId: { eq: $collectionId } }) {
      items {
        name
        schemaCollection {
          name
          externalId
          refId
        }
        rules(filter: { not: { tags: { containsAny: "_disabled" } } }) {
          items {
            ruleRunStatus(
              filter: { and: [{ not: { reportId: { eq: "" } } }] }
            ) {
              items {
                runAt
                totalValid
                totalFailed
                reportId
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetCollectionDetailsReportQuery__
 *
 * To run a query within a React component, call `useGetCollectionDetailsReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionDetailsReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionDetailsReportQuery({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *   },
 * });
 */
export function useGetCollectionDetailsReportQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCollectionDetailsReportQuery,
    GetCollectionDetailsReportQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCollectionDetailsReportQuery,
    GetCollectionDetailsReportQueryVariables
  >(GetCollectionDetailsReportDocument, options);
}
export function useGetCollectionDetailsReportLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCollectionDetailsReportQuery,
    GetCollectionDetailsReportQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCollectionDetailsReportQuery,
    GetCollectionDetailsReportQueryVariables
  >(GetCollectionDetailsReportDocument, options);
}
export type GetCollectionDetailsReportQueryHookResult = ReturnType<
  typeof useGetCollectionDetailsReportQuery
>;
export type GetCollectionDetailsReportLazyQueryHookResult = ReturnType<
  typeof useGetCollectionDetailsReportLazyQuery
>;
export type GetCollectionDetailsReportQueryResult = Apollo.QueryResult<
  GetCollectionDetailsReportQuery,
  GetCollectionDetailsReportQueryVariables
>;
export const GetRuleDetailsAndHistoryDocument = gql`
  query GetRuleDetailsAndHistory($ruleId: ID) {
    listRule(filter: { externalId: { eq: $ruleId } }) {
      items {
        externalId
        name
        primaryKeyName
        projectId
        tags
        space
        severity
        schemaType
        filters
        rules
        errorMessage
        description
        customerDefinedId
        milestones {
          items {
            schedule
            startActiveTime
            startScheduleTime
            endActiveTime
            endScheduleTime
          }
        }
        rulesets {
          items {
            name
            schemaType
            filters
          }
        }
        ruleRunStatus(filter: { and: [{ not: { reportId: { eq: "" } } }] }) {
          items {
            externalId
            runAt
            totalFailed
            totalValid
            message
            status
          }
        }
      }
    }
  }
`;

/**
 * __useGetRuleDetailsAndHistoryQuery__
 *
 * To run a query within a React component, call `useGetRuleDetailsAndHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRuleDetailsAndHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRuleDetailsAndHistoryQuery({
 *   variables: {
 *      ruleId: // value for 'ruleId'
 *   },
 * });
 */
export function useGetRuleDetailsAndHistoryQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetRuleDetailsAndHistoryQuery,
    GetRuleDetailsAndHistoryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetRuleDetailsAndHistoryQuery,
    GetRuleDetailsAndHistoryQueryVariables
  >(GetRuleDetailsAndHistoryDocument, options);
}
export function useGetRuleDetailsAndHistoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetRuleDetailsAndHistoryQuery,
    GetRuleDetailsAndHistoryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetRuleDetailsAndHistoryQuery,
    GetRuleDetailsAndHistoryQueryVariables
  >(GetRuleDetailsAndHistoryDocument, options);
}
export type GetRuleDetailsAndHistoryQueryHookResult = ReturnType<
  typeof useGetRuleDetailsAndHistoryQuery
>;
export type GetRuleDetailsAndHistoryLazyQueryHookResult = ReturnType<
  typeof useGetRuleDetailsAndHistoryLazyQuery
>;
export type GetRuleDetailsAndHistoryQueryResult = Apollo.QueryResult<
  GetRuleDetailsAndHistoryQuery,
  GetRuleDetailsAndHistoryQueryVariables
>;
export const GetRulesetsDocument = gql`
  query GetRulesets($projectId: String!) {
    listRuleset(filter: { projectId: { eq: $projectId } }) {
      items {
        externalId
        name
        description
        labels
        projectId
        schemaType
        rules {
          items {
            description
            severity
            errorMessage
            externalId
            name
            projectId
            customerDefinedId
            primaryKeyName
            rules
            invertedRules
            filters
            rulesets {
              items {
                externalId
                name
                schemaType
              }
            }
            schemaType
            tags
            milestones {
              items {
                externalId
                name
              }
            }
          }
        }
        filters
        milestones {
          items {
            externalId
            name
          }
        }
      }
    }
  }
`;

/**
 * __useGetRulesetsQuery__
 *
 * To run a query within a React component, call `useGetRulesetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRulesetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRulesetsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetRulesetsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetRulesetsQuery,
    GetRulesetsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetRulesetsQuery, GetRulesetsQueryVariables>(
    GetRulesetsDocument,
    options
  );
}
export function useGetRulesetsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetRulesetsQuery,
    GetRulesetsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetRulesetsQuery, GetRulesetsQueryVariables>(
    GetRulesetsDocument,
    options
  );
}
export type GetRulesetsQueryHookResult = ReturnType<typeof useGetRulesetsQuery>;
export type GetRulesetsLazyQueryHookResult = ReturnType<
  typeof useGetRulesetsLazyQuery
>;
export type GetRulesetsQueryResult = Apollo.QueryResult<
  GetRulesetsQuery,
  GetRulesetsQueryVariables
>;
export const GetRulesetDocument = gql`
  query GetRuleset($id: ID!, $projectId: String!) {
    listRuleset(
      filter: {
        and: [{ externalId: { eq: $id } }, { projectId: { eq: $projectId } }]
      }
    ) {
      items {
        externalId
        name
        description
        labels
        schemaType
        rules {
          items {
            description
            errorMessage
            externalId
            name
            projectId
            customerDefinedId
            severity
            primaryKeyName
            rules
            invertedRules
            filters
            rulesets {
              items {
                externalId
                name
                schemaType
              }
            }
            schemaType
            tags
            milestones {
              items {
                externalId
                name
              }
            }
          }
        }
        filters
        milestones {
          items {
            externalId
            name
          }
        }
      }
    }
  }
`;

/**
 * __useGetRulesetQuery__
 *
 * To run a query within a React component, call `useGetRulesetQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRulesetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRulesetQuery({
 *   variables: {
 *      id: // value for 'id'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetRulesetQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetRulesetQuery,
    GetRulesetQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetRulesetQuery, GetRulesetQueryVariables>(
    GetRulesetDocument,
    options
  );
}
export function useGetRulesetLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetRulesetQuery,
    GetRulesetQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetRulesetQuery, GetRulesetQueryVariables>(
    GetRulesetDocument,
    options
  );
}
export type GetRulesetQueryHookResult = ReturnType<typeof useGetRulesetQuery>;
export type GetRulesetLazyQueryHookResult = ReturnType<
  typeof useGetRulesetLazyQuery
>;
export type GetRulesetQueryResult = Apollo.QueryResult<
  GetRulesetQuery,
  GetRulesetQueryVariables
>;
export const CreateRulesetDocument = gql`
  mutation CreateRuleset(
    $id: ID!
    $name: String!
    $description: String
    $labels: [String]
    $schemaType: String
    $filters: String
    $projectId: ID!
  ) {
    Create_Ruleset(
      name: $name
      id: $id
      description: $description
      labels: $labels
      schemaType: $schemaType
      projectId: $projectId
      filters: $filters
    ) {
      externalId
    }
    Add_SchemaCollection_rulesets(endNode: $id, startNode: $projectId) {
      endNode
      startNode
    }
  }
`;
export type CreateRulesetMutationFn = Apollo.MutationFunction<
  CreateRulesetMutation,
  CreateRulesetMutationVariables
>;

/**
 * __useCreateRulesetMutation__
 *
 * To run a mutation, you first call `useCreateRulesetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRulesetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRulesetMutation, { data, loading, error }] = useCreateRulesetMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      labels: // value for 'labels'
 *      schemaType: // value for 'schemaType'
 *      filters: // value for 'filters'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useCreateRulesetMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateRulesetMutation,
    CreateRulesetMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateRulesetMutation,
    CreateRulesetMutationVariables
  >(CreateRulesetDocument, options);
}
export type CreateRulesetMutationHookResult = ReturnType<
  typeof useCreateRulesetMutation
>;
export type CreateRulesetMutationResult =
  Apollo.MutationResult<CreateRulesetMutation>;
export type CreateRulesetMutationOptions = Apollo.BaseMutationOptions<
  CreateRulesetMutation,
  CreateRulesetMutationVariables
>;
export const DeleteRulesetDocument = gql`
  mutation DeleteRuleset($id: ID!) {
    Delete_Ruleset(id: $id) {
      externalId
    }
  }
`;
export type DeleteRulesetMutationFn = Apollo.MutationFunction<
  DeleteRulesetMutation,
  DeleteRulesetMutationVariables
>;

/**
 * __useDeleteRulesetMutation__
 *
 * To run a mutation, you first call `useDeleteRulesetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRulesetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRulesetMutation, { data, loading, error }] = useDeleteRulesetMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteRulesetMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteRulesetMutation,
    DeleteRulesetMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteRulesetMutation,
    DeleteRulesetMutationVariables
  >(DeleteRulesetDocument, options);
}
export type DeleteRulesetMutationHookResult = ReturnType<
  typeof useDeleteRulesetMutation
>;
export type DeleteRulesetMutationResult =
  Apollo.MutationResult<DeleteRulesetMutation>;
export type DeleteRulesetMutationOptions = Apollo.BaseMutationOptions<
  DeleteRulesetMutation,
  DeleteRulesetMutationVariables
>;
export const UpdateRulesetDocument = gql`
  mutation UpdateRuleset(
    $id: ID!
    $name: String!
    $description: String
    $labels: [String]
    $schemaType: String
    $filters: String
  ) {
    Update_Ruleset(
      id: $id
      name: $name
      description: $description
      labels: $labels
      schemaType: $schemaType
      filters: $filters
    ) {
      externalId
    }
  }
`;
export type UpdateRulesetMutationFn = Apollo.MutationFunction<
  UpdateRulesetMutation,
  UpdateRulesetMutationVariables
>;

/**
 * __useUpdateRulesetMutation__
 *
 * To run a mutation, you first call `useUpdateRulesetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRulesetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRulesetMutation, { data, loading, error }] = useUpdateRulesetMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      labels: // value for 'labels'
 *      schemaType: // value for 'schemaType'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useUpdateRulesetMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateRulesetMutation,
    UpdateRulesetMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateRulesetMutation,
    UpdateRulesetMutationVariables
  >(UpdateRulesetDocument, options);
}
export type UpdateRulesetMutationHookResult = ReturnType<
  typeof useUpdateRulesetMutation
>;
export type UpdateRulesetMutationResult =
  Apollo.MutationResult<UpdateRulesetMutation>;
export type UpdateRulesetMutationOptions = Apollo.BaseMutationOptions<
  UpdateRulesetMutation,
  UpdateRulesetMutationVariables
>;
export const AddSchemaCollectionRulesetsDocument = gql`
  mutation AddSchemaCollectionRulesets($endNode: ID!, $startNode: ID!) {
    Add_SchemaCollection_rulesets(endNode: $endNode, startNode: $startNode) {
      endNode
      startNode
    }
  }
`;
export type AddSchemaCollectionRulesetsMutationFn = Apollo.MutationFunction<
  AddSchemaCollectionRulesetsMutation,
  AddSchemaCollectionRulesetsMutationVariables
>;

/**
 * __useAddSchemaCollectionRulesetsMutation__
 *
 * To run a mutation, you first call `useAddSchemaCollectionRulesetsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSchemaCollectionRulesetsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSchemaCollectionRulesetsMutation, { data, loading, error }] = useAddSchemaCollectionRulesetsMutation({
 *   variables: {
 *      endNode: // value for 'endNode'
 *      startNode: // value for 'startNode'
 *   },
 * });
 */
export function useAddSchemaCollectionRulesetsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddSchemaCollectionRulesetsMutation,
    AddSchemaCollectionRulesetsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AddSchemaCollectionRulesetsMutation,
    AddSchemaCollectionRulesetsMutationVariables
  >(AddSchemaCollectionRulesetsDocument, options);
}
export type AddSchemaCollectionRulesetsMutationHookResult = ReturnType<
  typeof useAddSchemaCollectionRulesetsMutation
>;
export type AddSchemaCollectionRulesetsMutationResult =
  Apollo.MutationResult<AddSchemaCollectionRulesetsMutation>;
export type AddSchemaCollectionRulesetsMutationOptions =
  Apollo.BaseMutationOptions<
    AddSchemaCollectionRulesetsMutation,
    AddSchemaCollectionRulesetsMutationVariables
  >;
export const AddSchemaCollectionRulesDocument = gql`
  mutation AddSchemaCollectionRules($endNode: ID!, $startNode: ID!) {
    Add_SchemaCollection_rules(endNode: $endNode, startNode: $startNode) {
      endNode
      startNode
    }
  }
`;
export type AddSchemaCollectionRulesMutationFn = Apollo.MutationFunction<
  AddSchemaCollectionRulesMutation,
  AddSchemaCollectionRulesMutationVariables
>;

/**
 * __useAddSchemaCollectionRulesMutation__
 *
 * To run a mutation, you first call `useAddSchemaCollectionRulesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSchemaCollectionRulesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSchemaCollectionRulesMutation, { data, loading, error }] = useAddSchemaCollectionRulesMutation({
 *   variables: {
 *      endNode: // value for 'endNode'
 *      startNode: // value for 'startNode'
 *   },
 * });
 */
export function useAddSchemaCollectionRulesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddSchemaCollectionRulesMutation,
    AddSchemaCollectionRulesMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AddSchemaCollectionRulesMutation,
    AddSchemaCollectionRulesMutationVariables
  >(AddSchemaCollectionRulesDocument, options);
}
export type AddSchemaCollectionRulesMutationHookResult = ReturnType<
  typeof useAddSchemaCollectionRulesMutation
>;
export type AddSchemaCollectionRulesMutationResult =
  Apollo.MutationResult<AddSchemaCollectionRulesMutation>;
export type AddSchemaCollectionRulesMutationOptions =
  Apollo.BaseMutationOptions<
    AddSchemaCollectionRulesMutation,
    AddSchemaCollectionRulesMutationVariables
  >;
export const AddRulesetRulesDocument = gql`
  mutation AddRulesetRules($endNode: ID!, $startNode: ID!) {
    Add_Ruleset_rules(endNode: $endNode, startNode: $startNode) {
      endNode
      startNode
    }
  }
`;
export type AddRulesetRulesMutationFn = Apollo.MutationFunction<
  AddRulesetRulesMutation,
  AddRulesetRulesMutationVariables
>;

/**
 * __useAddRulesetRulesMutation__
 *
 * To run a mutation, you first call `useAddRulesetRulesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddRulesetRulesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addRulesetRulesMutation, { data, loading, error }] = useAddRulesetRulesMutation({
 *   variables: {
 *      endNode: // value for 'endNode'
 *      startNode: // value for 'startNode'
 *   },
 * });
 */
export function useAddRulesetRulesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddRulesetRulesMutation,
    AddRulesetRulesMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AddRulesetRulesMutation,
    AddRulesetRulesMutationVariables
  >(AddRulesetRulesDocument, options);
}
export type AddRulesetRulesMutationHookResult = ReturnType<
  typeof useAddRulesetRulesMutation
>;
export type AddRulesetRulesMutationResult =
  Apollo.MutationResult<AddRulesetRulesMutation>;
export type AddRulesetRulesMutationOptions = Apollo.BaseMutationOptions<
  AddRulesetRulesMutation,
  AddRulesetRulesMutationVariables
>;
export const AddRuleRulesetsDocument = gql`
  mutation AddRuleRulesets($endNode: ID!, $startNode: ID!) {
    Add_Rule_rulesets(endNode: $endNode, startNode: $startNode) {
      endNode
      startNode
    }
  }
`;
export type AddRuleRulesetsMutationFn = Apollo.MutationFunction<
  AddRuleRulesetsMutation,
  AddRuleRulesetsMutationVariables
>;

/**
 * __useAddRuleRulesetsMutation__
 *
 * To run a mutation, you first call `useAddRuleRulesetsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddRuleRulesetsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addRuleRulesetsMutation, { data, loading, error }] = useAddRuleRulesetsMutation({
 *   variables: {
 *      endNode: // value for 'endNode'
 *      startNode: // value for 'startNode'
 *   },
 * });
 */
export function useAddRuleRulesetsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddRuleRulesetsMutation,
    AddRuleRulesetsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AddRuleRulesetsMutation,
    AddRuleRulesetsMutationVariables
  >(AddRuleRulesetsDocument, options);
}
export type AddRuleRulesetsMutationHookResult = ReturnType<
  typeof useAddRuleRulesetsMutation
>;
export type AddRuleRulesetsMutationResult =
  Apollo.MutationResult<AddRuleRulesetsMutation>;
export type AddRuleRulesetsMutationOptions = Apollo.BaseMutationOptions<
  AddRuleRulesetsMutation,
  AddRuleRulesetsMutationVariables
>;
export const RemoveMilestoneRulesetsDocument = gql`
  mutation RemoveMilestoneRulesets($endNode: ID!, $startNode: ID!) {
    Remove_Milestone_rulesets(endNode: $endNode, startNode: $startNode) {
      endNode
      startNode
    }
  }
`;
export type RemoveMilestoneRulesetsMutationFn = Apollo.MutationFunction<
  RemoveMilestoneRulesetsMutation,
  RemoveMilestoneRulesetsMutationVariables
>;

/**
 * __useRemoveMilestoneRulesetsMutation__
 *
 * To run a mutation, you first call `useRemoveMilestoneRulesetsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMilestoneRulesetsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeMilestoneRulesetsMutation, { data, loading, error }] = useRemoveMilestoneRulesetsMutation({
 *   variables: {
 *      endNode: // value for 'endNode'
 *      startNode: // value for 'startNode'
 *   },
 * });
 */
export function useRemoveMilestoneRulesetsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveMilestoneRulesetsMutation,
    RemoveMilestoneRulesetsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemoveMilestoneRulesetsMutation,
    RemoveMilestoneRulesetsMutationVariables
  >(RemoveMilestoneRulesetsDocument, options);
}
export type RemoveMilestoneRulesetsMutationHookResult = ReturnType<
  typeof useRemoveMilestoneRulesetsMutation
>;
export type RemoveMilestoneRulesetsMutationResult =
  Apollo.MutationResult<RemoveMilestoneRulesetsMutation>;
export type RemoveMilestoneRulesetsMutationOptions = Apollo.BaseMutationOptions<
  RemoveMilestoneRulesetsMutation,
  RemoveMilestoneRulesetsMutationVariables
>;
export const RemoveRulesetMilestonesDocument = gql`
  mutation RemoveRulesetMilestones($endNode: ID!, $startNode: ID!) {
    Remove_Ruleset_milestones(endNode: $endNode, startNode: $startNode) {
      endNode
      startNode
    }
  }
`;
export type RemoveRulesetMilestonesMutationFn = Apollo.MutationFunction<
  RemoveRulesetMilestonesMutation,
  RemoveRulesetMilestonesMutationVariables
>;

/**
 * __useRemoveRulesetMilestonesMutation__
 *
 * To run a mutation, you first call `useRemoveRulesetMilestonesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveRulesetMilestonesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeRulesetMilestonesMutation, { data, loading, error }] = useRemoveRulesetMilestonesMutation({
 *   variables: {
 *      endNode: // value for 'endNode'
 *      startNode: // value for 'startNode'
 *   },
 * });
 */
export function useRemoveRulesetMilestonesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveRulesetMilestonesMutation,
    RemoveRulesetMilestonesMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemoveRulesetMilestonesMutation,
    RemoveRulesetMilestonesMutationVariables
  >(RemoveRulesetMilestonesDocument, options);
}
export type RemoveRulesetMilestonesMutationHookResult = ReturnType<
  typeof useRemoveRulesetMilestonesMutation
>;
export type RemoveRulesetMilestonesMutationResult =
  Apollo.MutationResult<RemoveRulesetMilestonesMutation>;
export type RemoveRulesetMilestonesMutationOptions = Apollo.BaseMutationOptions<
  RemoveRulesetMilestonesMutation,
  RemoveRulesetMilestonesMutationVariables
>;
export const RemoveMilestoneRulesDocument = gql`
  mutation RemoveMilestoneRules($endNode: ID!, $startNode: ID!) {
    Remove_Milestone_rules(endNode: $endNode, startNode: $startNode) {
      endNode
      startNode
    }
  }
`;
export type RemoveMilestoneRulesMutationFn = Apollo.MutationFunction<
  RemoveMilestoneRulesMutation,
  RemoveMilestoneRulesMutationVariables
>;

/**
 * __useRemoveMilestoneRulesMutation__
 *
 * To run a mutation, you first call `useRemoveMilestoneRulesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMilestoneRulesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeMilestoneRulesMutation, { data, loading, error }] = useRemoveMilestoneRulesMutation({
 *   variables: {
 *      endNode: // value for 'endNode'
 *      startNode: // value for 'startNode'
 *   },
 * });
 */
export function useRemoveMilestoneRulesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveMilestoneRulesMutation,
    RemoveMilestoneRulesMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemoveMilestoneRulesMutation,
    RemoveMilestoneRulesMutationVariables
  >(RemoveMilestoneRulesDocument, options);
}
export type RemoveMilestoneRulesMutationHookResult = ReturnType<
  typeof useRemoveMilestoneRulesMutation
>;
export type RemoveMilestoneRulesMutationResult =
  Apollo.MutationResult<RemoveMilestoneRulesMutation>;
export type RemoveMilestoneRulesMutationOptions = Apollo.BaseMutationOptions<
  RemoveMilestoneRulesMutation,
  RemoveMilestoneRulesMutationVariables
>;
export const RemoveRuleMilestonesDocument = gql`
  mutation RemoveRuleMilestones($endNode: ID!, $startNode: ID!) {
    Remove_Rule_milestones(endNode: $endNode, startNode: $startNode) {
      endNode
      startNode
    }
  }
`;
export type RemoveRuleMilestonesMutationFn = Apollo.MutationFunction<
  RemoveRuleMilestonesMutation,
  RemoveRuleMilestonesMutationVariables
>;

/**
 * __useRemoveRuleMilestonesMutation__
 *
 * To run a mutation, you first call `useRemoveRuleMilestonesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveRuleMilestonesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeRuleMilestonesMutation, { data, loading, error }] = useRemoveRuleMilestonesMutation({
 *   variables: {
 *      endNode: // value for 'endNode'
 *      startNode: // value for 'startNode'
 *   },
 * });
 */
export function useRemoveRuleMilestonesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveRuleMilestonesMutation,
    RemoveRuleMilestonesMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemoveRuleMilestonesMutation,
    RemoveRuleMilestonesMutationVariables
  >(RemoveRuleMilestonesDocument, options);
}
export type RemoveRuleMilestonesMutationHookResult = ReturnType<
  typeof useRemoveRuleMilestonesMutation
>;
export type RemoveRuleMilestonesMutationResult =
  Apollo.MutationResult<RemoveRuleMilestonesMutation>;
export type RemoveRuleMilestonesMutationOptions = Apollo.BaseMutationOptions<
  RemoveRuleMilestonesMutation,
  RemoveRuleMilestonesMutationVariables
>;
export const RemoveEdgeRuleMilestoneDocument = gql`
  mutation RemoveEdgeRuleMilestone($endNode: ID!, $startNode: ID!) {
    Remove_Milestone_rules(endNode: $endNode, startNode: $startNode) {
      endNode
      startNode
    }
    Remove_Rule_milestones(endNode: $endNode, startNode: $startNode) {
      endNode
      startNode
    }
  }
`;
export type RemoveEdgeRuleMilestoneMutationFn = Apollo.MutationFunction<
  RemoveEdgeRuleMilestoneMutation,
  RemoveEdgeRuleMilestoneMutationVariables
>;

/**
 * __useRemoveEdgeRuleMilestoneMutation__
 *
 * To run a mutation, you first call `useRemoveEdgeRuleMilestoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveEdgeRuleMilestoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeEdgeRuleMilestoneMutation, { data, loading, error }] = useRemoveEdgeRuleMilestoneMutation({
 *   variables: {
 *      endNode: // value for 'endNode'
 *      startNode: // value for 'startNode'
 *   },
 * });
 */
export function useRemoveEdgeRuleMilestoneMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveEdgeRuleMilestoneMutation,
    RemoveEdgeRuleMilestoneMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemoveEdgeRuleMilestoneMutation,
    RemoveEdgeRuleMilestoneMutationVariables
  >(RemoveEdgeRuleMilestoneDocument, options);
}
export type RemoveEdgeRuleMilestoneMutationHookResult = ReturnType<
  typeof useRemoveEdgeRuleMilestoneMutation
>;
export type RemoveEdgeRuleMilestoneMutationResult =
  Apollo.MutationResult<RemoveEdgeRuleMilestoneMutation>;
export type RemoveEdgeRuleMilestoneMutationOptions = Apollo.BaseMutationOptions<
  RemoveEdgeRuleMilestoneMutation,
  RemoveEdgeRuleMilestoneMutationVariables
>;
export const GetAccessDocument = gql`
  query GetAccess($first: Int = 50, $cursor: String = null) {
    listAccess(first: $first, after: $cursor) {
      items {
        externalId
        userId
        role
        tenant
      }
      pageInfo {
        startCursor
        endCursor
      }
    }
  }
`;

/**
 * __useGetAccessQuery__
 *
 * To run a query within a React component, call `useGetAccessQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccessQuery({
 *   variables: {
 *      first: // value for 'first'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useGetAccessQuery(
  baseOptions?: Apollo.QueryHookOptions<GetAccessQuery, GetAccessQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAccessQuery, GetAccessQueryVariables>(
    GetAccessDocument,
    options
  );
}
export function useGetAccessLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAccessQuery,
    GetAccessQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAccessQuery, GetAccessQueryVariables>(
    GetAccessDocument,
    options
  );
}
export type GetAccessQueryHookResult = ReturnType<typeof useGetAccessQuery>;
export type GetAccessLazyQueryHookResult = ReturnType<
  typeof useGetAccessLazyQuery
>;
export type GetAccessQueryResult = Apollo.QueryResult<
  GetAccessQuery,
  GetAccessQueryVariables
>;
export const CountAccessDocument = gql`
  query CountAccess {
    aggregateAccess {
      items {
        count {
          externalId
        }
      }
    }
  }
`;

/**
 * __useCountAccessQuery__
 *
 * To run a query within a React component, call `useCountAccessQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountAccessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountAccessQuery({
 *   variables: {
 *   },
 * });
 */
export function useCountAccessQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CountAccessQuery,
    CountAccessQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CountAccessQuery, CountAccessQueryVariables>(
    CountAccessDocument,
    options
  );
}
export function useCountAccessLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CountAccessQuery,
    CountAccessQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CountAccessQuery, CountAccessQueryVariables>(
    CountAccessDocument,
    options
  );
}
export type CountAccessQueryHookResult = ReturnType<typeof useCountAccessQuery>;
export type CountAccessLazyQueryHookResult = ReturnType<
  typeof useCountAccessLazyQuery
>;
export type CountAccessQueryResult = Apollo.QueryResult<
  CountAccessQuery,
  CountAccessQueryVariables
>;
export const CreateAccessDocument = gql`
  mutation CreateAccess(
    $id: ID
    $userId: String!
    $role: String!
    $tenant: String!
  ) {
    Create_Access(id: $id, userId: $userId, role: $role, tenant: $tenant) {
      externalId
    }
  }
`;
export type CreateAccessMutationFn = Apollo.MutationFunction<
  CreateAccessMutation,
  CreateAccessMutationVariables
>;

/**
 * __useCreateAccessMutation__
 *
 * To run a mutation, you first call `useCreateAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAccessMutation, { data, loading, error }] = useCreateAccessMutation({
 *   variables: {
 *      id: // value for 'id'
 *      userId: // value for 'userId'
 *      role: // value for 'role'
 *      tenant: // value for 'tenant'
 *   },
 * });
 */
export function useCreateAccessMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateAccessMutation,
    CreateAccessMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateAccessMutation,
    CreateAccessMutationVariables
  >(CreateAccessDocument, options);
}
export type CreateAccessMutationHookResult = ReturnType<
  typeof useCreateAccessMutation
>;
export type CreateAccessMutationResult =
  Apollo.MutationResult<CreateAccessMutation>;
export type CreateAccessMutationOptions = Apollo.BaseMutationOptions<
  CreateAccessMutation,
  CreateAccessMutationVariables
>;
export const DeleteAccessDocument = gql`
  mutation DeleteAccess($id: ID!) {
    Delete_Access(id: $id) {
      externalId
    }
  }
`;
export type DeleteAccessMutationFn = Apollo.MutationFunction<
  DeleteAccessMutation,
  DeleteAccessMutationVariables
>;

/**
 * __useDeleteAccessMutation__
 *
 * To run a mutation, you first call `useDeleteAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAccessMutation, { data, loading, error }] = useDeleteAccessMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAccessMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteAccessMutation,
    DeleteAccessMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteAccessMutation,
    DeleteAccessMutationVariables
  >(DeleteAccessDocument, options);
}
export type DeleteAccessMutationHookResult = ReturnType<
  typeof useDeleteAccessMutation
>;
export type DeleteAccessMutationResult =
  Apollo.MutationResult<DeleteAccessMutation>;
export type DeleteAccessMutationOptions = Apollo.BaseMutationOptions<
  DeleteAccessMutation,
  DeleteAccessMutationVariables
>;
export const UpdateAccessDocument = gql`
  mutation UpdateAccess($id: ID!, $userId: String!, $role: String!) {
    Update_Access(id: $id, role: $role, userId: $userId, tenant: "") {
      externalId
    }
  }
`;
export type UpdateAccessMutationFn = Apollo.MutationFunction<
  UpdateAccessMutation,
  UpdateAccessMutationVariables
>;

/**
 * __useUpdateAccessMutation__
 *
 * To run a mutation, you first call `useUpdateAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccessMutation, { data, loading, error }] = useUpdateAccessMutation({
 *   variables: {
 *      id: // value for 'id'
 *      userId: // value for 'userId'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useUpdateAccessMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateAccessMutation,
    UpdateAccessMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateAccessMutation,
    UpdateAccessMutationVariables
  >(UpdateAccessDocument, options);
}
export type UpdateAccessMutationHookResult = ReturnType<
  typeof useUpdateAccessMutation
>;
export type UpdateAccessMutationResult =
  Apollo.MutationResult<UpdateAccessMutation>;
export type UpdateAccessMutationOptions = Apollo.BaseMutationOptions<
  UpdateAccessMutation,
  UpdateAccessMutationVariables
>;
export const ToggleDisableRuleDocument = gql`
  mutation toggleDisableRule($id: ID!, $tags: [String]) {
    Update_Rule(id: $id, tags: $tags) {
      externalId
    }
  }
`;
export type ToggleDisableRuleMutationFn = Apollo.MutationFunction<
  ToggleDisableRuleMutation,
  ToggleDisableRuleMutationVariables
>;

/**
 * __useToggleDisableRuleMutation__
 *
 * To run a mutation, you first call `useToggleDisableRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleDisableRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleDisableRuleMutation, { data, loading, error }] = useToggleDisableRuleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useToggleDisableRuleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ToggleDisableRuleMutation,
    ToggleDisableRuleMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ToggleDisableRuleMutation,
    ToggleDisableRuleMutationVariables
  >(ToggleDisableRuleDocument, options);
}
export type ToggleDisableRuleMutationHookResult = ReturnType<
  typeof useToggleDisableRuleMutation
>;
export type ToggleDisableRuleMutationResult =
  Apollo.MutationResult<ToggleDisableRuleMutation>;
export type ToggleDisableRuleMutationOptions = Apollo.BaseMutationOptions<
  ToggleDisableRuleMutation,
  ToggleDisableRuleMutationVariables
>;
export const GetAllRuleRunStatusDocument = gql`
  query GetAllRuleRunStatus($schemaIds: [ID!], $cursor: String) {
    listRuleRunStatus(
      after: $cursor
      first: 1000
      filter: { rule: { schemaCollection: { externalId: { in: $schemaIds } } } }
    ) {
      items {
        externalId
      }
      pageInfo {
        hasNextPage
        startCursor
        endCursor
      }
    }
  }
`;

/**
 * __useGetAllRuleRunStatusQuery__
 *
 * To run a query within a React component, call `useGetAllRuleRunStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRuleRunStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRuleRunStatusQuery({
 *   variables: {
 *      schemaIds: // value for 'schemaIds'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useGetAllRuleRunStatusQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAllRuleRunStatusQuery,
    GetAllRuleRunStatusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAllRuleRunStatusQuery,
    GetAllRuleRunStatusQueryVariables
  >(GetAllRuleRunStatusDocument, options);
}
export function useGetAllRuleRunStatusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAllRuleRunStatusQuery,
    GetAllRuleRunStatusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAllRuleRunStatusQuery,
    GetAllRuleRunStatusQueryVariables
  >(GetAllRuleRunStatusDocument, options);
}
export type GetAllRuleRunStatusQueryHookResult = ReturnType<
  typeof useGetAllRuleRunStatusQuery
>;
export type GetAllRuleRunStatusLazyQueryHookResult = ReturnType<
  typeof useGetAllRuleRunStatusLazyQuery
>;
export type GetAllRuleRunStatusQueryResult = Apollo.QueryResult<
  GetAllRuleRunStatusQuery,
  GetAllRuleRunStatusQueryVariables
>;
export const GetConsistencyCollectionsDocument = gql`
  query GetConsistencyCollections($projectId: String!) {
    listConsistencyCollection(
      first: 1000
      filter: { projectId: { eq: $projectId } }
    ) {
      items {
        externalId
        name
        description
        tenant
        projectId
        createdAt
        labels
        reportTemplate
        schemaFilters(first: 100) {
          items {
            externalId
            name
            description
            labels
            schemaType
            schemaCollectionId
            filters
            projectId
          }
        }
        rules(first: 1000) {
          items {
            externalId
            name
            customerDefinedId
            description
            sourceAttribute
            sourceFilters
            operator
            targetAttribute
            targetFilters
            severity
            errorMessage
            tags
            conditionChecksOnly
            projectId
            sourceSchemaFilter {
              externalId
              name
            }
            targetSchemaFilter {
              externalId
              name
            }
            conditionChecks(first: 100) {
              items {
                externalId
                sourceAttribute
                operator
                targetAttribute
                isLiteralValue
                useTargetSchema
              }
            }
            runStatuses(first: 10, sort: { runAt: DESC }) {
              items {
                externalId
                totalValid
                totalFailed
                status
                runAt
                reportId
                message
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetConsistencyCollectionsQuery__
 *
 * To run a query within a React component, call `useGetConsistencyCollectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConsistencyCollectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConsistencyCollectionsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetConsistencyCollectionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetConsistencyCollectionsQuery,
    GetConsistencyCollectionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetConsistencyCollectionsQuery,
    GetConsistencyCollectionsQueryVariables
  >(GetConsistencyCollectionsDocument, options);
}
export function useGetConsistencyCollectionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetConsistencyCollectionsQuery,
    GetConsistencyCollectionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetConsistencyCollectionsQuery,
    GetConsistencyCollectionsQueryVariables
  >(GetConsistencyCollectionsDocument, options);
}
export type GetConsistencyCollectionsQueryHookResult = ReturnType<
  typeof useGetConsistencyCollectionsQuery
>;
export type GetConsistencyCollectionsLazyQueryHookResult = ReturnType<
  typeof useGetConsistencyCollectionsLazyQuery
>;
export type GetConsistencyCollectionsQueryResult = Apollo.QueryResult<
  GetConsistencyCollectionsQuery,
  GetConsistencyCollectionsQueryVariables
>;
export const GetConsistencyReportDocument = gql`
  query GetConsistencyReport($reportId: String!) {
    listConsistencyRunStatus(
      first: 1000
      filter: { reportId: { eq: $reportId } }
    ) {
      items {
        externalId
        totalValid
        totalFailed
        status
        runAt
        reportId
        message
        rule {
          externalId
          name
          operator
          sourceAttribute
          targetAttribute
          severity
          errorMessage
          sourceSchemaFilter {
            externalId
            name
          }
          targetSchemaFilter {
            externalId
            name
          }
          collection {
            externalId
            name
            schemaFilters(first: 100) {
              items {
                schemaType
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetConsistencyReportQuery__
 *
 * To run a query within a React component, call `useGetConsistencyReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConsistencyReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConsistencyReportQuery({
 *   variables: {
 *      reportId: // value for 'reportId'
 *   },
 * });
 */
export function useGetConsistencyReportQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetConsistencyReportQuery,
    GetConsistencyReportQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetConsistencyReportQuery,
    GetConsistencyReportQueryVariables
  >(GetConsistencyReportDocument, options);
}
export function useGetConsistencyReportLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetConsistencyReportQuery,
    GetConsistencyReportQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetConsistencyReportQuery,
    GetConsistencyReportQueryVariables
  >(GetConsistencyReportDocument, options);
}
export type GetConsistencyReportQueryHookResult = ReturnType<
  typeof useGetConsistencyReportQuery
>;
export type GetConsistencyReportLazyQueryHookResult = ReturnType<
  typeof useGetConsistencyReportLazyQuery
>;
export type GetConsistencyReportQueryResult = Apollo.QueryResult<
  GetConsistencyReportQuery,
  GetConsistencyReportQueryVariables
>;
export const CreateConsistencyCollectionDocument = gql`
  mutation CreateConsistencyCollection(
    $id: ID!
    $name: String!
    $description: String
    $tenant: String!
    $labels: [String]
    $projectId: String!
    $digitalTwinId: ID!
  ) {
    Create_ConsistencyCollection(
      id: $id
      name: $name
      description: $description
      tenant: $tenant
      projectId: $projectId
      labels: $labels
      project: { _directRelation: $digitalTwinId }
    ) {
      externalId
    }
    Add_DigitalTwin_consistencyCollections(
      endNode: $id
      startNode: $digitalTwinId
    ) {
      endNode
      startNode
    }
  }
`;
export type CreateConsistencyCollectionMutationFn = Apollo.MutationFunction<
  CreateConsistencyCollectionMutation,
  CreateConsistencyCollectionMutationVariables
>;

/**
 * __useCreateConsistencyCollectionMutation__
 *
 * To run a mutation, you first call `useCreateConsistencyCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateConsistencyCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createConsistencyCollectionMutation, { data, loading, error }] = useCreateConsistencyCollectionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      tenant: // value for 'tenant'
 *      labels: // value for 'labels'
 *      projectId: // value for 'projectId'
 *      digitalTwinId: // value for 'digitalTwinId'
 *   },
 * });
 */
export function useCreateConsistencyCollectionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateConsistencyCollectionMutation,
    CreateConsistencyCollectionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateConsistencyCollectionMutation,
    CreateConsistencyCollectionMutationVariables
  >(CreateConsistencyCollectionDocument, options);
}
export type CreateConsistencyCollectionMutationHookResult = ReturnType<
  typeof useCreateConsistencyCollectionMutation
>;
export type CreateConsistencyCollectionMutationResult =
  Apollo.MutationResult<CreateConsistencyCollectionMutation>;
export type CreateConsistencyCollectionMutationOptions =
  Apollo.BaseMutationOptions<
    CreateConsistencyCollectionMutation,
    CreateConsistencyCollectionMutationVariables
  >;
export const UpdateConsistencyCollectionDocument = gql`
  mutation UpdateConsistencyCollection(
    $id: ID!
    $name: String
    $description: String
    $labels: [String]
    $reportTemplate: String
  ) {
    Update_ConsistencyCollection(
      id: $id
      name: $name
      description: $description
      labels: $labels
      reportTemplate: $reportTemplate
    ) {
      externalId
    }
  }
`;
export type UpdateConsistencyCollectionMutationFn = Apollo.MutationFunction<
  UpdateConsistencyCollectionMutation,
  UpdateConsistencyCollectionMutationVariables
>;

/**
 * __useUpdateConsistencyCollectionMutation__
 *
 * To run a mutation, you first call `useUpdateConsistencyCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateConsistencyCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateConsistencyCollectionMutation, { data, loading, error }] = useUpdateConsistencyCollectionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      labels: // value for 'labels'
 *      reportTemplate: // value for 'reportTemplate'
 *   },
 * });
 */
export function useUpdateConsistencyCollectionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateConsistencyCollectionMutation,
    UpdateConsistencyCollectionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateConsistencyCollectionMutation,
    UpdateConsistencyCollectionMutationVariables
  >(UpdateConsistencyCollectionDocument, options);
}
export type UpdateConsistencyCollectionMutationHookResult = ReturnType<
  typeof useUpdateConsistencyCollectionMutation
>;
export type UpdateConsistencyCollectionMutationResult =
  Apollo.MutationResult<UpdateConsistencyCollectionMutation>;
export type UpdateConsistencyCollectionMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateConsistencyCollectionMutation,
    UpdateConsistencyCollectionMutationVariables
  >;
export const DeleteConsistencyCollectionDocument = gql`
  mutation DeleteConsistencyCollection($id: ID!) {
    Delete_ConsistencyCollection(id: $id) {
      externalId
    }
  }
`;
export type DeleteConsistencyCollectionMutationFn = Apollo.MutationFunction<
  DeleteConsistencyCollectionMutation,
  DeleteConsistencyCollectionMutationVariables
>;

/**
 * __useDeleteConsistencyCollectionMutation__
 *
 * To run a mutation, you first call `useDeleteConsistencyCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteConsistencyCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteConsistencyCollectionMutation, { data, loading, error }] = useDeleteConsistencyCollectionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteConsistencyCollectionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteConsistencyCollectionMutation,
    DeleteConsistencyCollectionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteConsistencyCollectionMutation,
    DeleteConsistencyCollectionMutationVariables
  >(DeleteConsistencyCollectionDocument, options);
}
export type DeleteConsistencyCollectionMutationHookResult = ReturnType<
  typeof useDeleteConsistencyCollectionMutation
>;
export type DeleteConsistencyCollectionMutationResult =
  Apollo.MutationResult<DeleteConsistencyCollectionMutation>;
export type DeleteConsistencyCollectionMutationOptions =
  Apollo.BaseMutationOptions<
    DeleteConsistencyCollectionMutation,
    DeleteConsistencyCollectionMutationVariables
  >;
export const CreateConsistencySchemaFilterDocument = gql`
  mutation CreateConsistencySchemaFilter(
    $id: ID!
    $name: String!
    $description: String
    $labels: [String]
    $schemaType: String!
    $schemaCollectionId: String!
    $filters: String
    $projectId: String!
    $collectionId: ID!
  ) {
    Create_ConsistencySchemaFilter(
      id: $id
      name: $name
      description: $description
      labels: $labels
      schemaType: $schemaType
      schemaCollectionId: $schemaCollectionId
      filters: $filters
      projectId: $projectId
      collection: { _directRelation: $collectionId }
    ) {
      externalId
    }
    Add_ConsistencyCollection_schemaFilters(
      endNode: $id
      startNode: $collectionId
    ) {
      endNode
      startNode
    }
  }
`;
export type CreateConsistencySchemaFilterMutationFn = Apollo.MutationFunction<
  CreateConsistencySchemaFilterMutation,
  CreateConsistencySchemaFilterMutationVariables
>;

/**
 * __useCreateConsistencySchemaFilterMutation__
 *
 * To run a mutation, you first call `useCreateConsistencySchemaFilterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateConsistencySchemaFilterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createConsistencySchemaFilterMutation, { data, loading, error }] = useCreateConsistencySchemaFilterMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      labels: // value for 'labels'
 *      schemaType: // value for 'schemaType'
 *      schemaCollectionId: // value for 'schemaCollectionId'
 *      filters: // value for 'filters'
 *      projectId: // value for 'projectId'
 *      collectionId: // value for 'collectionId'
 *   },
 * });
 */
export function useCreateConsistencySchemaFilterMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateConsistencySchemaFilterMutation,
    CreateConsistencySchemaFilterMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateConsistencySchemaFilterMutation,
    CreateConsistencySchemaFilterMutationVariables
  >(CreateConsistencySchemaFilterDocument, options);
}
export type CreateConsistencySchemaFilterMutationHookResult = ReturnType<
  typeof useCreateConsistencySchemaFilterMutation
>;
export type CreateConsistencySchemaFilterMutationResult =
  Apollo.MutationResult<CreateConsistencySchemaFilterMutation>;
export type CreateConsistencySchemaFilterMutationOptions =
  Apollo.BaseMutationOptions<
    CreateConsistencySchemaFilterMutation,
    CreateConsistencySchemaFilterMutationVariables
  >;
export const UpdateConsistencySchemaFilterDocument = gql`
  mutation UpdateConsistencySchemaFilter(
    $id: ID!
    $name: String
    $description: String
    $labels: [String]
    $schemaType: String
    $schemaCollectionId: String
    $filters: String
  ) {
    Update_ConsistencySchemaFilter(
      id: $id
      name: $name
      description: $description
      labels: $labels
      schemaType: $schemaType
      schemaCollectionId: $schemaCollectionId
      filters: $filters
    ) {
      externalId
    }
  }
`;
export type UpdateConsistencySchemaFilterMutationFn = Apollo.MutationFunction<
  UpdateConsistencySchemaFilterMutation,
  UpdateConsistencySchemaFilterMutationVariables
>;

/**
 * __useUpdateConsistencySchemaFilterMutation__
 *
 * To run a mutation, you first call `useUpdateConsistencySchemaFilterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateConsistencySchemaFilterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateConsistencySchemaFilterMutation, { data, loading, error }] = useUpdateConsistencySchemaFilterMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      labels: // value for 'labels'
 *      schemaType: // value for 'schemaType'
 *      schemaCollectionId: // value for 'schemaCollectionId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useUpdateConsistencySchemaFilterMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateConsistencySchemaFilterMutation,
    UpdateConsistencySchemaFilterMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateConsistencySchemaFilterMutation,
    UpdateConsistencySchemaFilterMutationVariables
  >(UpdateConsistencySchemaFilterDocument, options);
}
export type UpdateConsistencySchemaFilterMutationHookResult = ReturnType<
  typeof useUpdateConsistencySchemaFilterMutation
>;
export type UpdateConsistencySchemaFilterMutationResult =
  Apollo.MutationResult<UpdateConsistencySchemaFilterMutation>;
export type UpdateConsistencySchemaFilterMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateConsistencySchemaFilterMutation,
    UpdateConsistencySchemaFilterMutationVariables
  >;
export const DeleteConsistencySchemaFilterDocument = gql`
  mutation DeleteConsistencySchemaFilter($id: ID!) {
    Delete_ConsistencySchemaFilter(id: $id) {
      externalId
    }
  }
`;
export type DeleteConsistencySchemaFilterMutationFn = Apollo.MutationFunction<
  DeleteConsistencySchemaFilterMutation,
  DeleteConsistencySchemaFilterMutationVariables
>;

/**
 * __useDeleteConsistencySchemaFilterMutation__
 *
 * To run a mutation, you first call `useDeleteConsistencySchemaFilterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteConsistencySchemaFilterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteConsistencySchemaFilterMutation, { data, loading, error }] = useDeleteConsistencySchemaFilterMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteConsistencySchemaFilterMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteConsistencySchemaFilterMutation,
    DeleteConsistencySchemaFilterMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteConsistencySchemaFilterMutation,
    DeleteConsistencySchemaFilterMutationVariables
  >(DeleteConsistencySchemaFilterDocument, options);
}
export type DeleteConsistencySchemaFilterMutationHookResult = ReturnType<
  typeof useDeleteConsistencySchemaFilterMutation
>;
export type DeleteConsistencySchemaFilterMutationResult =
  Apollo.MutationResult<DeleteConsistencySchemaFilterMutation>;
export type DeleteConsistencySchemaFilterMutationOptions =
  Apollo.BaseMutationOptions<
    DeleteConsistencySchemaFilterMutation,
    DeleteConsistencySchemaFilterMutationVariables
  >;
export const CreateConsistencyRuleDocument = gql`
  mutation CreateConsistencyRule(
    $id: ID!
    $name: String!
    $customerDefinedId: String
    $description: String
    $sourceAttribute: String!
    $sourceFilters: String
    $operator: String!
    $targetAttribute: String!
    $targetFilters: String
    $severity: String
    $errorMessage: String
    $tags: [String]
    $conditionChecksOnly: Boolean
    $projectId: String!
    $collectionId: ID!
    $sourceSchemaFilterId: ID!
    $targetSchemaFilterId: ID!
  ) {
    Create_ConsistencyRule(
      id: $id
      name: $name
      customerDefinedId: $customerDefinedId
      description: $description
      sourceAttribute: $sourceAttribute
      sourceFilters: $sourceFilters
      operator: $operator
      targetAttribute: $targetAttribute
      targetFilters: $targetFilters
      severity: $severity
      errorMessage: $errorMessage
      tags: $tags
      conditionChecksOnly: $conditionChecksOnly
      projectId: $projectId
      collection: { _directRelation: $collectionId }
      sourceSchemaFilter: { _directRelation: $sourceSchemaFilterId }
      targetSchemaFilter: { _directRelation: $targetSchemaFilterId }
    ) {
      externalId
    }
    Add_ConsistencyCollection_rules(endNode: $id, startNode: $collectionId) {
      endNode
      startNode
    }
  }
`;
export type CreateConsistencyRuleMutationFn = Apollo.MutationFunction<
  CreateConsistencyRuleMutation,
  CreateConsistencyRuleMutationVariables
>;

/**
 * __useCreateConsistencyRuleMutation__
 *
 * To run a mutation, you first call `useCreateConsistencyRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateConsistencyRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createConsistencyRuleMutation, { data, loading, error }] = useCreateConsistencyRuleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      customerDefinedId: // value for 'customerDefinedId'
 *      description: // value for 'description'
 *      sourceAttribute: // value for 'sourceAttribute'
 *      sourceFilters: // value for 'sourceFilters'
 *      operator: // value for 'operator'
 *      targetAttribute: // value for 'targetAttribute'
 *      targetFilters: // value for 'targetFilters'
 *      severity: // value for 'severity'
 *      errorMessage: // value for 'errorMessage'
 *      tags: // value for 'tags'
 *      conditionChecksOnly: // value for 'conditionChecksOnly'
 *      projectId: // value for 'projectId'
 *      collectionId: // value for 'collectionId'
 *      sourceSchemaFilterId: // value for 'sourceSchemaFilterId'
 *      targetSchemaFilterId: // value for 'targetSchemaFilterId'
 *   },
 * });
 */
export function useCreateConsistencyRuleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateConsistencyRuleMutation,
    CreateConsistencyRuleMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateConsistencyRuleMutation,
    CreateConsistencyRuleMutationVariables
  >(CreateConsistencyRuleDocument, options);
}
export type CreateConsistencyRuleMutationHookResult = ReturnType<
  typeof useCreateConsistencyRuleMutation
>;
export type CreateConsistencyRuleMutationResult =
  Apollo.MutationResult<CreateConsistencyRuleMutation>;
export type CreateConsistencyRuleMutationOptions = Apollo.BaseMutationOptions<
  CreateConsistencyRuleMutation,
  CreateConsistencyRuleMutationVariables
>;
export const UpdateConsistencyRuleDocument = gql`
  mutation UpdateConsistencyRule(
    $id: ID!
    $name: String
    $customerDefinedId: String
    $description: String
    $sourceAttribute: String
    $sourceFilters: String
    $operator: String
    $targetAttribute: String
    $targetFilters: String
    $severity: String
    $errorMessage: String
    $tags: [String]
    $conditionChecksOnly: Boolean
    $sourceSchemaFilter: _DirectRelationInput
    $targetSchemaFilter: _DirectRelationInput
  ) {
    Update_ConsistencyRule(
      id: $id
      name: $name
      customerDefinedId: $customerDefinedId
      description: $description
      sourceAttribute: $sourceAttribute
      sourceFilters: $sourceFilters
      operator: $operator
      targetAttribute: $targetAttribute
      targetFilters: $targetFilters
      severity: $severity
      errorMessage: $errorMessage
      tags: $tags
      conditionChecksOnly: $conditionChecksOnly
      sourceSchemaFilter: $sourceSchemaFilter
      targetSchemaFilter: $targetSchemaFilter
    ) {
      externalId
    }
  }
`;
export type UpdateConsistencyRuleMutationFn = Apollo.MutationFunction<
  UpdateConsistencyRuleMutation,
  UpdateConsistencyRuleMutationVariables
>;

/**
 * __useUpdateConsistencyRuleMutation__
 *
 * To run a mutation, you first call `useUpdateConsistencyRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateConsistencyRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateConsistencyRuleMutation, { data, loading, error }] = useUpdateConsistencyRuleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      customerDefinedId: // value for 'customerDefinedId'
 *      description: // value for 'description'
 *      sourceAttribute: // value for 'sourceAttribute'
 *      sourceFilters: // value for 'sourceFilters'
 *      operator: // value for 'operator'
 *      targetAttribute: // value for 'targetAttribute'
 *      targetFilters: // value for 'targetFilters'
 *      severity: // value for 'severity'
 *      errorMessage: // value for 'errorMessage'
 *      tags: // value for 'tags'
 *      conditionChecksOnly: // value for 'conditionChecksOnly'
 *      sourceSchemaFilter: // value for 'sourceSchemaFilter'
 *      targetSchemaFilter: // value for 'targetSchemaFilter'
 *   },
 * });
 */
export function useUpdateConsistencyRuleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateConsistencyRuleMutation,
    UpdateConsistencyRuleMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateConsistencyRuleMutation,
    UpdateConsistencyRuleMutationVariables
  >(UpdateConsistencyRuleDocument, options);
}
export type UpdateConsistencyRuleMutationHookResult = ReturnType<
  typeof useUpdateConsistencyRuleMutation
>;
export type UpdateConsistencyRuleMutationResult =
  Apollo.MutationResult<UpdateConsistencyRuleMutation>;
export type UpdateConsistencyRuleMutationOptions = Apollo.BaseMutationOptions<
  UpdateConsistencyRuleMutation,
  UpdateConsistencyRuleMutationVariables
>;
export const DeleteConsistencyRuleDocument = gql`
  mutation DeleteConsistencyRule($id: ID!) {
    Delete_ConsistencyRule(id: $id) {
      externalId
    }
  }
`;
export type DeleteConsistencyRuleMutationFn = Apollo.MutationFunction<
  DeleteConsistencyRuleMutation,
  DeleteConsistencyRuleMutationVariables
>;

/**
 * __useDeleteConsistencyRuleMutation__
 *
 * To run a mutation, you first call `useDeleteConsistencyRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteConsistencyRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteConsistencyRuleMutation, { data, loading, error }] = useDeleteConsistencyRuleMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteConsistencyRuleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteConsistencyRuleMutation,
    DeleteConsistencyRuleMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteConsistencyRuleMutation,
    DeleteConsistencyRuleMutationVariables
  >(DeleteConsistencyRuleDocument, options);
}
export type DeleteConsistencyRuleMutationHookResult = ReturnType<
  typeof useDeleteConsistencyRuleMutation
>;
export type DeleteConsistencyRuleMutationResult =
  Apollo.MutationResult<DeleteConsistencyRuleMutation>;
export type DeleteConsistencyRuleMutationOptions = Apollo.BaseMutationOptions<
  DeleteConsistencyRuleMutation,
  DeleteConsistencyRuleMutationVariables
>;
export const CreateConsistencyConditionCheckDocument = gql`
  mutation CreateConsistencyConditionCheck(
    $id: ID!
    $sourceAttribute: String!
    $operator: String!
    $targetAttribute: String!
    $isLiteralValue: Boolean
    $useTargetSchema: Boolean
    $ruleId: ID!
  ) {
    Create_ConsistencyConditionCheck(
      id: $id
      sourceAttribute: $sourceAttribute
      operator: $operator
      targetAttribute: $targetAttribute
      isLiteralValue: $isLiteralValue
      useTargetSchema: $useTargetSchema
      rule: { _directRelation: $ruleId }
    ) {
      externalId
    }
    Add_ConsistencyRule_conditionChecks(endNode: $id, startNode: $ruleId) {
      endNode
      startNode
    }
  }
`;
export type CreateConsistencyConditionCheckMutationFn = Apollo.MutationFunction<
  CreateConsistencyConditionCheckMutation,
  CreateConsistencyConditionCheckMutationVariables
>;

/**
 * __useCreateConsistencyConditionCheckMutation__
 *
 * To run a mutation, you first call `useCreateConsistencyConditionCheckMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateConsistencyConditionCheckMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createConsistencyConditionCheckMutation, { data, loading, error }] = useCreateConsistencyConditionCheckMutation({
 *   variables: {
 *      id: // value for 'id'
 *      sourceAttribute: // value for 'sourceAttribute'
 *      operator: // value for 'operator'
 *      targetAttribute: // value for 'targetAttribute'
 *      isLiteralValue: // value for 'isLiteralValue'
 *      useTargetSchema: // value for 'useTargetSchema'
 *      ruleId: // value for 'ruleId'
 *   },
 * });
 */
export function useCreateConsistencyConditionCheckMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateConsistencyConditionCheckMutation,
    CreateConsistencyConditionCheckMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateConsistencyConditionCheckMutation,
    CreateConsistencyConditionCheckMutationVariables
  >(CreateConsistencyConditionCheckDocument, options);
}
export type CreateConsistencyConditionCheckMutationHookResult = ReturnType<
  typeof useCreateConsistencyConditionCheckMutation
>;
export type CreateConsistencyConditionCheckMutationResult =
  Apollo.MutationResult<CreateConsistencyConditionCheckMutation>;
export type CreateConsistencyConditionCheckMutationOptions =
  Apollo.BaseMutationOptions<
    CreateConsistencyConditionCheckMutation,
    CreateConsistencyConditionCheckMutationVariables
  >;
export const UpdateConsistencyConditionCheckDocument = gql`
  mutation UpdateConsistencyConditionCheck(
    $id: ID!
    $sourceAttribute: String
    $operator: String
    $targetAttribute: String
    $isLiteralValue: Boolean
    $useTargetSchema: Boolean
  ) {
    Update_ConsistencyConditionCheck(
      id: $id
      sourceAttribute: $sourceAttribute
      operator: $operator
      targetAttribute: $targetAttribute
      isLiteralValue: $isLiteralValue
      useTargetSchema: $useTargetSchema
    ) {
      externalId
    }
  }
`;
export type UpdateConsistencyConditionCheckMutationFn = Apollo.MutationFunction<
  UpdateConsistencyConditionCheckMutation,
  UpdateConsistencyConditionCheckMutationVariables
>;

/**
 * __useUpdateConsistencyConditionCheckMutation__
 *
 * To run a mutation, you first call `useUpdateConsistencyConditionCheckMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateConsistencyConditionCheckMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateConsistencyConditionCheckMutation, { data, loading, error }] = useUpdateConsistencyConditionCheckMutation({
 *   variables: {
 *      id: // value for 'id'
 *      sourceAttribute: // value for 'sourceAttribute'
 *      operator: // value for 'operator'
 *      targetAttribute: // value for 'targetAttribute'
 *      isLiteralValue: // value for 'isLiteralValue'
 *      useTargetSchema: // value for 'useTargetSchema'
 *   },
 * });
 */
export function useUpdateConsistencyConditionCheckMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateConsistencyConditionCheckMutation,
    UpdateConsistencyConditionCheckMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateConsistencyConditionCheckMutation,
    UpdateConsistencyConditionCheckMutationVariables
  >(UpdateConsistencyConditionCheckDocument, options);
}
export type UpdateConsistencyConditionCheckMutationHookResult = ReturnType<
  typeof useUpdateConsistencyConditionCheckMutation
>;
export type UpdateConsistencyConditionCheckMutationResult =
  Apollo.MutationResult<UpdateConsistencyConditionCheckMutation>;
export type UpdateConsistencyConditionCheckMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateConsistencyConditionCheckMutation,
    UpdateConsistencyConditionCheckMutationVariables
  >;
export const DeleteConsistencyConditionCheckDocument = gql`
  mutation DeleteConsistencyConditionCheck($id: ID!) {
    Delete_ConsistencyConditionCheck(id: $id) {
      externalId
    }
  }
`;
export type DeleteConsistencyConditionCheckMutationFn = Apollo.MutationFunction<
  DeleteConsistencyConditionCheckMutation,
  DeleteConsistencyConditionCheckMutationVariables
>;

/**
 * __useDeleteConsistencyConditionCheckMutation__
 *
 * To run a mutation, you first call `useDeleteConsistencyConditionCheckMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteConsistencyConditionCheckMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteConsistencyConditionCheckMutation, { data, loading, error }] = useDeleteConsistencyConditionCheckMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteConsistencyConditionCheckMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteConsistencyConditionCheckMutation,
    DeleteConsistencyConditionCheckMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteConsistencyConditionCheckMutation,
    DeleteConsistencyConditionCheckMutationVariables
  >(DeleteConsistencyConditionCheckDocument, options);
}
export type DeleteConsistencyConditionCheckMutationHookResult = ReturnType<
  typeof useDeleteConsistencyConditionCheckMutation
>;
export type DeleteConsistencyConditionCheckMutationResult =
  Apollo.MutationResult<DeleteConsistencyConditionCheckMutation>;
export type DeleteConsistencyConditionCheckMutationOptions =
  Apollo.BaseMutationOptions<
    DeleteConsistencyConditionCheckMutation,
    DeleteConsistencyConditionCheckMutationVariables
  >;
export const GQLOperations = {
  Query: {
    GetDigitalTwins: 'GetDigitalTwins',
    CountDigitalTwins: 'CountDigitalTwins',
    GetDigitalTwin: 'GetDigitalTwin',
    GetDigitalTwinName: 'GetDigitalTwinName',
    GetSchemaCollection: 'GetSchemaCollection',
    GetRules: 'GetRules',
    GetRuleRunStatus: 'GetRuleRunStatus',
    GetRuleRunStatusByRuleId: 'GetRuleRunStatusByRuleId',
    GetMilestones: 'GetMilestones',
    GetCollectionReports: 'GetCollectionReports',
    GetCollectionRunReport: 'GetCollectionRunReport',
    GetCollectionDetailsReport: 'GetCollectionDetailsReport',
    GetRuleDetailsAndHistory: 'GetRuleDetailsAndHistory',
    GetRulesets: 'GetRulesets',
    GetRuleset: 'GetRuleset',
    GetAccess: 'GetAccess',
    CountAccess: 'CountAccess',
    GetAllRuleRunStatus: 'GetAllRuleRunStatus',
    GetConsistencyCollections: 'GetConsistencyCollections',
    GetConsistencyReport: 'GetConsistencyReport',
  },
  Mutation: {
    CreateDigitalTwin: 'CreateDigitalTwin',
    UpdateDigitalTwin: 'UpdateDigitalTwin',
    DeleteDigitalTwin: 'DeleteDigitalTwin',
    DeleteSchema: 'DeleteSchema',
    CreateRule: 'CreateRule',
    DeleteRule: 'DeleteRule',
    UpdateRule: 'UpdateRule',
    CreateMilestone: 'CreateMilestone',
    AddSchemaCollectionToDigitalTwin: 'AddSchemaCollectionToDigitalTwin',
    UpdateSchemaCollectionRefId: 'UpdateSchemaCollectionRefId',
    DeleteMilestone: 'DeleteMilestone',
    UpdateMilestone: 'UpdateMilestone',
    AddSchemaCollectionMilestones: 'AddSchemaCollectionMilestones',
    AddMilestoneRulesets: 'AddMilestoneRulesets',
    AddRulesetMilestones: 'AddRulesetMilestones',
    AddMilestoneRules: 'AddMilestoneRules',
    UpdateMilestoneReportTemplate: 'UpdateMilestoneReportTemplate',
    AddRuleMilestones: 'AddRuleMilestones',
    CreateRuleset: 'CreateRuleset',
    DeleteRuleset: 'DeleteRuleset',
    UpdateRuleset: 'UpdateRuleset',
    AddSchemaCollectionRulesets: 'AddSchemaCollectionRulesets',
    AddSchemaCollectionRules: 'AddSchemaCollectionRules',
    AddRulesetRules: 'AddRulesetRules',
    AddRuleRulesets: 'AddRuleRulesets',
    RemoveMilestoneRulesets: 'RemoveMilestoneRulesets',
    RemoveRulesetMilestones: 'RemoveRulesetMilestones',
    RemoveMilestoneRules: 'RemoveMilestoneRules',
    RemoveRuleMilestones: 'RemoveRuleMilestones',
    RemoveEdgeRuleMilestone: 'RemoveEdgeRuleMilestone',
    CreateAccess: 'CreateAccess',
    DeleteAccess: 'DeleteAccess',
    UpdateAccess: 'UpdateAccess',
    toggleDisableRule: 'toggleDisableRule',
    CreateConsistencyCollection: 'CreateConsistencyCollection',
    UpdateConsistencyCollection: 'UpdateConsistencyCollection',
    DeleteConsistencyCollection: 'DeleteConsistencyCollection',
    CreateConsistencySchemaFilter: 'CreateConsistencySchemaFilter',
    UpdateConsistencySchemaFilter: 'UpdateConsistencySchemaFilter',
    DeleteConsistencySchemaFilter: 'DeleteConsistencySchemaFilter',
    CreateConsistencyRule: 'CreateConsistencyRule',
    UpdateConsistencyRule: 'UpdateConsistencyRule',
    DeleteConsistencyRule: 'DeleteConsistencyRule',
    CreateConsistencyConditionCheck: 'CreateConsistencyConditionCheck',
    UpdateConsistencyConditionCheck: 'UpdateConsistencyConditionCheck',
    DeleteConsistencyConditionCheck: 'DeleteConsistencyConditionCheck',
  },
};
